//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class BalanceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getConstructeurs(): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetConstructeurs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstructeurs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstructeurs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetConstructeurs(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModeles(): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetModeles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModeles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModeles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetModeles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPartiePlastique(liaison_pp: number | undefined, pident: number | undefined, fnum: string | null | undefined, world: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetPartiePlastique?";
        if (liaison_pp === null)
            throw new Error("The parameter 'liaison_pp' cannot be null.");
        else if (liaison_pp !== undefined)
            url_ += "liaison_pp=" + encodeURIComponent("" + liaison_pp) + "&";
        if (pident === null)
            throw new Error("The parameter 'pident' cannot be null.");
        else if (pident !== undefined)
            url_ += "pident=" + encodeURIComponent("" + pident) + "&";
        if (fnum !== undefined && fnum !== null)
            url_ += "fnum=" + encodeURIComponent("" + fnum) + "&";
        if (world !== undefined && world !== null)
            url_ += "world=" + encodeURIComponent("" + world) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartiePlastique(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartiePlastique(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPartiePlastique(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVariantes(tident: number | undefined, mode: number | undefined, fnum: string | null | undefined, colorbox: string | null | undefined, ocode: string | null | undefined, tech: number | undefined, world: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetVariantes?";
        if (tident === null)
            throw new Error("The parameter 'tident' cannot be null.");
        else if (tident !== undefined)
            url_ += "tident=" + encodeURIComponent("" + tident) + "&";
        if (mode === null)
            throw new Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (fnum !== undefined && fnum !== null)
            url_ += "fnum=" + encodeURIComponent("" + fnum) + "&";
        if (colorbox !== undefined && colorbox !== null)
            url_ += "colorbox=" + encodeURIComponent("" + colorbox) + "&";
        if (ocode !== undefined && ocode !== null)
            url_ += "ocode=" + encodeURIComponent("" + ocode) + "&";
        if (tech === null)
            throw new Error("The parameter 'tech' cannot be null.");
        else if (tech !== undefined)
            url_ += "tech=" + encodeURIComponent("" + tech) + "&";
        if (world !== undefined && world !== null)
            url_ += "world=" + encodeURIComponent("" + world) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVariantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVariantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetVariantes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFormules(vident: string | null | undefined, fnum: string | null | undefined, ocode: string | null | undefined, tech: number | undefined, idform: number | undefined, itsection: string | null | undefined, itsectiontrad: string | null | undefined, pident: number | undefined, oldnnp: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetFormules?";
        if (vident !== undefined && vident !== null)
            url_ += "vident=" + encodeURIComponent("" + vident) + "&";
        if (fnum !== undefined && fnum !== null)
            url_ += "fnum=" + encodeURIComponent("" + fnum) + "&";
        if (ocode !== undefined && ocode !== null)
            url_ += "ocode=" + encodeURIComponent("" + ocode) + "&";
        if (tech === null)
            throw new Error("The parameter 'tech' cannot be null.");
        else if (tech !== undefined)
            url_ += "tech=" + encodeURIComponent("" + tech) + "&";
        if (idform === null)
            throw new Error("The parameter 'idform' cannot be null.");
        else if (idform !== undefined)
            url_ += "idform=" + encodeURIComponent("" + idform) + "&";
        if (itsection !== undefined && itsection !== null)
            url_ += "itsection=" + encodeURIComponent("" + itsection) + "&";
        if (itsectiontrad !== undefined && itsectiontrad !== null)
            url_ += "itsectiontrad=" + encodeURIComponent("" + itsectiontrad) + "&";
        if (pident === null)
            throw new Error("The parameter 'pident' cannot be null.");
        else if (pident !== undefined)
            url_ += "pident=" + encodeURIComponent("" + pident) + "&";
        if (oldnnp === null)
            throw new Error("The parameter 'oldnnp' cannot be null.");
        else if (oldnnp !== undefined)
            url_ += "oldnnp=" + encodeURIComponent("" + oldnnp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFormules(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIngredients(iident: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetIngredients?";
        if (iident === null)
            throw new Error("The parameter 'iident' cannot be null.");
        else if (iident !== undefined)
            url_ += "iident=" + encodeURIComponent("" + iident) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetIngredients(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAutoComplete(tcode: string | null | undefined, tnom: string | null | undefined, typetcode: string | null | undefined, typetnom: string | null | undefined, cnum: number | undefined, fnum: string | null | undefined, mode: number | undefined, world: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetAutoComplete?";
        if (tcode !== undefined && tcode !== null)
            url_ += "tcode=" + encodeURIComponent("" + tcode) + "&";
        if (tnom !== undefined && tnom !== null)
            url_ += "tnom=" + encodeURIComponent("" + tnom) + "&";
        if (typetcode !== undefined && typetcode !== null)
            url_ += "typetcode=" + encodeURIComponent("" + typetcode) + "&";
        if (typetnom !== undefined && typetnom !== null)
            url_ += "typetnom=" + encodeURIComponent("" + typetnom) + "&";
        if (cnum === null)
            throw new Error("The parameter 'cnum' cannot be null.");
        else if (cnum !== undefined)
            url_ += "cnum=" + encodeURIComponent("" + cnum) + "&";
        if (fnum !== undefined && fnum !== null)
            url_ += "fnum=" + encodeURIComponent("" + fnum) + "&";
        if (mode === null)
            throw new Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (world !== undefined && world !== null)
            url_ += "world=" + encodeURIComponent("" + world) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAutoComplete(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    relGET(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Balance/Rel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRelGET(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    relPOST(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Balance/Rel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRelPOST(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GetFormulesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    meres(cnum: number | undefined, tcode: string | null | undefined, tnom: string | null | undefined, colorbox: string | null | undefined, fnum: string | null | undefined, ocode: string | null | undefined, tech: number | undefined, typetcode: string | null | undefined, typetnom: string | null | undefined, appl: string | null | undefined, mdl: number | undefined, coul: number | undefined, mode: number | undefined, world: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Balance/GetFormules_Meres?";
        if (cnum === null)
            throw new Error("The parameter 'cnum' cannot be null.");
        else if (cnum !== undefined)
            url_ += "cnum=" + encodeURIComponent("" + cnum) + "&";
        if (tcode !== undefined && tcode !== null)
            url_ += "tcode=" + encodeURIComponent("" + tcode) + "&";
        if (tnom !== undefined && tnom !== null)
            url_ += "tnom=" + encodeURIComponent("" + tnom) + "&";
        if (colorbox !== undefined && colorbox !== null)
            url_ += "colorbox=" + encodeURIComponent("" + colorbox) + "&";
        if (fnum !== undefined && fnum !== null)
            url_ += "fnum=" + encodeURIComponent("" + fnum) + "&";
        if (ocode !== undefined && ocode !== null)
            url_ += "ocode=" + encodeURIComponent("" + ocode) + "&";
        if (tech === null)
            throw new Error("The parameter 'tech' cannot be null.");
        else if (tech !== undefined)
            url_ += "tech=" + encodeURIComponent("" + tech) + "&";
        if (typetcode !== undefined && typetcode !== null)
            url_ += "typetcode=" + encodeURIComponent("" + typetcode) + "&";
        if (typetnom !== undefined && typetnom !== null)
            url_ += "typetnom=" + encodeURIComponent("" + typetnom) + "&";
        if (appl !== undefined && appl !== null)
            url_ += "appl=" + encodeURIComponent("" + appl) + "&";
        if (mdl === null)
            throw new Error("The parameter 'mdl' cannot be null.");
        else if (mdl !== undefined)
            url_ += "mdl=" + encodeURIComponent("" + mdl) + "&";
        if (coul === null)
            throw new Error("The parameter 'coul' cannot be null.");
        else if (coul !== undefined)
            url_ += "coul=" + encodeURIComponent("" + coul) + "&";
        if (mode === null)
            throw new Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (world !== undefined && world !== null)
            url_ += "world=" + encodeURIComponent("" + world) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMeres(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMeres(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMeres(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IxellAPIService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    selectLog(startDate: Date): Observable<ILogV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startDate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ILogV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ILogV1[]>;
        }));
    }

    protected processSelectLog(response: HttpResponseBase): Observable<ILogV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ILogV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectLogAccesClient(startDate: Date): Observable<ILogV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectLogAccesClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startDate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectLogAccesClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectLogAccesClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ILogV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ILogV1[]>;
        }));
    }

    protected processSelectLogAccesClient(response: HttpResponseBase): Observable<ILogV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ILogV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportLogAccesClient(startDate: Date): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/ExportLogAccesClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startDate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLogAccesClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLogAccesClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportLogAccesClient(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(language: string | null | undefined, pays: string | null | undefined): Observable<IDocumentV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetDocuments?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (pays !== undefined && pays !== null)
            url_ += "pays=" + encodeURIComponent("" + pays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IDocumentV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IDocumentV1[]>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<IDocumentV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IDocumentV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentsEnfant(idTitreParent: number | undefined, language: string | null | undefined, pays: string | null | undefined): Observable<IDocumentV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetDocumentsEnfant?";
        if (idTitreParent === null)
            throw new Error("The parameter 'idTitreParent' cannot be null.");
        else if (idTitreParent !== undefined)
            url_ += "idTitreParent=" + encodeURIComponent("" + idTitreParent) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (pays !== undefined && pays !== null)
            url_ += "pays=" + encodeURIComponent("" + pays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsEnfant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsEnfant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IDocumentV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IDocumentV1[]>;
        }));
    }

    protected processGetDocumentsEnfant(response: HttpResponseBase): Observable<IDocumentV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IDocumentV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentsPDF(idTitre: number | undefined, language: string | null | undefined, pays: string | null | undefined): Observable<IDocumentV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetDocumentsPDF?";
        if (idTitre === null)
            throw new Error("The parameter 'idTitre' cannot be null.");
        else if (idTitre !== undefined)
            url_ += "idTitre=" + encodeURIComponent("" + idTitre) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (pays !== undefined && pays !== null)
            url_ += "pays=" + encodeURIComponent("" + pays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IDocumentV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IDocumentV1>;
        }));
    }

    protected processGetDocumentsPDF(response: HttpResponseBase): Observable<IDocumentV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IDocumentV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetKFOrder(): Observable<StatsKeyfactorKind[]> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetKFOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetKFOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetKFOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsKeyfactorKind[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsKeyfactorKind[]>;
        }));
    }

    protected processStatsGetKFOrder(response: HttpResponseBase): Observable<StatsKeyfactorKind[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsSetKFOrder(order: StatsKeyfactorKind[]): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsSetKFOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(order);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsSetKFOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsSetKFOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsSetKFOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetUsableGraphs(): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetUsableGraphs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetUsableGraphs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetUsableGraphs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processStatsGetUsableGraphs(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsAddUsableGraph(idx: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsAddUsableGraph?";
        if (idx === null)
            throw new Error("The parameter 'idx' cannot be null.");
        else if (idx !== undefined)
            url_ += "idx=" + encodeURIComponent("" + idx) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsAddUsableGraph(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsAddUsableGraph(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsAddUsableGraph(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetGraphs(): Observable<StatsGraphProps[]> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetGraphs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetGraphs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetGraphs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsGraphProps[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsGraphProps[]>;
        }));
    }

    protected processStatsGetGraphs(response: HttpResponseBase): Observable<StatsGraphProps[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatsGraphProps.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsSetGraphPrefs(prefs: StatsGraphPrefs[]): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsSetGraphPrefs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prefs);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsSetGraphPrefs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsSetGraphPrefs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsSetGraphPrefs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetDropdownContentsForKind(kind: StatsGraphFilterKind | undefined, language: string | null | undefined, previous: string | null | undefined): Observable<StatsDropdownValue[]> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetDropdownContentsForKind?";
        if (kind === null)
            throw new Error("The parameter 'kind' cannot be null.");
        else if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (previous !== undefined && previous !== null)
            url_ += "previous=" + encodeURIComponent("" + previous) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetDropdownContentsForKind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetDropdownContentsForKind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsDropdownValue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsDropdownValue[]>;
        }));
    }

    protected processStatsGetDropdownContentsForKind(response: HttpResponseBase): Observable<StatsDropdownValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatsDropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetShapeForDataY(dataY: StatsGraphDataY | undefined): Observable<StatsGraphShape[]> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetShapeForDataY?";
        if (dataY === null)
            throw new Error("The parameter 'dataY' cannot be null.");
        else if (dataY !== undefined)
            url_ += "dataY=" + encodeURIComponent("" + dataY) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetShapeForDataY(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetShapeForDataY(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsGraphShape[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsGraphShape[]>;
        }));
    }

    protected processStatsGetShapeForDataY(response: HttpResponseBase): Observable<StatsGraphShape[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetEarliestDateForData(kind: StatsGraphDataY | undefined): Observable<Date | null> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetEarliestDateForData?";
        if (kind === null)
            throw new Error("The parameter 'kind' cannot be null.");
        else if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetEarliestDateForData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetEarliestDateForData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date | null>;
        }));
    }

    protected processStatsGetEarliestDateForData(response: HttpResponseBase): Observable<Date | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetGraphData(dataX: StatsGraphDataX | undefined, dataY: StatsGraphDataY | undefined, language: string | null | undefined, filters: StatsGraphFiltersData): Observable<StatsGraphData> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetGraphData?";
        if (dataX === null)
            throw new Error("The parameter 'dataX' cannot be null.");
        else if (dataX !== undefined)
            url_ += "dataX=" + encodeURIComponent("" + dataX) + "&";
        if (dataY === null)
            throw new Error("The parameter 'dataY' cannot be null.");
        else if (dataY !== undefined)
            url_ += "dataY=" + encodeURIComponent("" + dataY) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetGraphData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetGraphData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsGraphData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsGraphData>;
        }));
    }

    protected processStatsGetGraphData(response: HttpResponseBase): Observable<StatsGraphData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatsGraphData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetAutocompleteList(kind: StatsGraphFilterKind | undefined, currValue: string | null | undefined, ext: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetAutocompleteList?";
        if (kind === null)
            throw new Error("The parameter 'kind' cannot be null.");
        else if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        if (currValue !== undefined && currValue !== null)
            url_ += "currValue=" + encodeURIComponent("" + currValue) + "&";
        if (ext === null)
            throw new Error("The parameter 'ext' cannot be null.");
        else if (ext !== undefined)
            url_ += "ext=" + encodeURIComponent("" + ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetAutocompleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetAutocompleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processStatsGetAutocompleteList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetLastConnection(userLogin: string | null | undefined, language: string | null | undefined, offset: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetLastConnection?";
        if (userLogin !== undefined && userLogin !== null)
            url_ += "userLogin=" + encodeURIComponent("" + userLogin) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetLastConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetLastConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStatsGetLastConnection(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountriesProperties(alpha3Codes: string[]): Observable<IPays[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetCountriesProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alpha3Codes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountriesProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountriesProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPays[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPays[]>;
        }));
    }

    protected processGetCountriesProperties(response: HttpResponseBase): Observable<IPays[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPays.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserAndCompany(): Observable<IUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetUserAndCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAndCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAndCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IUserV1>;
        }));
    }

    protected processGetUserAndCompany(response: HttpResponseBase): Observable<IUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompaniesByCP(cP: string | null | undefined): Observable<IColorMatchingV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetCompaniesByCP?";
        if (cP !== undefined && cP !== null)
            url_ += "CP=" + encodeURIComponent("" + cP) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompaniesByCP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompaniesByCP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorMatchingV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorMatchingV1[]>;
        }));
    }

    protected processGetCompaniesByCP(response: HttpResponseBase): Observable<IColorMatchingV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorMatchingV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserCMById(companyId: number | undefined, colorUserId: number | undefined): Observable<IColorMatchingV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetUserCMById?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (colorUserId === null)
            throw new Error("The parameter 'colorUserId' cannot be null.");
        else if (colorUserId !== undefined)
            url_ += "colorUserId=" + encodeURIComponent("" + colorUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCMById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCMById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorMatchingV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorMatchingV1[]>;
        }));
    }

    protected processGetUserCMById(response: HttpResponseBase): Observable<IColorMatchingV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorMatchingV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCTC(): Observable<ICtcV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetCTC";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1>;
        }));
    }

    protected processGetCTC(response: HttpResponseBase): Observable<ICtcV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ICtcV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkCTC(ctc: ICtcV1): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/CheckCTC";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ctc);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckCTC(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCtcByPhone(phone: string | null | undefined): Observable<ICtcV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetCtcByPhone?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCtcByPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCtcByPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1>;
        }));
    }

    protected processGetCtcByPhone(response: HttpResponseBase): Observable<ICtcV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ICtcV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkUser(login: string | null | undefined): Observable<IUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/CheckUser?";
        if (login !== undefined && login !== null)
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IUserV1>;
        }));
    }

    protected processCheckUser(response: HttpResponseBase): Observable<IUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRequestColorMatching(contretypageRequest: IColorMatchingV1): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/AddRequestColorMatching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contretypageRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRequestColorMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRequestColorMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddRequestColorMatching(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstColorMatching(filter: IFilterColorMatching): Observable<IColorMatchingV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstColorMatching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstColorMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstColorMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorMatchingV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorMatchingV1[]>;
        }));
    }

    protected processGetLstColorMatching(response: HttpResponseBase): Observable<IColorMatchingV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorMatchingV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorMatching(id: number | undefined): Observable<IColorMatchingV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorMatching?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorMatchingV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorMatchingV1>;
        }));
    }

    protected processGetColorMatching(response: HttpResponseBase): Observable<IColorMatchingV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorMatchingV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDateReceive(idCM: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/AddDateReceive?";
        if (idCM === null)
            throw new Error("The parameter 'idCM' cannot be null.");
        else if (idCM !== undefined)
            url_ += "idCM=" + encodeURIComponent("" + idCM) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDateReceive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDateReceive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddDateReceive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIngredient(technology: string | null | undefined): Observable<IIngredientColorMatchingV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetIngredient?";
        if (technology !== undefined && technology !== null)
            url_ += "technology=" + encodeURIComponent("" + technology) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IIngredientColorMatchingV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IIngredientColorMatchingV1[]>;
        }));
    }

    protected processGetIngredient(response: HttpResponseBase): Observable<IIngredientColorMatchingV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IIngredientColorMatchingV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTextSentence(): Observable<ITextSentenceColorMatchingV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetTextSentence";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTextSentence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTextSentence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ITextSentenceColorMatchingV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ITextSentenceColorMatchingV1[]>;
        }));
    }

    protected processGetTextSentence(response: HttpResponseBase): Observable<ITextSentenceColorMatchingV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ITextSentenceColorMatchingV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addResponseColorMatching(response: IResponseColorMatchingV1, cU: string | null | undefined, pdfHtml: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/AddResponseColorMatching?";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        if (pdfHtml !== undefined && pdfHtml !== null)
            url_ += "pdfHtml=" + encodeURIComponent("" + pdfHtml) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddResponseColorMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddResponseColorMatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddResponseColorMatching(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFormuleContretypage(degree: number | undefined, paintQuality: number | undefined, constructeur: string | null | undefined, code: string | null | undefined, designation: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetFormuleContretypage?";
        if (degree === null)
            throw new Error("The parameter 'degree' cannot be null.");
        else if (degree !== undefined)
            url_ += "degree=" + encodeURIComponent("" + degree) + "&";
        if (paintQuality === null)
            throw new Error("The parameter 'paintQuality' cannot be null.");
        else if (paintQuality !== undefined)
            url_ += "paintQuality=" + encodeURIComponent("" + paintQuality) + "&";
        if (constructeur !== undefined && constructeur !== null)
            url_ += "constructeur=" + encodeURIComponent("" + constructeur) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "designation=" + encodeURIComponent("" + designation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormuleContretypage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormuleContretypage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFormuleContretypage(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validationContretypage(res: IColorMatchingV1, cU: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ValidationContretypage?";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(res);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidationContretypage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidationContretypage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidationContretypage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstCtc(phone: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/getLstCtc?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstCtc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstCtc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLstCtc(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstCompany(codePostal: string | null | undefined): Observable<ICompanyV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/getLstCompany?";
        if (codePostal !== undefined && codePostal !== null)
            url_ += "codePostal=" + encodeURIComponent("" + codePostal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICompanyV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICompanyV1[]>;
        }));
    }

    protected processGetLstCompany(response: HttpResponseBase): Observable<ICompanyV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICompanyV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCodePostalCompany(codePostal: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/getCodePostalCompany?";
        if (codePostal !== undefined && codePostal !== null)
            url_ += "codePostal=" + encodeURIComponent("" + codePostal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodePostalCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodePostalCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCodePostalCompany(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copieContretypage(colorMatchingID: number | undefined, cU: string | null | undefined): Observable<IColorMatchingV1> {
        let url_ = this.baseUrl + "/IxellAPI/copieContretypage?";
        if (colorMatchingID === null)
            throw new Error("The parameter 'colorMatchingID' cannot be null.");
        else if (colorMatchingID !== undefined)
            url_ += "colorMatchingID=" + encodeURIComponent("" + colorMatchingID) + "&";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopieContretypage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopieContretypage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorMatchingV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorMatchingV1>;
        }));
    }

    protected processCopieContretypage(response: HttpResponseBase): Observable<IColorMatchingV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorMatchingV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copieFormuleContretypage(copyColorMatchingID: number | undefined, pasteColorMatchingID: number | undefined): Observable<IColorMatchingV1> {
        let url_ = this.baseUrl + "/IxellAPI/CopieFormuleContretypage?";
        if (copyColorMatchingID === null)
            throw new Error("The parameter 'copyColorMatchingID' cannot be null.");
        else if (copyColorMatchingID !== undefined)
            url_ += "copyColorMatchingID=" + encodeURIComponent("" + copyColorMatchingID) + "&";
        if (pasteColorMatchingID === null)
            throw new Error("The parameter 'pasteColorMatchingID' cannot be null.");
        else if (pasteColorMatchingID !== undefined)
            url_ += "pasteColorMatchingID=" + encodeURIComponent("" + pasteColorMatchingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopieFormuleContretypage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopieFormuleContretypage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorMatchingV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorMatchingV1>;
        }));
    }

    protected processCopieFormuleContretypage(response: HttpResponseBase): Observable<IColorMatchingV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorMatchingV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCoatCd(): Observable<ICoatColorMatchingV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetCoatCd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoatCd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoatCd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICoatColorMatchingV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICoatColorMatchingV1[]>;
        }));
    }

    protected processGetCoatCd(response: HttpResponseBase): Observable<ICoatColorMatchingV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICoatColorMatchingV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConnectionInfos(): Observable<Tchat> {
        let url_ = this.baseUrl + "/IxellAPI/GetConnectionInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tchat>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tchat>;
        }));
    }

    protected processGetConnectionInfos(response: HttpResponseBase): Observable<Tchat> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tchat.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPossibleLocales(): Observable<IUserLocale[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetPossibleLocales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPossibleLocales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPossibleLocales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IUserLocale[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IUserLocale[]>;
        }));
    }

    protected processGetPossibleLocales(response: HttpResponseBase): Observable<IUserLocale[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IUserLocale.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyLocale(): Observable<IUserLocale> {
        let url_ = this.baseUrl + "/IxellAPI/GetMyLocale";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IUserLocale>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IUserLocale>;
        }));
    }

    protected processGetMyLocale(response: HttpResponseBase): Observable<IUserLocale> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IUserLocale.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCloudTree(): Observable<IStockTree> {
        let url_ = this.baseUrl + "/IxellAPI/GetCloudTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloudTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloudTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IStockTree>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IStockTree>;
        }));
    }

    protected processGetCloudTree(response: HttpResponseBase): Observable<IStockTree> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IStockTree.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeCloudTreeDefaultLanguage(srcLang: number | undefined, dstLang: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ChangeCloudTreeDefaultLanguage?";
        if (srcLang === null)
            throw new Error("The parameter 'srcLang' cannot be null.");
        else if (srcLang !== undefined)
            url_ += "srcLang=" + encodeURIComponent("" + srcLang) + "&";
        if (dstLang === null)
            throw new Error("The parameter 'dstLang' cannot be null.");
        else if (dstLang !== undefined)
            url_ += "dstLang=" + encodeURIComponent("" + dstLang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCloudTreeDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCloudTreeDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeCloudTreeDefaultLanguage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCloudFile(fileEntry: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteCloudFile?";
        if (fileEntry === null)
            throw new Error("The parameter 'fileEntry' cannot be null.");
        else if (fileEntry !== undefined)
            url_ += "fileEntry=" + encodeURIComponent("" + fileEntry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCloudFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCloudFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCloudFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeCloudFileContentListing(fileContent: number | undefined, status: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ChangeCloudFileContentListing?";
        if (fileContent === null)
            throw new Error("The parameter 'fileContent' cannot be null.");
        else if (fileContent !== undefined)
            url_ += "fileContent=" + encodeURIComponent("" + fileContent) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCloudFileContentListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCloudFileContentListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeCloudFileContentListing(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCloudCommFile(docId: number | undefined, isBanner: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetCloudCommFile?";
        if (docId === null)
            throw new Error("The parameter 'docId' cannot be null.");
        else if (docId !== undefined)
            url_ += "docId=" + encodeURIComponent("" + docId) + "&";
        if (isBanner === null)
            throw new Error("The parameter 'isBanner' cannot be null.");
        else if (isBanner !== undefined)
            url_ += "isBanner=" + encodeURIComponent("" + isBanner) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloudCommFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloudCommFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCloudCommFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCloudComm(idStockComm: number | undefined, idStockFolder: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteCloudComm?";
        if (idStockComm === null)
            throw new Error("The parameter 'idStockComm' cannot be null.");
        else if (idStockComm !== undefined)
            url_ += "idStockComm=" + encodeURIComponent("" + idStockComm) + "&";
        if (idStockFolder === null)
            throw new Error("The parameter 'idStockFolder' cannot be null.");
        else if (idStockFolder !== undefined)
            url_ += "idStockFolder=" + encodeURIComponent("" + idStockFolder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCloudComm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCloudComm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCloudComm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCloudLogs(start: Date | undefined, end: Date | undefined, idPays: number | null | undefined, idLangue: number | null | undefined): Observable<IStockLog[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetCloudLogs?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (idPays !== undefined && idPays !== null)
            url_ += "idPays=" + encodeURIComponent("" + idPays) + "&";
        if (idLangue !== undefined && idLangue !== null)
            url_ += "idLangue=" + encodeURIComponent("" + idLangue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCloudLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCloudLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IStockLog[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IStockLog[]>;
        }));
    }

    protected processGetCloudLogs(response: HttpResponseBase): Observable<IStockLog[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IStockLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableTechnologies(): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAvailableTechnologies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableTechnologies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableTechnologies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAvailableTechnologies(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    redirectCloudFile(user: string | null | undefined, idLine: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/RedirectCloudFile?";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (idLine === null)
            throw new Error("The parameter 'idLine' cannot be null.");
        else if (idLine !== undefined)
            url_ += "idLine=" + encodeURIComponent("" + idLine) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectCloudFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectCloudFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRedirectCloudFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    redirectCloudFileNoLineFound(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/RedirectCloudFileNoLineFound";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectCloudFileNoLineFound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectCloudFileNoLineFound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRedirectCloudFileNoLineFound(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    redirectCloudFileDisabled(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/RedirectCloudFileDisabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectCloudFileDisabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectCloudFileDisabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRedirectCloudFileDisabled(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPlanningList(language: string | null | undefined): Observable<IPlanningListV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetPlanningList?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanningList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanningList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanningListV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanningListV1[]>;
        }));
    }

    protected processGetPlanningList(response: HttpResponseBase): Observable<IPlanningListV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPlanningListV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWeekDates(week: number | undefined, languagePlanning: string | null | undefined, languageUser: string | null | undefined): Observable<WeekDates> {
        let url_ = this.baseUrl + "/IxellAPI/GetWeekDates?";
        if (week === null)
            throw new Error("The parameter 'week' cannot be null.");
        else if (week !== undefined)
            url_ += "week=" + encodeURIComponent("" + week) + "&";
        if (languagePlanning !== undefined && languagePlanning !== null)
            url_ += "languagePlanning=" + encodeURIComponent("" + languagePlanning) + "&";
        if (languageUser !== undefined && languageUser !== null)
            url_ += "languageUser=" + encodeURIComponent("" + languageUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeekDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeekDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeekDates>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeekDates>;
        }));
    }

    protected processGetWeekDates(response: HttpResponseBase): Observable<WeekDates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeekDates.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPlagesHorairesWebPlanning(language: string | null | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetPlagesHorairesWebPlanning?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlagesHorairesWebPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlagesHorairesWebPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetPlagesHorairesWebPlanning(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreneauxWebPlanning(duration: number | undefined, language: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined, startDateMin: Date | undefined): Observable<ICreneauxPlanning[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetCreneauxWebPlanning?";
        if (duration === null)
            throw new Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (startDateMin === null)
            throw new Error("The parameter 'startDateMin' cannot be null.");
        else if (startDateMin !== undefined)
            url_ += "startDateMin=" + encodeURIComponent(startDateMin ? "" + startDateMin.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreneauxWebPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreneauxWebPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICreneauxPlanning[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICreneauxPlanning[]>;
        }));
    }

    protected processGetCreneauxWebPlanning(response: HttpResponseBase): Observable<ICreneauxPlanning[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICreneauxPlanning.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInterventionList(language: string | null | undefined): Observable<IPlanningInterventionLightV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetInterventionList?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInterventionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInterventionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanningInterventionLightV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanningInterventionLightV1[]>;
        }));
    }

    protected processGetInterventionList(response: HttpResponseBase): Observable<IPlanningInterventionLightV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPlanningInterventionLightV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientsByCountryAndPostalCodePlanning(country: string | null | undefined, postalCode: string | null | undefined): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetClientsByCountryAndPostalCodePlanning?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsByCountryAndPostalCodePlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsByCountryAndPostalCodePlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetClientsByCountryAndPostalCodePlanning(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyRDVAvailable(rdv: ICreneauxPlanning, duration: number | undefined, language: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined, startDateMin: Date | undefined, token: string | null | undefined): Observable<ICreneauxPlanning> {
        let url_ = this.baseUrl + "/IxellAPI/VerifyRDVAvailable?";
        if (duration === null)
            throw new Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (startDateMin === null)
            throw new Error("The parameter 'startDateMin' cannot be null.");
        else if (startDateMin !== undefined)
            url_ += "startDateMin=" + encodeURIComponent(startDateMin ? "" + startDateMin.toISOString() : "") + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rdv);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyRDVAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyRDVAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICreneauxPlanning>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICreneauxPlanning>;
        }));
    }

    protected processVerifyRDVAvailable(response: HttpResponseBase): Observable<ICreneauxPlanning> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ICreneauxPlanning.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRdvWebPlanning(rdv: IPlanningRdvV1): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/AddRdvWebPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rdv);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRdvWebPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRdvWebPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddRdvWebPlanning(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertRDVPlanning(rdv: IPlanningRdvV1): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/InsertRDVPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rdv);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertRDVPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertRDVPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processInsertRDVPlanning(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerRDV(rdv: IPlanningRdvV1): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/RegisterRDV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rdv);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterRDV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterRDV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRegisterRDV(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    allHistory(language: string | null | undefined): Observable<IPlanningHisto[]> {
        let url_ = this.baseUrl + "/IxellAPI/AllHistory?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanningHisto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanningHisto[]>;
        }));
    }

    protected processAllHistory(response: HttpResponseBase): Observable<IPlanningHisto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPlanningHisto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelRDV(rdvID: number | undefined, wpRdvID: number | undefined, language: string | null | undefined, mail: string | null | undefined, country: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/CancelRDV?";
        if (rdvID === null)
            throw new Error("The parameter 'rdvID' cannot be null.");
        else if (rdvID !== undefined)
            url_ += "rdvID=" + encodeURIComponent("" + rdvID) + "&";
        if (wpRdvID === null)
            throw new Error("The parameter 'wpRdvID' cannot be null.");
        else if (wpRdvID !== undefined)
            url_ += "wpRdvID=" + encodeURIComponent("" + wpRdvID) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (mail !== undefined && mail !== null)
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRDV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRDV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelRDV(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelRdvWebPlanning(wpRdvID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/CancelRdvWebPlanning?";
        if (wpRdvID === null)
            throw new Error("The parameter 'wpRdvID' cannot be null.");
        else if (wpRdvID !== undefined)
            url_ += "wpRdvID=" + encodeURIComponent("" + wpRdvID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRdvWebPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRdvWebPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCancelRdvWebPlanning(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getListRDVbyHotliner(): Observable<IPlanningGestionRDV[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetListRDVbyHotliner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListRDVbyHotliner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListRDVbyHotliner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanningGestionRDV[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanningGestionRDV[]>;
        }));
    }

    protected processGetListRDVbyHotliner(response: HttpResponseBase): Observable<IPlanningGestionRDV[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPlanningGestionRDV.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatusRDV(rdvID: number | undefined): Observable<StatusRDV> {
        let url_ = this.baseUrl + "/IxellAPI/GetStatusRDV?";
        if (rdvID === null)
            throw new Error("The parameter 'rdvID' cannot be null.");
        else if (rdvID !== undefined)
            url_ += "rdvID=" + encodeURIComponent("" + rdvID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusRDV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusRDV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusRDV>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusRDV>;
        }));
    }

    protected processGetStatusRDV(response: HttpResponseBase): Observable<StatusRDV> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendConfirmationRDVMail(infos: IPlanningRdvInfos): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SendConfirmationRDVMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationRDVMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationRDVMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendConfirmationRDVMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendCancelRDVMail(infos: IPlanningRdvInfos, language: string | null | undefined, mail: string | null | undefined, country: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SendCancelRDVMail?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (mail !== undefined && mail !== null)
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCancelRDVMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCancelRDVMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendCancelRDVMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHotlinerList(): Observable<IPlanningListV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetHotlinerList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotlinerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotlinerList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IPlanningListV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IPlanningListV1[]>;
        }));
    }

    protected processGetHotlinerList(response: HttpResponseBase): Observable<IPlanningListV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IPlanningListV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeRDV(rdv: IPlanningGestionRDV): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/ChangeRDV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rdv);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeRDV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRDV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeRDV(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRdvWebPlanning(rdv: IPlanningRdvV1): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateRdvWebPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rdv);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRdvWebPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRdvWebPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateRdvWebPlanning(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectErrorLog(startDate: Date): Observable<ErrorLogV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectErrorLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startDate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectErrorLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectErrorLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorLogV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorLogV1[]>;
        }));
    }

    protected processSelectErrorLog(response: HttpResponseBase): Observable<ErrorLogV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErrorLogV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    errorLog(code: string | null | undefined, description: string | null | undefined, parrameters: string | null | undefined): Observable<ErrorLogV1> {
        let url_ = this.baseUrl + "/IxellAPI/ErrorLog?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (parrameters !== undefined && parrameters !== null)
            url_ += "parrameters=" + encodeURIComponent("" + parrameters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processErrorLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processErrorLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorLogV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorLogV1>;
        }));
    }

    protected processErrorLog(response: HttpResponseBase): Observable<ErrorLogV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorLogV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setError(errorCode: string | null | undefined, errorDescription: string | null | undefined, errorParameters: string | null | undefined): Observable<ErrorLogV1> {
        let url_ = this.baseUrl + "/IxellAPI?";
        if (errorCode !== undefined && errorCode !== null)
            url_ += "errorCode=" + encodeURIComponent("" + errorCode) + "&";
        if (errorDescription !== undefined && errorDescription !== null)
            url_ += "errorDescription=" + encodeURIComponent("" + errorDescription) + "&";
        if (errorParameters !== undefined && errorParameters !== null)
            url_ += "errorParameters=" + encodeURIComponent("" + errorParameters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorLogV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorLogV1>;
        }));
    }

    protected processSetError(response: HttpResponseBase): Observable<ErrorLogV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorLogV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addUnisiteLogs(id: number | undefined, loginUnisiteUser: string | null | undefined, loginUnisitePayor: string | null | undefined, loginUnisiteCompany: string | null | undefined, loginUnisiteCompanyPayor: string | null | undefined, sageCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/AddUnisiteLogs?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (loginUnisiteUser !== undefined && loginUnisiteUser !== null)
            url_ += "loginUnisiteUser=" + encodeURIComponent("" + loginUnisiteUser) + "&";
        if (loginUnisitePayor !== undefined && loginUnisitePayor !== null)
            url_ += "loginUnisitePayor=" + encodeURIComponent("" + loginUnisitePayor) + "&";
        if (loginUnisiteCompany !== undefined && loginUnisiteCompany !== null)
            url_ += "loginUnisiteCompany=" + encodeURIComponent("" + loginUnisiteCompany) + "&";
        if (loginUnisiteCompanyPayor !== undefined && loginUnisiteCompanyPayor !== null)
            url_ += "loginUnisiteCompanyPayor=" + encodeURIComponent("" + loginUnisiteCompanyPayor) + "&";
        if (sageCode !== undefined && sageCode !== null)
            url_ += "sageCode=" + encodeURIComponent("" + sageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUnisiteLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUnisiteLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddUnisiteLogs(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isCheckedDossier(activationID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/IsCheckedDossier?";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckedDossier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckedDossier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCheckedDossier(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setInvoiceCode(invoiceCode: string | null | undefined, billingID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SetInvoiceCode?";
        if (invoiceCode !== undefined && invoiceCode !== null)
            url_ += "invoiceCode=" + encodeURIComponent("" + invoiceCode) + "&";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetInvoiceCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetInvoiceCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetInvoiceCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSageCode(sageCode: string | null | undefined, activationID: number | undefined, billingID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SetSageCode?";
        if (sageCode !== undefined && sageCode !== null)
            url_ += "sageCode=" + encodeURIComponent("" + sageCode) + "&";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSageCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSageCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetSageCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSleepyActivation(activationID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SetSleepyActivation?";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSleepyActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSleepyActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetSleepyActivation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendEmails(maildata: IMailDataV1): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/SendEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maildata);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendEmails(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeWithoutMail(maildata: IMailDataV1): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/CompleteWithoutMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(maildata);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteWithoutMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteWithoutMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCompleteWithoutMail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountryPayor(activationId: number | undefined, cU: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/GetCountryPayor?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryPayor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryPayor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetCountryPayor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountry(cU: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetCountry?";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCountry(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPayorMail(activationID: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetPayorMail?";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayorMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayorMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPayorMail(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTva(activationId: number | undefined, cU: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/GetTva?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTva(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTva(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTva(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailCommandByLogin(): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetEmailCommandByLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailCommandByLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailCommandByLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmailCommandByLogin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddressFact(activationId: number | undefined, cU: string | null | undefined): Observable<ICompanyV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetAddressFact?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICompanyV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICompanyV1>;
        }));
    }

    protected processGetAddressFact(response: HttpResponseBase): Observable<ICompanyV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ICompanyV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAddressDeli(activationId: number | undefined, cU: string | null | undefined): Observable<ICompanyV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetAddressDeli?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (cU !== undefined && cU !== null)
            url_ += "CU=" + encodeURIComponent("" + cU) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressDeli(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressDeli(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICompanyV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICompanyV1>;
        }));
    }

    protected processGetAddressDeli(response: HttpResponseBase): Observable<ICompanyV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ICompanyV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acceptPayment(billingID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/AcceptPayment?";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAcceptPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateActivationCode(): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GenerateActivationCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateActivationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateActivationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateActivationCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmPaymentPayzen(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/ConfirmPaymentPayzen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPaymentPayzen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPaymentPayzen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPaymentPayzen(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCtxMode(): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/GetCtxMode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCtxMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCtxMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetCtxMode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProduct(idProd: number | undefined): Observable<IProductV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetProduct?";
        if (idProd === null)
            throw new Error("The parameter 'idProd' cannot be null.");
        else if (idProd !== undefined)
            url_ += "idProd=" + encodeURIComponent("" + idProd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IProductV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IProductV1>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<IProductV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IProductV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addProduct(product: IProductV1): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/AddProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddProduct(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProduct(productId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteProduct?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteProduct(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editProduct(product: IProductV1): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/EditProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditProduct(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editDispoProduct(idProd: number | undefined, dispo: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/EditDispoProduct?";
        if (idProd === null)
            throw new Error("The parameter 'idProd' cannot be null.");
        else if (idProd !== undefined)
            url_ += "idProd=" + encodeURIComponent("" + idProd) + "&";
        if (dispo === null)
            throw new Error("The parameter 'dispo' cannot be null.");
        else if (dispo !== undefined)
            url_ += "dispo=" + encodeURIComponent("" + dispo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDispoProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDispoProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditDispoProduct(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editRentableProduct(idProd: number | undefined, rentable: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/EditRentableProduct?";
        if (idProd === null)
            throw new Error("The parameter 'idProd' cannot be null.");
        else if (idProd !== undefined)
            url_ += "idProd=" + encodeURIComponent("" + idProd) + "&";
        if (rentable === null)
            throw new Error("The parameter 'rentable' cannot be null.");
        else if (rentable !== undefined)
            url_ += "rentable=" + encodeURIComponent("" + rentable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditRentableProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditRentableProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditRentableProduct(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editRentableFraisLiv(idProd: number | undefined, rentable: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/EditRentableFraisLiv?";
        if (idProd === null)
            throw new Error("The parameter 'idProd' cannot be null.");
        else if (idProd !== undefined)
            url_ += "idProd=" + encodeURIComponent("" + idProd) + "&";
        if (rentable === null)
            throw new Error("The parameter 'rentable' cannot be null.");
        else if (rentable !== undefined)
            url_ += "rentable=" + encodeURIComponent("" + rentable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditRentableFraisLiv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditRentableFraisLiv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditRentableFraisLiv(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBankInfo(): Observable<BankInfoV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetBankInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankInfoV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankInfoV1>;
        }));
    }

    protected processGetBankInfo(response: HttpResponseBase): Observable<BankInfoV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankInfoV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCtcPhone(phone: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateCtcPhone?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCtcPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCtcPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCtcPhone(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validationCommande(activationID: number | undefined, activationDate: Date | undefined, isCB: boolean | undefined, billingID: number | undefined, noMail: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/ValidationCommande?";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        if (activationDate === null)
            throw new Error("The parameter 'activationDate' cannot be null.");
        else if (activationDate !== undefined)
            url_ += "activationDate=" + encodeURIComponent(activationDate ? "" + activationDate.toISOString() : "") + "&";
        if (isCB === null)
            throw new Error("The parameter 'isCB' cannot be null.");
        else if (isCB !== undefined)
            url_ += "isCB=" + encodeURIComponent("" + isCB) + "&";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        if (noMail === null)
            throw new Error("The parameter 'noMail' cannot be null.");
        else if (noMail !== undefined)
            url_ += "noMail=" + encodeURIComponent("" + noMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidationCommande(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidationCommande(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processValidationCommande(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addNewScale(data: ElectroniqueMaintenance): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/AddNewScale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewScale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewScale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddNewScale(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActivationCode(data: ElectroniqueMaintenance): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetActivationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetActivationCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    switchScale(data: ElectroniqueMaintenance): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SwitchScale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchScale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchScale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSwitchScale(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLibelleTeinte(vIN: string | null | undefined): Observable<Message> {
        let url_ = this.baseUrl + "/IxellAPI/GetLibelleTeinte?";
        if (vIN !== undefined && vIN !== null)
            url_ += "VIN=" + encodeURIComponent("" + vIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLibelleTeinte(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLibelleTeinte(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Message>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Message>;
        }));
    }

    protected processGetLibelleTeinte(response: HttpResponseBase): Observable<Message> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Message.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkMAJBalance(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/IxellAPI/CheckMAJBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMAJBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMAJBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processCheckMAJBalance(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertRentingFormGlobal(renting: IRentingV1, isUpdateCtcPhone: boolean | undefined, status: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/InsertRentingFormGlobal?";
        if (isUpdateCtcPhone === null)
            throw new Error("The parameter 'isUpdateCtcPhone' cannot be null.");
        else if (isUpdateCtcPhone !== undefined)
            url_ += "isUpdateCtcPhone=" + encodeURIComponent("" + isUpdateCtcPhone) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(renting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertRentingFormGlobal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertRentingFormGlobal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processInsertRentingFormGlobal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertRentingForm(renting: IRentingV1, isUpdateCtcPhone: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/InsertRentingForm?";
        if (isUpdateCtcPhone === null)
            throw new Error("The parameter 'isUpdateCtcPhone' cannot be null.");
        else if (isUpdateCtcPhone !== undefined)
            url_ += "isUpdateCtcPhone=" + encodeURIComponent("" + isUpdateCtcPhone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(renting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertRentingForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertRentingForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processInsertRentingForm(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertRentingOrder(order: IRentingOrderV1[], idrenting: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/InsertRentingOrder?";
        if (idrenting === null)
            throw new Error("The parameter 'idrenting' cannot be null.");
        else if (idrenting !== undefined)
            url_ += "idrenting=" + encodeURIComponent("" + idrenting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(order);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertRentingOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertRentingOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertRentingOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendRentingMail(rentingid: number | undefined, status: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SendRentingMail?";
        if (rentingid === null)
            throw new Error("The parameter 'rentingid' cannot be null.");
        else if (rentingid !== undefined)
            url_ += "rentingid=" + encodeURIComponent("" + rentingid) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRentingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRentingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendRentingMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCtcInfos(): Observable<ICtcV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetCtcInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCtcInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCtcInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1>;
        }));
    }

    protected processGetCtcInfos(response: HttpResponseBase): Observable<ICtcV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ICtcV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadExcel(rentingid: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/DownloadExcel?";
        if (rentingid === null)
            throw new Error("The parameter 'rentingid' cannot be null.");
        else if (rentingid !== undefined)
            url_ += "rentingid=" + encodeURIComponent("" + rentingid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectAllRenting(): Observable<IRentingLight[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectAllRenting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectAllRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectAllRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRentingLight[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRentingLight[]>;
        }));
    }

    protected processSelectAllRenting(response: HttpResponseBase): Observable<IRentingLight[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IRentingLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    haveOrder(rentingid: number | undefined): Observable<IRentingLight[]> {
        let url_ = this.baseUrl + "/IxellAPI/HaveOrder?";
        if (rentingid === null)
            throw new Error("The parameter 'rentingid' cannot be null.");
        else if (rentingid !== undefined)
            url_ += "rentingid=" + encodeURIComponent("" + rentingid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHaveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHaveOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRentingLight[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRentingLight[]>;
        }));
    }

    protected processHaveOrder(response: HttpResponseBase): Observable<IRentingLight[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IRentingLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectRentingInfo(id: number | undefined): Observable<IRentingInfo[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectRentingInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectRentingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectRentingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRentingInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRentingInfo[]>;
        }));
    }

    protected processSelectRentingInfo(response: HttpResponseBase): Observable<IRentingInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IRentingInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRentingInfo(patch: IRentingPatch): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateRentingInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRentingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRentingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRentingInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectCTForRenting(id: number | undefined): Observable<ICtcV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectCTForRenting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectCTForRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectCTForRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1[]>;
        }));
    }

    protected processSelectCTForRenting(response: HttpResponseBase): Observable<ICtcV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICtcV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addInfosRenting(rentingID: number | undefined, companyID: number | undefined, companyUnisiteCode: string | null | undefined, sageCode: string | null | undefined, bank: number | undefined, invoiceCode: string | null | undefined, renewal: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/AddInfosRenting?";
        if (rentingID === null)
            throw new Error("The parameter 'rentingID' cannot be null.");
        else if (rentingID !== undefined)
            url_ += "rentingID=" + encodeURIComponent("" + rentingID) + "&";
        if (companyID === null)
            throw new Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        if (companyUnisiteCode !== undefined && companyUnisiteCode !== null)
            url_ += "companyUnisiteCode=" + encodeURIComponent("" + companyUnisiteCode) + "&";
        if (sageCode !== undefined && sageCode !== null)
            url_ += "sageCode=" + encodeURIComponent("" + sageCode) + "&";
        if (bank === null)
            throw new Error("The parameter 'bank' cannot be null.");
        else if (bank !== undefined)
            url_ += "bank=" + encodeURIComponent("" + bank) + "&";
        if (invoiceCode !== undefined && invoiceCode !== null)
            url_ += "invoiceCode=" + encodeURIComponent("" + invoiceCode) + "&";
        if (renewal !== undefined && renewal !== null)
            url_ += "renewal=" + encodeURIComponent("" + renewal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInfosRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInfosRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddInfosRenting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatusRenting(rentingID: number | undefined, status: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateStatusRenting?";
        if (rentingID === null)
            throw new Error("The parameter 'rentingID' cannot be null.");
        else if (rentingID !== undefined)
            url_ += "rentingID=" + encodeURIComponent("" + rentingID) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateStatusRenting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendValidationRentingMail(ctcMail: string | null | undefined, ctcLanguage: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SendValidationRentingMail?";
        if (ctcMail !== undefined && ctcMail !== null)
            url_ += "ctcMail=" + encodeURIComponent("" + ctcMail) + "&";
        if (ctcLanguage !== undefined && ctcLanguage !== null)
            url_ += "ctcLanguage=" + encodeURIComponent("" + ctcLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendValidationRentingMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendValidationRentingMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendValidationRentingMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectOrderLightById(rentingID: number | undefined, language: string | null | undefined): Observable<OrderLight[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectOrderLightById?";
        if (rentingID === null)
            throw new Error("The parameter 'rentingID' cannot be null.");
        else if (rentingID !== undefined)
            url_ += "rentingID=" + encodeURIComponent("" + rentingID) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectOrderLightById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectOrderLightById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderLight[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderLight[]>;
        }));
    }

    protected processSelectOrderLightById(response: HttpResponseBase): Observable<OrderLight[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectRentableProductsLight(language: string | null | undefined): Observable<OrderLight[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectRentableProductsLight?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectRentableProductsLight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectRentableProductsLight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderLight[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderLight[]>;
        }));
    }

    protected processSelectRentableProductsLight(response: HttpResponseBase): Observable<OrderLight[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isCheckedRenting(rentingID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/IsCheckedRenting?";
        if (rentingID === null)
            throw new Error("The parameter 'rentingID' cannot be null.");
        else if (rentingID !== undefined)
            url_ += "rentingID=" + encodeURIComponent("" + rentingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCheckedRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCheckedRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCheckedRenting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ctcRenting(): Observable<IRentingInfo[]> {
        let url_ = this.baseUrl + "/IxellAPI/CtcRenting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCtcRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCtcRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IRentingInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IRentingInfo[]>;
        }));
    }

    protected processCtcRenting(response: HttpResponseBase): Observable<IRentingInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IRentingInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertAssistance(assistance: IAssistanceV1, language: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/InsertAssistance?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assistance);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processInsertAssistance(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendAssistanceMail(infos: IAssistanceLight, mail: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SendAssistanceMail?";
        if (mail !== undefined && mail !== null)
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAssistanceMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAssistanceMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendAssistanceMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserInfos(): Observable<IUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetUserInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IUserV1>;
        }));
    }

    protected processGetUserInfos(response: HttpResponseBase): Observable<IUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    allBreakdownFiles(): Observable<IBreakdownFileV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/action";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllBreakdownFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllBreakdownFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IBreakdownFileV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IBreakdownFileV1[]>;
        }));
    }

    protected processAllBreakdownFiles(response: HttpResponseBase): Observable<IBreakdownFileV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IBreakdownFileV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    filteredBreakdownFiles(interval: BreakdownInterval): Observable<IBreakdownFileV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interval);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilteredBreakdownFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilteredBreakdownFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IBreakdownFileV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IBreakdownFileV1[]>;
        }));
    }

    protected processFilteredBreakdownFiles(response: HttpResponseBase): Observable<IBreakdownFileV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IBreakdownFileV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addBreakdownFile(bdFile: IBreakdownFileV1): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/AddBreakdownFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bdFile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBreakdownFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBreakdownFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddBreakdownFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBreakdownFile(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteBreakdownFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBreakdownFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBreakdownFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteBreakdownFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editBreakdownFile(bdFile: IBreakdownFileV1): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/EditBreakdownFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bdFile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBreakdownFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBreakdownFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEditBreakdownFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    breakdownFile(id: number | undefined): Observable<IBreakdownFileV1> {
        let url_ = this.baseUrl + "/IxellAPI/BreakdownFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBreakdownFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBreakdownFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IBreakdownFileV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IBreakdownFileV1>;
        }));
    }

    protected processBreakdownFile(response: HttpResponseBase): Observable<IBreakdownFileV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IBreakdownFileV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDateImportationBalances(): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetDateImportationBalances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDateImportationBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDateImportationBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDateImportationBalances(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScalesVersion(): Observable<CountryScaleStats[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetScalesVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScalesVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScalesVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryScaleStats[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryScaleStats[]>;
        }));
    }

    protected processGetScalesVersion(response: HttpResponseBase): Observable<CountryScaleStats[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryScaleStats.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportScalesVersionDetails(connexion: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/ExportScalesVersionDetails?";
        if (connexion === null)
            throw new Error("The parameter 'connexion' cannot be null.");
        else if (connexion !== undefined)
            url_ += "connexion=" + encodeURIComponent("" + connexion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportScalesVersionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportScalesVersionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportScalesVersionDetails(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDisconnectedScalesVersion(): Observable<ListeScaleVersion> {
        let url_ = this.baseUrl + "/IxellAPI/GetDisconnectedScalesVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDisconnectedScalesVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDisconnectedScalesVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListeScaleVersion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListeScaleVersion>;
        }));
    }

    protected processGetDisconnectedScalesVersion(response: HttpResponseBase): Observable<ListeScaleVersion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListeScaleVersion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDisconnectedTempScalesVersion(): Observable<ListeScaleVersion> {
        let url_ = this.baseUrl + "/IxellAPI/GetDisconnectedTempScalesVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDisconnectedTempScalesVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDisconnectedTempScalesVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListeScaleVersion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListeScaleVersion>;
        }));
    }

    protected processGetDisconnectedTempScalesVersion(response: HttpResponseBase): Observable<ListeScaleVersion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListeScaleVersion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConnectedScalesVersion(): Observable<ListeScaleVersion> {
        let url_ = this.baseUrl + "/IxellAPI/GetConnectedScalesVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectedScalesVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectedScalesVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListeScaleVersion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListeScaleVersion>;
        }));
    }

    protected processGetConnectedScalesVersion(response: HttpResponseBase): Observable<ListeScaleVersion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListeScaleVersion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHorsContratScalesVersion(): Observable<ListeScaleVersion> {
        let url_ = this.baseUrl + "/IxellAPI/GetHorsContratScalesVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHorsContratScalesVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHorsContratScalesVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListeScaleVersion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListeScaleVersion>;
        }));
    }

    protected processGetHorsContratScalesVersion(response: HttpResponseBase): Observable<ListeScaleVersion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListeScaleVersion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportScalesVersion(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/ExportScalesVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportScalesVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportScalesVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportScalesVersion(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatsAssitance(): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetStatsAssitance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatsAssitance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatsAssitance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetStatsAssitance(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScalesAssistance(country: string | null | undefined, postaleCode: string | null | undefined, socialeReason: string | null | undefined, cTC: string | null | undefined, dateStart: Date | null | undefined, dateEnd: Date | null | undefined): Observable<ListeScaleAssistance> {
        let url_ = this.baseUrl + "/IxellAPI/GetScalesAssistance?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (postaleCode !== undefined && postaleCode !== null)
            url_ += "postaleCode=" + encodeURIComponent("" + postaleCode) + "&";
        if (socialeReason !== undefined && socialeReason !== null)
            url_ += "socialeReason=" + encodeURIComponent("" + socialeReason) + "&";
        if (cTC !== undefined && cTC !== null)
            url_ += "CTC=" + encodeURIComponent("" + cTC) + "&";
        if (dateStart !== undefined && dateStart !== null)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd !== undefined && dateEnd !== null)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScalesAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScalesAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListeScaleAssistance>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListeScaleAssistance>;
        }));
    }

    protected processGetScalesAssistance(response: HttpResponseBase): Observable<ListeScaleAssistance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListeScaleAssistance.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportScalesAssistance(country: string | null | undefined, postaleCode: string | null | undefined, socialeReason: string | null | undefined, cTC: string | null | undefined, dateStart: Date | undefined, dateEnd: Date | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/ExportScalesAssistance?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (postaleCode !== undefined && postaleCode !== null)
            url_ += "postaleCode=" + encodeURIComponent("" + postaleCode) + "&";
        if (socialeReason !== undefined && socialeReason !== null)
            url_ += "socialeReason=" + encodeURIComponent("" + socialeReason) + "&";
        if (cTC !== undefined && cTC !== null)
            url_ += "CTC=" + encodeURIComponent("" + cTC) + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "dateStart=" + encodeURIComponent(dateStart ? "" + dateStart.toISOString() : "") + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "dateEnd=" + encodeURIComponent(dateEnd ? "" + dateEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportScalesAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportScalesAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportScalesAssistance(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsLogVisit(path: string | null | undefined, screen: ISize): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsLogVisit?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(screen);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsLogVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsLogVisit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsLogVisit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsLogFeature(name: StatsFeatureType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsLogFeature?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsLogFeature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsLogFeature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsLogFeature(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsLogCBGamme(gamme: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsLogCBGamme?";
        if (gamme !== undefined && gamme !== null)
            url_ += "gamme=" + encodeURIComponent("" + gamme) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsLogCBGamme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsLogCBGamme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsLogCBGamme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsLogCBSerie(serie: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsLogCBSerie?";
        if (serie !== undefined && serie !== null)
            url_ += "serie=" + encodeURIComponent("" + serie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsLogCBSerie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsLogCBSerie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsLogCBSerie(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsLogCBLibelle(libelle: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsLogCBLibelle?";
        if (libelle !== undefined && libelle !== null)
            url_ += "libelle=" + encodeURIComponent("" + libelle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsLogCBLibelle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsLogCBLibelle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsLogCBLibelle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsLogCBCategorie(categorie: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsLogCBCategorie?";
        if (categorie !== undefined && categorie !== null)
            url_ += "categorie=" + encodeURIComponent("" + categorie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsLogCBCategorie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsLogCBCategorie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsLogCBCategorie(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsLogCWTFormule(formule: string | null | undefined, technologie: string | null | undefined, layer: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsLogCWTFormule?";
        if (formule !== undefined && formule !== null)
            url_ += "formule=" + encodeURIComponent("" + formule) + "&";
        if (technologie !== undefined && technologie !== null)
            url_ += "technologie=" + encodeURIComponent("" + technologie) + "&";
        if (layer !== undefined && layer !== null)
            url_ += "layer=" + encodeURIComponent("" + layer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsLogCWTFormule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsLogCWTFormule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsLogCWTFormule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetKeyfactors(period: StatsPrefsPeriod | undefined, language: string | null | undefined): Observable<StatsKeyfactorInfo[]> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetKeyfactors?";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetKeyfactors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetKeyfactors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsKeyfactorInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsKeyfactorInfo[]>;
        }));
    }

    protected processStatsGetKeyfactors(response: HttpResponseBase): Observable<StatsKeyfactorInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatsKeyfactorInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsGetKFPeriod(): Observable<StatsPrefsPeriod> {
        let url_ = this.baseUrl + "/IxellAPI/StatsGetKFPeriod";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsGetKFPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsGetKFPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsPrefsPeriod>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsPrefsPeriod>;
        }));
    }

    protected processStatsGetKFPeriod(response: HttpResponseBase): Observable<StatsPrefsPeriod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    statsSetKFPeriod(period: StatsPrefsPeriod | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/StatsSetKFPeriod?";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatsSetKFPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatsSetKFPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatsSetKFPeriod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importScaleVersion(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/ImportScaleVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportScaleVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportScaleVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportScaleVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectAllRtMail(): Observable<ValidationMail[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectAllRtMail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectAllRtMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectAllRtMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidationMail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidationMail[]>;
        }));
    }

    protected processSelectAllRtMail(response: HttpResponseBase): Observable<ValidationMail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValidationMail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRtMail(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteRtMail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRtMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRtMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteRtMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    modifyRt(data: ValidationMail): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ModifyRt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifyRt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifyRt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processModifyRt(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRt(data: ValidationMail): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/AddRt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddRt(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllActivations(): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAllActivations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActivations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActivations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetAllActivations(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompleteHistory(limit: number | undefined, offset: number | undefined): Observable<ICompleteHistoryV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetCompleteHistory?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompleteHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompleteHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICompleteHistoryV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICompleteHistoryV1>;
        }));
    }

    protected processGetCompleteHistory(response: HttpResponseBase): Observable<ICompleteHistoryV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ICompleteHistoryV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientsByCountryAndPostalCode(country: string | null | undefined, postalCode: string | null | undefined, planning: boolean | undefined, register: boolean | undefined, annuaireIxell: boolean | undefined): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetClientsByCountryAndPostalCode?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (planning === null)
            throw new Error("The parameter 'planning' cannot be null.");
        else if (planning !== undefined)
            url_ += "planning=" + encodeURIComponent("" + planning) + "&";
        if (register === null)
            throw new Error("The parameter 'register' cannot be null.");
        else if (register !== undefined)
            url_ += "register=" + encodeURIComponent("" + register) + "&";
        if (annuaireIxell === null)
            throw new Error("The parameter 'annuaireIxell' cannot be null.");
        else if (annuaireIxell !== undefined)
            url_ += "annuaireIxell=" + encodeURIComponent("" + annuaireIxell) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsByCountryAndPostalCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsByCountryAndPostalCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetClientsByCountryAndPostalCode(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientsByCountryAndPostalCodeAndIdCTC(country: string | null | undefined, postalCode: string | null | undefined, idCtc: number | undefined, annuaireIxell: boolean | undefined): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetClientsByCountryAndPostalCodeAndIdCTC?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (idCtc === null)
            throw new Error("The parameter 'idCtc' cannot be null.");
        else if (idCtc !== undefined)
            url_ += "idCtc=" + encodeURIComponent("" + idCtc) + "&";
        if (annuaireIxell === null)
            throw new Error("The parameter 'annuaireIxell' cannot be null.");
        else if (annuaireIxell !== undefined)
            url_ += "annuaireIxell=" + encodeURIComponent("" + annuaireIxell) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsByCountryAndPostalCodeAndIdCTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsByCountryAndPostalCodeAndIdCTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetClientsByCountryAndPostalCodeAndIdCTC(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientsByCompany(listMail: string | null | undefined): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/getClientsByCompany?";
        if (listMail !== undefined && listMail !== null)
            url_ += "listMail=" + encodeURIComponent("" + listMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientsByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientsByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetClientsByCompany(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectClientsById(idColorUser: number | undefined): Observable<IColorUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/SelectClientsById?";
        if (idColorUser === null)
            throw new Error("The parameter 'idColorUser' cannot be null.");
        else if (idColorUser !== undefined)
            url_ += "idColorUser=" + encodeURIComponent("" + idColorUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectClientsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectClientsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1>;
        }));
    }

    protected processSelectClientsById(response: HttpResponseBase): Observable<IColorUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDateMail(idCustomer: number | undefined, fromComponent: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteDateMail?";
        if (idCustomer === null)
            throw new Error("The parameter 'idCustomer' cannot be null.");
        else if (idCustomer !== undefined)
            url_ += "idCustomer=" + encodeURIComponent("" + idCustomer) + "&";
        if (fromComponent !== undefined && fromComponent !== null)
            url_ += "fromComponent=" + encodeURIComponent("" + fromComponent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDateMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDateMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteDateMail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hiddeCustomer(idCustomer: number | undefined, fromComponent: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/HiddeCustomer?";
        if (idCustomer === null)
            throw new Error("The parameter 'idCustomer' cannot be null.");
        else if (idCustomer !== undefined)
            url_ += "idCustomer=" + encodeURIComponent("" + idCustomer) + "&";
        if (fromComponent !== undefined && fromComponent !== null)
            url_ += "fromComponent=" + encodeURIComponent("" + fromComponent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHiddeCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHiddeCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHiddeCustomer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkMail(email: string | null | undefined, colorUserID: number | undefined): Observable<IColorUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/CheckMail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (colorUserID === null)
            throw new Error("The parameter 'colorUserID' cannot be null.");
        else if (colorUserID !== undefined)
            url_ += "colorUserID=" + encodeURIComponent("" + colorUserID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1>;
        }));
    }

    protected processCheckMail(response: HttpResponseBase): Observable<IColorUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkMailEdit(email: string | null | undefined, colorUserID: number | undefined, mailEmergency: string | null | undefined, idColoruserEmergency: number | undefined): Observable<IColorUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/CheckMailEdit?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (colorUserID === null)
            throw new Error("The parameter 'colorUserID' cannot be null.");
        else if (colorUserID !== undefined)
            url_ += "colorUserID=" + encodeURIComponent("" + colorUserID) + "&";
        if (mailEmergency !== undefined && mailEmergency !== null)
            url_ += "mailEmergency=" + encodeURIComponent("" + mailEmergency) + "&";
        if (idColoruserEmergency === null)
            throw new Error("The parameter 'idColoruserEmergency' cannot be null.");
        else if (idColoruserEmergency !== undefined)
            url_ += "idColoruserEmergency=" + encodeURIComponent("" + idColoruserEmergency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMailEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMailEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1>;
        }));
    }

    protected processCheckMailEdit(response: HttpResponseBase): Observable<IColorUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveEditCompanyColorUser(user: IColorUserV1, fromComponent: string | null | undefined, log: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SaveEditCompanyColorUser?";
        if (fromComponent !== undefined && fromComponent !== null)
            url_ += "fromComponent=" + encodeURIComponent("" + fromComponent) + "&";
        if (log === null)
            throw new Error("The parameter 'log' cannot be null.");
        else if (log !== undefined)
            url_ += "log=" + encodeURIComponent("" + log) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEditCompanyColorUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEditCompanyColorUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveEditCompanyColorUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveColorUser(user: IColorUserV1, newCustomer: boolean | undefined, type: string | null | undefined, fromComponent: string | null | undefined, log: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SaveColorUser?";
        if (newCustomer === null)
            throw new Error("The parameter 'newCustomer' cannot be null.");
        else if (newCustomer !== undefined)
            url_ += "newCustomer=" + encodeURIComponent("" + newCustomer) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (fromComponent !== undefined && fromComponent !== null)
            url_ += "fromComponent=" + encodeURIComponent("" + fromComponent) + "&";
        if (log === null)
            throw new Error("The parameter 'log' cannot be null.");
        else if (log !== undefined)
            url_ += "log=" + encodeURIComponent("" + log) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveColorUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveColorUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveColorUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveColorUserAndSendID(user: IColorUserV1, newCustomer: boolean | undefined, type: string | null | undefined, fromComponent: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SaveColorUserAndSendID?";
        if (newCustomer === null)
            throw new Error("The parameter 'newCustomer' cannot be null.");
        else if (newCustomer !== undefined)
            url_ += "newCustomer=" + encodeURIComponent("" + newCustomer) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (fromComponent !== undefined && fromComponent !== null)
            url_ += "fromComponent=" + encodeURIComponent("" + fromComponent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveColorUserAndSendID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveColorUserAndSendID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveColorUserAndSendID(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveColorUserEmergency(user: IColorUserV1, fromComponent: string | null | undefined, log: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SaveColorUserEmergency?";
        if (fromComponent !== undefined && fromComponent !== null)
            url_ += "fromComponent=" + encodeURIComponent("" + fromComponent) + "&";
        if (log === null)
            throw new Error("The parameter 'log' cannot be null.");
        else if (log !== undefined)
            url_ += "log=" + encodeURIComponent("" + log) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveColorUserEmergency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveColorUserEmergency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveColorUserEmergency(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveColorUserEmergencyAndSendID(user: IColorUserV1, type: string | null | undefined, fromComponent: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SaveColorUserEmergencyAndSendID?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (fromComponent !== undefined && fromComponent !== null)
            url_ += "fromComponent=" + encodeURIComponent("" + fromComponent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveColorUserEmergencyAndSendID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveColorUserEmergencyAndSendID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveColorUserEmergencyAndSendID(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorUserByCtcID(): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorUserByCtcID";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorUserByCtcID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorUserByCtcID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetColorUserByCtcID(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorUserByCountryAndCTC(country: string | null | undefined, ctcID: number | undefined, dr: string | null | undefined): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorUserByCountryAndCTC?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (ctcID === null)
            throw new Error("The parameter 'ctcID' cannot be null.");
        else if (ctcID !== undefined)
            url_ += "ctcID=" + encodeURIComponent("" + ctcID) + "&";
        if (dr !== undefined && dr !== null)
            url_ += "dr=" + encodeURIComponent("" + dr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorUserByCountryAndCTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorUserByCountryAndCTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetColorUserByCountryAndCTC(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorUserByCountry(country: string | null | undefined, dr: string | null | undefined): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorUserByCountry?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (dr !== undefined && dr !== null)
            url_ += "dr=" + encodeURIComponent("" + dr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorUserByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorUserByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetColorUserByCountry(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorUserbyID(id: number | undefined): Observable<IColorUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorUserbyID?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorUserbyID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorUserbyID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1>;
        }));
    }

    protected processGetColorUserbyID(response: HttpResponseBase): Observable<IColorUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateColorUser(user: IColorUserV1, id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateColorUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateColorUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateColorUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateColorUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorUsersbyStatusAdmin(status: number | undefined): Observable<IColorUserAdminV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorUsersbyStatusAdmin?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorUsersbyStatusAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorUsersbyStatusAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserAdminV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserAdminV1[]>;
        }));
    }

    protected processGetColorUsersbyStatusAdmin(response: HttpResponseBase): Observable<IColorUserAdminV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserAdminV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateColorUserUnisiteCodeAndStatusByAdmin(idcoloruser: number | undefined, unisiteCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateColorUserUnisiteCodeAndStatusByAdmin?";
        if (idcoloruser === null)
            throw new Error("The parameter 'idcoloruser' cannot be null.");
        else if (idcoloruser !== undefined)
            url_ += "idcoloruser=" + encodeURIComponent("" + idcoloruser) + "&";
        if (unisiteCode !== undefined && unisiteCode !== null)
            url_ += "unisiteCode=" + encodeURIComponent("" + unisiteCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateColorUserUnisiteCodeAndStatusByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateColorUserUnisiteCodeAndStatusByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateColorUserUnisiteCodeAndStatusByAdmin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorUserAdminHistoById(id: number | undefined): Observable<LogV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorUserAdminHistoById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorUserAdminHistoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorUserAdminHistoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogV1[]>;
        }));
    }

    protected processGetColorUserAdminHistoById(response: HttpResponseBase): Observable<LogV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSimilarColorUserAdmin(user: IColorUserAdminV1): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetSimilarColorUserAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimilarColorUserAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimilarColorUserAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetSimilarColorUserAdmin(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSimilarCompany(country: string | null | undefined, postalCode: string | null | undefined, city: string | null | undefined): Observable<ICompanyColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetSimilarCompany?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimilarCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimilarCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICompanyColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICompanyColorUserV1[]>;
        }));
    }

    protected processGetSimilarCompany(response: HttpResponseBase): Observable<ICompanyColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICompanyColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getListUsersById(listID: string | null | undefined): Observable<IColorUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetListUsersById?";
        if (listID !== undefined && listID !== null)
            url_ += "listID=" + encodeURIComponent("" + listID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListUsersById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListUsersById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1[]>;
        }));
    }

    protected processGetListUsersById(response: HttpResponseBase): Observable<IColorUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IColorUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkDocumentUserConnected(): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/CheckDocumentUserConnected";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDocumentUserConnected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDocumentUserConnected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDocumentUserConnected(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setCheckDocumentUserConnected(isChecked: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/SetCheckDocumentUserConnected?";
        if (isChecked === null)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else if (isChecked !== undefined)
            url_ += "isChecked=" + encodeURIComponent("" + isChecked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCheckDocumentUserConnected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCheckDocumentUserConnected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCheckDocumentUserConnected(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstCtcByCountry(country: string | null | undefined): Observable<ICtcV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstCtcByCountry?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstCtcByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstCtcByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1[]>;
        }));
    }

    protected processGetLstCtcByCountry(response: HttpResponseBase): Observable<ICtcV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICtcV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstCtcByCountryAndOrDR(country: string | null | undefined, dr: string | null | undefined): Observable<ICtcV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstCtcByCountryAndOrDR?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (dr !== undefined && dr !== null)
            url_ += "dr=" + encodeURIComponent("" + dr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstCtcByCountryAndOrDR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstCtcByCountryAndOrDR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1[]>;
        }));
    }

    protected processGetLstCtcByCountryAndOrDR(response: HttpResponseBase): Observable<ICtcV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICtcV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatCtcByCountry(idCTC: string | null | undefined, country: string | null | undefined, dr: string | null | undefined): Observable<StatsCTC> {
        let url_ = this.baseUrl + "/IxellAPI/GetStatCtcByCountry?";
        if (idCTC !== undefined && idCTC !== null)
            url_ += "idCTC=" + encodeURIComponent("" + idCTC) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (dr !== undefined && dr !== null)
            url_ += "dr=" + encodeURIComponent("" + dr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatCtcByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatCtcByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatsCTC>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatsCTC>;
        }));
    }

    protected processGetStatCtcByCountry(response: HttpResponseBase): Observable<StatsCTC> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatsCTC.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllStatCtcByCountry(country: string | null | undefined, dr: string | null | undefined): Observable<ICtcV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAllStatCtcByCountry?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (dr !== undefined && dr !== null)
            url_ += "dr=" + encodeURIComponent("" + dr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatCtcByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatCtcByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1[]>;
        }));
    }

    protected processGetAllStatCtcByCountry(response: HttpResponseBase): Observable<ICtcV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICtcV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDR(): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetDR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDR(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorUserByMail(mail: string | null | undefined): Observable<IColorUserV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorUserByMail?";
        if (mail !== undefined && mail !== null)
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorUserByMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorUserByMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IColorUserV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IColorUserV1>;
        }));
    }

    protected processGetColorUserByMail(response: HttpResponseBase): Observable<IColorUserV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IColorUserV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setBalanceActivation(activation: IActivationV1): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SetBalanceActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBalanceActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBalanceActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetBalanceActivation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyBalance(scaleNum: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/VerifyBalance?";
        if (scaleNum !== undefined && scaleNum !== null)
            url_ += "scaleNum=" + encodeURIComponent("" + scaleNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyBalance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyRole(actualRole: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/VerifyRole?";
        if (actualRole !== undefined && actualRole !== null)
            url_ += "actualRole=" + encodeURIComponent("" + actualRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyRole(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    allActivationBilling(): Observable<IActivationLight[]> {
        let url_ = this.baseUrl + "/IxellAPI/AllActivationBilling";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllActivationBilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllActivationBilling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IActivationLight[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IActivationLight[]>;
        }));
    }

    protected processAllActivationBilling(response: HttpResponseBase): Observable<IActivationLight[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IActivationLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    allOrders(): Observable<IBillingV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/AllOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IBillingV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IBillingV1[]>;
        }));
    }

    protected processAllOrders(response: HttpResponseBase): Observable<IBillingV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IBillingV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllScaleHistory(): Observable<IScaleHistoryV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAllScaleHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScaleHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScaleHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IScaleHistoryV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IScaleHistoryV1[]>;
        }));
    }

    protected processGetAllScaleHistory(response: HttpResponseBase): Observable<IScaleHistoryV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IScaleHistoryV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePayment(payInfo: PaymentInfo, activationID: number | undefined, idActivationBackupAndStats: number | undefined, idActivationExtendedWarranty: number | undefined): Observable<PaymentInfo> {
        let url_ = this.baseUrl + "/IxellAPI/SavePayment?";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        if (idActivationBackupAndStats === null)
            throw new Error("The parameter 'idActivationBackupAndStats' cannot be null.");
        else if (idActivationBackupAndStats !== undefined)
            url_ += "idActivationBackupAndStats=" + encodeURIComponent("" + idActivationBackupAndStats) + "&";
        if (idActivationExtendedWarranty === null)
            throw new Error("The parameter 'idActivationExtendedWarranty' cannot be null.");
        else if (idActivationExtendedWarranty !== undefined)
            url_ += "idActivationExtendedWarranty=" + encodeURIComponent("" + idActivationExtendedWarranty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentInfo>;
        }));
    }

    protected processSavePayment(response: HttpResponseBase): Observable<PaymentInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setQuoteShippingFees(billingID: number | undefined, fdp: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SetQuoteShippingFees?";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        if (fdp === null)
            throw new Error("The parameter 'fdp' cannot be null.");
        else if (fdp !== undefined)
            url_ += "fdp=" + encodeURIComponent("" + fdp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetQuoteShippingFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetQuoteShippingFees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetQuoteShippingFees(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBillingByLogin(billingID: number | undefined): Observable<IBillingV1> {
        let url_ = this.baseUrl + "/IxellAPI/GetBillingByLogin?";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillingByLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillingByLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IBillingV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IBillingV1>;
        }));
    }

    protected processGetBillingByLogin(response: HttpResponseBase): Observable<IBillingV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IBillingV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNumberOrderByLogin(): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/GetNumberOrderByLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOrderByLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOrderByLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOrderByLogin(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkPayment(billingID: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/CheckPayment?";
        if (billingID !== undefined && billingID !== null)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addLogsPaiment(params: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/AddLogsPaiment?";
        if (params !== undefined && params !== null)
            url_ += "Params=" + encodeURIComponent("" + params) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLogsPaiment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLogsPaiment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLogsPaiment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSignature(params: CryptSignature): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(params);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSignature(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    analyzePaymentResponse(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/AnalyzePaymentResponse";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnalyzePaymentResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnalyzePaymentResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAnalyzePaymentResponse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectProducts(): Observable<IProductV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IProductV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IProductV1[]>;
        }));
    }

    protected processSelectProducts(response: HttpResponseBase): Observable<IProductV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IProductV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectRentingProducts(): Observable<IProductV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectRentingProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectRentingProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectRentingProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IProductV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IProductV1[]>;
        }));
    }

    protected processSelectRentingProducts(response: HttpResponseBase): Observable<IProductV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IProductV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    selectProductsAdmin(): Observable<IProductV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/SelectProductsAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectProductsAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectProductsAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IProductV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IProductV1[]>;
        }));
    }

    protected processSelectProductsAdmin(response: HttpResponseBase): Observable<IProductV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IProductV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activationsLicence(): Observable<ActivationLicenceInfo[]> {
        let url_ = this.baseUrl + "/IxellAPI/ActivationsLicence";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivationsLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivationsLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivationLicenceInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivationLicenceInfo[]>;
        }));
    }

    protected processActivationsLicence(response: HttpResponseBase): Observable<ActivationLicenceInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivationLicenceInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activationsLicenceExtendedWarranty(): Observable<ActivationLicenceInfo[]> {
        let url_ = this.baseUrl + "/IxellAPI/ActivationsLicenceExtendedWarranty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivationsLicenceExtendedWarranty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivationsLicenceExtendedWarranty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivationLicenceInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivationLicenceInfo[]>;
        }));
    }

    protected processActivationsLicenceExtendedWarranty(response: HttpResponseBase): Observable<ActivationLicenceInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivationLicenceInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLicenceDuration(activationId: number | undefined): Observable<Date | null> {
        let url_ = this.baseUrl + "/IxellAPI/GetLicenceDuration?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date | null>;
        }));
    }

    protected processGetLicenceDuration(response: HttpResponseBase): Observable<Date | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    displayBillDetails(billingID: number | undefined): Observable<IAdminBillingV1> {
        let url_ = this.baseUrl + "/IxellAPI/DisplayBillDetails?";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisplayBillDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisplayBillDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IAdminBillingV1>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IAdminBillingV1>;
        }));
    }

    protected processDisplayBillDetails(response: HttpResponseBase): Observable<IAdminBillingV1> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IAdminBillingV1.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    displayHistoryUser(): Observable<IHistoryV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/DisplayHistoryUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisplayHistoryUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisplayHistoryUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IHistoryV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IHistoryV1[]>;
        }));
    }

    protected processDisplayHistoryUser(response: HttpResponseBase): Observable<IHistoryV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IHistoryV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notifySending(billingID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/NotifySending?";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifySending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifySending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processNotifySending(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infoActivation(id: number | undefined, idBilling: number | undefined): Observable<IActivationInfo[]> {
        let url_ = this.baseUrl + "/IxellAPI/InfoActivation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (idBilling === null)
            throw new Error("The parameter 'idBilling' cannot be null.");
        else if (idBilling !== undefined)
            url_ += "idBilling=" + encodeURIComponent("" + idBilling) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfoActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfoActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IActivationInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IActivationInfo[]>;
        }));
    }

    protected processInfoActivation(response: HttpResponseBase): Observable<IActivationInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IActivationInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infoDetailActivation(id: number | undefined): Observable<IScaleFull> {
        let url_ = this.baseUrl + "/IxellAPI/InfoDetailActivation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfoDetailActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfoDetailActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IScaleFull>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IScaleFull>;
        }));
    }

    protected processInfoDetailActivation(response: HttpResponseBase): Observable<IScaleFull> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IScaleFull.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteActivation(activationID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteActivation?";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteActivation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAlternativeCTC(id: number | undefined): Observable<ICtcV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAlternativeCTC?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlternativeCTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlternativeCTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICtcV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICtcV1[]>;
        }));
    }

    protected processGetAlternativeCTC(response: HttpResponseBase): Observable<ICtcV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICtcV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllUsers(): Observable<IUserV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IUserV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IUserV1[]>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<IUserV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IUserV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCompanies(): Observable<ICompanyV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAllCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICompanyV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICompanyV1[]>;
        }));
    }

    protected processGetAllCompanies(response: HttpResponseBase): Observable<ICompanyV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICompanyV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllBalances(): Observable<IScaleV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAllBalances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBalances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBalances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IScaleV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IScaleV1[]>;
        }));
    }

    protected processGetAllBalances(response: HttpResponseBase): Observable<IScaleV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IScaleV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteScaleLicenceDates(scaleID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteScaleLicenceDates?";
        if (scaleID === null)
            throw new Error("The parameter 'scaleID' cannot be null.");
        else if (scaleID !== undefined)
            url_ += "scaleID=" + encodeURIComponent("" + scaleID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScaleLicenceDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScaleLicenceDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteScaleLicenceDates(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeActivationCTC(activationId: number | undefined, ctcId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ChangeActivationCTC?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (ctcId === null)
            throw new Error("The parameter 'ctcId' cannot be null.");
        else if (ctcId !== undefined)
            url_ += "ctcId=" + encodeURIComponent("" + ctcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeActivationCTC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeActivationCTC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeActivationCTC(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeActivationUserFull(activationId: number | undefined, userId: number | undefined, isPayor: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ChangeActivationUserFull?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isPayor === null)
            throw new Error("The parameter 'isPayor' cannot be null.");
        else if (isPayor !== undefined)
            url_ += "isPayor=" + encodeURIComponent("" + isPayor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeActivationUserFull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeActivationUserFull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeActivationUserFull(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeActivationCompanyUserFull(activationId: number | undefined, companyId: number | undefined, isPayor: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ChangeActivationCompanyUserFull?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (isPayor === null)
            throw new Error("The parameter 'isPayor' cannot be null.");
        else if (isPayor !== undefined)
            url_ += "isPayor=" + encodeURIComponent("" + isPayor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeActivationCompanyUserFull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeActivationCompanyUserFull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeActivationCompanyUserFull(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicateActivationUserFull(activationId: number | undefined, isPayor: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DuplicateActivationUserFull?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (isPayor === null)
            throw new Error("The parameter 'isPayor' cannot be null.");
        else if (isPayor !== undefined)
            url_ += "isPayor=" + encodeURIComponent("" + isPayor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateActivationUserFull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateActivationUserFull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDuplicateActivationUserFull(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    duplicateActivationCompanyUserFull(activationId: number | undefined, isPayor: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DuplicateActivationCompanyUserFull?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        if (isPayor === null)
            throw new Error("The parameter 'isPayor' cannot be null.");
        else if (isPayor !== undefined)
            url_ += "isPayor=" + encodeURIComponent("" + isPayor) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateActivationCompanyUserFull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateActivationCompanyUserFull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDuplicateActivationCompanyUserFull(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeActivationSubProp(id: number | undefined, container: string | null | undefined, property: string | null | undefined, newValue: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ChangeActivationSubProp?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (container !== undefined && container !== null)
            url_ += "container=" + encodeURIComponent("" + container) + "&";
        if (property !== undefined && property !== null)
            url_ += "property=" + encodeURIComponent("" + property) + "&";
        if (newValue !== undefined && newValue !== null)
            url_ += "newValue=" + encodeURIComponent("" + newValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeActivationSubProp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeActivationSubProp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeActivationSubProp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendMigrationRequest(balanceId: number | undefined, activationIDs: number[]): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/SendMigrationRequest?";
        if (balanceId === null)
            throw new Error("The parameter 'balanceId' cannot be null.");
        else if (balanceId !== undefined)
            url_ += "balanceId=" + encodeURIComponent("" + balanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activationIDs);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMigrationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMigrationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSendMigrationRequest(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resolveMigrationRequest(migrationId: number | undefined, enteredCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ResolveMigrationRequest?";
        if (migrationId === null)
            throw new Error("The parameter 'migrationId' cannot be null.");
        else if (migrationId !== undefined)
            url_ += "migrationId=" + encodeURIComponent("" + migrationId) + "&";
        if (enteredCode !== undefined && enteredCode !== null)
            url_ += "enteredCode=" + encodeURIComponent("" + enteredCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveMigrationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveMigrationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResolveMigrationRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addBillingToActivation(billing: IBillingV1, noMail: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/AddBillingToActivation?";
        if (noMail === null)
            throw new Error("The parameter 'noMail' cannot be null.");
        else if (noMail !== undefined)
            url_ += "noMail=" + encodeURIComponent("" + noMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(billing);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBillingToActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBillingToActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddBillingToActivation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLogLacourEdit(startDate: Date): Observable<ILogLacourEditV1[][]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLogLacourEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(startDate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogLacourEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogLacourEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ILogLacourEditV1[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ILogLacourEditV1[][]>;
        }));
    }

    protected processGetLogLacourEdit(response: HttpResponseBase): Observable<ILogLacourEditV1[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rewindLogLacourEdit(logLacourEditID: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/IxellAPI/RewindLogLacourEdit?";
        if (logLacourEditID === null)
            throw new Error("The parameter 'logLacourEditID' cannot be null.");
        else if (logLacourEditID !== undefined)
            url_ += "logLacourEditID=" + encodeURIComponent("" + logLacourEditID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRewindLogLacourEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRewindLogLacourEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRewindLogLacourEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBilling(billingID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteBilling?";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBilling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteBilling(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendCodeActivationLicence(activationID: number | undefined, billingID: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/SendCodeActivationLicence?";
        if (activationID === null)
            throw new Error("The parameter 'activationID' cannot be null.");
        else if (activationID !== undefined)
            url_ += "activationID=" + encodeURIComponent("" + activationID) + "&";
        if (billingID === null)
            throw new Error("The parameter 'billingID' cannot be null.");
        else if (billingID !== undefined)
            url_ += "billingID=" + encodeURIComponent("" + billingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCodeActivationLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCodeActivationLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendCodeActivationLicence(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ctcActivation(): Observable<IActivationLight[]> {
        let url_ = this.baseUrl + "/IxellAPI/CtcActivation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCtcActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCtcActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IActivationLight[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IActivationLight[]>;
        }));
    }

    protected processCtcActivation(response: HttpResponseBase): Observable<IActivationLight[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IActivationLight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoles(): Observable<Roles> {
        let url_ = this.baseUrl + "/IxellAPI/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Roles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Roles>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<Roles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getListSitePilote(): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetListSitePilote";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListSitePilote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListSitePilote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetListSitePilote(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    identificationLoginOAuth(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/IdentificationLoginOAuth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIdentificationLoginOAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIdentificationLoginOAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processIdentificationLoginOAuth(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loginOAuth(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/LoginOAuth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginOAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginOAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLoginOAuth(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logInAutoConnexion(loginData: LoginData): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/LogInAutoConnexion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInAutoConnexion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInAutoConnexion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogInAutoConnexion(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAutoConnexion(idCtc: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetAutoConnexion?";
        if (idCtc === null)
            throw new Error("The parameter 'idCtc' cannot be null.");
        else if (idCtc !== undefined)
            url_ += "idCtc=" + encodeURIComponent("" + idCtc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoConnexion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoConnexion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAutoConnexion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAutoConnexionColorUser(idColorUser: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/getAutoConnexionColorUser?";
        if (idColorUser === null)
            throw new Error("The parameter 'idColorUser' cannot be null.");
        else if (idColorUser !== undefined)
            url_ += "idColorUser=" + encodeURIComponent("" + idColorUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoConnexionColorUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoConnexionColorUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAutoConnexionColorUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logInColorBook(loginData: LoginData): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/LogInColorBook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInColorBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInColorBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogInColorBook(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logInDocument(loginData: LoginData): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/IxellAPI/LogInDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogInDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUrlPortailTuto(codeTuto: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetUrlPortailTuto?";
        if (codeTuto !== undefined && codeTuto !== null)
            url_ += "codeTuto=" + encodeURIComponent("" + codeTuto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlPortailTuto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlPortailTuto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlPortailTuto(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccessoriesColorBook(modele_id: number | undefined, manufacturer: string | null | undefined, modele: string | null | undefined): Observable<Accessoire[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAccessoriesColorBook?";
        if (modele_id === null)
            throw new Error("The parameter 'modele_id' cannot be null.");
        else if (modele_id !== undefined)
            url_ += "modele_id=" + encodeURIComponent("" + modele_id) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (modele !== undefined && modele !== null)
            url_ += "modele=" + encodeURIComponent("" + modele) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessoriesColorBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessoriesColorBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Accessoire[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Accessoire[]>;
        }));
    }

    protected processGetAccessoriesColorBook(response: HttpResponseBase): Observable<Accessoire[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Accessoire.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllManufacturers(): Observable<IConstructeurV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetAllManufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllManufacturers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllManufacturers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IConstructeurV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IConstructeurV1[]>;
        }));
    }

    protected processGetAllManufacturers(response: HttpResponseBase): Observable<IConstructeurV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IConstructeurV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModelsByManufacturer(id: number | undefined, manufacturer: string | null | undefined): Observable<IModeleV1[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetModelsByManufacturer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModelsByManufacturer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModelsByManufacturer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IModeleV1[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IModeleV1[]>;
        }));
    }

    protected processGetModelsByManufacturer(response: HttpResponseBase): Observable<IModeleV1[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IModeleV1.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModelColor(modeleID: number | undefined, manufacturer: string | null | undefined): Observable<TeinteCarrosserie[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetModelColor?";
        if (modeleID === null)
            throw new Error("The parameter 'modeleID' cannot be null.");
        else if (modeleID !== undefined)
            url_ += "modeleID=" + encodeURIComponent("" + modeleID) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModelColor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModelColor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TeinteCarrosserie[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TeinteCarrosserie[]>;
        }));
    }

    protected processGetModelColor(response: HttpResponseBase): Observable<TeinteCarrosserie[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeinteCarrosserie.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importTeinteAccessEtJantes(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/ImportTeinteAccessEtJantes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTeinteAccessEtJantes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTeinteAccessEtJantes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportTeinteAccessEtJantes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importAerosols(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/ImportAerosols";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportAerosols(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAerosols(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportAerosols(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importColor(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/ImportColor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportColor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportColor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportColor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getColorGroup(language: string | null | undefined): Observable<ColorGroup[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetColorGroup?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColorGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColorGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ColorGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ColorGroup[]>;
        }));
    }

    protected processGetColorGroup(response: HttpResponseBase): Observable<ColorGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ColorGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplications(language: string | null | undefined): Observable<Application[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetApplications?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Application[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Application[]>;
        }));
    }

    protected processGetApplications(response: HttpResponseBase): Observable<Application[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Application.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReferences(code: string | null | undefined, designation: string | null | undefined, formuleNum: string | null | undefined, shadeGuideNum: string | null | undefined, colorGroup: string | null | undefined, manufacturer: string | null | undefined, model: string | null | undefined, year: string | null | undefined, application: string | null | undefined, codeSearch: number | undefined, designationSearch: number | undefined, searchWorld: boolean | undefined, tech: string | null | undefined): Observable<Reference[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetReferences?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "designation=" + encodeURIComponent("" + designation) + "&";
        if (formuleNum !== undefined && formuleNum !== null)
            url_ += "formuleNum=" + encodeURIComponent("" + formuleNum) + "&";
        if (shadeGuideNum !== undefined && shadeGuideNum !== null)
            url_ += "shadeGuideNum=" + encodeURIComponent("" + shadeGuideNum) + "&";
        if (colorGroup !== undefined && colorGroup !== null)
            url_ += "colorGroup=" + encodeURIComponent("" + colorGroup) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (application !== undefined && application !== null)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        if (codeSearch === null)
            throw new Error("The parameter 'codeSearch' cannot be null.");
        else if (codeSearch !== undefined)
            url_ += "codeSearch=" + encodeURIComponent("" + codeSearch) + "&";
        if (designationSearch === null)
            throw new Error("The parameter 'designationSearch' cannot be null.");
        else if (designationSearch !== undefined)
            url_ += "designationSearch=" + encodeURIComponent("" + designationSearch) + "&";
        if (searchWorld === null)
            throw new Error("The parameter 'searchWorld' cannot be null.");
        else if (searchWorld !== undefined)
            url_ += "searchWorld=" + encodeURIComponent("" + searchWorld) + "&";
        if (tech !== undefined && tech !== null)
            url_ += "tech=" + encodeURIComponent("" + tech) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Reference[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Reference[]>;
        }));
    }

    protected processGetReferences(response: HttpResponseBase): Observable<Reference[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Reference.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVariants(code: string | null | undefined, designation: string | null | undefined, manufacturer: string | null | undefined, formuleNum: string | null | undefined, shadeGuideNum: string | null | undefined, shadeGuideNumAlt: string | null | undefined, searchWorld: boolean | undefined, tech: string | null | undefined, isBiTon: boolean | undefined): Observable<Reference[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetVariants?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (designation !== undefined && designation !== null)
            url_ += "designation=" + encodeURIComponent("" + designation) + "&";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (formuleNum !== undefined && formuleNum !== null)
            url_ += "formuleNum=" + encodeURIComponent("" + formuleNum) + "&";
        if (shadeGuideNum !== undefined && shadeGuideNum !== null)
            url_ += "shadeGuideNum=" + encodeURIComponent("" + shadeGuideNum) + "&";
        if (shadeGuideNumAlt !== undefined && shadeGuideNumAlt !== null)
            url_ += "shadeGuideNumAlt=" + encodeURIComponent("" + shadeGuideNumAlt) + "&";
        if (searchWorld === null)
            throw new Error("The parameter 'searchWorld' cannot be null.");
        else if (searchWorld !== undefined)
            url_ += "searchWorld=" + encodeURIComponent("" + searchWorld) + "&";
        if (tech !== undefined && tech !== null)
            url_ += "tech=" + encodeURIComponent("" + tech) + "&";
        if (isBiTon === null)
            throw new Error("The parameter 'isBiTon' cannot be null.");
        else if (isBiTon !== undefined)
            url_ += "isBiTon=" + encodeURIComponent("" + isBiTon) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVariants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVariants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Reference[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Reference[]>;
        }));
    }

    protected processGetVariants(response: HttpResponseBase): Observable<Reference[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Reference.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBiTons(id: string | null | undefined, searchWorld: boolean | undefined, tech: string | null | undefined): Observable<Reference[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetBiTons?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (searchWorld === null)
            throw new Error("The parameter 'searchWorld' cannot be null.");
        else if (searchWorld !== undefined)
            url_ += "searchWorld=" + encodeURIComponent("" + searchWorld) + "&";
        if (tech !== undefined && tech !== null)
            url_ += "tech=" + encodeURIComponent("" + tech) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiTons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiTons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Reference[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Reference[]>;
        }));
    }

    protected processGetBiTons(response: HttpResponseBase): Observable<Reference[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Reference.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFormules(data: ReferenceDetails): Observable<Ligne[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetFormules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ligne[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ligne[]>;
        }));
    }

    protected processGetFormules(response: HttpResponseBase): Observable<Ligne[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ligne.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRetourDLLPAE(data: ReferenceDetails, withFirstCallEtapeDillution: boolean | undefined): Observable<Retour_DLL_PAE> {
        let url_ = this.baseUrl + "/IxellAPI/GetRetourDLLPAE?";
        if (withFirstCallEtapeDillution === null)
            throw new Error("The parameter 'withFirstCallEtapeDillution' cannot be null.");
        else if (withFirstCallEtapeDillution !== undefined)
            url_ += "withFirstCallEtapeDillution=" + encodeURIComponent("" + withFirstCallEtapeDillution) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetourDLLPAE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetourDLLPAE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Retour_DLL_PAE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Retour_DLL_PAE>;
        }));
    }

    protected processGetRetourDLLPAE(response: HttpResponseBase): Observable<Retour_DLL_PAE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Retour_DLL_PAE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRetourDLLPAEEquinox(data: FormulaLayer, fnum: number | undefined, constructeur: string | null | undefined, language: string | null | undefined, withFirstCallEtapeDillution: boolean | undefined): Observable<Retour_DLL_PAE> {
        let url_ = this.baseUrl + "/IxellAPI/GetRetourDLLPAEEquinox?";
        if (fnum === null)
            throw new Error("The parameter 'fnum' cannot be null.");
        else if (fnum !== undefined)
            url_ += "fnum=" + encodeURIComponent("" + fnum) + "&";
        if (constructeur !== undefined && constructeur !== null)
            url_ += "constructeur=" + encodeURIComponent("" + constructeur) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (withFirstCallEtapeDillution === null)
            throw new Error("The parameter 'withFirstCallEtapeDillution' cannot be null.");
        else if (withFirstCallEtapeDillution !== undefined)
            url_ += "withFirstCallEtapeDillution=" + encodeURIComponent("" + withFirstCallEtapeDillution) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetourDLLPAEEquinox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetourDLLPAEEquinox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Retour_DLL_PAE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Retour_DLL_PAE>;
        }));
    }

    protected processGetRetourDLLPAEEquinox(response: HttpResponseBase): Observable<Retour_DLL_PAE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Retour_DLL_PAE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    traitementEtapeDillution(retour_DLL_PAE: Retour_DLL_PAE, langue: string | null | undefined, formuleCouranteIsMultiCoucheFisrt: boolean | undefined): Observable<Retour_DLL_PAE> {
        let url_ = this.baseUrl + "/IxellAPI/TraitementEtapeDillution?";
        if (langue !== undefined && langue !== null)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        if (formuleCouranteIsMultiCoucheFisrt === null)
            throw new Error("The parameter 'formuleCouranteIsMultiCoucheFisrt' cannot be null.");
        else if (formuleCouranteIsMultiCoucheFisrt !== undefined)
            url_ += "formuleCouranteIsMultiCoucheFisrt=" + encodeURIComponent("" + formuleCouranteIsMultiCoucheFisrt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(retour_DLL_PAE);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTraitementEtapeDillution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTraitementEtapeDillution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Retour_DLL_PAE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Retour_DLL_PAE>;
        }));
    }

    protected processTraitementEtapeDillution(response: HttpResponseBase): Observable<Retour_DLL_PAE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Retour_DLL_PAE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDillutionPAE(cleDillution: string | null | undefined, langue: string | null | undefined, choixVernisPAE: string | null | undefined, isEquinox: boolean | undefined): Observable<IxellColorWebPAE[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetDillutionPAE?";
        if (cleDillution !== undefined && cleDillution !== null)
            url_ += "cleDillution=" + encodeURIComponent("" + cleDillution) + "&";
        if (langue !== undefined && langue !== null)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        if (choixVernisPAE !== undefined && choixVernisPAE !== null)
            url_ += "choixVernisPAE=" + encodeURIComponent("" + choixVernisPAE) + "&";
        if (isEquinox === null)
            throw new Error("The parameter 'isEquinox' cannot be null.");
        else if (isEquinox !== undefined)
            url_ += "isEquinox=" + encodeURIComponent("" + isEquinox) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDillutionPAE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDillutionPAE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IxellColorWebPAE[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IxellColorWebPAE[]>;
        }));
    }

    protected processGetDillutionPAE(response: HttpResponseBase): Observable<IxellColorWebPAE[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IxellColorWebPAE.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTarifCtc(isEquinox: boolean | undefined): Observable<Tarif> {
        let url_ = this.baseUrl + "/IxellAPI/GetTarifCtc?";
        if (isEquinox === null)
            throw new Error("The parameter 'isEquinox' cannot be null.");
        else if (isEquinox !== undefined)
            url_ += "isEquinox=" + encodeURIComponent("" + isEquinox) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTarifCtc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTarifCtc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tarif>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tarif>;
        }));
    }

    protected processGetTarifCtc(response: HttpResponseBase): Observable<Tarif> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tarif.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTarifCategoriesForAllCountries(idsPays: number[]): Observable<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/IxellAPI/GetTarifCategoriesForAllCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsPays);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTarifCategoriesForAllCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTarifCategoriesForAllCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string[]; }>;
        }));
    }

    protected processGetTarifCategoriesForAllCountries(response: HttpResponseBase): Observable<{ [key: string]: string[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCategoryCtc(): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetCategoryCtc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryCtc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryCtc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCategoryCtc(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setCategoryCtc(data: ReferenceDetails, category: string | null | undefined): Observable<Ligne[]> {
        let url_ = this.baseUrl + "/IxellAPI/SetCategoryCtc?";
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCategoryCtc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCategoryCtc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Ligne[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Ligne[]>;
        }));
    }

    protected processSetCategoryCtc(response: HttpResponseBase): Observable<Ligne[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ligne.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setCategoryCtcEquinox(data: SearchResponseFormula, category: string | null | undefined): Observable<SearchResponseFormula> {
        let url_ = this.baseUrl + "/IxellAPI/SetCategoryCtcEquinox?";
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCategoryCtcEquinox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCategoryCtcEquinox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponseFormula>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponseFormula>;
        }));
    }

    protected processSetCategoryCtcEquinox(response: HttpResponseBase): Observable<SearchResponseFormula> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponseFormula.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModelsForVariation(vident: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetModelsForVariation?";
        if (vident === null)
            throw new Error("The parameter 'vident' cannot be null.");
        else if (vident !== undefined)
            url_ += "vident=" + encodeURIComponent("" + vident) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModelsForVariation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModelsForVariation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetModelsForVariation(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstCode(code: string | null | undefined, codeSearch: number | undefined, searchWorld: boolean | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (codeSearch === null)
            throw new Error("The parameter 'codeSearch' cannot be null.");
        else if (codeSearch !== undefined)
            url_ += "codeSearch=" + encodeURIComponent("" + codeSearch) + "&";
        if (searchWorld === null)
            throw new Error("The parameter 'searchWorld' cannot be null.");
        else if (searchWorld !== undefined)
            url_ += "searchWorld=" + encodeURIComponent("" + searchWorld) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLstCode(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstDesignation(designation: string | null | undefined, designationSearch: number | undefined, searchWorld: boolean | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstDesignation?";
        if (designation !== undefined && designation !== null)
            url_ += "designation=" + encodeURIComponent("" + designation) + "&";
        if (designationSearch === null)
            throw new Error("The parameter 'designationSearch' cannot be null.");
        else if (designationSearch !== undefined)
            url_ += "designationSearch=" + encodeURIComponent("" + designationSearch) + "&";
        if (searchWorld === null)
            throw new Error("The parameter 'searchWorld' cannot be null.");
        else if (searchWorld !== undefined)
            url_ += "searchWorld=" + encodeURIComponent("" + searchWorld) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstDesignation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstDesignation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLstDesignation(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstManufacturer(manufacturer: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstManufacturer?";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstManufacturer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstManufacturer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLstManufacturer(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstModel(manufacturer: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstModel?";
        if (manufacturer !== undefined && manufacturer !== null)
            url_ += "manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLstModel(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBddMajDate(): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GetBddMajDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBddMajDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBddMajDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBddMajDate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateQRCode(data: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/GenerateQRCode?";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQRCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQRCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateQRCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateQRCodeMulti(data: string | null | undefined, idFormule: number | undefined): Observable<IResponseQrCodeFormule> {
        let url_ = this.baseUrl + "/IxellAPI/GenerateQRCodeMulti?";
        if (data !== undefined && data !== null)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        if (idFormule === null)
            throw new Error("The parameter 'idFormule' cannot be null.");
        else if (idFormule !== undefined)
            url_ += "idFormule=" + encodeURIComponent("" + idFormule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQRCodeMulti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQRCodeMulti(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IResponseQrCodeFormule>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IResponseQrCodeFormule>;
        }));
    }

    protected processGenerateQRCodeMulti(response: HttpResponseBase): Observable<IResponseQrCodeFormule> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IResponseQrCodeFormule.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLstCodeMixitCloud(codeTeinte: string | null | undefined, country: string | null | undefined, langue: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetLstCodeMixitCloud?";
        if (codeTeinte !== undefined && codeTeinte !== null)
            url_ += "codeTeinte=" + encodeURIComponent("" + codeTeinte) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (langue !== undefined && langue !== null)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLstCodeMixitCloud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLstCodeMixitCloud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLstCodeMixitCloud(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFiltreMixiCloud(codeTeinte: string | null | undefined, constructeur: string | null | undefined, modele: string | null | undefined, annnee: string | null | undefined, groupeCouleur: string | null | undefined, country: string | null | undefined, langue: string | null | undefined): Observable<Facets> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateFiltreMixiCloud?";
        if (codeTeinte !== undefined && codeTeinte !== null)
            url_ += "codeTeinte=" + encodeURIComponent("" + codeTeinte) + "&";
        if (constructeur !== undefined && constructeur !== null)
            url_ += "constructeur=" + encodeURIComponent("" + constructeur) + "&";
        if (modele !== undefined && modele !== null)
            url_ += "modele=" + encodeURIComponent("" + modele) + "&";
        if (annnee !== undefined && annnee !== null)
            url_ += "annnee=" + encodeURIComponent("" + annnee) + "&";
        if (groupeCouleur !== undefined && groupeCouleur !== null)
            url_ += "groupeCouleur=" + encodeURIComponent("" + groupeCouleur) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (langue !== undefined && langue !== null)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFiltreMixiCloud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFiltreMixiCloud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Facets>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Facets>;
        }));
    }

    protected processUpdateFiltreMixiCloud(response: HttpResponseBase): Observable<Facets> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Facets.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFormulesMeresMixitCloud(codeTeinte: string | null | undefined, constructeur: string | null | undefined, modele: string | null | undefined, annnee: string | null | undefined, groupeCouleur: string | null | undefined, country: string | null | undefined, langue: string | null | undefined, skip: number | undefined, listCodeTeinte: boolean | undefined): Observable<SearchResponseMarket> {
        let url_ = this.baseUrl + "/IxellAPI/SearchFormulesMeresMixitCloud?";
        if (codeTeinte !== undefined && codeTeinte !== null)
            url_ += "codeTeinte=" + encodeURIComponent("" + codeTeinte) + "&";
        if (constructeur !== undefined && constructeur !== null)
            url_ += "constructeur=" + encodeURIComponent("" + constructeur) + "&";
        if (modele !== undefined && modele !== null)
            url_ += "modele=" + encodeURIComponent("" + modele) + "&";
        if (annnee !== undefined && annnee !== null)
            url_ += "annnee=" + encodeURIComponent("" + annnee) + "&";
        if (groupeCouleur !== undefined && groupeCouleur !== null)
            url_ += "groupeCouleur=" + encodeURIComponent("" + groupeCouleur) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (langue !== undefined && langue !== null)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (listCodeTeinte === null)
            throw new Error("The parameter 'listCodeTeinte' cannot be null.");
        else if (listCodeTeinte !== undefined)
            url_ += "listCodeTeinte=" + encodeURIComponent("" + listCodeTeinte) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFormulesMeresMixitCloud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFormulesMeresMixitCloud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponseMarket>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponseMarket>;
        }));
    }

    protected processSearchFormulesMeresMixitCloud(response: HttpResponseBase): Observable<SearchResponseMarket> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponseMarket.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchVariantesMixitCloud(colorIdMixitCloud: string | null | undefined, country: string | null | undefined, langue: string | null | undefined): Observable<SearchResponseVariants> {
        let url_ = this.baseUrl + "/IxellAPI/SearchVariantesMixitCloud?";
        if (colorIdMixitCloud !== undefined && colorIdMixitCloud !== null)
            url_ += "colorIdMixitCloud=" + encodeURIComponent("" + colorIdMixitCloud) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (langue !== undefined && langue !== null)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchVariantesMixitCloud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVariantesMixitCloud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponseVariants>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponseVariants>;
        }));
    }

    protected processSearchVariantesMixitCloud(response: HttpResponseBase): Observable<SearchResponseVariants> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponseVariants.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFormuleMixitCloud(colorIdMixitCloud: string | null | undefined, varianteNumber: string | null | undefined, country: string | null | undefined, langue: string | null | undefined, prodnb: string | null | undefined): Observable<SearchResponseFormula> {
        let url_ = this.baseUrl + "/IxellAPI/SearchFormuleMixitCloud?";
        if (colorIdMixitCloud !== undefined && colorIdMixitCloud !== null)
            url_ += "colorIdMixitCloud=" + encodeURIComponent("" + colorIdMixitCloud) + "&";
        if (varianteNumber !== undefined && varianteNumber !== null)
            url_ += "varianteNumber=" + encodeURIComponent("" + varianteNumber) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (langue !== undefined && langue !== null)
            url_ += "langue=" + encodeURIComponent("" + langue) + "&";
        if (prodnb !== undefined && prodnb !== null)
            url_ += "prodnb=" + encodeURIComponent("" + prodnb) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFormuleMixitCloud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFormuleMixitCloud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponseFormula>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponseFormula>;
        }));
    }

    protected processSearchFormuleMixitCloud(response: HttpResponseBase): Observable<SearchResponseFormula> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponseFormula.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserRenault(country: string | null | undefined, name: string | null | undefined, firstName: string | null | undefined, language: string | null | undefined, offset: number | undefined): Observable<IUserRenault[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetUserRenault?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRenault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRenault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IUserRenault[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IUserRenault[]>;
        }));
    }

    protected processGetUserRenault(response: HttpResponseBase): Observable<IUserRenault[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IUserRenault.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveUserModifications(user: IUserRenault): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/SaveUserModifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserModifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserModifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveUserModifications(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveUserModificationsAndSendId(user: IUserRenault, typeSend: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/SaveUserModificationsAndSendId?";
        if (typeSend !== undefined && typeSend !== null)
            url_ += "typeSend=" + encodeURIComponent("" + typeSend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserModificationsAndSendId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserModificationsAndSendId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveUserModificationsAndSendId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(user: IUserRenault): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/DeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bloquerUser(user: IUserRenault): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/BloquerUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBloquerUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBloquerUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBloquerUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpainRegion(): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetSpainRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpainRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpainRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSpainRegion(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegions(country: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetRegions?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetRegions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegionsWithStats(country: string | null | undefined): Observable<DRStats[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetRegionsWithStats?";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionsWithStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionsWithStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DRStats[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DRStats[]>;
        }));
    }

    protected processGetRegionsWithStats(response: HttpResponseBase): Observable<DRStats[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DRStats.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountriesStats(countries: string | null | undefined): Observable<CountryStats[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetCountriesStats?";
        if (countries !== undefined && countries !== null)
            url_ += "countries=" + encodeURIComponent("" + countries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountriesStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountriesStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryStats[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryStats[]>;
        }));
    }

    protected processGetCountriesStats(response: HttpResponseBase): Observable<CountryStats[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryStats.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMailRT(region: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/IxellAPI/GetMailRT?";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailRT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailRT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetMailRT(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reallocateColorUsers(region: string | null | undefined, newCtcId: number | undefined, oldCtcId: number | undefined, lstUser: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/ReallocateColorUsers?";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (newCtcId === null)
            throw new Error("The parameter 'newCtcId' cannot be null.");
        else if (newCtcId !== undefined)
            url_ += "newCtcId=" + encodeURIComponent("" + newCtcId) + "&";
        if (oldCtcId === null)
            throw new Error("The parameter 'oldCtcId' cannot be null.");
        else if (oldCtcId !== undefined)
            url_ += "oldCtcId=" + encodeURIComponent("" + oldCtcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lstUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReallocateColorUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReallocateColorUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processReallocateColorUsers(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reallocateColorUsersDR(region: string | null | undefined, ctcId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/IxellAPI/reallocateColorUsersDR?";
        if (region !== undefined && region !== null)
            url_ += "region=" + encodeURIComponent("" + region) + "&";
        if (ctcId === null)
            throw new Error("The parameter 'ctcId' cannot be null.");
        else if (ctcId !== undefined)
            url_ += "ctcId=" + encodeURIComponent("" + ctcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReallocateColorUsersDR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReallocateColorUsersDR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processReallocateColorUsersDR(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logInCtcReallocation(data: LoginData, activationId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/IxellAPI/LogInCtcReallocation?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInCtcReallocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInCtcReallocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLogInCtcReallocation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importClientsLacour(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/ImportClientsLacour";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportClientsLacour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportClientsLacour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportClientsLacour(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUnisiteCode(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateUnisiteCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUnisiteCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUnisiteCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUnisiteCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUnisiteCodeAndStatusAdmin(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/UpdateUnisiteCodeAndStatusAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUnisiteCodeAndStatusAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUnisiteCodeAndStatusAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUnisiteCodeAndStatusAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importNewLocalAccounts(): Observable<void> {
        let url_ = this.baseUrl + "/IxellAPI/ImportNewLocalAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportNewLocalAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportNewLocalAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportNewLocalAccounts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LacourIdPAuthenticationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    logout(): Observable<void> {
        let url_ = this.baseUrl + "/LacourIdPAuthentication/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TchatService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getParamTchat(): Observable<number> {
        let url_ = this.baseUrl + "/Tchat/GetParamTchat";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParamTchat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParamTchat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetParamTchat(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createToken(data: Tchat, language: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Tchat/CreateToken?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    closeConversation(data: Tchat): Observable<number> {
        let url_ = this.baseUrl + "/Tchat/CloseConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCloseConversation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSvcUrl(): Observable<string> {
        let url_ = this.baseUrl + "/Tchat/GetSvcUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSvcUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSvcUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSvcUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getModuleUrl(): Observable<string> {
        let url_ = this.baseUrl + "/Tchat/GetModuleUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModuleUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModuleUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetModuleUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getToken(): Observable<string> {
        let url_ = this.baseUrl + "/Tchat/GetToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setToken(token: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Tchat/SetToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFlag(): Observable<ETchatFlag> {
        let url_ = this.baseUrl + "/Tchat/GetFlag";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ETchatFlag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ETchatFlag>;
        }));
    }

    protected processGetFlag(response: HttpResponseBase): Observable<ETchatFlag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFlag(flag: ETchatFlag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Tchat/SetFlag?";
        if (flag === null)
            throw new Error("The parameter 'flag' cannot be null.");
        else if (flag !== undefined)
            url_ += "flag=" + encodeURIComponent("" + flag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TestAppliService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTestAppli(): Observable<void> {
        let url_ = this.baseUrl + "/TestAppli";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTestAppli(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTestAppli(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTestAppli(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UnisiteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    logInImumu(data: InfosImumu): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Unisite/LogInImumu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInImumu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInImumu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogInImumu(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEncoursAssistance(header: string | null | undefined, dates: EncoursDates): Observable<void> {
        let url_ = this.baseUrl + "/Unisite/GetEncoursAssistance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "header": header !== undefined && header !== null ? "" + header : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEncoursAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEncoursAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetEncoursAssistance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRDVPlanning(dates: EncoursDates): Observable<void> {
        let url_ = this.baseUrl + "/Unisite/GetRDVPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRDVPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRDVPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRDVPlanning(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendRDVPlanning(rdvs: ListeRdvUnisite): Observable<InfoRdvUnisite[]> {
        let url_ = this.baseUrl + "/Unisite/SendRDVPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rdvs);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendRDVPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRDVPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoRdvUnisite[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoRdvUnisite[]>;
        }));
    }

    protected processSendRDVPlanning(response: HttpResponseBase): Observable<InfoRdvUnisite[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfoRdvUnisite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendScalesVersion(scales: ListeScaleVersion): Observable<boolean> {
        let url_ = this.baseUrl + "/Unisite/SendScalesVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scales);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendScalesVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendScalesVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendScalesVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendScalesAssistance(scales: ListeScaleAssistance): Observable<boolean> {
        let url_ = this.baseUrl + "/Unisite/SendScalesAssistance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scales);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendScalesAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendScalesAssistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendScalesAssistance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDroits(): Observable<string> {
        let url_ = this.baseUrl + "/Unisite/GetDroits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDroits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDroits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDroits(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendAckGetDroits(userFailed: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Unisite/SendAckGetDroits?";
        if (userFailed !== undefined && userFailed !== null)
            url_ += "userFailed=" + encodeURIComponent("" + userFailed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAckGetDroits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAckGetDroits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendAckGetDroits(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ILogV1 implements IILogV1 {
    logID!: number;
    logDate!: Date;
    categorie!: CategoryLog;
    sousCategorie!: SubCategoryLog;
    evenement?: string | undefined;
    infosComp?: string | undefined;
    login?: string | undefined;
    categoryLogName?: string | undefined;
    subCategoryLogName?: string | undefined;

    constructor(data?: IILogV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logID = _data["logID"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.categorie = _data["categorie"];
            this.sousCategorie = _data["sousCategorie"];
            this.evenement = _data["evenement"];
            this.infosComp = _data["infosComp"];
            this.login = _data["login"];
            this.categoryLogName = _data["categoryLogName"];
            this.subCategoryLogName = _data["subCategoryLogName"];
        }
    }

    static fromJS(data: any): ILogV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ILogV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["categorie"] = this.categorie;
        data["sousCategorie"] = this.sousCategorie;
        data["evenement"] = this.evenement;
        data["infosComp"] = this.infosComp;
        data["login"] = this.login;
        data["categoryLogName"] = this.categoryLogName;
        data["subCategoryLogName"] = this.subCategoryLogName;
        return data;
    }
}

export interface IILogV1 {
    logID: number;
    logDate: Date;
    categorie: CategoryLog;
    sousCategorie: SubCategoryLog;
    evenement?: string | undefined;
    infosComp?: string | undefined;
    login?: string | undefined;
    categoryLogName?: string | undefined;
    subCategoryLogName?: string | undefined;
}

export enum CategoryLog {
    Assistance = 0,
    Tchat = 1,
    Planning = 2,
    ColorUser = 3,
    Scale = 4,
    Payment = 5,
    GestionLicence = 6,
    ColorWebTech = 7,
    Interne = 8,
    Optimisation = 9,
    Connexion = 10,
    TachePlanifier = 11,
}

export enum SubCategoryLog {
    New = 0,
    EnvoiUnisite = 1,
    Cancel = 2,
    Update = 3,
    Hide = 4,
    SendID = 5,
    ReaffectationCTC = 6,
    DeleteDateMail = 7,
    SavePayment = 8,
    AnalyzePaymentResponse = 9,
    ValidationCommande = 10,
    DeleteBillingActivation = 11,
    AnalyzePaymentSended = 12,
    ColorWebTech_VIN = 13,
    GetActivationCode = 14,
    SwitchScale = 15,
    TestDuree = 16,
    AddNewScale = 17,
    Connexion = 18,
    NotificationColorCloud = 19,
}

export class IDocumentV1 implements IIDocumentV1 {
    idLexique!: number;
    idLangue!: number;
    codeLexique?: string | undefined;
    libelle?: string | undefined;
    haveDoc!: boolean;
    doc?: string | undefined;
    idTitre!: number;
    ordre!: number;
    niveau!: number;
    idTitrePrecedent!: number;
    idDocument!: number;
    idPays!: number;
    isActif!: boolean;
    isInternet!: boolean;
    isSite!: boolean;
    isDev!: boolean;
    extension?: string | undefined;

    constructor(data?: IIDocumentV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idLexique = _data["idLexique"];
            this.idLangue = _data["idLangue"];
            this.codeLexique = _data["codeLexique"];
            this.libelle = _data["libelle"];
            this.haveDoc = _data["haveDoc"];
            this.doc = _data["doc"];
            this.idTitre = _data["idTitre"];
            this.ordre = _data["ordre"];
            this.niveau = _data["niveau"];
            this.idTitrePrecedent = _data["idTitrePrecedent"];
            this.idDocument = _data["idDocument"];
            this.idPays = _data["idPays"];
            this.isActif = _data["isActif"];
            this.isInternet = _data["isInternet"];
            this.isSite = _data["isSite"];
            this.isDev = _data["isDev"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): IDocumentV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IDocumentV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLexique"] = this.idLexique;
        data["idLangue"] = this.idLangue;
        data["codeLexique"] = this.codeLexique;
        data["libelle"] = this.libelle;
        data["haveDoc"] = this.haveDoc;
        data["doc"] = this.doc;
        data["idTitre"] = this.idTitre;
        data["ordre"] = this.ordre;
        data["niveau"] = this.niveau;
        data["idTitrePrecedent"] = this.idTitrePrecedent;
        data["idDocument"] = this.idDocument;
        data["idPays"] = this.idPays;
        data["isActif"] = this.isActif;
        data["isInternet"] = this.isInternet;
        data["isSite"] = this.isSite;
        data["isDev"] = this.isDev;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IIDocumentV1 {
    idLexique: number;
    idLangue: number;
    codeLexique?: string | undefined;
    libelle?: string | undefined;
    haveDoc: boolean;
    doc?: string | undefined;
    idTitre: number;
    ordre: number;
    niveau: number;
    idTitrePrecedent: number;
    idDocument: number;
    idPays: number;
    isActif: boolean;
    isInternet: boolean;
    isSite: boolean;
    isDev: boolean;
    extension?: string | undefined;
}

export enum StatsKeyfactorKind {
    BOUNCE = 0,
    VISITS = 1,
    UNIQUEUSERS = 2,
    SESSIONS = 3,
    PAGES = 4,
    TIME = 5,
    MODEL = 6,
    TINT = 7,
}

export class StatsGraphProps implements IStatsGraphProps {
    graph?: StatsGraphInfo | undefined;
    filters?: StatsGraphFilterInfo[] | undefined;
    level!: number;

    constructor(data?: IStatsGraphProps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.graph = _data["graph"] ? StatsGraphInfo.fromJS(_data["graph"]) : <any>undefined;
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(StatsGraphFilterInfo.fromJS(item));
            }
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): StatsGraphProps {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphProps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["graph"] = this.graph ? this.graph.toJSON() : <any>undefined;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["level"] = this.level;
        return data;
    }
}

export interface IStatsGraphProps {
    graph?: StatsGraphInfo | undefined;
    filters?: StatsGraphFilterInfo[] | undefined;
    level: number;
}

export class StatsGraphInfo implements IStatsGraphInfo {
    idGraph!: number;
    title?: string | undefined;
    prio!: number;
    isEnlarged!: boolean;
    dataX!: StatsGraphDataX;
    dataY!: StatsGraphDataY;
    latestShape?: StatsGraphShape | undefined;
    latestDateStart?: Date | undefined;
    latestDateEnd?: Date | undefined;
    availableShapes?: StatsGraphShape[] | undefined;

    constructor(data?: IStatsGraphInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idGraph = _data["idGraph"];
            this.title = _data["title"];
            this.prio = _data["prio"];
            this.isEnlarged = _data["isEnlarged"];
            this.dataX = _data["dataX"];
            this.dataY = _data["dataY"];
            this.latestShape = _data["latestShape"];
            this.latestDateStart = _data["latestDateStart"] ? new Date(_data["latestDateStart"].toString()) : <any>undefined;
            this.latestDateEnd = _data["latestDateEnd"] ? new Date(_data["latestDateEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["availableShapes"])) {
                this.availableShapes = [] as any;
                for (let item of _data["availableShapes"])
                    this.availableShapes!.push(item);
            }
        }
    }

    static fromJS(data: any): StatsGraphInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idGraph"] = this.idGraph;
        data["title"] = this.title;
        data["prio"] = this.prio;
        data["isEnlarged"] = this.isEnlarged;
        data["dataX"] = this.dataX;
        data["dataY"] = this.dataY;
        data["latestShape"] = this.latestShape;
        data["latestDateStart"] = this.latestDateStart ? this.latestDateStart.toISOString() : <any>undefined;
        data["latestDateEnd"] = this.latestDateEnd ? this.latestDateEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.availableShapes)) {
            data["availableShapes"] = [];
            for (let item of this.availableShapes)
                data["availableShapes"].push(item);
        }
        return data;
    }
}

export interface IStatsGraphInfo {
    idGraph: number;
    title?: string | undefined;
    prio: number;
    isEnlarged: boolean;
    dataX: StatsGraphDataX;
    dataY: StatsGraphDataY;
    latestShape?: StatsGraphShape | undefined;
    latestDateStart?: Date | undefined;
    latestDateEnd?: Date | undefined;
    availableShapes?: StatsGraphShape[] | undefined;
}

export enum StatsGraphDataX {
    DATE = 0,
}

export enum StatsGraphDataY {
    TEINTE = 0,
    CB = 1,
    FEATURES = 2,
    OS = 3,
    VISITS = 4,
    SESSIONS = 5,
    ACTIONS = 6,
    ORDERS = 7,
    BROWSER = 8,
    LOGS = 9,
    PROCESSING = 10,
}

export enum StatsGraphShape {
    TABLE = 0,
    LINES = 1,
    PIE = 2,
    DONUT = 3,
    MAP = 4,
    HIST = 5,
    BROWSING = 6,
    ACTIONS = 7,
    ARBITRARYTABLE = 8,
}

export class StatsGraphFilterInfo implements IStatsGraphFilterInfo {
    kind!: StatsGraphFilterKind;
    latestValue?: string | undefined;

    constructor(data?: IStatsGraphFilterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.latestValue = _data["latestValue"];
        }
    }

    static fromJS(data: any): StatsGraphFilterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphFilterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["latestValue"] = this.latestValue;
        return data;
    }
}

export interface IStatsGraphFilterInfo {
    kind: StatsGraphFilterKind;
    latestValue?: string | undefined;
}

export enum StatsGraphFilterKind {
    SPLITCOUNTRY = 0,
    SPLITUSERTYPE = 1,
    SPLITBALANCES = 2,
    CWTCOLORCODE = 3,
    CWTDESIG = 4,
    CWTFORMULA = 5,
    CWTTEINTIER = 6,
    CWTGROUP = 7,
    CWTMANUFACTURER = 8,
    CWTMODEL = 9,
    CWTYEAR = 10,
    CWTAPP = 11,
    CWTTECHNO = 12,
    CWTSOURCEENGINE = 13,
    CBMANUFACTURER = 14,
    CBGAMME = 15,
    CBSERIE = 16,
    CBMODEL = 17,
    CBPART = 18,
    CBSHOWTYPE = 19,
    SPLITVARIANTS = 20,
    SEETOP = 21,
    FEATURETYPE = 22,
    TIMECUT = 23,
    USERID = 24,
    ORDERFILTERBY = 25,
    LOGTYPE = 26,
    LOGCAT = 27,
}

export class StatsGraphPrefs implements IStatsGraphPrefs {
    id!: number;
    prio!: number;
    isEnlarged!: boolean;
    latestShape?: StatsGraphShape | undefined;
    latestDateStart?: Date | undefined;
    latestDateEnd?: Date | undefined;
    filters?: StatsGraphFilterInfo[] | undefined;

    constructor(data?: IStatsGraphPrefs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.prio = _data["prio"];
            this.isEnlarged = _data["isEnlarged"];
            this.latestShape = _data["latestShape"];
            this.latestDateStart = _data["latestDateStart"] ? new Date(_data["latestDateStart"].toString()) : <any>undefined;
            this.latestDateEnd = _data["latestDateEnd"] ? new Date(_data["latestDateEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(StatsGraphFilterInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatsGraphPrefs {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphPrefs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["prio"] = this.prio;
        data["isEnlarged"] = this.isEnlarged;
        data["latestShape"] = this.latestShape;
        data["latestDateStart"] = this.latestDateStart ? this.latestDateStart.toISOString() : <any>undefined;
        data["latestDateEnd"] = this.latestDateEnd ? this.latestDateEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStatsGraphPrefs {
    id: number;
    prio: number;
    isEnlarged: boolean;
    latestShape?: StatsGraphShape | undefined;
    latestDateStart?: Date | undefined;
    latestDateEnd?: Date | undefined;
    filters?: StatsGraphFilterInfo[] | undefined;
}

export class StatsDropdownValue implements IStatsDropdownValue {
    label?: string | undefined;
    value?: any | undefined;

    constructor(data?: IStatsDropdownValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatsDropdownValue {
        data = typeof data === 'object' ? data : {};
        let result = new StatsDropdownValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatsDropdownValue {
    label?: string | undefined;
    value?: any | undefined;
}

export class StatsGraphData implements IStatsGraphData {
    start?: number | undefined;
    end?: number | undefined;
    interval!: StatsGraphDataInterval;
    xName?: string | undefined;
    yName?: string | undefined;
    labelName?: string | undefined;
    keyName?: string | undefined;
    data?: { [key: string]: { [key: string]: StatsGraphDataRecords; }; } | undefined;
    arbitraryTable?: StatsGraphDataLogs | undefined;
    error?: string | undefined;

    constructor(data?: IStatsGraphData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"];
            this.end = _data["end"];
            this.interval = _data["interval"];
            this.xName = _data["xName"];
            this.yName = _data["yName"];
            this.labelName = _data["labelName"];
            this.keyName = _data["keyName"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key] !== undefined ? _data["data"][key] : {};
                }
            }
            this.arbitraryTable = _data["arbitraryTable"] ? StatsGraphDataLogs.fromJS(_data["arbitraryTable"]) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): StatsGraphData {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start;
        data["end"] = this.end;
        data["interval"] = this.interval;
        data["xName"] = this.xName;
        data["yName"] = this.yName;
        data["labelName"] = this.labelName;
        data["keyName"] = this.keyName;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["arbitraryTable"] = this.arbitraryTable ? this.arbitraryTable.toJSON() : <any>undefined;
        data["error"] = this.error;
        return data;
    }
}

export interface IStatsGraphData {
    start?: number | undefined;
    end?: number | undefined;
    interval: StatsGraphDataInterval;
    xName?: string | undefined;
    yName?: string | undefined;
    labelName?: string | undefined;
    keyName?: string | undefined;
    data?: { [key: string]: { [key: string]: StatsGraphDataRecords; }; } | undefined;
    arbitraryTable?: StatsGraphDataLogs | undefined;
    error?: string | undefined;
}

export enum StatsGraphDataInterval {
    None = 0,
    Hour = 1,
    Day = 2,
    Week = 3,
    Month = 4,
    Year = 5,
}

export class StatsGraphDataRecords implements IStatsGraphDataRecords {
    associatedColor?: string | undefined;
    records?: { [key: string]: number; } | undefined;
    browsingNodes?: StatsGraphDataBrowsingNode[] | undefined;
    actions?: StatsGraphDataAction[] | undefined;

    constructor(data?: IStatsGraphDataRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.associatedColor = _data["associatedColor"];
            if (_data["records"]) {
                this.records = {} as any;
                for (let key in _data["records"]) {
                    if (_data["records"].hasOwnProperty(key))
                        (<any>this.records)![key] = _data["records"][key];
                }
            }
            if (Array.isArray(_data["browsingNodes"])) {
                this.browsingNodes = [] as any;
                for (let item of _data["browsingNodes"])
                    this.browsingNodes!.push(StatsGraphDataBrowsingNode.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(StatsGraphDataAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatsGraphDataRecords {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphDataRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associatedColor"] = this.associatedColor;
        if (this.records) {
            data["records"] = {};
            for (let key in this.records) {
                if (this.records.hasOwnProperty(key))
                    (<any>data["records"])[key] = (<any>this.records)[key];
            }
        }
        if (Array.isArray(this.browsingNodes)) {
            data["browsingNodes"] = [];
            for (let item of this.browsingNodes)
                data["browsingNodes"].push(item.toJSON());
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStatsGraphDataRecords {
    associatedColor?: string | undefined;
    records?: { [key: string]: number; } | undefined;
    browsingNodes?: StatsGraphDataBrowsingNode[] | undefined;
    actions?: StatsGraphDataAction[] | undefined;
}

export class StatsGraphDataBrowsingNode implements IStatsGraphDataBrowsingNode {
    name?: string | undefined;
    parents?: number[] | undefined;
    value?: number[] | undefined;
    alternateColor!: boolean;
    details?: string | undefined;

    constructor(data?: IStatsGraphDataBrowsingNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(item);
            }
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.alternateColor = _data["alternateColor"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): StatsGraphDataBrowsingNode {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphDataBrowsingNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item);
        }
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["alternateColor"] = this.alternateColor;
        data["details"] = this.details;
        return data;
    }
}

export interface IStatsGraphDataBrowsingNode {
    name?: string | undefined;
    parents?: number[] | undefined;
    value?: number[] | undefined;
    alternateColor: boolean;
    details?: string | undefined;
}

export class StatsGraphDataAction implements IStatsGraphDataAction {
    time?: string | undefined;
    label?: string | undefined;

    constructor(data?: IStatsGraphDataAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): StatsGraphDataAction {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphDataAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        data["label"] = this.label;
        return data;
    }
}

export interface IStatsGraphDataAction {
    time?: string | undefined;
    label?: string | undefined;
}

export class StatsGraphDataLogs implements IStatsGraphDataLogs {
    logs?: any[] | undefined;
    names?: { [key: string]: string; } | undefined;
    canSort!: boolean;

    constructor(data?: IStatsGraphDataLogs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(item);
            }
            if (_data["names"]) {
                this.names = {} as any;
                for (let key in _data["names"]) {
                    if (_data["names"].hasOwnProperty(key))
                        (<any>this.names)![key] = _data["names"][key];
                }
            }
            this.canSort = _data["canSort"];
        }
    }

    static fromJS(data: any): StatsGraphDataLogs {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphDataLogs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item);
        }
        if (this.names) {
            data["names"] = {};
            for (let key in this.names) {
                if (this.names.hasOwnProperty(key))
                    (<any>data["names"])[key] = (<any>this.names)[key];
            }
        }
        data["canSort"] = this.canSort;
        return data;
    }
}

export interface IStatsGraphDataLogs {
    logs?: any[] | undefined;
    names?: { [key: string]: string; } | undefined;
    canSort: boolean;
}

export class StatsGraphFiltersData implements IStatsGraphFiltersData {
    dataX!: DataX;
    dataY!: DataY;

    constructor(data?: IStatsGraphFiltersData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataX = _data["dataX"];
            this.dataY = _data["dataY"];
        }
    }

    static fromJS(data: any): StatsGraphFiltersData {
        data = typeof data === 'object' ? data : {};
        let result = new StatsGraphFiltersData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataX"] = this.dataX;
        data["dataY"] = this.dataY;
        return data;
    }
}

export interface IStatsGraphFiltersData {
    dataX: DataX;
    dataY: DataY;
}

export class IPays implements IIPays {
    payS_ID!: number;
    payS_NAME?: string | undefined;
    payS_NAME_GB?: string | undefined;
    payS_COUNTRY_ALPHA2?: string | undefined;
    payS_COUNTRY_ALPHA3?: string | undefined;
    payS_COUNTRY_CODE?: string | undefined;
    codeLexique?: string | undefined;

    constructor(data?: IIPays) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payS_ID = _data["payS_ID"];
            this.payS_NAME = _data["payS_NAME"];
            this.payS_NAME_GB = _data["payS_NAME_GB"];
            this.payS_COUNTRY_ALPHA2 = _data["payS_COUNTRY_ALPHA2"];
            this.payS_COUNTRY_ALPHA3 = _data["payS_COUNTRY_ALPHA3"];
            this.payS_COUNTRY_CODE = _data["payS_COUNTRY_CODE"];
            this.codeLexique = _data["codeLexique"];
        }
    }

    static fromJS(data: any): IPays {
        data = typeof data === 'object' ? data : {};
        let result = new IPays();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payS_ID"] = this.payS_ID;
        data["payS_NAME"] = this.payS_NAME;
        data["payS_NAME_GB"] = this.payS_NAME_GB;
        data["payS_COUNTRY_ALPHA2"] = this.payS_COUNTRY_ALPHA2;
        data["payS_COUNTRY_ALPHA3"] = this.payS_COUNTRY_ALPHA3;
        data["payS_COUNTRY_CODE"] = this.payS_COUNTRY_CODE;
        data["codeLexique"] = this.codeLexique;
        return data;
    }
}

export interface IIPays {
    payS_ID: number;
    payS_NAME?: string | undefined;
    payS_NAME_GB?: string | undefined;
    payS_COUNTRY_ALPHA2?: string | undefined;
    payS_COUNTRY_ALPHA3?: string | undefined;
    payS_COUNTRY_CODE?: string | undefined;
    codeLexique?: string | undefined;
}

export class IUserV1 implements IIUserV1 {
    userID!: number;
    gender?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    mail?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    loginUnisite?: string | undefined;
    language?: string | undefined;
    unisiteCode?: string | undefined;
    company?: ICompanyV1 | undefined;
    company_companyID!: number;

    constructor(data?: IIUserV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.gender = _data["gender"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.mail = _data["mail"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.loginUnisite = _data["loginUnisite"];
            this.language = _data["language"];
            this.unisiteCode = _data["unisiteCode"];
            this.company = _data["company"] ? ICompanyV1.fromJS(_data["company"]) : <any>undefined;
            this.company_companyID = _data["company_companyID"];
        }
    }

    static fromJS(data: any): IUserV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IUserV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["gender"] = this.gender;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["mail"] = this.mail;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["loginUnisite"] = this.loginUnisite;
        data["language"] = this.language;
        data["unisiteCode"] = this.unisiteCode;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["company_companyID"] = this.company_companyID;
        return data;
    }
}

export interface IIUserV1 {
    userID: number;
    gender?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    mail?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    loginUnisite?: string | undefined;
    language?: string | undefined;
    unisiteCode?: string | undefined;
    company?: ICompanyV1 | undefined;
    company_companyID: number;
}

export class ICompanyV1 implements IICompanyV1 {
    companyId!: number;
    unisiteCode?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    siret?: string | undefined;
    tva?: string | undefined;
    siren?: string | undefined;

    constructor(data?: IICompanyV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.unisiteCode = _data["unisiteCode"];
            this.socialReason = _data["socialReason"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.siret = _data["siret"];
            this.tva = _data["tva"];
            this.siren = _data["siren"];
        }
    }

    static fromJS(data: any): ICompanyV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ICompanyV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["unisiteCode"] = this.unisiteCode;
        data["socialReason"] = this.socialReason;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["siret"] = this.siret;
        data["tva"] = this.tva;
        data["siren"] = this.siren;
        return data;
    }
}

export interface IICompanyV1 {
    companyId: number;
    unisiteCode?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    siret?: string | undefined;
    tva?: string | undefined;
    siren?: string | undefined;
}

export class IColorMatchingV1 implements IIColorMatchingV1 {
    colorMatchingID!: number;
    reference?: string | undefined;
    numeroSuivi?: string | undefined;
    status!: number;
    dateCreate!: Date;
    dateReceive!: Date;
    dateFinish!: Date;
    userID!: number;
    userCompanyID!: number;
    colorUserID!: number;
    ctcID!: number;
    brandVehicle?: string | undefined;
    yearVehicle!: number;
    modelVehicle?: string | undefined;
    codePainting?: string | undefined;
    designationPainting?: string | undefined;
    designationOriginElement?: string | undefined;
    colorOriginElement!: number;
    weightOriginElement!: number;
    lenghtOriginElement!: number;
    heightOriginElement!: number;
    designationFinalElement?: string | undefined;
    restitution!: number;
    paintQuality?: string | undefined;
    qualityId?: string | undefined;
    comment?: string | undefined;
    user_Name?: string | undefined;
    user_Firstname?: string | undefined;
    user_Mail?: string | undefined;
    user_Phone?: string | undefined;
    user_Mobile?: string | undefined;
    user_Language?: string | undefined;
    company_SocialReason?: string | undefined;
    company_Address?: string | undefined;
    company_PostalCode?: string | undefined;
    company_City?: string | undefined;
    company_Country?: string | undefined;
    ctC_Name?: string | undefined;
    ctC_Firstname?: string | undefined;
    ctC_Mail?: string | undefined;
    ctC_Phone?: string | undefined;
    published!: number;
    duplicated!: number;
    user?: IUserV1 | undefined;
    ctc?: ICtcV1 | undefined;
    response?: IResponseColorMatchingV1 | undefined;

    constructor(data?: IIColorMatchingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorMatchingID = _data["colorMatchingID"];
            this.reference = _data["reference"];
            this.numeroSuivi = _data["numeroSuivi"];
            this.status = _data["status"];
            this.dateCreate = _data["dateCreate"] ? new Date(_data["dateCreate"].toString()) : <any>undefined;
            this.dateReceive = _data["dateReceive"] ? new Date(_data["dateReceive"].toString()) : <any>undefined;
            this.dateFinish = _data["dateFinish"] ? new Date(_data["dateFinish"].toString()) : <any>undefined;
            this.userID = _data["userID"];
            this.userCompanyID = _data["userCompanyID"];
            this.colorUserID = _data["colorUserID"];
            this.ctcID = _data["ctcID"];
            this.brandVehicle = _data["brandVehicle"];
            this.yearVehicle = _data["yearVehicle"];
            this.modelVehicle = _data["modelVehicle"];
            this.codePainting = _data["codePainting"];
            this.designationPainting = _data["designationPainting"];
            this.designationOriginElement = _data["designationOriginElement"];
            this.colorOriginElement = _data["colorOriginElement"];
            this.weightOriginElement = _data["weightOriginElement"];
            this.lenghtOriginElement = _data["lenghtOriginElement"];
            this.heightOriginElement = _data["heightOriginElement"];
            this.designationFinalElement = _data["designationFinalElement"];
            this.restitution = _data["restitution"];
            this.paintQuality = _data["paintQuality"];
            this.qualityId = _data["qualityId"];
            this.comment = _data["comment"];
            this.user_Name = _data["user_Name"];
            this.user_Firstname = _data["user_Firstname"];
            this.user_Mail = _data["user_Mail"];
            this.user_Phone = _data["user_Phone"];
            this.user_Mobile = _data["user_Mobile"];
            this.user_Language = _data["user_Language"];
            this.company_SocialReason = _data["company_SocialReason"];
            this.company_Address = _data["company_Address"];
            this.company_PostalCode = _data["company_PostalCode"];
            this.company_City = _data["company_City"];
            this.company_Country = _data["company_Country"];
            this.ctC_Name = _data["ctC_Name"];
            this.ctC_Firstname = _data["ctC_Firstname"];
            this.ctC_Mail = _data["ctC_Mail"];
            this.ctC_Phone = _data["ctC_Phone"];
            this.published = _data["published"];
            this.duplicated = _data["duplicated"];
            this.user = _data["user"] ? IUserV1.fromJS(_data["user"]) : <any>undefined;
            this.ctc = _data["ctc"] ? ICtcV1.fromJS(_data["ctc"]) : <any>undefined;
            this.response = _data["response"] ? IResponseColorMatchingV1.fromJS(_data["response"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IColorMatchingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IColorMatchingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorMatchingID"] = this.colorMatchingID;
        data["reference"] = this.reference;
        data["numeroSuivi"] = this.numeroSuivi;
        data["status"] = this.status;
        data["dateCreate"] = this.dateCreate ? this.dateCreate.toISOString() : <any>undefined;
        data["dateReceive"] = this.dateReceive ? this.dateReceive.toISOString() : <any>undefined;
        data["dateFinish"] = this.dateFinish ? this.dateFinish.toISOString() : <any>undefined;
        data["userID"] = this.userID;
        data["userCompanyID"] = this.userCompanyID;
        data["colorUserID"] = this.colorUserID;
        data["ctcID"] = this.ctcID;
        data["brandVehicle"] = this.brandVehicle;
        data["yearVehicle"] = this.yearVehicle;
        data["modelVehicle"] = this.modelVehicle;
        data["codePainting"] = this.codePainting;
        data["designationPainting"] = this.designationPainting;
        data["designationOriginElement"] = this.designationOriginElement;
        data["colorOriginElement"] = this.colorOriginElement;
        data["weightOriginElement"] = this.weightOriginElement;
        data["lenghtOriginElement"] = this.lenghtOriginElement;
        data["heightOriginElement"] = this.heightOriginElement;
        data["designationFinalElement"] = this.designationFinalElement;
        data["restitution"] = this.restitution;
        data["paintQuality"] = this.paintQuality;
        data["qualityId"] = this.qualityId;
        data["comment"] = this.comment;
        data["user_Name"] = this.user_Name;
        data["user_Firstname"] = this.user_Firstname;
        data["user_Mail"] = this.user_Mail;
        data["user_Phone"] = this.user_Phone;
        data["user_Mobile"] = this.user_Mobile;
        data["user_Language"] = this.user_Language;
        data["company_SocialReason"] = this.company_SocialReason;
        data["company_Address"] = this.company_Address;
        data["company_PostalCode"] = this.company_PostalCode;
        data["company_City"] = this.company_City;
        data["company_Country"] = this.company_Country;
        data["ctC_Name"] = this.ctC_Name;
        data["ctC_Firstname"] = this.ctC_Firstname;
        data["ctC_Mail"] = this.ctC_Mail;
        data["ctC_Phone"] = this.ctC_Phone;
        data["published"] = this.published;
        data["duplicated"] = this.duplicated;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["ctc"] = this.ctc ? this.ctc.toJSON() : <any>undefined;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIColorMatchingV1 {
    colorMatchingID: number;
    reference?: string | undefined;
    numeroSuivi?: string | undefined;
    status: number;
    dateCreate: Date;
    dateReceive: Date;
    dateFinish: Date;
    userID: number;
    userCompanyID: number;
    colorUserID: number;
    ctcID: number;
    brandVehicle?: string | undefined;
    yearVehicle: number;
    modelVehicle?: string | undefined;
    codePainting?: string | undefined;
    designationPainting?: string | undefined;
    designationOriginElement?: string | undefined;
    colorOriginElement: number;
    weightOriginElement: number;
    lenghtOriginElement: number;
    heightOriginElement: number;
    designationFinalElement?: string | undefined;
    restitution: number;
    paintQuality?: string | undefined;
    qualityId?: string | undefined;
    comment?: string | undefined;
    user_Name?: string | undefined;
    user_Firstname?: string | undefined;
    user_Mail?: string | undefined;
    user_Phone?: string | undefined;
    user_Mobile?: string | undefined;
    user_Language?: string | undefined;
    company_SocialReason?: string | undefined;
    company_Address?: string | undefined;
    company_PostalCode?: string | undefined;
    company_City?: string | undefined;
    company_Country?: string | undefined;
    ctC_Name?: string | undefined;
    ctC_Firstname?: string | undefined;
    ctC_Mail?: string | undefined;
    ctC_Phone?: string | undefined;
    published: number;
    duplicated: number;
    user?: IUserV1 | undefined;
    ctc?: ICtcV1 | undefined;
    response?: IResponseColorMatchingV1 | undefined;
}

export class IUserRenault implements IIUserRenault {
    id!: number;
    idCtc!: number;
    idMci!: number;
    login?: string | undefined;
    mail?: string | undefined;
    firstname?: string | undefined;
    name?: string | undefined;
    language?: string | undefined;
    phone?: string | undefined;
    unisiteCode?: string | undefined;
    country?: string | undefined;
    dr?: string | undefined;
    isAdminRenault!: boolean;
    isAdminRenaultPays!: boolean;
    isCTC!: boolean;
    isMCI!: boolean;
    isRT!: boolean;
    isAttum!: boolean;
    isAkzo!: boolean;
    isAxalta!: boolean;
    isTechLine!: boolean;
    isFournisseur!: boolean;
    isFormateur!: boolean;
    isInternCorporate!: boolean;
    isClientCorporate!: boolean;
    haveMonitoring!: boolean;
    havePreprod!: boolean;
    haveGPI!: boolean;
    password?: string | undefined;
    droits?: string | undefined;
    compteurHisto!: number;
    userLacour!: number;
    temporaryPwd!: boolean;
    havePassword!: boolean;
    bloquer!: boolean;
    lastConnectionTS?: number | undefined;
    lastConnectionDate?: string | undefined;

    constructor(data?: IIUserRenault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idCtc = _data["idCtc"];
            this.idMci = _data["idMci"];
            this.login = _data["login"];
            this.mail = _data["mail"];
            this.firstname = _data["firstname"];
            this.name = _data["name"];
            this.language = _data["language"];
            this.phone = _data["phone"];
            this.unisiteCode = _data["unisiteCode"];
            this.country = _data["country"];
            this.dr = _data["dr"];
            this.isAdminRenault = _data["isAdminRenault"];
            this.isAdminRenaultPays = _data["isAdminRenaultPays"];
            this.isCTC = _data["isCTC"];
            this.isMCI = _data["isMCI"];
            this.isRT = _data["isRT"];
            this.isAttum = _data["isAttum"];
            this.isAkzo = _data["isAkzo"];
            this.isAxalta = _data["isAxalta"];
            this.isTechLine = _data["isTechLine"];
            this.isFournisseur = _data["isFournisseur"];
            this.isFormateur = _data["isFormateur"];
            this.isInternCorporate = _data["isInternCorporate"];
            this.isClientCorporate = _data["isClientCorporate"];
            this.haveMonitoring = _data["haveMonitoring"];
            this.havePreprod = _data["havePreprod"];
            this.haveGPI = _data["haveGPI"];
            this.password = _data["password"];
            this.droits = _data["droits"];
            this.compteurHisto = _data["compteurHisto"];
            this.userLacour = _data["userLacour"];
            this.temporaryPwd = _data["temporaryPwd"];
            this.havePassword = _data["havePassword"];
            this.bloquer = _data["bloquer"];
            this.lastConnectionTS = _data["lastConnectionTS"];
            this.lastConnectionDate = _data["lastConnectionDate"];
        }
    }

    static fromJS(data: any): IUserRenault {
        data = typeof data === 'object' ? data : {};
        let result = new IUserRenault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idCtc"] = this.idCtc;
        data["idMci"] = this.idMci;
        data["login"] = this.login;
        data["mail"] = this.mail;
        data["firstname"] = this.firstname;
        data["name"] = this.name;
        data["language"] = this.language;
        data["phone"] = this.phone;
        data["unisiteCode"] = this.unisiteCode;
        data["country"] = this.country;
        data["dr"] = this.dr;
        data["isAdminRenault"] = this.isAdminRenault;
        data["isAdminRenaultPays"] = this.isAdminRenaultPays;
        data["isCTC"] = this.isCTC;
        data["isMCI"] = this.isMCI;
        data["isRT"] = this.isRT;
        data["isAttum"] = this.isAttum;
        data["isAkzo"] = this.isAkzo;
        data["isAxalta"] = this.isAxalta;
        data["isTechLine"] = this.isTechLine;
        data["isFournisseur"] = this.isFournisseur;
        data["isFormateur"] = this.isFormateur;
        data["isInternCorporate"] = this.isInternCorporate;
        data["isClientCorporate"] = this.isClientCorporate;
        data["haveMonitoring"] = this.haveMonitoring;
        data["havePreprod"] = this.havePreprod;
        data["haveGPI"] = this.haveGPI;
        data["password"] = this.password;
        data["droits"] = this.droits;
        data["compteurHisto"] = this.compteurHisto;
        data["userLacour"] = this.userLacour;
        data["temporaryPwd"] = this.temporaryPwd;
        data["havePassword"] = this.havePassword;
        data["bloquer"] = this.bloquer;
        data["lastConnectionTS"] = this.lastConnectionTS;
        data["lastConnectionDate"] = this.lastConnectionDate;
        return data;
    }
}

export interface IIUserRenault {
    id: number;
    idCtc: number;
    idMci: number;
    login?: string | undefined;
    mail?: string | undefined;
    firstname?: string | undefined;
    name?: string | undefined;
    language?: string | undefined;
    phone?: string | undefined;
    unisiteCode?: string | undefined;
    country?: string | undefined;
    dr?: string | undefined;
    isAdminRenault: boolean;
    isAdminRenaultPays: boolean;
    isCTC: boolean;
    isMCI: boolean;
    isRT: boolean;
    isAttum: boolean;
    isAkzo: boolean;
    isAxalta: boolean;
    isTechLine: boolean;
    isFournisseur: boolean;
    isFormateur: boolean;
    isInternCorporate: boolean;
    isClientCorporate: boolean;
    haveMonitoring: boolean;
    havePreprod: boolean;
    haveGPI: boolean;
    password?: string | undefined;
    droits?: string | undefined;
    compteurHisto: number;
    userLacour: number;
    temporaryPwd: boolean;
    havePassword: boolean;
    bloquer: boolean;
    lastConnectionTS?: number | undefined;
    lastConnectionDate?: string | undefined;
}

export class ICtcV1 extends IUserRenault implements IICtcV1 {
    stats?: StatsCTC | undefined;

    constructor(data?: IICtcV1) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stats = _data["stats"] ? StatsCTC.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ICtcV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ICtcV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IICtcV1 extends IIUserRenault {
    stats?: StatsCTC | undefined;
}

export class StatsCTC implements IStatsCTC {
    nbEmailSent!: number;
    nbAccountActivated!: number;
    nbAccountTotal!: number;
    nbAccountCreated!: number;

    constructor(data?: IStatsCTC) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nbEmailSent = _data["nbEmailSent"];
            this.nbAccountActivated = _data["nbAccountActivated"];
            this.nbAccountTotal = _data["nbAccountTotal"];
            this.nbAccountCreated = _data["nbAccountCreated"];
        }
    }

    static fromJS(data: any): StatsCTC {
        data = typeof data === 'object' ? data : {};
        let result = new StatsCTC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nbEmailSent"] = this.nbEmailSent;
        data["nbAccountActivated"] = this.nbAccountActivated;
        data["nbAccountTotal"] = this.nbAccountTotal;
        data["nbAccountCreated"] = this.nbAccountCreated;
        return data;
    }
}

export interface IStatsCTC {
    nbEmailSent: number;
    nbAccountActivated: number;
    nbAccountTotal: number;
    nbAccountCreated: number;
}

export class IResponseColorMatchingV1 implements IIResponseColorMatchingV1 {
    responsecmID!: number;
    colorMatchingID!: number;
    dateResponse!: Date;
    comment?: string | undefined;
    legend!: number;
    formuleInfo?: string | undefined;
    brandVehicle?: string | undefined;
    codeFormule?: string | undefined;
    sentences?: string | undefined;
    paintQuality!: number;
    designationPainting?: string | undefined;
    multicouches!: number;
    multicouches_responsecmID?: number | undefined;
    variante?: string | undefined;
    coatCd?: string | undefined;
    contretypage?: IColorMatchingV1 | undefined;
    ingredients?: IIngredientColorMatchingV1[] | undefined;
    responseMulti?: IResponseColorMatchingV1[] | undefined;

    constructor(data?: IIResponseColorMatchingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsecmID = _data["responsecmID"];
            this.colorMatchingID = _data["colorMatchingID"];
            this.dateResponse = _data["dateResponse"] ? new Date(_data["dateResponse"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.legend = _data["legend"];
            this.formuleInfo = _data["formuleInfo"];
            this.brandVehicle = _data["brandVehicle"];
            this.codeFormule = _data["codeFormule"];
            this.sentences = _data["sentences"];
            this.paintQuality = _data["paintQuality"];
            this.designationPainting = _data["designationPainting"];
            this.multicouches = _data["multicouches"];
            this.multicouches_responsecmID = _data["multicouches_responsecmID"];
            this.variante = _data["variante"];
            this.coatCd = _data["coatCd"];
            this.contretypage = _data["contretypage"] ? IColorMatchingV1.fromJS(_data["contretypage"]) : <any>undefined;
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(IIngredientColorMatchingV1.fromJS(item));
            }
            if (Array.isArray(_data["responseMulti"])) {
                this.responseMulti = [] as any;
                for (let item of _data["responseMulti"])
                    this.responseMulti!.push(IResponseColorMatchingV1.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IResponseColorMatchingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IResponseColorMatchingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsecmID"] = this.responsecmID;
        data["colorMatchingID"] = this.colorMatchingID;
        data["dateResponse"] = this.dateResponse ? this.dateResponse.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["legend"] = this.legend;
        data["formuleInfo"] = this.formuleInfo;
        data["brandVehicle"] = this.brandVehicle;
        data["codeFormule"] = this.codeFormule;
        data["sentences"] = this.sentences;
        data["paintQuality"] = this.paintQuality;
        data["designationPainting"] = this.designationPainting;
        data["multicouches"] = this.multicouches;
        data["multicouches_responsecmID"] = this.multicouches_responsecmID;
        data["variante"] = this.variante;
        data["coatCd"] = this.coatCd;
        data["contretypage"] = this.contretypage ? this.contretypage.toJSON() : <any>undefined;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        if (Array.isArray(this.responseMulti)) {
            data["responseMulti"] = [];
            for (let item of this.responseMulti)
                data["responseMulti"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIResponseColorMatchingV1 {
    responsecmID: number;
    colorMatchingID: number;
    dateResponse: Date;
    comment?: string | undefined;
    legend: number;
    formuleInfo?: string | undefined;
    brandVehicle?: string | undefined;
    codeFormule?: string | undefined;
    sentences?: string | undefined;
    paintQuality: number;
    designationPainting?: string | undefined;
    multicouches: number;
    multicouches_responsecmID?: number | undefined;
    variante?: string | undefined;
    coatCd?: string | undefined;
    contretypage?: IColorMatchingV1 | undefined;
    ingredients?: IIngredientColorMatchingV1[] | undefined;
    responseMulti?: IResponseColorMatchingV1[] | undefined;
}

export class IIngredientColorMatchingV1 implements IIIngredientColorMatchingV1 {
    ingredientcmID!: number;
    responsecmID!: number;
    bnum!: number;
    code?: string | undefined;
    position!: number;
    quantity!: number;
    qtyCumule!: number;
    name?: string | undefined;
    bdensite!: number;
    typeprod!: number;

    constructor(data?: IIIngredientColorMatchingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientcmID = _data["ingredientcmID"];
            this.responsecmID = _data["responsecmID"];
            this.bnum = _data["bnum"];
            this.code = _data["code"];
            this.position = _data["position"];
            this.quantity = _data["quantity"];
            this.qtyCumule = _data["qtyCumule"];
            this.name = _data["name"];
            this.bdensite = _data["bdensite"];
            this.typeprod = _data["typeprod"];
        }
    }

    static fromJS(data: any): IIngredientColorMatchingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IIngredientColorMatchingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientcmID"] = this.ingredientcmID;
        data["responsecmID"] = this.responsecmID;
        data["bnum"] = this.bnum;
        data["code"] = this.code;
        data["position"] = this.position;
        data["quantity"] = this.quantity;
        data["qtyCumule"] = this.qtyCumule;
        data["name"] = this.name;
        data["bdensite"] = this.bdensite;
        data["typeprod"] = this.typeprod;
        return data;
    }
}

export interface IIIngredientColorMatchingV1 {
    ingredientcmID: number;
    responsecmID: number;
    bnum: number;
    code?: string | undefined;
    position: number;
    quantity: number;
    qtyCumule: number;
    name?: string | undefined;
    bdensite: number;
    typeprod: number;
}

export class IFilterColorMatching implements IIFilterColorMatching {
    filterColorMatchingID?: string | undefined;
    filterStatus?: number[] | undefined;
    sFilterDateStart?: string | undefined;
    sFilterDateEnd?: string | undefined;
    histoPerso!: number;

    constructor(data?: IIFilterColorMatching) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterColorMatchingID = _data["filterColorMatchingID"];
            if (Array.isArray(_data["filterStatus"])) {
                this.filterStatus = [] as any;
                for (let item of _data["filterStatus"])
                    this.filterStatus!.push(item);
            }
            this.sFilterDateStart = _data["sFilterDateStart"];
            this.sFilterDateEnd = _data["sFilterDateEnd"];
            this.histoPerso = _data["histoPerso"];
        }
    }

    static fromJS(data: any): IFilterColorMatching {
        data = typeof data === 'object' ? data : {};
        let result = new IFilterColorMatching();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterColorMatchingID"] = this.filterColorMatchingID;
        if (Array.isArray(this.filterStatus)) {
            data["filterStatus"] = [];
            for (let item of this.filterStatus)
                data["filterStatus"].push(item);
        }
        data["sFilterDateStart"] = this.sFilterDateStart;
        data["sFilterDateEnd"] = this.sFilterDateEnd;
        data["histoPerso"] = this.histoPerso;
        return data;
    }
}

export interface IIFilterColorMatching {
    filterColorMatchingID?: string | undefined;
    filterStatus?: number[] | undefined;
    sFilterDateStart?: string | undefined;
    sFilterDateEnd?: string | undefined;
    histoPerso: number;
}

export class ITextSentenceColorMatchingV1 implements IITextSentenceColorMatchingV1 {
    id!: number;
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: IITextSentenceColorMatchingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ITextSentenceColorMatchingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ITextSentenceColorMatchingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["text"] = this.text;
        return data;
    }
}

export interface IITextSentenceColorMatchingV1 {
    id: number;
    code?: string | undefined;
    text?: string | undefined;
}

export class ICoatColorMatchingV1 implements IICoatColorMatchingV1 {
    coatcmID!: number;
    coatCd?: string | undefined;
    coatDesc?: string | undefined;
    coatTypeCd?: string | undefined;

    constructor(data?: IICoatColorMatchingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coatcmID = _data["coatcmID"];
            this.coatCd = _data["coatCd"];
            this.coatDesc = _data["coatDesc"];
            this.coatTypeCd = _data["coatTypeCd"];
        }
    }

    static fromJS(data: any): ICoatColorMatchingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ICoatColorMatchingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coatcmID"] = this.coatcmID;
        data["coatCd"] = this.coatCd;
        data["coatDesc"] = this.coatDesc;
        data["coatTypeCd"] = this.coatTypeCd;
        return data;
    }
}

export interface IICoatColorMatchingV1 {
    coatcmID: number;
    coatCd?: string | undefined;
    coatDesc?: string | undefined;
    coatTypeCd?: string | undefined;
}

export class Tchat implements ITchat {
    login?: string | undefined;
    pwd?: string | undefined;
    token?: string | undefined;
    firstname?: string | undefined;
    name?: string | undefined;
    unisiteCode?: string | undefined;

    constructor(data?: ITchat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.pwd = _data["pwd"];
            this.token = _data["token"];
            this.firstname = _data["firstname"];
            this.name = _data["name"];
            this.unisiteCode = _data["unisiteCode"];
        }
    }

    static fromJS(data: any): Tchat {
        data = typeof data === 'object' ? data : {};
        let result = new Tchat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["pwd"] = this.pwd;
        data["token"] = this.token;
        data["firstname"] = this.firstname;
        data["name"] = this.name;
        data["unisiteCode"] = this.unisiteCode;
        return data;
    }
}

export interface ITchat {
    login?: string | undefined;
    pwd?: string | undefined;
    token?: string | undefined;
    firstname?: string | undefined;
    name?: string | undefined;
    unisiteCode?: string | undefined;
}

export class IUserLocale implements IIUserLocale {
    idPays!: number;
    idLangue!: number;
    pays?: string | undefined;
    langue?: string | undefined;

    constructor(data?: IIUserLocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPays = _data["idPays"];
            this.idLangue = _data["idLangue"];
            this.pays = _data["pays"];
            this.langue = _data["langue"];
        }
    }

    static fromJS(data: any): IUserLocale {
        data = typeof data === 'object' ? data : {};
        let result = new IUserLocale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPays"] = this.idPays;
        data["idLangue"] = this.idLangue;
        data["pays"] = this.pays;
        data["langue"] = this.langue;
        return data;
    }
}

export interface IIUserLocale {
    idPays: number;
    idLangue: number;
    pays?: string | undefined;
    langue?: string | undefined;
}

export class IStockTree implements IIStockTree {
    roots?: IStockFolder[] | undefined;
    redirects?: IStockLangRedirect[] | undefined;

    constructor(data?: IIStockTree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roots"])) {
                this.roots = [] as any;
                for (let item of _data["roots"])
                    this.roots!.push(IStockFolder.fromJS(item));
            }
            if (Array.isArray(_data["redirects"])) {
                this.redirects = [] as any;
                for (let item of _data["redirects"])
                    this.redirects!.push(IStockLangRedirect.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IStockTree {
        data = typeof data === 'object' ? data : {};
        let result = new IStockTree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roots)) {
            data["roots"] = [];
            for (let item of this.roots)
                data["roots"].push(item.toJSON());
        }
        if (Array.isArray(this.redirects)) {
            data["redirects"] = [];
            for (let item of this.redirects)
                data["redirects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIStockTree {
    roots?: IStockFolder[] | undefined;
    redirects?: IStockLangRedirect[] | undefined;
}

export abstract class IStockTreeElement implements IIStockTreeElement {
    parentStockFolder?: number | undefined;

    protected _discriminator: string;

    constructor(data?: IIStockTreeElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "IStockTreeElement";
    }

    init(_data?: any) {
        if (_data) {
            this.parentStockFolder = _data["parentStockFolder"];
        }
    }

    static fromJS(data: any): IStockTreeElement {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "IStockFolder") {
            let result = new IStockFolder();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IStockFileEntry") {
            let result = new IStockFileEntry();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IStockComm") {
            let result = new IStockComm();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'IStockTreeElement' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["parentStockFolder"] = this.parentStockFolder;
        return data;
    }
}

export interface IIStockTreeElement {
    parentStockFolder?: number | undefined;
}

export class IStockFolder extends IStockTreeElement implements IIStockFolder {
    idStockFolder!: number;
    parentStockFolder?: number | undefined;
    name?: string | undefined;
    mode!: number;
    extensions?: string | undefined;
    orderFolder!: number;
    children?: IStockTreeElement[] | undefined;
    path?: string | undefined;
    discriminator?: string | undefined;

    constructor(data?: IIStockFolder) {
        super(data);
        this._discriminator = "IStockFolder";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idStockFolder = _data["idStockFolder"];
            this.parentStockFolder = _data["parentStockFolder"];
            this.name = _data["name"];
            this.mode = _data["mode"];
            this.extensions = _data["extensions"];
            this.orderFolder = _data["orderFolder"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(IStockTreeElement.fromJS(item));
            }
            this.path = _data["path"];
            this.discriminator = _data["discriminator"];
        }
    }

    static override fromJS(data: any): IStockFolder {
        data = typeof data === 'object' ? data : {};
        let result = new IStockFolder();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idStockFolder"] = this.idStockFolder;
        data["parentStockFolder"] = this.parentStockFolder;
        data["name"] = this.name;
        data["mode"] = this.mode;
        data["extensions"] = this.extensions;
        data["orderFolder"] = this.orderFolder;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["path"] = this.path;
        data["discriminator"] = this.discriminator;
        super.toJSON(data);
        return data;
    }
}

export interface IIStockFolder extends IIStockTreeElement {
    idStockFolder: number;
    parentStockFolder?: number | undefined;
    name?: string | undefined;
    mode: number;
    extensions?: string | undefined;
    orderFolder: number;
    children?: IStockTreeElement[] | undefined;
    path?: string | undefined;
    discriminator?: string | undefined;
}

export class IStockFileEntry extends IStockTreeElement implements IIStockFileEntry {
    idStockFileEntry!: number;
    contents?: IStockFileContent[] | undefined;
    discriminator?: string | undefined;

    constructor(data?: IIStockFileEntry) {
        super(data);
        this._discriminator = "IStockFileEntry";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idStockFileEntry = _data["idStockFileEntry"];
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(IStockFileContent.fromJS(item));
            }
            this.discriminator = _data["discriminator"];
        }
    }

    static override fromJS(data: any): IStockFileEntry {
        data = typeof data === 'object' ? data : {};
        let result = new IStockFileEntry();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idStockFileEntry"] = this.idStockFileEntry;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        data["discriminator"] = this.discriminator;
        super.toJSON(data);
        return data;
    }
}

export interface IIStockFileEntry extends IIStockTreeElement {
    idStockFileEntry: number;
    contents?: IStockFileContent[] | undefined;
    discriminator?: string | undefined;
}

export class IStockFileContent implements IIStockFileContent {
    idStockFileContent!: number;
    idStockFileEntry!: number;
    paysId?: number | undefined;
    langId?: number | undefined;
    name?: string | undefined;
    content?: string | undefined;
    lastEdit!: Date;
    unlisted!: boolean;
    url?: string | undefined;

    constructor(data?: IIStockFileContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idStockFileContent = _data["idStockFileContent"];
            this.idStockFileEntry = _data["idStockFileEntry"];
            this.paysId = _data["paysId"];
            this.langId = _data["langId"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.lastEdit = _data["lastEdit"] ? new Date(_data["lastEdit"].toString()) : <any>undefined;
            this.unlisted = _data["unlisted"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): IStockFileContent {
        data = typeof data === 'object' ? data : {};
        let result = new IStockFileContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idStockFileContent"] = this.idStockFileContent;
        data["idStockFileEntry"] = this.idStockFileEntry;
        data["paysId"] = this.paysId;
        data["langId"] = this.langId;
        data["name"] = this.name;
        data["content"] = this.content;
        data["lastEdit"] = this.lastEdit ? this.lastEdit.toISOString() : <any>undefined;
        data["unlisted"] = this.unlisted;
        data["url"] = this.url;
        return data;
    }
}

export interface IIStockFileContent {
    idStockFileContent: number;
    idStockFileEntry: number;
    paysId?: number | undefined;
    langId?: number | undefined;
    name?: string | undefined;
    content?: string | undefined;
    lastEdit: Date;
    unlisted: boolean;
    url?: string | undefined;
}

export class IStockComm extends IStockTreeElement implements IIStockComm {
    idStockComm!: number;
    startingDate!: Date;
    endingDate!: Date;
    title?: string | undefined;
    docFilename?: string | undefined;
    bannerFilename?: string | undefined;
    tariff?: string | undefined;
    tech?: string | undefined;
    paysId!: number;
    docFile?: string | undefined;
    bannerFile?: string | undefined;
    discriminator?: string | undefined;

    constructor(data?: IIStockComm) {
        super(data);
        this._discriminator = "IStockComm";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idStockComm = _data["idStockComm"];
            this.startingDate = _data["startingDate"] ? new Date(_data["startingDate"].toString()) : <any>undefined;
            this.endingDate = _data["endingDate"] ? new Date(_data["endingDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.docFilename = _data["docFilename"];
            this.bannerFilename = _data["bannerFilename"];
            this.tariff = _data["tariff"];
            this.tech = _data["tech"];
            this.paysId = _data["paysId"];
            this.docFile = _data["docFile"];
            this.bannerFile = _data["bannerFile"];
            this.discriminator = _data["discriminator"];
        }
    }

    static override fromJS(data: any): IStockComm {
        data = typeof data === 'object' ? data : {};
        let result = new IStockComm();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idStockComm"] = this.idStockComm;
        data["startingDate"] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data["endingDate"] = this.endingDate ? this.endingDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["docFilename"] = this.docFilename;
        data["bannerFilename"] = this.bannerFilename;
        data["tariff"] = this.tariff;
        data["tech"] = this.tech;
        data["paysId"] = this.paysId;
        data["docFile"] = this.docFile;
        data["bannerFile"] = this.bannerFile;
        data["discriminator"] = this.discriminator;
        super.toJSON(data);
        return data;
    }
}

export interface IIStockComm extends IIStockTreeElement {
    idStockComm: number;
    startingDate: Date;
    endingDate: Date;
    title?: string | undefined;
    docFilename?: string | undefined;
    bannerFilename?: string | undefined;
    tariff?: string | undefined;
    tech?: string | undefined;
    paysId: number;
    docFile?: string | undefined;
    bannerFile?: string | undefined;
    discriminator?: string | undefined;
}

export class IStockLangRedirect implements IIStockLangRedirect {
    srcLang!: number;
    dstLang!: number;

    constructor(data?: IIStockLangRedirect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.srcLang = _data["srcLang"];
            this.dstLang = _data["dstLang"];
        }
    }

    static fromJS(data: any): IStockLangRedirect {
        data = typeof data === 'object' ? data : {};
        let result = new IStockLangRedirect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["srcLang"] = this.srcLang;
        data["dstLang"] = this.dstLang;
        return data;
    }
}

export interface IIStockLangRedirect {
    srcLang: number;
    dstLang: number;
}

export class IStockLog implements IIStockLog {
    idStockLog!: number;
    idStockFolder!: number;
    idStockFileContent?: number | undefined;
    login?: string | undefined;
    date!: Date;
    action!: StockLogAction;
    filename?: string | undefined;
    details?: string | undefined;

    constructor(data?: IIStockLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idStockLog = _data["idStockLog"];
            this.idStockFolder = _data["idStockFolder"];
            this.idStockFileContent = _data["idStockFileContent"];
            this.login = _data["login"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.action = _data["action"];
            this.filename = _data["filename"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): IStockLog {
        data = typeof data === 'object' ? data : {};
        let result = new IStockLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idStockLog"] = this.idStockLog;
        data["idStockFolder"] = this.idStockFolder;
        data["idStockFileContent"] = this.idStockFileContent;
        data["login"] = this.login;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["action"] = this.action;
        data["filename"] = this.filename;
        data["details"] = this.details;
        return data;
    }
}

export interface IIStockLog {
    idStockLog: number;
    idStockFolder: number;
    idStockFileContent?: number | undefined;
    login?: string | undefined;
    date: Date;
    action: StockLogAction;
    filename?: string | undefined;
    details?: string | undefined;
}

export enum StockLogAction {
    ADD = 0,
    DELETE = 1,
    EDIT = 2,
}

export class IPlanningListV1 implements IIPlanningListV1 {
    planningID!: number;
    planningToken?: string | undefined;
    loginHotliner?: string | undefined;
    firstnameHotliner?: string | undefined;
    nameHotliner?: string | undefined;
    mailHotliner?: string | undefined;
    languages?: string | undefined;
    status!: PlanningStatus;

    constructor(data?: IIPlanningListV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planningID = _data["planningID"];
            this.planningToken = _data["planningToken"];
            this.loginHotliner = _data["loginHotliner"];
            this.firstnameHotliner = _data["firstnameHotliner"];
            this.nameHotliner = _data["nameHotliner"];
            this.mailHotliner = _data["mailHotliner"];
            this.languages = _data["languages"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IPlanningListV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IPlanningListV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planningID"] = this.planningID;
        data["planningToken"] = this.planningToken;
        data["loginHotliner"] = this.loginHotliner;
        data["firstnameHotliner"] = this.firstnameHotliner;
        data["nameHotliner"] = this.nameHotliner;
        data["mailHotliner"] = this.mailHotliner;
        data["languages"] = this.languages;
        data["status"] = this.status;
        return data;
    }
}

export interface IIPlanningListV1 {
    planningID: number;
    planningToken?: string | undefined;
    loginHotliner?: string | undefined;
    firstnameHotliner?: string | undefined;
    nameHotliner?: string | undefined;
    mailHotliner?: string | undefined;
    languages?: string | undefined;
    status: PlanningStatus;
}

export enum PlanningStatus {
    Sleepy = 0,
    Active = 1,
}

export class WeekDates implements IWeekDates {
    startDate!: Date;
    endDate!: Date;
    monday!: Date;
    friday!: Date;
    isBack!: boolean;
    isNext!: boolean;
    minStartDate!: Date;
    listOfDaysWeek?: string[] | undefined;
    listOfDaysWeekShort?: string[] | undefined;

    constructor(data?: IWeekDates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.monday = _data["monday"] ? new Date(_data["monday"].toString()) : <any>undefined;
            this.friday = _data["friday"] ? new Date(_data["friday"].toString()) : <any>undefined;
            this.isBack = _data["isBack"];
            this.isNext = _data["isNext"];
            this.minStartDate = _data["minStartDate"] ? new Date(_data["minStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["listOfDaysWeek"])) {
                this.listOfDaysWeek = [] as any;
                for (let item of _data["listOfDaysWeek"])
                    this.listOfDaysWeek!.push(item);
            }
            if (Array.isArray(_data["listOfDaysWeekShort"])) {
                this.listOfDaysWeekShort = [] as any;
                for (let item of _data["listOfDaysWeekShort"])
                    this.listOfDaysWeekShort!.push(item);
            }
        }
    }

    static fromJS(data: any): WeekDates {
        data = typeof data === 'object' ? data : {};
        let result = new WeekDates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["monday"] = this.monday ? this.monday.toISOString() : <any>undefined;
        data["friday"] = this.friday ? this.friday.toISOString() : <any>undefined;
        data["isBack"] = this.isBack;
        data["isNext"] = this.isNext;
        data["minStartDate"] = this.minStartDate ? this.minStartDate.toISOString() : <any>undefined;
        if (Array.isArray(this.listOfDaysWeek)) {
            data["listOfDaysWeek"] = [];
            for (let item of this.listOfDaysWeek)
                data["listOfDaysWeek"].push(item);
        }
        if (Array.isArray(this.listOfDaysWeekShort)) {
            data["listOfDaysWeekShort"] = [];
            for (let item of this.listOfDaysWeekShort)
                data["listOfDaysWeekShort"].push(item);
        }
        return data;
    }
}

export interface IWeekDates {
    startDate: Date;
    endDate: Date;
    monday: Date;
    friday: Date;
    isBack: boolean;
    isNext: boolean;
    minStartDate: Date;
    listOfDaysWeek?: string[] | undefined;
    listOfDaysWeekShort?: string[] | undefined;
}

export class ICreneauxPlanning implements IICreneauxPlanning {
    date!: Date;
    dateString?: string | undefined;
    heureDebut!: string;
    heureDebutRdv?: string | undefined;
    heureFin!: string;
    heureFinRdv?: string | undefined;
    centreID!: number;
    planningID!: number;
    planningToken?: string | undefined;
    reserved!: number;
    reserver!: boolean;

    constructor(data?: IICreneauxPlanning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dateString = _data["dateString"];
            this.heureDebut = _data["heureDebut"];
            this.heureDebutRdv = _data["heureDebutRdv"];
            this.heureFin = _data["heureFin"];
            this.heureFinRdv = _data["heureFinRdv"];
            this.centreID = _data["centreID"];
            this.planningID = _data["planningID"];
            this.planningToken = _data["planningToken"];
            this.reserved = _data["reserved"];
            this.reserver = _data["reserver"];
        }
    }

    static fromJS(data: any): ICreneauxPlanning {
        data = typeof data === 'object' ? data : {};
        let result = new ICreneauxPlanning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dateString"] = this.dateString;
        data["heureDebut"] = this.heureDebut;
        data["heureDebutRdv"] = this.heureDebutRdv;
        data["heureFin"] = this.heureFin;
        data["heureFinRdv"] = this.heureFinRdv;
        data["centreID"] = this.centreID;
        data["planningID"] = this.planningID;
        data["planningToken"] = this.planningToken;
        data["reserved"] = this.reserved;
        data["reserver"] = this.reserver;
        return data;
    }
}

export interface IICreneauxPlanning {
    date: Date;
    dateString?: string | undefined;
    heureDebut: string;
    heureDebutRdv?: string | undefined;
    heureFin: string;
    heureFinRdv?: string | undefined;
    centreID: number;
    planningID: number;
    planningToken?: string | undefined;
    reserved: number;
    reserver: boolean;
}

export class IPlanningInterventionLightV1 implements IIPlanningInterventionLightV1 {
    interventionID!: number;
    label?: string | undefined;
    duration!: number;

    constructor(data?: IIPlanningInterventionLightV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interventionID = _data["interventionID"];
            this.label = _data["label"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): IPlanningInterventionLightV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IPlanningInterventionLightV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interventionID"] = this.interventionID;
        data["label"] = this.label;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IIPlanningInterventionLightV1 {
    interventionID: number;
    label?: string | undefined;
    duration: number;
}

export class IColorUserV1 implements IIColorUserV1 {
    idcolorUser!: number;
    mail?: string | undefined;
    listMail?: string | undefined;
    password?: string | undefined;
    emergencyMail?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    language?: string | undefined;
    businessCode?: string | undefined;
    customerCode?: string | undefined;
    cityRenault?: string | undefined;
    accepted!: number;
    refusal?: string | undefined;
    activationDate?: string | undefined;
    haveScale!: number;
    scaleType!: number;
    paintBrand?: string | undefined;
    mrpAccount?: string | undefined;
    temporaryPwd!: boolean;
    ctcName?: string | undefined;
    mailSended!: boolean;
    unisiteCode?: string | undefined;
    serialNumber?: string | undefined;
    compteTresor?: string | undefined;
    scale?: string | undefined;
    idCtc?: string | undefined;
    hidden!: boolean;
    ctcCreated!: boolean;
    dateMailSent?: string | undefined;
    nbConnection!: number;
    statusAdmin!: number;
    dateMajAdmin?: Date | undefined;
    loginAdmin?: string | undefined;
    haveCtcAndDR!: number;
    userLacour!: boolean;
    havePassword!: boolean;
    tva?: string | undefined;
    siren?: string | undefined;
    createProvenance!: number;
    colorUserParent!: number;
    isAdminIVC!: boolean;
    isAdminIVL!: boolean;

    constructor(data?: IIColorUserV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcolorUser = _data["idcolorUser"];
            this.mail = _data["mail"];
            this.listMail = _data["listMail"];
            this.password = _data["password"];
            this.emergencyMail = _data["emergencyMail"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.socialReason = _data["socialReason"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.language = _data["language"];
            this.businessCode = _data["businessCode"];
            this.customerCode = _data["customerCode"];
            this.cityRenault = _data["cityRenault"];
            this.accepted = _data["accepted"];
            this.refusal = _data["refusal"];
            this.activationDate = _data["activationDate"];
            this.haveScale = _data["haveScale"];
            this.scaleType = _data["scaleType"];
            this.paintBrand = _data["paintBrand"];
            this.mrpAccount = _data["mrpAccount"];
            this.temporaryPwd = _data["temporaryPwd"];
            this.ctcName = _data["ctcName"];
            this.mailSended = _data["mailSended"];
            this.unisiteCode = _data["unisiteCode"];
            this.serialNumber = _data["serialNumber"];
            this.compteTresor = _data["compteTresor"];
            this.scale = _data["scale"];
            this.idCtc = _data["idCtc"];
            this.hidden = _data["hidden"];
            this.ctcCreated = _data["ctcCreated"];
            this.dateMailSent = _data["dateMailSent"];
            this.nbConnection = _data["nbConnection"];
            this.statusAdmin = _data["statusAdmin"];
            this.dateMajAdmin = _data["dateMajAdmin"] ? new Date(_data["dateMajAdmin"].toString()) : <any>undefined;
            this.loginAdmin = _data["loginAdmin"];
            this.haveCtcAndDR = _data["haveCtcAndDR"];
            this.userLacour = _data["userLacour"];
            this.havePassword = _data["havePassword"];
            this.tva = _data["tva"];
            this.siren = _data["siren"];
            this.createProvenance = _data["createProvenance"];
            this.colorUserParent = _data["colorUserParent"];
            this.isAdminIVC = _data["isAdminIVC"];
            this.isAdminIVL = _data["isAdminIVL"];
        }
    }

    static fromJS(data: any): IColorUserV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IColorUserV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcolorUser"] = this.idcolorUser;
        data["mail"] = this.mail;
        data["listMail"] = this.listMail;
        data["password"] = this.password;
        data["emergencyMail"] = this.emergencyMail;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["socialReason"] = this.socialReason;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["language"] = this.language;
        data["businessCode"] = this.businessCode;
        data["customerCode"] = this.customerCode;
        data["cityRenault"] = this.cityRenault;
        data["accepted"] = this.accepted;
        data["refusal"] = this.refusal;
        data["activationDate"] = this.activationDate;
        data["haveScale"] = this.haveScale;
        data["scaleType"] = this.scaleType;
        data["paintBrand"] = this.paintBrand;
        data["mrpAccount"] = this.mrpAccount;
        data["temporaryPwd"] = this.temporaryPwd;
        data["ctcName"] = this.ctcName;
        data["mailSended"] = this.mailSended;
        data["unisiteCode"] = this.unisiteCode;
        data["serialNumber"] = this.serialNumber;
        data["compteTresor"] = this.compteTresor;
        data["scale"] = this.scale;
        data["idCtc"] = this.idCtc;
        data["hidden"] = this.hidden;
        data["ctcCreated"] = this.ctcCreated;
        data["dateMailSent"] = this.dateMailSent;
        data["nbConnection"] = this.nbConnection;
        data["statusAdmin"] = this.statusAdmin;
        data["dateMajAdmin"] = this.dateMajAdmin ? this.dateMajAdmin.toISOString() : <any>undefined;
        data["loginAdmin"] = this.loginAdmin;
        data["haveCtcAndDR"] = this.haveCtcAndDR;
        data["userLacour"] = this.userLacour;
        data["havePassword"] = this.havePassword;
        data["tva"] = this.tva;
        data["siren"] = this.siren;
        data["createProvenance"] = this.createProvenance;
        data["colorUserParent"] = this.colorUserParent;
        data["isAdminIVC"] = this.isAdminIVC;
        data["isAdminIVL"] = this.isAdminIVL;
        return data;
    }
}

export interface IIColorUserV1 {
    idcolorUser: number;
    mail?: string | undefined;
    listMail?: string | undefined;
    password?: string | undefined;
    emergencyMail?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    language?: string | undefined;
    businessCode?: string | undefined;
    customerCode?: string | undefined;
    cityRenault?: string | undefined;
    accepted: number;
    refusal?: string | undefined;
    activationDate?: string | undefined;
    haveScale: number;
    scaleType: number;
    paintBrand?: string | undefined;
    mrpAccount?: string | undefined;
    temporaryPwd: boolean;
    ctcName?: string | undefined;
    mailSended: boolean;
    unisiteCode?: string | undefined;
    serialNumber?: string | undefined;
    compteTresor?: string | undefined;
    scale?: string | undefined;
    idCtc?: string | undefined;
    hidden: boolean;
    ctcCreated: boolean;
    dateMailSent?: string | undefined;
    nbConnection: number;
    statusAdmin: number;
    dateMajAdmin?: Date | undefined;
    loginAdmin?: string | undefined;
    haveCtcAndDR: number;
    userLacour: boolean;
    havePassword: boolean;
    tva?: string | undefined;
    siren?: string | undefined;
    createProvenance: number;
    colorUserParent: number;
    isAdminIVC: boolean;
    isAdminIVL: boolean;
}

export class IPlanningRdvV1 implements IIPlanningRdvV1 {
    rdvID!: number;
    planningToken?: string | undefined;
    interventionID!: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    coloruser_UserID!: number;
    ctc_ctcID!: number;
    status!: StatusRDV;
    wpStatus!: StatusRDV;
    wpDate?: Date | undefined;
    wpPlanningID!: number;
    wpRdvID!: number;
    unisiteStatus!: StatusRDV;
    unisiteDate!: Date;
    unisiteRdvID?: string | undefined;
    unisiteCongesID!: number;
    unisiteRdvType!: UnisiteTypeRDV;

    constructor(data?: IIPlanningRdvV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rdvID = _data["rdvID"];
            this.planningToken = _data["planningToken"];
            this.interventionID = _data["interventionID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.coloruser_UserID = _data["coloruser_UserID"];
            this.ctc_ctcID = _data["ctc_ctcID"];
            this.status = _data["status"];
            this.wpStatus = _data["wpStatus"];
            this.wpDate = _data["wpDate"] ? new Date(_data["wpDate"].toString()) : <any>undefined;
            this.wpPlanningID = _data["wpPlanningID"];
            this.wpRdvID = _data["wpRdvID"];
            this.unisiteStatus = _data["unisiteStatus"];
            this.unisiteDate = _data["unisiteDate"] ? new Date(_data["unisiteDate"].toString()) : <any>undefined;
            this.unisiteRdvID = _data["unisiteRdvID"];
            this.unisiteCongesID = _data["unisiteCongesID"];
            this.unisiteRdvType = _data["unisiteRdvType"];
        }
    }

    static fromJS(data: any): IPlanningRdvV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IPlanningRdvV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rdvID"] = this.rdvID;
        data["planningToken"] = this.planningToken;
        data["interventionID"] = this.interventionID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["coloruser_UserID"] = this.coloruser_UserID;
        data["ctc_ctcID"] = this.ctc_ctcID;
        data["status"] = this.status;
        data["wpStatus"] = this.wpStatus;
        data["wpDate"] = this.wpDate ? this.wpDate.toISOString() : <any>undefined;
        data["wpPlanningID"] = this.wpPlanningID;
        data["wpRdvID"] = this.wpRdvID;
        data["unisiteStatus"] = this.unisiteStatus;
        data["unisiteDate"] = this.unisiteDate ? this.unisiteDate.toISOString() : <any>undefined;
        data["unisiteRdvID"] = this.unisiteRdvID;
        data["unisiteCongesID"] = this.unisiteCongesID;
        data["unisiteRdvType"] = this.unisiteRdvType;
        return data;
    }
}

export interface IIPlanningRdvV1 {
    rdvID: number;
    planningToken?: string | undefined;
    interventionID: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    coloruser_UserID: number;
    ctc_ctcID: number;
    status: StatusRDV;
    wpStatus: StatusRDV;
    wpDate?: Date | undefined;
    wpPlanningID: number;
    wpRdvID: number;
    unisiteStatus: StatusRDV;
    unisiteDate: Date;
    unisiteRdvID?: string | undefined;
    unisiteCongesID: number;
    unisiteRdvType: UnisiteTypeRDV;
}

export enum StatusRDV {
    WAITING_SEND = 0,
    TRANSMITTED = 1,
    CANCELLED = 2,
}

export enum UnisiteTypeRDV {
    CREATION = 1,
    DELETION = 2,
}

export class IPlanningHisto implements IIPlanningHisto {
    rdv?: IPlanningRdvInfos | undefined;
    typeIntervention?: string | undefined;
    user_Code?: string | undefined;
    user_FirstName?: string | undefined;
    user_Name?: string | undefined;
    user_SocialReason?: string | undefined;
    ctc_FirstName?: string | undefined;
    ctc_Name?: string | undefined;
    ctc_Phone?: string | undefined;
    canCancel!: boolean;

    constructor(data?: IIPlanningHisto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rdv = _data["rdv"] ? IPlanningRdvInfos.fromJS(_data["rdv"]) : <any>undefined;
            this.typeIntervention = _data["typeIntervention"];
            this.user_Code = _data["user_Code"];
            this.user_FirstName = _data["user_FirstName"];
            this.user_Name = _data["user_Name"];
            this.user_SocialReason = _data["user_SocialReason"];
            this.ctc_FirstName = _data["ctc_FirstName"];
            this.ctc_Name = _data["ctc_Name"];
            this.ctc_Phone = _data["ctc_Phone"];
            this.canCancel = _data["canCancel"];
        }
    }

    static fromJS(data: any): IPlanningHisto {
        data = typeof data === 'object' ? data : {};
        let result = new IPlanningHisto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rdv"] = this.rdv ? this.rdv.toJSON() : <any>undefined;
        data["typeIntervention"] = this.typeIntervention;
        data["user_Code"] = this.user_Code;
        data["user_FirstName"] = this.user_FirstName;
        data["user_Name"] = this.user_Name;
        data["user_SocialReason"] = this.user_SocialReason;
        data["ctc_FirstName"] = this.ctc_FirstName;
        data["ctc_Name"] = this.ctc_Name;
        data["ctc_Phone"] = this.ctc_Phone;
        data["canCancel"] = this.canCancel;
        return data;
    }
}

export interface IIPlanningHisto {
    rdv?: IPlanningRdvInfos | undefined;
    typeIntervention?: string | undefined;
    user_Code?: string | undefined;
    user_FirstName?: string | undefined;
    user_Name?: string | undefined;
    user_SocialReason?: string | undefined;
    ctc_FirstName?: string | undefined;
    ctc_Name?: string | undefined;
    ctc_Phone?: string | undefined;
    canCancel: boolean;
}

export class IPlanningRdvInfos implements IIPlanningRdvInfos {
    rdvID!: number;
    label?: string | undefined;
    labelFR?: string | undefined;
    duration!: number;
    startDate!: Date;
    endDate!: Date;
    status!: StatusRDV;
    wpRdvID!: number;
    name?: string | undefined;
    firstname?: string | undefined;
    socialReason?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    mailHotliner?: string | undefined;

    constructor(data?: IIPlanningRdvInfos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rdvID = _data["rdvID"];
            this.label = _data["label"];
            this.labelFR = _data["labelFR"];
            this.duration = _data["duration"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.wpRdvID = _data["wpRdvID"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.socialReason = _data["socialReason"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.mailHotliner = _data["mailHotliner"];
        }
    }

    static fromJS(data: any): IPlanningRdvInfos {
        data = typeof data === 'object' ? data : {};
        let result = new IPlanningRdvInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rdvID"] = this.rdvID;
        data["label"] = this.label;
        data["labelFR"] = this.labelFR;
        data["duration"] = this.duration;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["wpRdvID"] = this.wpRdvID;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["socialReason"] = this.socialReason;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["mailHotliner"] = this.mailHotliner;
        return data;
    }
}

export interface IIPlanningRdvInfos {
    rdvID: number;
    label?: string | undefined;
    labelFR?: string | undefined;
    duration: number;
    startDate: Date;
    endDate: Date;
    status: StatusRDV;
    wpRdvID: number;
    name?: string | undefined;
    firstname?: string | undefined;
    socialReason?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    mailHotliner?: string | undefined;
}

export class IPlanningGestionRDV implements IIPlanningGestionRDV {
    rdvID!: number;
    typeIntervention?: string | undefined;
    duration!: number;
    startDate!: Date;
    endDate!: Date;
    status!: StatusRDV;
    wpRdvID!: number;
    ctc_ctcID!: number;
    ctc_Name?: string | undefined;
    ctc_Firstname?: string | undefined;
    ctc_Phone?: string | undefined;
    ctc_Mail?: string | undefined;
    ctc_Language?: string | undefined;
    ctc_Country?: string | undefined;
    user_Name?: string | undefined;
    user_Firstname?: string | undefined;
    user_SocialReason?: string | undefined;
    user_PostalCode?: string | undefined;
    user_City?: string | undefined;
    loginHotliner?: string | undefined;
    firstnameHotliner?: string | undefined;
    nameHotliner?: string | undefined;
    mailHotliner?: string | undefined;
    canCancel!: boolean;

    constructor(data?: IIPlanningGestionRDV) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rdvID = _data["rdvID"];
            this.typeIntervention = _data["typeIntervention"];
            this.duration = _data["duration"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.wpRdvID = _data["wpRdvID"];
            this.ctc_ctcID = _data["ctc_ctcID"];
            this.ctc_Name = _data["ctc_Name"];
            this.ctc_Firstname = _data["ctc_Firstname"];
            this.ctc_Phone = _data["ctc_Phone"];
            this.ctc_Mail = _data["ctc_Mail"];
            this.ctc_Language = _data["ctc_Language"];
            this.ctc_Country = _data["ctc_Country"];
            this.user_Name = _data["user_Name"];
            this.user_Firstname = _data["user_Firstname"];
            this.user_SocialReason = _data["user_SocialReason"];
            this.user_PostalCode = _data["user_PostalCode"];
            this.user_City = _data["user_City"];
            this.loginHotliner = _data["loginHotliner"];
            this.firstnameHotliner = _data["firstnameHotliner"];
            this.nameHotliner = _data["nameHotliner"];
            this.mailHotliner = _data["mailHotliner"];
            this.canCancel = _data["canCancel"];
        }
    }

    static fromJS(data: any): IPlanningGestionRDV {
        data = typeof data === 'object' ? data : {};
        let result = new IPlanningGestionRDV();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rdvID"] = this.rdvID;
        data["typeIntervention"] = this.typeIntervention;
        data["duration"] = this.duration;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["wpRdvID"] = this.wpRdvID;
        data["ctc_ctcID"] = this.ctc_ctcID;
        data["ctc_Name"] = this.ctc_Name;
        data["ctc_Firstname"] = this.ctc_Firstname;
        data["ctc_Phone"] = this.ctc_Phone;
        data["ctc_Mail"] = this.ctc_Mail;
        data["ctc_Language"] = this.ctc_Language;
        data["ctc_Country"] = this.ctc_Country;
        data["user_Name"] = this.user_Name;
        data["user_Firstname"] = this.user_Firstname;
        data["user_SocialReason"] = this.user_SocialReason;
        data["user_PostalCode"] = this.user_PostalCode;
        data["user_City"] = this.user_City;
        data["loginHotliner"] = this.loginHotliner;
        data["firstnameHotliner"] = this.firstnameHotliner;
        data["nameHotliner"] = this.nameHotliner;
        data["mailHotliner"] = this.mailHotliner;
        data["canCancel"] = this.canCancel;
        return data;
    }
}

export interface IIPlanningGestionRDV {
    rdvID: number;
    typeIntervention?: string | undefined;
    duration: number;
    startDate: Date;
    endDate: Date;
    status: StatusRDV;
    wpRdvID: number;
    ctc_ctcID: number;
    ctc_Name?: string | undefined;
    ctc_Firstname?: string | undefined;
    ctc_Phone?: string | undefined;
    ctc_Mail?: string | undefined;
    ctc_Language?: string | undefined;
    ctc_Country?: string | undefined;
    user_Name?: string | undefined;
    user_Firstname?: string | undefined;
    user_SocialReason?: string | undefined;
    user_PostalCode?: string | undefined;
    user_City?: string | undefined;
    loginHotliner?: string | undefined;
    firstnameHotliner?: string | undefined;
    nameHotliner?: string | undefined;
    mailHotliner?: string | undefined;
    canCancel: boolean;
}

export abstract class AbstractEntity implements IAbstractEntity {

    constructor(data?: IAbstractEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AbstractEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AbstractEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAbstractEntity {
}

export class ErrorLogV1 extends AbstractEntity implements IErrorLogV1 {
    iderrorlog!: number;
    code?: string | undefined;
    description?: string | undefined;
    parameters?: string | undefined;
    date!: Date;

    constructor(data?: IErrorLogV1) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iderrorlog = _data["iderrorlog"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.parameters = _data["parameters"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ErrorLogV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorLogV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iderrorlog"] = this.iderrorlog;
        data["code"] = this.code;
        data["description"] = this.description;
        data["parameters"] = this.parameters;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IErrorLogV1 extends IAbstractEntity {
    iderrorlog: number;
    code?: string | undefined;
    description?: string | undefined;
    parameters?: string | undefined;
    date: Date;
}

export class IMailDataV1 implements IIMailDataV1 {
    activationId!: number;
    activStatut!: number;
    scaleCode?: string | undefined;
    userMail?: string | undefined;
    userLanguage?: string | undefined;
    userFirstname?: string | undefined;
    userName?: string | undefined;
    userLoginUnisite?: string | undefined;
    userPwdUnisite?: string | undefined;
    userCompany?: string | undefined;
    payorMail?: string | undefined;
    payorLanguage?: string | undefined;
    payorFirstname?: string | undefined;
    payorName?: string | undefined;
    payorLoginUnisite?: string | undefined;
    payorPwdUnisite?: string | undefined;
    payorCompany?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    ctcFirstname?: string | undefined;
    ctcName?: string | undefined;

    constructor(data?: IIMailDataV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationId = _data["activationId"];
            this.activStatut = _data["activStatut"];
            this.scaleCode = _data["scaleCode"];
            this.userMail = _data["userMail"];
            this.userLanguage = _data["userLanguage"];
            this.userFirstname = _data["userFirstname"];
            this.userName = _data["userName"];
            this.userLoginUnisite = _data["userLoginUnisite"];
            this.userPwdUnisite = _data["userPwdUnisite"];
            this.userCompany = _data["userCompany"];
            this.payorMail = _data["payorMail"];
            this.payorLanguage = _data["payorLanguage"];
            this.payorFirstname = _data["payorFirstname"];
            this.payorName = _data["payorName"];
            this.payorLoginUnisite = _data["payorLoginUnisite"];
            this.payorPwdUnisite = _data["payorPwdUnisite"];
            this.payorCompany = _data["payorCompany"];
            this.ctcMail = _data["ctcMail"];
            this.ctcLanguage = _data["ctcLanguage"];
            this.ctcFirstname = _data["ctcFirstname"];
            this.ctcName = _data["ctcName"];
        }
    }

    static fromJS(data: any): IMailDataV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IMailDataV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationId"] = this.activationId;
        data["activStatut"] = this.activStatut;
        data["scaleCode"] = this.scaleCode;
        data["userMail"] = this.userMail;
        data["userLanguage"] = this.userLanguage;
        data["userFirstname"] = this.userFirstname;
        data["userName"] = this.userName;
        data["userLoginUnisite"] = this.userLoginUnisite;
        data["userPwdUnisite"] = this.userPwdUnisite;
        data["userCompany"] = this.userCompany;
        data["payorMail"] = this.payorMail;
        data["payorLanguage"] = this.payorLanguage;
        data["payorFirstname"] = this.payorFirstname;
        data["payorName"] = this.payorName;
        data["payorLoginUnisite"] = this.payorLoginUnisite;
        data["payorPwdUnisite"] = this.payorPwdUnisite;
        data["payorCompany"] = this.payorCompany;
        data["ctcMail"] = this.ctcMail;
        data["ctcLanguage"] = this.ctcLanguage;
        data["ctcFirstname"] = this.ctcFirstname;
        data["ctcName"] = this.ctcName;
        return data;
    }
}

export interface IIMailDataV1 {
    activationId: number;
    activStatut: number;
    scaleCode?: string | undefined;
    userMail?: string | undefined;
    userLanguage?: string | undefined;
    userFirstname?: string | undefined;
    userName?: string | undefined;
    userLoginUnisite?: string | undefined;
    userPwdUnisite?: string | undefined;
    userCompany?: string | undefined;
    payorMail?: string | undefined;
    payorLanguage?: string | undefined;
    payorFirstname?: string | undefined;
    payorName?: string | undefined;
    payorLoginUnisite?: string | undefined;
    payorPwdUnisite?: string | undefined;
    payorCompany?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    ctcFirstname?: string | undefined;
    ctcName?: string | undefined;
}

export class IProductV1 implements IIProductV1 {
    productID!: number;
    typeP!: ProductType;
    associatedScale!: ScaleSelect;
    refP?: string | undefined;
    labelP?: string | undefined;
    labelENP?: string | undefined;
    labelDEP?: string | undefined;
    labelESP?: string | undefined;
    labelITP?: string | undefined;
    labelNLP?: string | undefined;
    labelPLP?: string | undefined;
    labelPTP?: string | undefined;
    labelROP?: string | undefined;
    labelTRP?: string | undefined;
    fraisLivManuel!: boolean;
    fraisLivP!: number;
    fraisLivBEP!: number;
    fraisLivDEP!: number;
    fraisLivENP!: number;
    fraisLivESP!: number;
    fraisLivITP!: number;
    fraisLivNLP!: number;
    fraisLivPLP!: number;
    fraisLivPTP!: number;
    fraisLivROP!: number;
    fraisLivTRP!: number;
    amountP!: number;
    qteStock!: number;
    available!: boolean;
    picture?: string | undefined;
    pictureBlob?: string | undefined;
    pictureBlob2?: string | undefined;
    pictureZoom?: string | undefined;
    pictureZoomInsertBlob?: string | undefined;
    pictureZoomDisplayBlob?: string | undefined;
    qte!: number;
    rentable!: number;
    fraisLivRentable!: number;
    typeName?: string | undefined;

    constructor(data?: IIProductV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.typeP = _data["typeP"];
            this.associatedScale = _data["associatedScale"];
            this.refP = _data["refP"];
            this.labelP = _data["labelP"];
            this.labelENP = _data["labelENP"];
            this.labelDEP = _data["labelDEP"];
            this.labelESP = _data["labelESP"];
            this.labelITP = _data["labelITP"];
            this.labelNLP = _data["labelNLP"];
            this.labelPLP = _data["labelPLP"];
            this.labelPTP = _data["labelPTP"];
            this.labelROP = _data["labelROP"];
            this.labelTRP = _data["labelTRP"];
            this.fraisLivManuel = _data["fraisLivManuel"];
            this.fraisLivP = _data["fraisLivP"];
            this.fraisLivBEP = _data["fraisLivBEP"];
            this.fraisLivDEP = _data["fraisLivDEP"];
            this.fraisLivENP = _data["fraisLivENP"];
            this.fraisLivESP = _data["fraisLivESP"];
            this.fraisLivITP = _data["fraisLivITP"];
            this.fraisLivNLP = _data["fraisLivNLP"];
            this.fraisLivPLP = _data["fraisLivPLP"];
            this.fraisLivPTP = _data["fraisLivPTP"];
            this.fraisLivROP = _data["fraisLivROP"];
            this.fraisLivTRP = _data["fraisLivTRP"];
            this.amountP = _data["amountP"];
            this.qteStock = _data["qteStock"];
            this.available = _data["available"];
            this.picture = _data["picture"];
            this.pictureBlob = _data["pictureBlob"];
            this.pictureBlob2 = _data["pictureBlob2"];
            this.pictureZoom = _data["pictureZoom"];
            this.pictureZoomInsertBlob = _data["pictureZoomInsertBlob"];
            this.pictureZoomDisplayBlob = _data["pictureZoomDisplayBlob"];
            this.qte = _data["qte"];
            this.rentable = _data["rentable"];
            this.fraisLivRentable = _data["fraisLivRentable"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): IProductV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IProductV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["typeP"] = this.typeP;
        data["associatedScale"] = this.associatedScale;
        data["refP"] = this.refP;
        data["labelP"] = this.labelP;
        data["labelENP"] = this.labelENP;
        data["labelDEP"] = this.labelDEP;
        data["labelESP"] = this.labelESP;
        data["labelITP"] = this.labelITP;
        data["labelNLP"] = this.labelNLP;
        data["labelPLP"] = this.labelPLP;
        data["labelPTP"] = this.labelPTP;
        data["labelROP"] = this.labelROP;
        data["labelTRP"] = this.labelTRP;
        data["fraisLivManuel"] = this.fraisLivManuel;
        data["fraisLivP"] = this.fraisLivP;
        data["fraisLivBEP"] = this.fraisLivBEP;
        data["fraisLivDEP"] = this.fraisLivDEP;
        data["fraisLivENP"] = this.fraisLivENP;
        data["fraisLivESP"] = this.fraisLivESP;
        data["fraisLivITP"] = this.fraisLivITP;
        data["fraisLivNLP"] = this.fraisLivNLP;
        data["fraisLivPLP"] = this.fraisLivPLP;
        data["fraisLivPTP"] = this.fraisLivPTP;
        data["fraisLivROP"] = this.fraisLivROP;
        data["fraisLivTRP"] = this.fraisLivTRP;
        data["amountP"] = this.amountP;
        data["qteStock"] = this.qteStock;
        data["available"] = this.available;
        data["picture"] = this.picture;
        data["pictureBlob"] = this.pictureBlob;
        data["pictureBlob2"] = this.pictureBlob2;
        data["pictureZoom"] = this.pictureZoom;
        data["pictureZoomInsertBlob"] = this.pictureZoomInsertBlob;
        data["pictureZoomDisplayBlob"] = this.pictureZoomDisplayBlob;
        data["qte"] = this.qte;
        data["rentable"] = this.rentable;
        data["fraisLivRentable"] = this.fraisLivRentable;
        data["typeName"] = this.typeName;
        return data;
    }
}

export interface IIProductV1 {
    productID: number;
    typeP: ProductType;
    associatedScale: ScaleSelect;
    refP?: string | undefined;
    labelP?: string | undefined;
    labelENP?: string | undefined;
    labelDEP?: string | undefined;
    labelESP?: string | undefined;
    labelITP?: string | undefined;
    labelNLP?: string | undefined;
    labelPLP?: string | undefined;
    labelPTP?: string | undefined;
    labelROP?: string | undefined;
    labelTRP?: string | undefined;
    fraisLivManuel: boolean;
    fraisLivP: number;
    fraisLivBEP: number;
    fraisLivDEP: number;
    fraisLivENP: number;
    fraisLivESP: number;
    fraisLivITP: number;
    fraisLivNLP: number;
    fraisLivPLP: number;
    fraisLivPTP: number;
    fraisLivROP: number;
    fraisLivTRP: number;
    amountP: number;
    qteStock: number;
    available: boolean;
    picture?: string | undefined;
    pictureBlob?: string | undefined;
    pictureBlob2?: string | undefined;
    pictureZoom?: string | undefined;
    pictureZoomInsertBlob?: string | undefined;
    pictureZoomDisplayBlob?: string | undefined;
    qte: number;
    rentable: number;
    fraisLivRentable: number;
    typeName?: string | undefined;
}

export enum ProductType {
    Licence = 1,
    Support = 2,
    Cables = 3,
    Reseau = 4,
    Divers = 5,
}

export enum ScaleSelect {
    IxellColorV1 = 1,
    IxellColorV2 = 2,
    IxellColorConnect = 4,
    IxellColorConnectPro = 8,
}

export class BankInfoV1 extends AbstractEntity implements IBankInfoV1 {
    bankInfoID!: number;
    iban?: string | undefined;
    bic?: string | undefined;
    owner?: string | undefined;
    address?: string | undefined;
    order?: string | undefined;

    constructor(data?: IBankInfoV1) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bankInfoID = _data["bankInfoID"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.owner = _data["owner"];
            this.address = _data["address"];
            this.order = _data["order"];
        }
    }

    static override fromJS(data: any): BankInfoV1 {
        data = typeof data === 'object' ? data : {};
        let result = new BankInfoV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankInfoID"] = this.bankInfoID;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["owner"] = this.owner;
        data["address"] = this.address;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export interface IBankInfoV1 extends IAbstractEntity {
    bankInfoID: number;
    iban?: string | undefined;
    bic?: string | undefined;
    owner?: string | undefined;
    address?: string | undefined;
    order?: string | undefined;
}

export class ElectroniqueMaintenance implements IElectroniqueMaintenance {
    login?: string | undefined;
    password?: string | undefined;
    numSerie?: string | undefined;
    code!: number;
    oldScaleCode?: string | undefined;
    oldNumSerie?: string | undefined;
    newScaleCode?: string | undefined;
    newNumSerie?: string | undefined;

    constructor(data?: IElectroniqueMaintenance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.password = _data["password"];
            this.numSerie = _data["numSerie"];
            this.code = _data["code"];
            this.oldScaleCode = _data["oldScaleCode"];
            this.oldNumSerie = _data["oldNumSerie"];
            this.newScaleCode = _data["newScaleCode"];
            this.newNumSerie = _data["newNumSerie"];
        }
    }

    static fromJS(data: any): ElectroniqueMaintenance {
        data = typeof data === 'object' ? data : {};
        let result = new ElectroniqueMaintenance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["password"] = this.password;
        data["numSerie"] = this.numSerie;
        data["code"] = this.code;
        data["oldScaleCode"] = this.oldScaleCode;
        data["oldNumSerie"] = this.oldNumSerie;
        data["newScaleCode"] = this.newScaleCode;
        data["newNumSerie"] = this.newNumSerie;
        return data;
    }
}

export interface IElectroniqueMaintenance {
    login?: string | undefined;
    password?: string | undefined;
    numSerie?: string | undefined;
    code: number;
    oldScaleCode?: string | undefined;
    oldNumSerie?: string | undefined;
    newScaleCode?: string | undefined;
    newNumSerie?: string | undefined;
}

export class Message implements IMessage {
    libelle?: string | undefined;
    code!: number;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.libelle = _data["libelle"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["libelle"] = this.libelle;
        data["code"] = this.code;
        return data;
    }
}

export interface IMessage {
    libelle?: string | undefined;
    code: number;
}

export class IRentingV1 implements IIRentingV1 {
    rentingid!: number;
    companyid?: ICompanyV1 | undefined;
    leader?: string | undefined;
    bodyshopInterlocutor?: string | undefined;
    ctPhone?: string | undefined;
    companyPhone?: string | undefined;
    companyMail?: string | undefined;
    companyDirectLign?: string | undefined;
    customerStatus?: string | undefined;
    technology?: string | undefined;
    ixellAccount?: string | undefined;
    companyType?: string | undefined;
    companyTypeName?: string | undefined;
    rentingDuration!: number;
    status!: number;
    isChecked!: number;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;
    bank!: BankName;
    rentingDate!: Date;
    treatmentDate!: Date;
    renewal!: number;
    cashPayement!: number;
    order?: IRentingOrderV1[] | undefined;

    constructor(data?: IIRentingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentingid = _data["rentingid"];
            this.companyid = _data["companyid"] ? ICompanyV1.fromJS(_data["companyid"]) : <any>undefined;
            this.leader = _data["leader"];
            this.bodyshopInterlocutor = _data["bodyshopInterlocutor"];
            this.ctPhone = _data["ctPhone"];
            this.companyPhone = _data["companyPhone"];
            this.companyMail = _data["companyMail"];
            this.companyDirectLign = _data["companyDirectLign"];
            this.customerStatus = _data["customerStatus"];
            this.technology = _data["technology"];
            this.ixellAccount = _data["ixellAccount"];
            this.companyType = _data["companyType"];
            this.companyTypeName = _data["companyTypeName"];
            this.rentingDuration = _data["rentingDuration"];
            this.status = _data["status"];
            this.isChecked = _data["isChecked"];
            this.sageCode = _data["sageCode"];
            this.invoiceCode = _data["invoiceCode"];
            this.bank = _data["bank"];
            this.rentingDate = _data["rentingDate"] ? new Date(_data["rentingDate"].toString()) : <any>undefined;
            this.treatmentDate = _data["treatmentDate"] ? new Date(_data["treatmentDate"].toString()) : <any>undefined;
            this.renewal = _data["renewal"];
            this.cashPayement = _data["cashPayement"];
            if (Array.isArray(_data["order"])) {
                this.order = [] as any;
                for (let item of _data["order"])
                    this.order!.push(IRentingOrderV1.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IRentingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IRentingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentingid"] = this.rentingid;
        data["companyid"] = this.companyid ? this.companyid.toJSON() : <any>undefined;
        data["leader"] = this.leader;
        data["bodyshopInterlocutor"] = this.bodyshopInterlocutor;
        data["ctPhone"] = this.ctPhone;
        data["companyPhone"] = this.companyPhone;
        data["companyMail"] = this.companyMail;
        data["companyDirectLign"] = this.companyDirectLign;
        data["customerStatus"] = this.customerStatus;
        data["technology"] = this.technology;
        data["ixellAccount"] = this.ixellAccount;
        data["companyType"] = this.companyType;
        data["companyTypeName"] = this.companyTypeName;
        data["rentingDuration"] = this.rentingDuration;
        data["status"] = this.status;
        data["isChecked"] = this.isChecked;
        data["sageCode"] = this.sageCode;
        data["invoiceCode"] = this.invoiceCode;
        data["bank"] = this.bank;
        data["rentingDate"] = this.rentingDate ? this.rentingDate.toISOString() : <any>undefined;
        data["treatmentDate"] = this.treatmentDate ? this.treatmentDate.toISOString() : <any>undefined;
        data["renewal"] = this.renewal;
        data["cashPayement"] = this.cashPayement;
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIRentingV1 {
    rentingid: number;
    companyid?: ICompanyV1 | undefined;
    leader?: string | undefined;
    bodyshopInterlocutor?: string | undefined;
    ctPhone?: string | undefined;
    companyPhone?: string | undefined;
    companyMail?: string | undefined;
    companyDirectLign?: string | undefined;
    customerStatus?: string | undefined;
    technology?: string | undefined;
    ixellAccount?: string | undefined;
    companyType?: string | undefined;
    companyTypeName?: string | undefined;
    rentingDuration: number;
    status: number;
    isChecked: number;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;
    bank: BankName;
    rentingDate: Date;
    treatmentDate: Date;
    renewal: number;
    cashPayement: number;
    order?: IRentingOrderV1[] | undefined;
}

export enum BankName {
    NC = 0,
    BNP = 1,
    CMCIC = 2,
}

export class IRentingOrderV1 extends AbstractEntity implements IIRentingOrderV1 {
    productid!: number;
    labelP!: number;
    productqte!: number;
    productamount!: number;

    constructor(data?: IIRentingOrderV1) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productid = _data["productid"];
            this.labelP = _data["labelP"];
            this.productqte = _data["productqte"];
            this.productamount = _data["productamount"];
        }
    }

    static override fromJS(data: any): IRentingOrderV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IRentingOrderV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productid"] = this.productid;
        data["labelP"] = this.labelP;
        data["productqte"] = this.productqte;
        data["productamount"] = this.productamount;
        super.toJSON(data);
        return data;
    }
}

export interface IIRentingOrderV1 extends IAbstractEntity {
    productid: number;
    labelP: number;
    productqte: number;
    productamount: number;
}

export class IRentingLight implements IIRentingLight {
    rentingID!: number;
    companyID!: number;
    socialReason?: string | undefined;
    country?: string | undefined;
    ctcID!: number;
    rentingDuration!: number;
    status!: number;
    isChecked!: number;
    sageCode?: string | undefined;
    bank!: BankName;
    invoiceCode?: string | undefined;
    rentingDate?: string | undefined;
    treatmentDate?: string | undefined;
    companyUnisiteCode?: string | undefined;
    ctcFirstname?: string | undefined;
    ctcName?: string | undefined;
    ctcPhone?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    nbProducts!: number;
    renewal!: number;
    cashPayement!: number;

    constructor(data?: IIRentingLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentingID = _data["rentingID"];
            this.companyID = _data["companyID"];
            this.socialReason = _data["socialReason"];
            this.country = _data["country"];
            this.ctcID = _data["ctcID"];
            this.rentingDuration = _data["rentingDuration"];
            this.status = _data["status"];
            this.isChecked = _data["isChecked"];
            this.sageCode = _data["sageCode"];
            this.bank = _data["bank"];
            this.invoiceCode = _data["invoiceCode"];
            this.rentingDate = _data["rentingDate"];
            this.treatmentDate = _data["treatmentDate"];
            this.companyUnisiteCode = _data["companyUnisiteCode"];
            this.ctcFirstname = _data["ctcFirstname"];
            this.ctcName = _data["ctcName"];
            this.ctcPhone = _data["ctcPhone"];
            this.ctcMail = _data["ctcMail"];
            this.ctcLanguage = _data["ctcLanguage"];
            this.nbProducts = _data["nbProducts"];
            this.renewal = _data["renewal"];
            this.cashPayement = _data["cashPayement"];
        }
    }

    static fromJS(data: any): IRentingLight {
        data = typeof data === 'object' ? data : {};
        let result = new IRentingLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentingID"] = this.rentingID;
        data["companyID"] = this.companyID;
        data["socialReason"] = this.socialReason;
        data["country"] = this.country;
        data["ctcID"] = this.ctcID;
        data["rentingDuration"] = this.rentingDuration;
        data["status"] = this.status;
        data["isChecked"] = this.isChecked;
        data["sageCode"] = this.sageCode;
        data["bank"] = this.bank;
        data["invoiceCode"] = this.invoiceCode;
        data["rentingDate"] = this.rentingDate;
        data["treatmentDate"] = this.treatmentDate;
        data["companyUnisiteCode"] = this.companyUnisiteCode;
        data["ctcFirstname"] = this.ctcFirstname;
        data["ctcName"] = this.ctcName;
        data["ctcPhone"] = this.ctcPhone;
        data["ctcMail"] = this.ctcMail;
        data["ctcLanguage"] = this.ctcLanguage;
        data["nbProducts"] = this.nbProducts;
        data["renewal"] = this.renewal;
        data["cashPayement"] = this.cashPayement;
        return data;
    }
}

export interface IIRentingLight {
    rentingID: number;
    companyID: number;
    socialReason?: string | undefined;
    country?: string | undefined;
    ctcID: number;
    rentingDuration: number;
    status: number;
    isChecked: number;
    sageCode?: string | undefined;
    bank: BankName;
    invoiceCode?: string | undefined;
    rentingDate?: string | undefined;
    treatmentDate?: string | undefined;
    companyUnisiteCode?: string | undefined;
    ctcFirstname?: string | undefined;
    ctcName?: string | undefined;
    ctcPhone?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    nbProducts: number;
    renewal: number;
    cashPayement: number;
}

export class IRentingInfo implements IIRentingInfo {
    rentingID!: number;
    companyID!: number;
    leader?: string | undefined;
    bodyshopInterlocutor?: string | undefined;
    ctcID!: number;
    companyPhone?: string | undefined;
    companyMail?: string | undefined;
    companyDirectLign?: string | undefined;
    customerStatus?: string | undefined;
    technology?: string | undefined;
    ixellAccount?: string | undefined;
    companyType?: string | undefined;
    companyTypeName?: string | undefined;
    rentingDuration!: number;
    status!: number;
    isChecked!: number;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;
    rentingDate?: string | undefined;
    treatmentDate?: string | undefined;
    bank!: BankName;
    companyUnisiteCode?: string | undefined;
    companySocialReason?: string | undefined;
    companyAddress?: string | undefined;
    companyPostalCode?: string | undefined;
    companyCity?: string | undefined;
    companyCountry?: string | undefined;
    companySiren?: string | undefined;
    companyTva?: string | undefined;
    ctcFirstname?: string | undefined;
    ctcName?: string | undefined;
    ctcPhone?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    renewal!: number;

    constructor(data?: IIRentingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentingID = _data["rentingID"];
            this.companyID = _data["companyID"];
            this.leader = _data["leader"];
            this.bodyshopInterlocutor = _data["bodyshopInterlocutor"];
            this.ctcID = _data["ctcID"];
            this.companyPhone = _data["companyPhone"];
            this.companyMail = _data["companyMail"];
            this.companyDirectLign = _data["companyDirectLign"];
            this.customerStatus = _data["customerStatus"];
            this.technology = _data["technology"];
            this.ixellAccount = _data["ixellAccount"];
            this.companyType = _data["companyType"];
            this.companyTypeName = _data["companyTypeName"];
            this.rentingDuration = _data["rentingDuration"];
            this.status = _data["status"];
            this.isChecked = _data["isChecked"];
            this.sageCode = _data["sageCode"];
            this.invoiceCode = _data["invoiceCode"];
            this.rentingDate = _data["rentingDate"];
            this.treatmentDate = _data["treatmentDate"];
            this.bank = _data["bank"];
            this.companyUnisiteCode = _data["companyUnisiteCode"];
            this.companySocialReason = _data["companySocialReason"];
            this.companyAddress = _data["companyAddress"];
            this.companyPostalCode = _data["companyPostalCode"];
            this.companyCity = _data["companyCity"];
            this.companyCountry = _data["companyCountry"];
            this.companySiren = _data["companySiren"];
            this.companyTva = _data["companyTva"];
            this.ctcFirstname = _data["ctcFirstname"];
            this.ctcName = _data["ctcName"];
            this.ctcPhone = _data["ctcPhone"];
            this.ctcMail = _data["ctcMail"];
            this.ctcLanguage = _data["ctcLanguage"];
            this.renewal = _data["renewal"];
        }
    }

    static fromJS(data: any): IRentingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IRentingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentingID"] = this.rentingID;
        data["companyID"] = this.companyID;
        data["leader"] = this.leader;
        data["bodyshopInterlocutor"] = this.bodyshopInterlocutor;
        data["ctcID"] = this.ctcID;
        data["companyPhone"] = this.companyPhone;
        data["companyMail"] = this.companyMail;
        data["companyDirectLign"] = this.companyDirectLign;
        data["customerStatus"] = this.customerStatus;
        data["technology"] = this.technology;
        data["ixellAccount"] = this.ixellAccount;
        data["companyType"] = this.companyType;
        data["companyTypeName"] = this.companyTypeName;
        data["rentingDuration"] = this.rentingDuration;
        data["status"] = this.status;
        data["isChecked"] = this.isChecked;
        data["sageCode"] = this.sageCode;
        data["invoiceCode"] = this.invoiceCode;
        data["rentingDate"] = this.rentingDate;
        data["treatmentDate"] = this.treatmentDate;
        data["bank"] = this.bank;
        data["companyUnisiteCode"] = this.companyUnisiteCode;
        data["companySocialReason"] = this.companySocialReason;
        data["companyAddress"] = this.companyAddress;
        data["companyPostalCode"] = this.companyPostalCode;
        data["companyCity"] = this.companyCity;
        data["companyCountry"] = this.companyCountry;
        data["companySiren"] = this.companySiren;
        data["companyTva"] = this.companyTva;
        data["ctcFirstname"] = this.ctcFirstname;
        data["ctcName"] = this.ctcName;
        data["ctcPhone"] = this.ctcPhone;
        data["ctcMail"] = this.ctcMail;
        data["ctcLanguage"] = this.ctcLanguage;
        data["renewal"] = this.renewal;
        return data;
    }
}

export interface IIRentingInfo {
    rentingID: number;
    companyID: number;
    leader?: string | undefined;
    bodyshopInterlocutor?: string | undefined;
    ctcID: number;
    companyPhone?: string | undefined;
    companyMail?: string | undefined;
    companyDirectLign?: string | undefined;
    customerStatus?: string | undefined;
    technology?: string | undefined;
    ixellAccount?: string | undefined;
    companyType?: string | undefined;
    companyTypeName?: string | undefined;
    rentingDuration: number;
    status: number;
    isChecked: number;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;
    rentingDate?: string | undefined;
    treatmentDate?: string | undefined;
    bank: BankName;
    companyUnisiteCode?: string | undefined;
    companySocialReason?: string | undefined;
    companyAddress?: string | undefined;
    companyPostalCode?: string | undefined;
    companyCity?: string | undefined;
    companyCountry?: string | undefined;
    companySiren?: string | undefined;
    companyTva?: string | undefined;
    ctcFirstname?: string | undefined;
    ctcName?: string | undefined;
    ctcPhone?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    renewal: number;
}

export class IRentingPatch implements IIRentingPatch {
    rentingID?: number | undefined;
    leader?: string | undefined;
    bodyshopInterlocutor?: string | undefined;
    companyPhone?: string | undefined;
    companyMail?: string | undefined;
    companyDirectLign?: string | undefined;
    customerStatus?: string | undefined;
    technology?: string | undefined;
    ixellAccount?: string | undefined;
    companyType?: string | undefined;
    companyTypeName?: string | undefined;
    companySocialReason?: string | undefined;
    companyAddress?: string | undefined;
    companyPostalCode?: string | undefined;
    companyCity?: string | undefined;
    companyCountry?: string | undefined;
    companySiren?: string | undefined;
    companyTva?: string | undefined;
    ctcID?: number | undefined;
    orders?: OrderLight[] | undefined;
    status?: number | undefined;

    constructor(data?: IIRentingPatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentingID = _data["rentingID"];
            this.leader = _data["leader"];
            this.bodyshopInterlocutor = _data["bodyshopInterlocutor"];
            this.companyPhone = _data["companyPhone"];
            this.companyMail = _data["companyMail"];
            this.companyDirectLign = _data["companyDirectLign"];
            this.customerStatus = _data["customerStatus"];
            this.technology = _data["technology"];
            this.ixellAccount = _data["ixellAccount"];
            this.companyType = _data["companyType"];
            this.companyTypeName = _data["companyTypeName"];
            this.companySocialReason = _data["companySocialReason"];
            this.companyAddress = _data["companyAddress"];
            this.companyPostalCode = _data["companyPostalCode"];
            this.companyCity = _data["companyCity"];
            this.companyCountry = _data["companyCountry"];
            this.companySiren = _data["companySiren"];
            this.companyTva = _data["companyTva"];
            this.ctcID = _data["ctcID"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderLight.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): IRentingPatch {
        data = typeof data === 'object' ? data : {};
        let result = new IRentingPatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentingID"] = this.rentingID;
        data["leader"] = this.leader;
        data["bodyshopInterlocutor"] = this.bodyshopInterlocutor;
        data["companyPhone"] = this.companyPhone;
        data["companyMail"] = this.companyMail;
        data["companyDirectLign"] = this.companyDirectLign;
        data["customerStatus"] = this.customerStatus;
        data["technology"] = this.technology;
        data["ixellAccount"] = this.ixellAccount;
        data["companyType"] = this.companyType;
        data["companyTypeName"] = this.companyTypeName;
        data["companySocialReason"] = this.companySocialReason;
        data["companyAddress"] = this.companyAddress;
        data["companyPostalCode"] = this.companyPostalCode;
        data["companyCity"] = this.companyCity;
        data["companyCountry"] = this.companyCountry;
        data["companySiren"] = this.companySiren;
        data["companyTva"] = this.companyTva;
        data["ctcID"] = this.ctcID;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IIRentingPatch {
    rentingID?: number | undefined;
    leader?: string | undefined;
    bodyshopInterlocutor?: string | undefined;
    companyPhone?: string | undefined;
    companyMail?: string | undefined;
    companyDirectLign?: string | undefined;
    customerStatus?: string | undefined;
    technology?: string | undefined;
    ixellAccount?: string | undefined;
    companyType?: string | undefined;
    companyTypeName?: string | undefined;
    companySocialReason?: string | undefined;
    companyAddress?: string | undefined;
    companyPostalCode?: string | undefined;
    companyCity?: string | undefined;
    companyCountry?: string | undefined;
    companySiren?: string | undefined;
    companyTva?: string | undefined;
    ctcID?: number | undefined;
    orders?: OrderLight[] | undefined;
    status?: number | undefined;
}

export class OrderLight implements IOrderLight {
    productID?: number | undefined;
    labelP?: string | undefined;
    amountP!: number;
    qty!: number;
    typeP!: number;
    qteStock!: number;

    constructor(data?: IOrderLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.labelP = _data["labelP"];
            this.amountP = _data["amountP"];
            this.qty = _data["qty"];
            this.typeP = _data["typeP"];
            this.qteStock = _data["qteStock"];
        }
    }

    static fromJS(data: any): OrderLight {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["labelP"] = this.labelP;
        data["amountP"] = this.amountP;
        data["qty"] = this.qty;
        data["typeP"] = this.typeP;
        data["qteStock"] = this.qteStock;
        return data;
    }
}

export interface IOrderLight {
    productID?: number | undefined;
    labelP?: string | undefined;
    amountP: number;
    qty: number;
    typeP: number;
    qteStock: number;
}

export class IAssistanceV1 implements IIAssistanceV1 {
    assistanceID!: number;
    assistanceDate!: Date;
    serialNumberScale?: string | undefined;
    breakdownType!: number;
    name?: string | undefined;
    firstname?: string | undefined;
    mail?: string | undefined;
    phone?: string | undefined;
    remoteMaintenanceID?: string | undefined;
    comment?: string | undefined;
    ctc_ctcID!: number;
    envoiUnisiteStatut!: UnisiteStatus;
    envoiUnisiteDate!: Date;
    user_userID!: number;

    constructor(data?: IIAssistanceV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistanceID = _data["assistanceID"];
            this.assistanceDate = _data["assistanceDate"] ? new Date(_data["assistanceDate"].toString()) : <any>undefined;
            this.serialNumberScale = _data["serialNumberScale"];
            this.breakdownType = _data["breakdownType"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.mail = _data["mail"];
            this.phone = _data["phone"];
            this.remoteMaintenanceID = _data["remoteMaintenanceID"];
            this.comment = _data["comment"];
            this.ctc_ctcID = _data["ctc_ctcID"];
            this.envoiUnisiteStatut = _data["envoiUnisiteStatut"];
            this.envoiUnisiteDate = _data["envoiUnisiteDate"] ? new Date(_data["envoiUnisiteDate"].toString()) : <any>undefined;
            this.user_userID = _data["user_userID"];
        }
    }

    static fromJS(data: any): IAssistanceV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IAssistanceV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceID"] = this.assistanceID;
        data["assistanceDate"] = this.assistanceDate ? this.assistanceDate.toISOString() : <any>undefined;
        data["serialNumberScale"] = this.serialNumberScale;
        data["breakdownType"] = this.breakdownType;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["mail"] = this.mail;
        data["phone"] = this.phone;
        data["remoteMaintenanceID"] = this.remoteMaintenanceID;
        data["comment"] = this.comment;
        data["ctc_ctcID"] = this.ctc_ctcID;
        data["envoiUnisiteStatut"] = this.envoiUnisiteStatut;
        data["envoiUnisiteDate"] = this.envoiUnisiteDate ? this.envoiUnisiteDate.toISOString() : <any>undefined;
        data["user_userID"] = this.user_userID;
        return data;
    }
}

export interface IIAssistanceV1 {
    assistanceID: number;
    assistanceDate: Date;
    serialNumberScale?: string | undefined;
    breakdownType: number;
    name?: string | undefined;
    firstname?: string | undefined;
    mail?: string | undefined;
    phone?: string | undefined;
    remoteMaintenanceID?: string | undefined;
    comment?: string | undefined;
    ctc_ctcID: number;
    envoiUnisiteStatut: UnisiteStatus;
    envoiUnisiteDate: Date;
    user_userID: number;
}

export enum UnisiteStatus {
    WAITING_SEND = 0,
    TRANSMITTED = 1,
}

export class IAssistanceLight extends AbstractEntity implements IIAssistanceLight {
    assistanceID!: number;
    serialNumberScale?: string | undefined;
    breakdownText?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    mail?: string | undefined;
    phone?: string | undefined;
    remoteMaintenanceID?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IIAssistanceLight) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assistanceID = _data["assistanceID"];
            this.serialNumberScale = _data["serialNumberScale"];
            this.breakdownText = _data["breakdownText"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.mail = _data["mail"];
            this.phone = _data["phone"];
            this.remoteMaintenanceID = _data["remoteMaintenanceID"];
            this.comment = _data["comment"];
        }
    }

    static override fromJS(data: any): IAssistanceLight {
        data = typeof data === 'object' ? data : {};
        let result = new IAssistanceLight();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistanceID"] = this.assistanceID;
        data["serialNumberScale"] = this.serialNumberScale;
        data["breakdownText"] = this.breakdownText;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["mail"] = this.mail;
        data["phone"] = this.phone;
        data["remoteMaintenanceID"] = this.remoteMaintenanceID;
        data["comment"] = this.comment;
        super.toJSON(data);
        return data;
    }
}

export interface IIAssistanceLight extends IAbstractEntity {
    assistanceID: number;
    serialNumberScale?: string | undefined;
    breakdownText?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    mail?: string | undefined;
    phone?: string | undefined;
    remoteMaintenanceID?: string | undefined;
    comment?: string | undefined;
}

export class IBreakdownFileV1 implements IIBreakdownFileV1 {
    breakdownFileID!: number;
    breakdownName?: string | undefined;
    breakdownFile?: string | undefined;
    fileDate!: Date;

    constructor(data?: IIBreakdownFileV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakdownFileID = _data["breakdownFileID"];
            this.breakdownName = _data["breakdownName"];
            this.breakdownFile = _data["breakdownFile"];
            this.fileDate = _data["fileDate"] ? new Date(_data["fileDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IBreakdownFileV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IBreakdownFileV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breakdownFileID"] = this.breakdownFileID;
        data["breakdownName"] = this.breakdownName;
        data["breakdownFile"] = this.breakdownFile;
        data["fileDate"] = this.fileDate ? this.fileDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIBreakdownFileV1 {
    breakdownFileID: number;
    breakdownName?: string | undefined;
    breakdownFile?: string | undefined;
    fileDate: Date;
}

export class BreakdownInterval implements IBreakdownInterval {
    start!: Date;
    end!: Date;

    constructor(data?: IBreakdownInterval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BreakdownInterval {
        data = typeof data === 'object' ? data : {};
        let result = new BreakdownInterval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBreakdownInterval {
    start: Date;
    end: Date;
}

export class CountryScaleStats implements ICountryScaleStats {
    dateImportation?: string | undefined;
    country?: string | undefined;
    stats?: ScaleStats | undefined;

    constructor(data?: ICountryScaleStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateImportation = _data["dateImportation"];
            this.country = _data["country"];
            this.stats = _data["stats"] ? ScaleStats.fromJS(_data["stats"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CountryScaleStats {
        data = typeof data === 'object' ? data : {};
        let result = new CountryScaleStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateImportation"] = this.dateImportation;
        data["country"] = this.country;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICountryScaleStats {
    dateImportation?: string | undefined;
    country?: string | undefined;
    stats?: ScaleStats | undefined;
}

export class ScaleStats implements IScaleStats {
    country?: string | undefined;
    bddLocal?: Stats[] | undefined;
    bddInternet?: Stats[] | undefined;
    majSpectro?: Stats[] | undefined;

    constructor(data?: IScaleStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            if (Array.isArray(_data["bddLocal"])) {
                this.bddLocal = [] as any;
                for (let item of _data["bddLocal"])
                    this.bddLocal!.push(Stats.fromJS(item));
            }
            if (Array.isArray(_data["bddInternet"])) {
                this.bddInternet = [] as any;
                for (let item of _data["bddInternet"])
                    this.bddInternet!.push(Stats.fromJS(item));
            }
            if (Array.isArray(_data["majSpectro"])) {
                this.majSpectro = [] as any;
                for (let item of _data["majSpectro"])
                    this.majSpectro!.push(Stats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScaleStats {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        if (Array.isArray(this.bddLocal)) {
            data["bddLocal"] = [];
            for (let item of this.bddLocal)
                data["bddLocal"].push(item.toJSON());
        }
        if (Array.isArray(this.bddInternet)) {
            data["bddInternet"] = [];
            for (let item of this.bddInternet)
                data["bddInternet"].push(item.toJSON());
        }
        if (Array.isArray(this.majSpectro)) {
            data["majSpectro"] = [];
            for (let item of this.majSpectro)
                data["majSpectro"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScaleStats {
    country?: string | undefined;
    bddLocal?: Stats[] | undefined;
    bddInternet?: Stats[] | undefined;
    majSpectro?: Stats[] | undefined;
}

export class Stats implements IStats {
    version?: string | undefined;
    nb!: number;

    constructor(data?: IStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.nb = _data["nb"];
        }
    }

    static fromJS(data: any): Stats {
        data = typeof data === 'object' ? data : {};
        let result = new Stats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["nb"] = this.nb;
        return data;
    }
}

export interface IStats {
    version?: string | undefined;
    nb: number;
}

export class ListeScaleVersion implements IListeScaleVersion {
    dateImportation?: string | undefined;
    scale?: IScaleVersion[] | undefined;

    constructor(data?: IListeScaleVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateImportation = _data["dateImportation"];
            if (Array.isArray(_data["scale"])) {
                this.scale = [] as any;
                for (let item of _data["scale"])
                    this.scale!.push(IScaleVersion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListeScaleVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ListeScaleVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateImportation"] = this.dateImportation;
        if (Array.isArray(this.scale)) {
            data["scale"] = [];
            for (let item of this.scale)
                data["scale"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListeScaleVersion {
    dateImportation?: string | undefined;
    scale?: IScaleVersion[] | undefined;
}

export class IScaleVersion implements IIScaleVersion {
    idScaleVersion!: number;
    unisite?: string | undefined;
    nom_ou_RS?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    code_Postal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    sN_Balance?: string | undefined;
    date_installation?: string | undefined;
    fin_de_contrat?: string | undefined;
    mode_commercialisation?: string | undefined;
    technologie?: string | undefined;
    programme?: string | undefined;
    bddinternet?: string | undefined;
    bddlocale?: string | undefined;
    spectro?: string | undefined;
    connexion?: string | undefined;
    plusdebalance?: string | undefined;
    stock?: string | undefined;

    constructor(data?: IIScaleVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idScaleVersion = _data["idScaleVersion"];
            this.unisite = _data["unisite"];
            this.nom_ou_RS = _data["nom_ou_RS"];
            this.adresse1 = _data["adresse1"];
            this.adresse2 = _data["adresse2"];
            this.code_Postal = _data["code_Postal"];
            this.ville = _data["ville"];
            this.pays = _data["pays"];
            this.sN_Balance = _data["sN_Balance"];
            this.date_installation = _data["date_installation"];
            this.fin_de_contrat = _data["fin_de_contrat"];
            this.mode_commercialisation = _data["mode_commercialisation"];
            this.technologie = _data["technologie"];
            this.programme = _data["programme"];
            this.bddinternet = _data["bddinternet"];
            this.bddlocale = _data["bddlocale"];
            this.spectro = _data["spectro"];
            this.connexion = _data["connexion"];
            this.plusdebalance = _data["plusdebalance"];
            this.stock = _data["stock"];
        }
    }

    static fromJS(data: any): IScaleVersion {
        data = typeof data === 'object' ? data : {};
        let result = new IScaleVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idScaleVersion"] = this.idScaleVersion;
        data["unisite"] = this.unisite;
        data["nom_ou_RS"] = this.nom_ou_RS;
        data["adresse1"] = this.adresse1;
        data["adresse2"] = this.adresse2;
        data["code_Postal"] = this.code_Postal;
        data["ville"] = this.ville;
        data["pays"] = this.pays;
        data["sN_Balance"] = this.sN_Balance;
        data["date_installation"] = this.date_installation;
        data["fin_de_contrat"] = this.fin_de_contrat;
        data["mode_commercialisation"] = this.mode_commercialisation;
        data["technologie"] = this.technologie;
        data["programme"] = this.programme;
        data["bddinternet"] = this.bddinternet;
        data["bddlocale"] = this.bddlocale;
        data["spectro"] = this.spectro;
        data["connexion"] = this.connexion;
        data["plusdebalance"] = this.plusdebalance;
        data["stock"] = this.stock;
        return data;
    }
}

export interface IIScaleVersion {
    idScaleVersion: number;
    unisite?: string | undefined;
    nom_ou_RS?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    code_Postal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    sN_Balance?: string | undefined;
    date_installation?: string | undefined;
    fin_de_contrat?: string | undefined;
    mode_commercialisation?: string | undefined;
    technologie?: string | undefined;
    programme?: string | undefined;
    bddinternet?: string | undefined;
    bddlocale?: string | undefined;
    spectro?: string | undefined;
    connexion?: string | undefined;
    plusdebalance?: string | undefined;
    stock?: string | undefined;
}

export class ListeScaleAssistance implements IListeScaleAssistance {
    send_Balance_Assistance?: IScaleAssistance[] | undefined;
    nbDossier!: number;
    dureeAppelMoyen!: number;
    dateImportation?: string | undefined;

    constructor(data?: IListeScaleAssistance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["send_Balance_Assistance"])) {
                this.send_Balance_Assistance = [] as any;
                for (let item of _data["send_Balance_Assistance"])
                    this.send_Balance_Assistance!.push(IScaleAssistance.fromJS(item));
            }
            this.nbDossier = _data["nbDossier"];
            this.dureeAppelMoyen = _data["dureeAppelMoyen"];
            this.dateImportation = _data["dateImportation"];
        }
    }

    static fromJS(data: any): ListeScaleAssistance {
        data = typeof data === 'object' ? data : {};
        let result = new ListeScaleAssistance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.send_Balance_Assistance)) {
            data["send_Balance_Assistance"] = [];
            for (let item of this.send_Balance_Assistance)
                data["send_Balance_Assistance"].push(item.toJSON());
        }
        data["nbDossier"] = this.nbDossier;
        data["dureeAppelMoyen"] = this.dureeAppelMoyen;
        data["dateImportation"] = this.dateImportation;
        return data;
    }
}

export interface IListeScaleAssistance {
    send_Balance_Assistance?: IScaleAssistance[] | undefined;
    nbDossier: number;
    dureeAppelMoyen: number;
    dateImportation?: string | undefined;
}

export class IScaleAssistance implements IIScaleAssistance {
    idScaleAssistance!: number;
    numDossier?: string | undefined;
    code_Client?: string | undefined;
    raison_sociale?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    code_Postal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    ctc?: string | undefined;
    materiel_SN?: string | undefined;
    date_creation?: string | undefined;
    message_Date_creation?: string | undefined;
    date_de_cloture?: string | undefined;
    atL_dateCreation?: string | undefined;
    msG_DateCreation?: string | undefined;
    tempsPriseEncharge?: string | undefined;
    tempsPriseEnchargeCalc?: string | undefined;
    qualification_1?: string | undefined;
    qualification_2?: string | undefined;
    qualification_3?: string | undefined;
    echange_Date_Expedition?: string | undefined;
    echange_Date_Mise_en_route?: string | undefined;
    echange_Duree?: string | undefined;
    echange_Diagnostic_SAV1?: string | undefined;
    echange_Diagnostic_SAV2?: string | undefined;
    balance_echange?: string | undefined;
    appel?: IAppelV1[] | undefined;

    constructor(data?: IIScaleAssistance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idScaleAssistance = _data["idScaleAssistance"];
            this.numDossier = _data["numDossier"];
            this.code_Client = _data["code_Client"];
            this.raison_sociale = _data["raison_sociale"];
            this.adresse1 = _data["adresse1"];
            this.adresse2 = _data["adresse2"];
            this.code_Postal = _data["code_Postal"];
            this.ville = _data["ville"];
            this.pays = _data["pays"];
            this.ctc = _data["ctc"];
            this.materiel_SN = _data["materiel_SN"];
            this.date_creation = _data["date_creation"];
            this.message_Date_creation = _data["message_Date_creation"];
            this.date_de_cloture = _data["date_de_cloture"];
            this.atL_dateCreation = _data["atL_dateCreation"];
            this.msG_DateCreation = _data["msG_DateCreation"];
            this.tempsPriseEncharge = _data["tempsPriseEncharge"];
            this.tempsPriseEnchargeCalc = _data["tempsPriseEnchargeCalc"];
            this.qualification_1 = _data["qualification_1"];
            this.qualification_2 = _data["qualification_2"];
            this.qualification_3 = _data["qualification_3"];
            this.echange_Date_Expedition = _data["echange_Date_Expedition"];
            this.echange_Date_Mise_en_route = _data["echange_Date_Mise_en_route"];
            this.echange_Duree = _data["echange_Duree"];
            this.echange_Diagnostic_SAV1 = _data["echange_Diagnostic_SAV1"];
            this.echange_Diagnostic_SAV2 = _data["echange_Diagnostic_SAV2"];
            this.balance_echange = _data["balance_echange"];
            if (Array.isArray(_data["appel"])) {
                this.appel = [] as any;
                for (let item of _data["appel"])
                    this.appel!.push(IAppelV1.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IScaleAssistance {
        data = typeof data === 'object' ? data : {};
        let result = new IScaleAssistance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idScaleAssistance"] = this.idScaleAssistance;
        data["numDossier"] = this.numDossier;
        data["code_Client"] = this.code_Client;
        data["raison_sociale"] = this.raison_sociale;
        data["adresse1"] = this.adresse1;
        data["adresse2"] = this.adresse2;
        data["code_Postal"] = this.code_Postal;
        data["ville"] = this.ville;
        data["pays"] = this.pays;
        data["ctc"] = this.ctc;
        data["materiel_SN"] = this.materiel_SN;
        data["date_creation"] = this.date_creation;
        data["message_Date_creation"] = this.message_Date_creation;
        data["date_de_cloture"] = this.date_de_cloture;
        data["atL_dateCreation"] = this.atL_dateCreation;
        data["msG_DateCreation"] = this.msG_DateCreation;
        data["tempsPriseEncharge"] = this.tempsPriseEncharge;
        data["tempsPriseEnchargeCalc"] = this.tempsPriseEnchargeCalc;
        data["qualification_1"] = this.qualification_1;
        data["qualification_2"] = this.qualification_2;
        data["qualification_3"] = this.qualification_3;
        data["echange_Date_Expedition"] = this.echange_Date_Expedition;
        data["echange_Date_Mise_en_route"] = this.echange_Date_Mise_en_route;
        data["echange_Duree"] = this.echange_Duree;
        data["echange_Diagnostic_SAV1"] = this.echange_Diagnostic_SAV1;
        data["echange_Diagnostic_SAV2"] = this.echange_Diagnostic_SAV2;
        data["balance_echange"] = this.balance_echange;
        if (Array.isArray(this.appel)) {
            data["appel"] = [];
            for (let item of this.appel)
                data["appel"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIScaleAssistance {
    idScaleAssistance: number;
    numDossier?: string | undefined;
    code_Client?: string | undefined;
    raison_sociale?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    code_Postal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    ctc?: string | undefined;
    materiel_SN?: string | undefined;
    date_creation?: string | undefined;
    message_Date_creation?: string | undefined;
    date_de_cloture?: string | undefined;
    atL_dateCreation?: string | undefined;
    msG_DateCreation?: string | undefined;
    tempsPriseEncharge?: string | undefined;
    tempsPriseEnchargeCalc?: string | undefined;
    qualification_1?: string | undefined;
    qualification_2?: string | undefined;
    qualification_3?: string | undefined;
    echange_Date_Expedition?: string | undefined;
    echange_Date_Mise_en_route?: string | undefined;
    echange_Duree?: string | undefined;
    echange_Diagnostic_SAV1?: string | undefined;
    echange_Diagnostic_SAV2?: string | undefined;
    balance_echange?: string | undefined;
    appel?: IAppelV1[] | undefined;
}

export class IAppelV1 implements IIAppelV1 {
    appel_Date_Creation?: string | undefined;
    heuredebutAppel?: string | undefined;
    heurefinappel?: string | undefined;
    dureeAppel?: string | undefined;
    dureeAppelCalc?: string | undefined;
    acquittement?: string | undefined;
    question?: string | undefined;
    reponse?: string | undefined;
    interlocuteur?: string | undefined;
    dateDemande?: string | undefined;
    heureDemande?: string | undefined;
    sensAppel?: string | undefined;
    tempsPriseEncharge?: string | undefined;

    constructor(data?: IIAppelV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appel_Date_Creation = _data["appel_Date_Creation"];
            this.heuredebutAppel = _data["heuredebutAppel"];
            this.heurefinappel = _data["heurefinappel"];
            this.dureeAppel = _data["dureeAppel"];
            this.dureeAppelCalc = _data["dureeAppelCalc"];
            this.acquittement = _data["acquittement"];
            this.question = _data["question"];
            this.reponse = _data["reponse"];
            this.interlocuteur = _data["interlocuteur"];
            this.dateDemande = _data["dateDemande"];
            this.heureDemande = _data["heureDemande"];
            this.sensAppel = _data["sensAppel"];
            this.tempsPriseEncharge = _data["tempsPriseEncharge"];
        }
    }

    static fromJS(data: any): IAppelV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IAppelV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appel_Date_Creation"] = this.appel_Date_Creation;
        data["heuredebutAppel"] = this.heuredebutAppel;
        data["heurefinappel"] = this.heurefinappel;
        data["dureeAppel"] = this.dureeAppel;
        data["dureeAppelCalc"] = this.dureeAppelCalc;
        data["acquittement"] = this.acquittement;
        data["question"] = this.question;
        data["reponse"] = this.reponse;
        data["interlocuteur"] = this.interlocuteur;
        data["dateDemande"] = this.dateDemande;
        data["heureDemande"] = this.heureDemande;
        data["sensAppel"] = this.sensAppel;
        data["tempsPriseEncharge"] = this.tempsPriseEncharge;
        return data;
    }
}

export interface IIAppelV1 {
    appel_Date_Creation?: string | undefined;
    heuredebutAppel?: string | undefined;
    heurefinappel?: string | undefined;
    dureeAppel?: string | undefined;
    dureeAppelCalc?: string | undefined;
    acquittement?: string | undefined;
    question?: string | undefined;
    reponse?: string | undefined;
    interlocuteur?: string | undefined;
    dateDemande?: string | undefined;
    heureDemande?: string | undefined;
    sensAppel?: string | undefined;
    tempsPriseEncharge?: string | undefined;
}

export class ISize implements IISize {
    width!: number;
    height!: number;

    constructor(data?: IISize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): ISize {
        data = typeof data === 'object' ? data : {};
        let result = new ISize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IISize {
    width: number;
    height: number;
}

export enum StatsFeatureType {
    CWT = 0,
    CB = 1,
    UpdateDownload = 2,
    ViewFAQ = 3,
    AssistTchat = 4,
    AssistForm = 5,
    AssistRDV = 6,
    ColoruserCreation = 7,
    ColoruserActivation = 8,
    ColoruserEdit = 9,
    UserRenaultCreation = 10,
    UserRenaultEdit = 11,
    NonLacourRedirect = 12,
    NewMachineRegistration = 13,
    DocumentRead = 14,
}

export class StatsKeyfactorInfo implements IStatsKeyfactorInfo {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IStatsKeyfactorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatsKeyfactorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StatsKeyfactorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatsKeyfactorInfo {
    name?: string | undefined;
    value?: string | undefined;
}

export enum StatsPrefsPeriod {
    TODAY = 0,
    WEEK = 1,
    MONTH = 2,
    YEAR = 3,
    ALWAYS = 4,
}

export class ValidationMail extends AbstractEntity implements IValidationMail {
    idvalidationMail!: number;
    location?: string | undefined;
    rTmail?: string | undefined;
    rTname?: string | undefined;
    login?: string | undefined;
    city?: string | undefined;

    constructor(data?: IValidationMail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idvalidationMail = _data["idvalidationMail"];
            this.location = _data["location"];
            this.rTmail = _data["rTmail"];
            this.rTname = _data["rTname"];
            this.login = _data["login"];
            this.city = _data["city"];
        }
    }

    static override fromJS(data: any): ValidationMail {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationMail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idvalidationMail"] = this.idvalidationMail;
        data["location"] = this.location;
        data["rTmail"] = this.rTmail;
        data["rTname"] = this.rTname;
        data["login"] = this.login;
        data["city"] = this.city;
        super.toJSON(data);
        return data;
    }
}

export interface IValidationMail extends IAbstractEntity {
    idvalidationMail: number;
    location?: string | undefined;
    rTmail?: string | undefined;
    rTname?: string | undefined;
    login?: string | undefined;
    city?: string | undefined;
}

export class ICompleteHistoryV1 implements IICompleteHistoryV1 {
    history?: ILogHistoryV1[] | undefined;
    totalCount!: number;

    constructor(data?: IICompleteHistoryV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ILogHistoryV1.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ICompleteHistoryV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ICompleteHistoryV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IICompleteHistoryV1 {
    history?: ILogHistoryV1[] | undefined;
    totalCount: number;
}

export class ILogHistoryV1 implements IILogHistoryV1 {
    actionDate?: string | undefined;
    action?: string | undefined;
    mail?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    country?: string | undefined;
    rTname?: string | undefined;
    location?: string | undefined;
    ctcName?: string | undefined;
    ctcFirstname?: string | undefined;

    constructor(data?: IILogHistoryV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionDate = _data["actionDate"];
            this.action = _data["action"];
            this.mail = _data["mail"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.country = _data["country"];
            this.rTname = _data["rTname"];
            this.location = _data["location"];
            this.ctcName = _data["ctcName"];
            this.ctcFirstname = _data["ctcFirstname"];
        }
    }

    static fromJS(data: any): ILogHistoryV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ILogHistoryV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionDate"] = this.actionDate;
        data["action"] = this.action;
        data["mail"] = this.mail;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["country"] = this.country;
        data["rTname"] = this.rTname;
        data["location"] = this.location;
        data["ctcName"] = this.ctcName;
        data["ctcFirstname"] = this.ctcFirstname;
        return data;
    }
}

export interface IILogHistoryV1 {
    actionDate?: string | undefined;
    action?: string | undefined;
    mail?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    country?: string | undefined;
    rTname?: string | undefined;
    location?: string | undefined;
    ctcName?: string | undefined;
    ctcFirstname?: string | undefined;
}

export class IColorUserAdminV1 implements IIColorUserAdminV1 {
    idcolorUser!: number;
    mail?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    unisiteCode?: string | undefined;
    mailSended!: boolean;
    dateMailSent?: string | undefined;
    nbConnection!: number;
    statusAdmin!: number;
    dateMajAdmin?: Date | undefined;
    loginAdmin?: string | undefined;
    siren?: string | undefined;
    tva?: string | undefined;

    constructor(data?: IIColorUserAdminV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idcolorUser = _data["idcolorUser"];
            this.mail = _data["mail"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.socialReason = _data["socialReason"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.unisiteCode = _data["unisiteCode"];
            this.mailSended = _data["mailSended"];
            this.dateMailSent = _data["dateMailSent"];
            this.nbConnection = _data["nbConnection"];
            this.statusAdmin = _data["statusAdmin"];
            this.dateMajAdmin = _data["dateMajAdmin"] ? new Date(_data["dateMajAdmin"].toString()) : <any>undefined;
            this.loginAdmin = _data["loginAdmin"];
            this.siren = _data["siren"];
            this.tva = _data["tva"];
        }
    }

    static fromJS(data: any): IColorUserAdminV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IColorUserAdminV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idcolorUser"] = this.idcolorUser;
        data["mail"] = this.mail;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["socialReason"] = this.socialReason;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["unisiteCode"] = this.unisiteCode;
        data["mailSended"] = this.mailSended;
        data["dateMailSent"] = this.dateMailSent;
        data["nbConnection"] = this.nbConnection;
        data["statusAdmin"] = this.statusAdmin;
        data["dateMajAdmin"] = this.dateMajAdmin ? this.dateMajAdmin.toISOString() : <any>undefined;
        data["loginAdmin"] = this.loginAdmin;
        data["siren"] = this.siren;
        data["tva"] = this.tva;
        return data;
    }
}

export interface IIColorUserAdminV1 {
    idcolorUser: number;
    mail?: string | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    unisiteCode?: string | undefined;
    mailSended: boolean;
    dateMailSent?: string | undefined;
    nbConnection: number;
    statusAdmin: number;
    dateMajAdmin?: Date | undefined;
    loginAdmin?: string | undefined;
    siren?: string | undefined;
    tva?: string | undefined;
}

export class LogV1 extends AbstractEntity implements ILogV1 {
    logID!: number;
    logDate!: Date;
    categorie!: CategoryLog;
    sousCategorie!: SubCategoryLog;
    evenement?: string | undefined;
    infosComp?: string | undefined;
    login?: string | undefined;

    constructor(data?: ILogV1) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logID = _data["logID"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.categorie = _data["categorie"];
            this.sousCategorie = _data["sousCategorie"];
            this.evenement = _data["evenement"];
            this.infosComp = _data["infosComp"];
            this.login = _data["login"];
        }
    }

    static override fromJS(data: any): LogV1 {
        data = typeof data === 'object' ? data : {};
        let result = new LogV1();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["categorie"] = this.categorie;
        data["sousCategorie"] = this.sousCategorie;
        data["evenement"] = this.evenement;
        data["infosComp"] = this.infosComp;
        data["login"] = this.login;
        super.toJSON(data);
        return data;
    }
}

export interface ILogV1 extends IAbstractEntity {
    logID: number;
    logDate: Date;
    categorie: CategoryLog;
    sousCategorie: SubCategoryLog;
    evenement?: string | undefined;
    infosComp?: string | undefined;
    login?: string | undefined;
}

export class ICompanyColorUserV1 implements IICompanyColorUserV1 {
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    listIdcolorUser?: string | undefined;
    siren?: string | undefined;
    tva?: string | undefined;

    constructor(data?: IICompanyColorUserV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialReason = _data["socialReason"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.listIdcolorUser = _data["listIdcolorUser"];
            this.siren = _data["siren"];
            this.tva = _data["tva"];
        }
    }

    static fromJS(data: any): ICompanyColorUserV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ICompanyColorUserV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialReason"] = this.socialReason;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["listIdcolorUser"] = this.listIdcolorUser;
        data["siren"] = this.siren;
        data["tva"] = this.tva;
        return data;
    }
}

export interface IICompanyColorUserV1 {
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    listIdcolorUser?: string | undefined;
    siren?: string | undefined;
    tva?: string | undefined;
}

export class IActivationV1 implements IIActivationV1 {
    scale?: IScaleV1 | undefined;
    ctcLogin?: string | undefined;
    user?: IUserV1 | undefined;
    userCompany?: ICompanyV1 | undefined;
    billing?: IBillingV1 | undefined;
    activationCode?: string | undefined;
    payor?: IUserV1 | undefined;
    payorCompany?: ICompanyV1 | undefined;

    constructor(data?: IIActivationV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scale = _data["scale"] ? IScaleV1.fromJS(_data["scale"]) : <any>undefined;
            this.ctcLogin = _data["ctcLogin"];
            this.user = _data["user"] ? IUserV1.fromJS(_data["user"]) : <any>undefined;
            this.userCompany = _data["userCompany"] ? ICompanyV1.fromJS(_data["userCompany"]) : <any>undefined;
            this.billing = _data["billing"] ? IBillingV1.fromJS(_data["billing"]) : <any>undefined;
            this.activationCode = _data["activationCode"];
            this.payor = _data["payor"] ? IUserV1.fromJS(_data["payor"]) : <any>undefined;
            this.payorCompany = _data["payorCompany"] ? ICompanyV1.fromJS(_data["payorCompany"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IActivationV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IActivationV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scale"] = this.scale ? this.scale.toJSON() : <any>undefined;
        data["ctcLogin"] = this.ctcLogin;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userCompany"] = this.userCompany ? this.userCompany.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["activationCode"] = this.activationCode;
        data["payor"] = this.payor ? this.payor.toJSON() : <any>undefined;
        data["payorCompany"] = this.payorCompany ? this.payorCompany.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIActivationV1 {
    scale?: IScaleV1 | undefined;
    ctcLogin?: string | undefined;
    user?: IUserV1 | undefined;
    userCompany?: ICompanyV1 | undefined;
    billing?: IBillingV1 | undefined;
    activationCode?: string | undefined;
    payor?: IUserV1 | undefined;
    payorCompany?: ICompanyV1 | undefined;
}

export class IScaleV1 implements IIScaleV1 {
    scaleID!: number;
    code?: string | undefined;
    serialNumber?: string | undefined;

    constructor(data?: IIScaleV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scaleID = _data["scaleID"];
            this.code = _data["code"];
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): IScaleV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IScaleV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scaleID"] = this.scaleID;
        data["code"] = this.code;
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface IIScaleV1 {
    scaleID: number;
    code?: string | undefined;
    serialNumber?: string | undefined;
}

export class IBillingV1 implements IIBillingV1 {
    billingID!: number;
    billingInfo?: string | undefined;
    nbProducts!: number;
    amountTotal!: number;
    currency!: number;
    transDate!: Date;
    transDateUTC?: string | undefined;
    transID!: number;
    transStatus!: number;
    activationID!: number;
    payor_userID!: number;
    user_userid!: number;
    login?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    orderNumber?: string | undefined;
    sageCode?: string | undefined;
    tvaID!: number;
    paymentCB!: boolean;
    shipping!: number;
    tva!: number;
    amountHT!: number;
    invoiceNotification!: number;
    invoiceCode?: string | undefined;
    invoiceDate?: string | undefined;
    unisiteCode?: string | undefined;
    isQuote!: boolean;
    fdpManuel!: number;
    isSended!: boolean;
    lstBillDetails?: IBillingDetailV1[] | undefined;
    idAdrFact!: number;
    idAdrLiv!: number;
    adresseFacturation?: IAdresseV1 | undefined;
    adresseLivraison?: IAdresseV1 | undefined;

    constructor(data?: IIBillingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingID = _data["billingID"];
            this.billingInfo = _data["billingInfo"];
            this.nbProducts = _data["nbProducts"];
            this.amountTotal = _data["amountTotal"];
            this.currency = _data["currency"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
            this.transDateUTC = _data["transDateUTC"];
            this.transID = _data["transID"];
            this.transStatus = _data["transStatus"];
            this.activationID = _data["activationID"];
            this.payor_userID = _data["payor_userID"];
            this.user_userid = _data["user_userid"];
            this.login = _data["login"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.orderNumber = _data["orderNumber"];
            this.sageCode = _data["sageCode"];
            this.tvaID = _data["tvaID"];
            this.paymentCB = _data["paymentCB"];
            this.shipping = _data["shipping"];
            this.tva = _data["tva"];
            this.amountHT = _data["amountHT"];
            this.invoiceNotification = _data["invoiceNotification"];
            this.invoiceCode = _data["invoiceCode"];
            this.invoiceDate = _data["invoiceDate"];
            this.unisiteCode = _data["unisiteCode"];
            this.isQuote = _data["isQuote"];
            this.fdpManuel = _data["fdpManuel"];
            this.isSended = _data["isSended"];
            if (Array.isArray(_data["lstBillDetails"])) {
                this.lstBillDetails = [] as any;
                for (let item of _data["lstBillDetails"])
                    this.lstBillDetails!.push(IBillingDetailV1.fromJS(item));
            }
            this.idAdrFact = _data["idAdrFact"];
            this.idAdrLiv = _data["idAdrLiv"];
            this.adresseFacturation = _data["adresseFacturation"] ? IAdresseV1.fromJS(_data["adresseFacturation"]) : <any>undefined;
            this.adresseLivraison = _data["adresseLivraison"] ? IAdresseV1.fromJS(_data["adresseLivraison"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IBillingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IBillingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingID"] = this.billingID;
        data["billingInfo"] = this.billingInfo;
        data["nbProducts"] = this.nbProducts;
        data["amountTotal"] = this.amountTotal;
        data["currency"] = this.currency;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        data["transDateUTC"] = this.transDateUTC;
        data["transID"] = this.transID;
        data["transStatus"] = this.transStatus;
        data["activationID"] = this.activationID;
        data["payor_userID"] = this.payor_userID;
        data["user_userid"] = this.user_userid;
        data["login"] = this.login;
        data["email"] = this.email;
        data["language"] = this.language;
        data["orderNumber"] = this.orderNumber;
        data["sageCode"] = this.sageCode;
        data["tvaID"] = this.tvaID;
        data["paymentCB"] = this.paymentCB;
        data["shipping"] = this.shipping;
        data["tva"] = this.tva;
        data["amountHT"] = this.amountHT;
        data["invoiceNotification"] = this.invoiceNotification;
        data["invoiceCode"] = this.invoiceCode;
        data["invoiceDate"] = this.invoiceDate;
        data["unisiteCode"] = this.unisiteCode;
        data["isQuote"] = this.isQuote;
        data["fdpManuel"] = this.fdpManuel;
        data["isSended"] = this.isSended;
        if (Array.isArray(this.lstBillDetails)) {
            data["lstBillDetails"] = [];
            for (let item of this.lstBillDetails)
                data["lstBillDetails"].push(item.toJSON());
        }
        data["idAdrFact"] = this.idAdrFact;
        data["idAdrLiv"] = this.idAdrLiv;
        data["adresseFacturation"] = this.adresseFacturation ? this.adresseFacturation.toJSON() : <any>undefined;
        data["adresseLivraison"] = this.adresseLivraison ? this.adresseLivraison.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIBillingV1 {
    billingID: number;
    billingInfo?: string | undefined;
    nbProducts: number;
    amountTotal: number;
    currency: number;
    transDate: Date;
    transDateUTC?: string | undefined;
    transID: number;
    transStatus: number;
    activationID: number;
    payor_userID: number;
    user_userid: number;
    login?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    orderNumber?: string | undefined;
    sageCode?: string | undefined;
    tvaID: number;
    paymentCB: boolean;
    shipping: number;
    tva: number;
    amountHT: number;
    invoiceNotification: number;
    invoiceCode?: string | undefined;
    invoiceDate?: string | undefined;
    unisiteCode?: string | undefined;
    isQuote: boolean;
    fdpManuel: number;
    isSended: boolean;
    lstBillDetails?: IBillingDetailV1[] | undefined;
    idAdrFact: number;
    idAdrLiv: number;
    adresseFacturation?: IAdresseV1 | undefined;
    adresseLivraison?: IAdresseV1 | undefined;
}

export class IBillingDetailV1 implements IIBillingDetailV1 {
    billingDetailId!: number;
    billingId!: number;
    productId!: number;
    qty!: number;
    product?: IProductV1 | undefined;
    rentingID!: number;
    activationID!: number;

    constructor(data?: IIBillingDetailV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingDetailId = _data["billingDetailId"];
            this.billingId = _data["billingId"];
            this.productId = _data["productId"];
            this.qty = _data["qty"];
            this.product = _data["product"] ? IProductV1.fromJS(_data["product"]) : <any>undefined;
            this.rentingID = _data["rentingID"];
            this.activationID = _data["activationID"];
        }
    }

    static fromJS(data: any): IBillingDetailV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IBillingDetailV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingDetailId"] = this.billingDetailId;
        data["billingId"] = this.billingId;
        data["productId"] = this.productId;
        data["qty"] = this.qty;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["rentingID"] = this.rentingID;
        data["activationID"] = this.activationID;
        return data;
    }
}

export interface IIBillingDetailV1 {
    billingDetailId: number;
    billingId: number;
    productId: number;
    qty: number;
    product?: IProductV1 | undefined;
    rentingID: number;
    activationID: number;
}

export class IAdresseV1 implements IIAdresseV1 {
    addressID!: number;
    login?: string | undefined;
    type!: number;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    siret?: string | undefined;
    tvaIntra?: string | undefined;
    isIsland!: boolean;
    lBillProducts?: IBillingDetailV1[] | undefined;

    constructor(data?: IIAdresseV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressID = _data["addressID"];
            this.login = _data["login"];
            this.type = _data["type"];
            this.socialReason = _data["socialReason"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.siret = _data["siret"];
            this.tvaIntra = _data["tvaIntra"];
            this.isIsland = _data["isIsland"];
            if (Array.isArray(_data["lBillProducts"])) {
                this.lBillProducts = [] as any;
                for (let item of _data["lBillProducts"])
                    this.lBillProducts!.push(IBillingDetailV1.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IAdresseV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IAdresseV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressID"] = this.addressID;
        data["login"] = this.login;
        data["type"] = this.type;
        data["socialReason"] = this.socialReason;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["siret"] = this.siret;
        data["tvaIntra"] = this.tvaIntra;
        data["isIsland"] = this.isIsland;
        if (Array.isArray(this.lBillProducts)) {
            data["lBillProducts"] = [];
            for (let item of this.lBillProducts)
                data["lBillProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIAdresseV1 {
    addressID: number;
    login?: string | undefined;
    type: number;
    socialReason?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    siret?: string | undefined;
    tvaIntra?: string | undefined;
    isIsland: boolean;
    lBillProducts?: IBillingDetailV1[] | undefined;
}

export class IActivationLight implements IIActivationLight {
    billingID!: number;
    activationID!: number;
    scaleCode?: string | undefined;
    ctcFirstName?: string | undefined;
    ctcName?: string | undefined;
    ctcLogin?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    activationDate?: string | undefined;
    licenceStart?: string | undefined;
    licenceEnd?: string | undefined;
    userName?: string | undefined;
    userFirstName?: string | undefined;
    userMail?: string | undefined;
    userLoginUnisite?: string | undefined;
    userLanguage?: string | undefined;
    payorName?: string | undefined;
    payorFirstName?: string | undefined;
    payorMail?: string | undefined;
    payorLoginUnisite?: string | undefined;
    payorLanguage?: string | undefined;
    activationStatus!: number;
    companyUnisiteCode?: string | undefined;
    companySocialReason?: string | undefined;
    companyAddress?: string | undefined;
    companyPostalCode?: string | undefined;
    companyCity?: string | undefined;
    companyCountry?: string | undefined;
    companyPayorUnisiteCode?: string | undefined;
    companyPayorSocialReason?: string | undefined;
    companyPayorAddress?: string | undefined;
    companyPayorPostalCode?: string | undefined;
    companyPayorCity?: string | undefined;
    companyPayorCountry?: string | undefined;
    companyPayorSiret?: string | undefined;
    activationCode?: string | undefined;
    qty?: string | undefined;
    serialNumber?: string | undefined;
    isChecked!: number;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;
    transStatus!: number;
    transDate?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceNotification!: number;

    constructor(data?: IIActivationLight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingID = _data["billingID"];
            this.activationID = _data["activationID"];
            this.scaleCode = _data["scaleCode"];
            this.ctcFirstName = _data["ctcFirstName"];
            this.ctcName = _data["ctcName"];
            this.ctcLogin = _data["ctcLogin"];
            this.ctcMail = _data["ctcMail"];
            this.ctcLanguage = _data["ctcLanguage"];
            this.activationDate = _data["activationDate"];
            this.licenceStart = _data["licenceStart"];
            this.licenceEnd = _data["licenceEnd"];
            this.userName = _data["userName"];
            this.userFirstName = _data["userFirstName"];
            this.userMail = _data["userMail"];
            this.userLoginUnisite = _data["userLoginUnisite"];
            this.userLanguage = _data["userLanguage"];
            this.payorName = _data["payorName"];
            this.payorFirstName = _data["payorFirstName"];
            this.payorMail = _data["payorMail"];
            this.payorLoginUnisite = _data["payorLoginUnisite"];
            this.payorLanguage = _data["payorLanguage"];
            this.activationStatus = _data["activationStatus"];
            this.companyUnisiteCode = _data["companyUnisiteCode"];
            this.companySocialReason = _data["companySocialReason"];
            this.companyAddress = _data["companyAddress"];
            this.companyPostalCode = _data["companyPostalCode"];
            this.companyCity = _data["companyCity"];
            this.companyCountry = _data["companyCountry"];
            this.companyPayorUnisiteCode = _data["companyPayorUnisiteCode"];
            this.companyPayorSocialReason = _data["companyPayorSocialReason"];
            this.companyPayorAddress = _data["companyPayorAddress"];
            this.companyPayorPostalCode = _data["companyPayorPostalCode"];
            this.companyPayorCity = _data["companyPayorCity"];
            this.companyPayorCountry = _data["companyPayorCountry"];
            this.companyPayorSiret = _data["companyPayorSiret"];
            this.activationCode = _data["activationCode"];
            this.qty = _data["qty"];
            this.serialNumber = _data["serialNumber"];
            this.isChecked = _data["isChecked"];
            this.sageCode = _data["sageCode"];
            this.invoiceCode = _data["invoiceCode"];
            this.transStatus = _data["transStatus"];
            this.transDate = _data["transDate"];
            this.invoiceDate = _data["invoiceDate"];
            this.invoiceNotification = _data["invoiceNotification"];
        }
    }

    static fromJS(data: any): IActivationLight {
        data = typeof data === 'object' ? data : {};
        let result = new IActivationLight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingID"] = this.billingID;
        data["activationID"] = this.activationID;
        data["scaleCode"] = this.scaleCode;
        data["ctcFirstName"] = this.ctcFirstName;
        data["ctcName"] = this.ctcName;
        data["ctcLogin"] = this.ctcLogin;
        data["ctcMail"] = this.ctcMail;
        data["ctcLanguage"] = this.ctcLanguage;
        data["activationDate"] = this.activationDate;
        data["licenceStart"] = this.licenceStart;
        data["licenceEnd"] = this.licenceEnd;
        data["userName"] = this.userName;
        data["userFirstName"] = this.userFirstName;
        data["userMail"] = this.userMail;
        data["userLoginUnisite"] = this.userLoginUnisite;
        data["userLanguage"] = this.userLanguage;
        data["payorName"] = this.payorName;
        data["payorFirstName"] = this.payorFirstName;
        data["payorMail"] = this.payorMail;
        data["payorLoginUnisite"] = this.payorLoginUnisite;
        data["payorLanguage"] = this.payorLanguage;
        data["activationStatus"] = this.activationStatus;
        data["companyUnisiteCode"] = this.companyUnisiteCode;
        data["companySocialReason"] = this.companySocialReason;
        data["companyAddress"] = this.companyAddress;
        data["companyPostalCode"] = this.companyPostalCode;
        data["companyCity"] = this.companyCity;
        data["companyCountry"] = this.companyCountry;
        data["companyPayorUnisiteCode"] = this.companyPayorUnisiteCode;
        data["companyPayorSocialReason"] = this.companyPayorSocialReason;
        data["companyPayorAddress"] = this.companyPayorAddress;
        data["companyPayorPostalCode"] = this.companyPayorPostalCode;
        data["companyPayorCity"] = this.companyPayorCity;
        data["companyPayorCountry"] = this.companyPayorCountry;
        data["companyPayorSiret"] = this.companyPayorSiret;
        data["activationCode"] = this.activationCode;
        data["qty"] = this.qty;
        data["serialNumber"] = this.serialNumber;
        data["isChecked"] = this.isChecked;
        data["sageCode"] = this.sageCode;
        data["invoiceCode"] = this.invoiceCode;
        data["transStatus"] = this.transStatus;
        data["transDate"] = this.transDate;
        data["invoiceDate"] = this.invoiceDate;
        data["invoiceNotification"] = this.invoiceNotification;
        return data;
    }
}

export interface IIActivationLight {
    billingID: number;
    activationID: number;
    scaleCode?: string | undefined;
    ctcFirstName?: string | undefined;
    ctcName?: string | undefined;
    ctcLogin?: string | undefined;
    ctcMail?: string | undefined;
    ctcLanguage?: string | undefined;
    activationDate?: string | undefined;
    licenceStart?: string | undefined;
    licenceEnd?: string | undefined;
    userName?: string | undefined;
    userFirstName?: string | undefined;
    userMail?: string | undefined;
    userLoginUnisite?: string | undefined;
    userLanguage?: string | undefined;
    payorName?: string | undefined;
    payorFirstName?: string | undefined;
    payorMail?: string | undefined;
    payorLoginUnisite?: string | undefined;
    payorLanguage?: string | undefined;
    activationStatus: number;
    companyUnisiteCode?: string | undefined;
    companySocialReason?: string | undefined;
    companyAddress?: string | undefined;
    companyPostalCode?: string | undefined;
    companyCity?: string | undefined;
    companyCountry?: string | undefined;
    companyPayorUnisiteCode?: string | undefined;
    companyPayorSocialReason?: string | undefined;
    companyPayorAddress?: string | undefined;
    companyPayorPostalCode?: string | undefined;
    companyPayorCity?: string | undefined;
    companyPayorCountry?: string | undefined;
    companyPayorSiret?: string | undefined;
    activationCode?: string | undefined;
    qty?: string | undefined;
    serialNumber?: string | undefined;
    isChecked: number;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;
    transStatus: number;
    transDate?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceNotification: number;
}

export class IScaleHistoryV1 implements IIScaleHistoryV1 {
    scaleHistoryID!: number;
    scaleID!: number;
    orderDate!: Date;
    activationID!: number;
    billingID!: number;
    licenceStartDate!: Date;
    licenceEndDate!: Date;
    activationCode?: string | undefined;
    durationBought!: number;
    user_UserID!: number;
    user_ColorUserID!: number;
    payor_UserID!: number;
    payor_ColorUserID!: number;
    oldScaleID!: number;
    isActif!: number;
    code!: number;
    serialNumber?: string | undefined;
    oldScaleCode!: number;
    oldScaleSerialNumber?: string | undefined;

    constructor(data?: IIScaleHistoryV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scaleHistoryID = _data["scaleHistoryID"];
            this.scaleID = _data["scaleID"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.activationID = _data["activationID"];
            this.billingID = _data["billingID"];
            this.licenceStartDate = _data["licenceStartDate"] ? new Date(_data["licenceStartDate"].toString()) : <any>undefined;
            this.licenceEndDate = _data["licenceEndDate"] ? new Date(_data["licenceEndDate"].toString()) : <any>undefined;
            this.activationCode = _data["activationCode"];
            this.durationBought = _data["durationBought"];
            this.user_UserID = _data["user_UserID"];
            this.user_ColorUserID = _data["user_ColorUserID"];
            this.payor_UserID = _data["payor_UserID"];
            this.payor_ColorUserID = _data["payor_ColorUserID"];
            this.oldScaleID = _data["oldScaleID"];
            this.isActif = _data["isActif"];
            this.code = _data["code"];
            this.serialNumber = _data["serialNumber"];
            this.oldScaleCode = _data["oldScaleCode"];
            this.oldScaleSerialNumber = _data["oldScaleSerialNumber"];
        }
    }

    static fromJS(data: any): IScaleHistoryV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IScaleHistoryV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scaleHistoryID"] = this.scaleHistoryID;
        data["scaleID"] = this.scaleID;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["activationID"] = this.activationID;
        data["billingID"] = this.billingID;
        data["licenceStartDate"] = this.licenceStartDate ? this.licenceStartDate.toISOString() : <any>undefined;
        data["licenceEndDate"] = this.licenceEndDate ? this.licenceEndDate.toISOString() : <any>undefined;
        data["activationCode"] = this.activationCode;
        data["durationBought"] = this.durationBought;
        data["user_UserID"] = this.user_UserID;
        data["user_ColorUserID"] = this.user_ColorUserID;
        data["payor_UserID"] = this.payor_UserID;
        data["payor_ColorUserID"] = this.payor_ColorUserID;
        data["oldScaleID"] = this.oldScaleID;
        data["isActif"] = this.isActif;
        data["code"] = this.code;
        data["serialNumber"] = this.serialNumber;
        data["oldScaleCode"] = this.oldScaleCode;
        data["oldScaleSerialNumber"] = this.oldScaleSerialNumber;
        return data;
    }
}

export interface IIScaleHistoryV1 {
    scaleHistoryID: number;
    scaleID: number;
    orderDate: Date;
    activationID: number;
    billingID: number;
    licenceStartDate: Date;
    licenceEndDate: Date;
    activationCode?: string | undefined;
    durationBought: number;
    user_UserID: number;
    user_ColorUserID: number;
    payor_UserID: number;
    payor_ColorUserID: number;
    oldScaleID: number;
    isActif: number;
    code: number;
    serialNumber?: string | undefined;
    oldScaleCode: number;
    oldScaleSerialNumber?: string | undefined;
}

export class PaymentInfo implements IPaymentInfo {
    billing?: IBillingV1 | undefined;
    payment!: number;
    billingID!: number;

    constructor(data?: IPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billing = _data["billing"] ? IBillingV1.fromJS(_data["billing"]) : <any>undefined;
            this.payment = _data["payment"];
            this.billingID = _data["billingID"];
        }
    }

    static fromJS(data: any): PaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["payment"] = this.payment;
        data["billingID"] = this.billingID;
        return data;
    }
}

export interface IPaymentInfo {
    billing?: IBillingV1 | undefined;
    payment: number;
    billingID: number;
}

export class CryptSignature implements ICryptSignature {
    value?: string | undefined;
    cryptMode?: string | undefined;

    constructor(data?: ICryptSignature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.cryptMode = _data["cryptMode"];
        }
    }

    static fromJS(data: any): CryptSignature {
        data = typeof data === 'object' ? data : {};
        let result = new CryptSignature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["cryptMode"] = this.cryptMode;
        return data;
    }
}

export interface ICryptSignature {
    value?: string | undefined;
    cryptMode?: string | undefined;
}

export class ActivationLicenceInfo implements IActivationLicenceInfo {
    activationID!: number;
    code?: string | undefined;
    socialReason?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    unisiteCode?: string | undefined;
    licenceStart!: Date;
    licenceEnd!: Date;
    dateActivationLicence!: Date;

    constructor(data?: IActivationLicenceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationID = _data["activationID"];
            this.code = _data["code"];
            this.socialReason = _data["socialReason"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.unisiteCode = _data["unisiteCode"];
            this.licenceStart = _data["licenceStart"] ? new Date(_data["licenceStart"].toString()) : <any>undefined;
            this.licenceEnd = _data["licenceEnd"] ? new Date(_data["licenceEnd"].toString()) : <any>undefined;
            this.dateActivationLicence = _data["dateActivationLicence"] ? new Date(_data["dateActivationLicence"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivationLicenceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationLicenceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationID"] = this.activationID;
        data["code"] = this.code;
        data["socialReason"] = this.socialReason;
        data["city"] = this.city;
        data["country"] = this.country;
        data["unisiteCode"] = this.unisiteCode;
        data["licenceStart"] = this.licenceStart ? this.licenceStart.toISOString() : <any>undefined;
        data["licenceEnd"] = this.licenceEnd ? this.licenceEnd.toISOString() : <any>undefined;
        data["dateActivationLicence"] = this.dateActivationLicence ? this.dateActivationLicence.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActivationLicenceInfo {
    activationID: number;
    code?: string | undefined;
    socialReason?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    unisiteCode?: string | undefined;
    licenceStart: Date;
    licenceEnd: Date;
    dateActivationLicence: Date;
}

export class IAdminBillingV1 implements IIAdminBillingV1 {
    activationID!: number;
    billingID!: number;
    name?: string | undefined;
    firstname?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    unisiteCode?: string | undefined;
    code?: string | undefined;
    lstBillDetails?: IBillingDetailV1[] | undefined;
    tva!: number;

    constructor(data?: IIAdminBillingV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationID = _data["activationID"];
            this.billingID = _data["billingID"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.socialReason = _data["socialReason"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.unisiteCode = _data["unisiteCode"];
            this.code = _data["code"];
            if (Array.isArray(_data["lstBillDetails"])) {
                this.lstBillDetails = [] as any;
                for (let item of _data["lstBillDetails"])
                    this.lstBillDetails!.push(IBillingDetailV1.fromJS(item));
            }
            this.tva = _data["tva"];
        }
    }

    static fromJS(data: any): IAdminBillingV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IAdminBillingV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationID"] = this.activationID;
        data["billingID"] = this.billingID;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["socialReason"] = this.socialReason;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["unisiteCode"] = this.unisiteCode;
        data["code"] = this.code;
        if (Array.isArray(this.lstBillDetails)) {
            data["lstBillDetails"] = [];
            for (let item of this.lstBillDetails)
                data["lstBillDetails"].push(item.toJSON());
        }
        data["tva"] = this.tva;
        return data;
    }
}

export interface IIAdminBillingV1 {
    activationID: number;
    billingID: number;
    name?: string | undefined;
    firstname?: string | undefined;
    socialReason?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    unisiteCode?: string | undefined;
    code?: string | undefined;
    lstBillDetails?: IBillingDetailV1[] | undefined;
    tva: number;
}

export class IHistoryV1 implements IIHistoryV1 {
    haveLicence!: boolean;
    billingID!: number;
    unisiteCode?: string | undefined;
    activationId?: string | undefined;
    code?: string | undefined;
    licenceStart?: string | undefined;
    licenceEnd?: string | undefined;
    activationCode?: string | undefined;
    orderNumber?: string | undefined;
    amountTotal!: number;
    orderDetails?: OrderDetail[] | undefined;
    transStatus!: number;
    transDate!: Date;

    constructor(data?: IIHistoryV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveLicence = _data["haveLicence"];
            this.billingID = _data["billingID"];
            this.unisiteCode = _data["unisiteCode"];
            this.activationId = _data["activationId"];
            this.code = _data["code"];
            this.licenceStart = _data["licenceStart"];
            this.licenceEnd = _data["licenceEnd"];
            this.activationCode = _data["activationCode"];
            this.orderNumber = _data["orderNumber"];
            this.amountTotal = _data["amountTotal"];
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
            this.transStatus = _data["transStatus"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IHistoryV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IHistoryV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveLicence"] = this.haveLicence;
        data["billingID"] = this.billingID;
        data["unisiteCode"] = this.unisiteCode;
        data["activationId"] = this.activationId;
        data["code"] = this.code;
        data["licenceStart"] = this.licenceStart;
        data["licenceEnd"] = this.licenceEnd;
        data["activationCode"] = this.activationCode;
        data["orderNumber"] = this.orderNumber;
        data["amountTotal"] = this.amountTotal;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        data["transStatus"] = this.transStatus;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIHistoryV1 {
    haveLicence: boolean;
    billingID: number;
    unisiteCode?: string | undefined;
    activationId?: string | undefined;
    code?: string | undefined;
    licenceStart?: string | undefined;
    licenceEnd?: string | undefined;
    activationCode?: string | undefined;
    orderNumber?: string | undefined;
    amountTotal: number;
    orderDetails?: OrderDetail[] | undefined;
    transStatus: number;
    transDate: Date;
}

export class OrderDetail implements IOrderDetail {
    qty!: number;
    amountP!: number;
    labelP?: string | undefined;
    typeP?: string | undefined;

    constructor(data?: IOrderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qty = _data["qty"];
            this.amountP = _data["amountP"];
            this.labelP = _data["labelP"];
            this.typeP = _data["typeP"];
        }
    }

    static fromJS(data: any): OrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qty"] = this.qty;
        data["amountP"] = this.amountP;
        data["labelP"] = this.labelP;
        data["typeP"] = this.typeP;
        return data;
    }
}

export interface IOrderDetail {
    qty: number;
    amountP: number;
    labelP?: string | undefined;
    typeP?: string | undefined;
}

export class IActivationInfo implements IIActivationInfo {
    activationId!: number;
    billingID!: number;
    scaleID?: string | undefined;
    scaleCode?: string | undefined;
    serialNumber?: string | undefined;
    activationCode?: string | undefined;
    licenceStart!: Date;
    licenceEnd!: Date;
    ctclogin?: string | undefined;
    ctcmail?: string | undefined;
    ctcfirstname?: string | undefined;
    ctcname?: string | undefined;
    ctclanguage?: string | undefined;
    activStatut?: string | undefined;
    usergender?: string | undefined;
    username?: string | undefined;
    userfirstname?: string | undefined;
    usermail?: string | undefined;
    userphone?: string | undefined;
    usermobile?: string | undefined;
    userlanguage?: string | undefined;
    userloginunisite?: string | undefined;
    user_colorUserID?: string | undefined;
    payorgender?: string | undefined;
    payorname?: string | undefined;
    payorfirstname?: string | undefined;
    payormail?: string | undefined;
    payorphone?: string | undefined;
    payorlanguage?: string | undefined;
    payorloginunisite?: string | undefined;
    payor_colorUserID?: string | undefined;
    companyunisitecode?: string | undefined;
    companysocialreason?: string | undefined;
    companyaddress?: string | undefined;
    companypostalcode?: string | undefined;
    companycity?: string | undefined;
    companycountry?: string | undefined;
    companyPayorunisitecode?: string | undefined;
    companyPayorsocialreason?: string | undefined;
    companyPayoraddress?: string | undefined;
    companyPayorpostalcode?: string | undefined;
    companyPayorcity?: string | undefined;
    companyPayorcountry?: string | undefined;
    companyPayorsiret?: string | undefined;
    companyPayortva?: string | undefined;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;

    constructor(data?: IIActivationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationId = _data["activationId"];
            this.billingID = _data["billingID"];
            this.scaleID = _data["scaleID"];
            this.scaleCode = _data["scaleCode"];
            this.serialNumber = _data["serialNumber"];
            this.activationCode = _data["activationCode"];
            this.licenceStart = _data["licenceStart"] ? new Date(_data["licenceStart"].toString()) : <any>undefined;
            this.licenceEnd = _data["licenceEnd"] ? new Date(_data["licenceEnd"].toString()) : <any>undefined;
            this.ctclogin = _data["ctclogin"];
            this.ctcmail = _data["ctcmail"];
            this.ctcfirstname = _data["ctcfirstname"];
            this.ctcname = _data["ctcname"];
            this.ctclanguage = _data["ctclanguage"];
            this.activStatut = _data["activStatut"];
            this.usergender = _data["usergender"];
            this.username = _data["username"];
            this.userfirstname = _data["userfirstname"];
            this.usermail = _data["usermail"];
            this.userphone = _data["userphone"];
            this.usermobile = _data["usermobile"];
            this.userlanguage = _data["userlanguage"];
            this.userloginunisite = _data["userloginunisite"];
            this.user_colorUserID = _data["user_colorUserID"];
            this.payorgender = _data["payorgender"];
            this.payorname = _data["payorname"];
            this.payorfirstname = _data["payorfirstname"];
            this.payormail = _data["payormail"];
            this.payorphone = _data["payorphone"];
            this.payorlanguage = _data["payorlanguage"];
            this.payorloginunisite = _data["payorloginunisite"];
            this.payor_colorUserID = _data["payor_colorUserID"];
            this.companyunisitecode = _data["companyunisitecode"];
            this.companysocialreason = _data["companysocialreason"];
            this.companyaddress = _data["companyaddress"];
            this.companypostalcode = _data["companypostalcode"];
            this.companycity = _data["companycity"];
            this.companycountry = _data["companycountry"];
            this.companyPayorunisitecode = _data["companyPayorunisitecode"];
            this.companyPayorsocialreason = _data["companyPayorsocialreason"];
            this.companyPayoraddress = _data["companyPayoraddress"];
            this.companyPayorpostalcode = _data["companyPayorpostalcode"];
            this.companyPayorcity = _data["companyPayorcity"];
            this.companyPayorcountry = _data["companyPayorcountry"];
            this.companyPayorsiret = _data["companyPayorsiret"];
            this.companyPayortva = _data["companyPayortva"];
            this.sageCode = _data["sageCode"];
            this.invoiceCode = _data["invoiceCode"];
        }
    }

    static fromJS(data: any): IActivationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new IActivationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationId"] = this.activationId;
        data["billingID"] = this.billingID;
        data["scaleID"] = this.scaleID;
        data["scaleCode"] = this.scaleCode;
        data["serialNumber"] = this.serialNumber;
        data["activationCode"] = this.activationCode;
        data["licenceStart"] = this.licenceStart ? this.licenceStart.toISOString() : <any>undefined;
        data["licenceEnd"] = this.licenceEnd ? this.licenceEnd.toISOString() : <any>undefined;
        data["ctclogin"] = this.ctclogin;
        data["ctcmail"] = this.ctcmail;
        data["ctcfirstname"] = this.ctcfirstname;
        data["ctcname"] = this.ctcname;
        data["ctclanguage"] = this.ctclanguage;
        data["activStatut"] = this.activStatut;
        data["usergender"] = this.usergender;
        data["username"] = this.username;
        data["userfirstname"] = this.userfirstname;
        data["usermail"] = this.usermail;
        data["userphone"] = this.userphone;
        data["usermobile"] = this.usermobile;
        data["userlanguage"] = this.userlanguage;
        data["userloginunisite"] = this.userloginunisite;
        data["user_colorUserID"] = this.user_colorUserID;
        data["payorgender"] = this.payorgender;
        data["payorname"] = this.payorname;
        data["payorfirstname"] = this.payorfirstname;
        data["payormail"] = this.payormail;
        data["payorphone"] = this.payorphone;
        data["payorlanguage"] = this.payorlanguage;
        data["payorloginunisite"] = this.payorloginunisite;
        data["payor_colorUserID"] = this.payor_colorUserID;
        data["companyunisitecode"] = this.companyunisitecode;
        data["companysocialreason"] = this.companysocialreason;
        data["companyaddress"] = this.companyaddress;
        data["companypostalcode"] = this.companypostalcode;
        data["companycity"] = this.companycity;
        data["companycountry"] = this.companycountry;
        data["companyPayorunisitecode"] = this.companyPayorunisitecode;
        data["companyPayorsocialreason"] = this.companyPayorsocialreason;
        data["companyPayoraddress"] = this.companyPayoraddress;
        data["companyPayorpostalcode"] = this.companyPayorpostalcode;
        data["companyPayorcity"] = this.companyPayorcity;
        data["companyPayorcountry"] = this.companyPayorcountry;
        data["companyPayorsiret"] = this.companyPayorsiret;
        data["companyPayortva"] = this.companyPayortva;
        data["sageCode"] = this.sageCode;
        data["invoiceCode"] = this.invoiceCode;
        return data;
    }
}

export interface IIActivationInfo {
    activationId: number;
    billingID: number;
    scaleID?: string | undefined;
    scaleCode?: string | undefined;
    serialNumber?: string | undefined;
    activationCode?: string | undefined;
    licenceStart: Date;
    licenceEnd: Date;
    ctclogin?: string | undefined;
    ctcmail?: string | undefined;
    ctcfirstname?: string | undefined;
    ctcname?: string | undefined;
    ctclanguage?: string | undefined;
    activStatut?: string | undefined;
    usergender?: string | undefined;
    username?: string | undefined;
    userfirstname?: string | undefined;
    usermail?: string | undefined;
    userphone?: string | undefined;
    usermobile?: string | undefined;
    userlanguage?: string | undefined;
    userloginunisite?: string | undefined;
    user_colorUserID?: string | undefined;
    payorgender?: string | undefined;
    payorname?: string | undefined;
    payorfirstname?: string | undefined;
    payormail?: string | undefined;
    payorphone?: string | undefined;
    payorlanguage?: string | undefined;
    payorloginunisite?: string | undefined;
    payor_colorUserID?: string | undefined;
    companyunisitecode?: string | undefined;
    companysocialreason?: string | undefined;
    companyaddress?: string | undefined;
    companypostalcode?: string | undefined;
    companycity?: string | undefined;
    companycountry?: string | undefined;
    companyPayorunisitecode?: string | undefined;
    companyPayorsocialreason?: string | undefined;
    companyPayoraddress?: string | undefined;
    companyPayorpostalcode?: string | undefined;
    companyPayorcity?: string | undefined;
    companyPayorcountry?: string | undefined;
    companyPayorsiret?: string | undefined;
    companyPayortva?: string | undefined;
    sageCode?: string | undefined;
    invoiceCode?: string | undefined;
}

export class IScaleFull implements IIScaleFull {
    s_scaleID!: number;
    s_code?: string | undefined;
    s_serialNumber?: string | undefined;
    s_licenceStart?: string | undefined;
    s_licenceEnd?: string | undefined;
    activationFull?: IActivationFull[] | undefined;

    constructor(data?: IIScaleFull) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.s_scaleID = _data["s_scaleID"];
            this.s_code = _data["s_code"];
            this.s_serialNumber = _data["s_serialNumber"];
            this.s_licenceStart = _data["s_licenceStart"];
            this.s_licenceEnd = _data["s_licenceEnd"];
            if (Array.isArray(_data["activationFull"])) {
                this.activationFull = [] as any;
                for (let item of _data["activationFull"])
                    this.activationFull!.push(IActivationFull.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IScaleFull {
        data = typeof data === 'object' ? data : {};
        let result = new IScaleFull();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["s_scaleID"] = this.s_scaleID;
        data["s_code"] = this.s_code;
        data["s_serialNumber"] = this.s_serialNumber;
        data["s_licenceStart"] = this.s_licenceStart;
        data["s_licenceEnd"] = this.s_licenceEnd;
        if (Array.isArray(this.activationFull)) {
            data["activationFull"] = [];
            for (let item of this.activationFull)
                data["activationFull"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIScaleFull {
    s_scaleID: number;
    s_code?: string | undefined;
    s_serialNumber?: string | undefined;
    s_licenceStart?: string | undefined;
    s_licenceEnd?: string | undefined;
    activationFull?: IActivationFull[] | undefined;
}

export class IActivationFull implements IIActivationFull {
    a_activationID!: number;
    a_scale_scaleID!: number;
    a_user_userid!: number;
    a_user_companyID!: number;
    a_user_colorUserID!: number;
    a_activationCode?: string | undefined;
    a_payor_userID!: number;
    a_payor_companyID!: number;
    a_payor_colorUserID!: number;
    a_activationDate?: string | undefined;
    a_ctc!: number;
    a_status!: number;
    a_statusFullBillingDelete!: number;
    a_isChecked!: number;
    a_recoveryDate?: string | undefined;
    a_recoveryNotifications!: number;
    a_sageCode?: string | undefined;
    a_invoiceCode?: string | undefined;
    a_sleepyDate?: string | undefined;
    a_invoiceDate?: string | undefined;
    a_invoiceNotification!: number;
    userFull?: IUserFull | undefined;
    payorFull?: IPayorFull | undefined;
    companyUserFull?: ICompanyUserFull | undefined;
    companyPayorFull?: ICompanyPayorFull | undefined;
    billingFull?: IBillingFull[] | undefined;
    decode_codeAtivationStart?: string | undefined;
    decode_codeAtivationEnd?: string | undefined;
    decode_codeAtivationDuree!: number;

    constructor(data?: IIActivationFull) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.a_activationID = _data["a_activationID"];
            this.a_scale_scaleID = _data["a_scale_scaleID"];
            this.a_user_userid = _data["a_user_userid"];
            this.a_user_companyID = _data["a_user_companyID"];
            this.a_user_colorUserID = _data["a_user_colorUserID"];
            this.a_activationCode = _data["a_activationCode"];
            this.a_payor_userID = _data["a_payor_userID"];
            this.a_payor_companyID = _data["a_payor_companyID"];
            this.a_payor_colorUserID = _data["a_payor_colorUserID"];
            this.a_activationDate = _data["a_activationDate"];
            this.a_ctc = _data["a_ctc"];
            this.a_status = _data["a_status"];
            this.a_statusFullBillingDelete = _data["a_statusFullBillingDelete"];
            this.a_isChecked = _data["a_isChecked"];
            this.a_recoveryDate = _data["a_recoveryDate"];
            this.a_recoveryNotifications = _data["a_recoveryNotifications"];
            this.a_sageCode = _data["a_sageCode"];
            this.a_invoiceCode = _data["a_invoiceCode"];
            this.a_sleepyDate = _data["a_sleepyDate"];
            this.a_invoiceDate = _data["a_invoiceDate"];
            this.a_invoiceNotification = _data["a_invoiceNotification"];
            this.userFull = _data["userFull"] ? IUserFull.fromJS(_data["userFull"]) : <any>undefined;
            this.payorFull = _data["payorFull"] ? IPayorFull.fromJS(_data["payorFull"]) : <any>undefined;
            this.companyUserFull = _data["companyUserFull"] ? ICompanyUserFull.fromJS(_data["companyUserFull"]) : <any>undefined;
            this.companyPayorFull = _data["companyPayorFull"] ? ICompanyPayorFull.fromJS(_data["companyPayorFull"]) : <any>undefined;
            if (Array.isArray(_data["billingFull"])) {
                this.billingFull = [] as any;
                for (let item of _data["billingFull"])
                    this.billingFull!.push(IBillingFull.fromJS(item));
            }
            this.decode_codeAtivationStart = _data["decode_codeAtivationStart"];
            this.decode_codeAtivationEnd = _data["decode_codeAtivationEnd"];
            this.decode_codeAtivationDuree = _data["decode_codeAtivationDuree"];
        }
    }

    static fromJS(data: any): IActivationFull {
        data = typeof data === 'object' ? data : {};
        let result = new IActivationFull();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["a_activationID"] = this.a_activationID;
        data["a_scale_scaleID"] = this.a_scale_scaleID;
        data["a_user_userid"] = this.a_user_userid;
        data["a_user_companyID"] = this.a_user_companyID;
        data["a_user_colorUserID"] = this.a_user_colorUserID;
        data["a_activationCode"] = this.a_activationCode;
        data["a_payor_userID"] = this.a_payor_userID;
        data["a_payor_companyID"] = this.a_payor_companyID;
        data["a_payor_colorUserID"] = this.a_payor_colorUserID;
        data["a_activationDate"] = this.a_activationDate;
        data["a_ctc"] = this.a_ctc;
        data["a_status"] = this.a_status;
        data["a_statusFullBillingDelete"] = this.a_statusFullBillingDelete;
        data["a_isChecked"] = this.a_isChecked;
        data["a_recoveryDate"] = this.a_recoveryDate;
        data["a_recoveryNotifications"] = this.a_recoveryNotifications;
        data["a_sageCode"] = this.a_sageCode;
        data["a_invoiceCode"] = this.a_invoiceCode;
        data["a_sleepyDate"] = this.a_sleepyDate;
        data["a_invoiceDate"] = this.a_invoiceDate;
        data["a_invoiceNotification"] = this.a_invoiceNotification;
        data["userFull"] = this.userFull ? this.userFull.toJSON() : <any>undefined;
        data["payorFull"] = this.payorFull ? this.payorFull.toJSON() : <any>undefined;
        data["companyUserFull"] = this.companyUserFull ? this.companyUserFull.toJSON() : <any>undefined;
        data["companyPayorFull"] = this.companyPayorFull ? this.companyPayorFull.toJSON() : <any>undefined;
        if (Array.isArray(this.billingFull)) {
            data["billingFull"] = [];
            for (let item of this.billingFull)
                data["billingFull"].push(item.toJSON());
        }
        data["decode_codeAtivationStart"] = this.decode_codeAtivationStart;
        data["decode_codeAtivationEnd"] = this.decode_codeAtivationEnd;
        data["decode_codeAtivationDuree"] = this.decode_codeAtivationDuree;
        return data;
    }
}

export interface IIActivationFull {
    a_activationID: number;
    a_scale_scaleID: number;
    a_user_userid: number;
    a_user_companyID: number;
    a_user_colorUserID: number;
    a_activationCode?: string | undefined;
    a_payor_userID: number;
    a_payor_companyID: number;
    a_payor_colorUserID: number;
    a_activationDate?: string | undefined;
    a_ctc: number;
    a_status: number;
    a_statusFullBillingDelete: number;
    a_isChecked: number;
    a_recoveryDate?: string | undefined;
    a_recoveryNotifications: number;
    a_sageCode?: string | undefined;
    a_invoiceCode?: string | undefined;
    a_sleepyDate?: string | undefined;
    a_invoiceDate?: string | undefined;
    a_invoiceNotification: number;
    userFull?: IUserFull | undefined;
    payorFull?: IPayorFull | undefined;
    companyUserFull?: ICompanyUserFull | undefined;
    companyPayorFull?: ICompanyPayorFull | undefined;
    billingFull?: IBillingFull[] | undefined;
    decode_codeAtivationStart?: string | undefined;
    decode_codeAtivationEnd?: string | undefined;
    decode_codeAtivationDuree: number;
}

export class IUserFull implements IIUserFull {
    u_userid!: number;
    u_gender?: string | undefined;
    u_name?: string | undefined;
    u_firstname?: string | undefined;
    u_mail?: string | undefined;
    u_phone?: string | undefined;
    u_mobile?: string | undefined;
    u_loginUnisite?: string | undefined;
    u_language?: string | undefined;
    u_unisiteCode?: string | undefined;
    u_company_companyID!: number;
    u_isColorUser!: number;

    constructor(data?: IIUserFull) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.u_userid = _data["u_userid"];
            this.u_gender = _data["u_gender"];
            this.u_name = _data["u_name"];
            this.u_firstname = _data["u_firstname"];
            this.u_mail = _data["u_mail"];
            this.u_phone = _data["u_phone"];
            this.u_mobile = _data["u_mobile"];
            this.u_loginUnisite = _data["u_loginUnisite"];
            this.u_language = _data["u_language"];
            this.u_unisiteCode = _data["u_unisiteCode"];
            this.u_company_companyID = _data["u_company_companyID"];
            this.u_isColorUser = _data["u_isColorUser"];
        }
    }

    static fromJS(data: any): IUserFull {
        data = typeof data === 'object' ? data : {};
        let result = new IUserFull();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["u_userid"] = this.u_userid;
        data["u_gender"] = this.u_gender;
        data["u_name"] = this.u_name;
        data["u_firstname"] = this.u_firstname;
        data["u_mail"] = this.u_mail;
        data["u_phone"] = this.u_phone;
        data["u_mobile"] = this.u_mobile;
        data["u_loginUnisite"] = this.u_loginUnisite;
        data["u_language"] = this.u_language;
        data["u_unisiteCode"] = this.u_unisiteCode;
        data["u_company_companyID"] = this.u_company_companyID;
        data["u_isColorUser"] = this.u_isColorUser;
        return data;
    }
}

export interface IIUserFull {
    u_userid: number;
    u_gender?: string | undefined;
    u_name?: string | undefined;
    u_firstname?: string | undefined;
    u_mail?: string | undefined;
    u_phone?: string | undefined;
    u_mobile?: string | undefined;
    u_loginUnisite?: string | undefined;
    u_language?: string | undefined;
    u_unisiteCode?: string | undefined;
    u_company_companyID: number;
    u_isColorUser: number;
}

export class IPayorFull implements IIPayorFull {
    p_userid!: number;
    p_gender?: string | undefined;
    p_name?: string | undefined;
    p_firstname?: string | undefined;
    p_mail?: string | undefined;
    p_phone?: string | undefined;
    p_mobile?: string | undefined;
    p_loginUnisite?: string | undefined;
    p_language?: string | undefined;
    p_unisiteCode?: string | undefined;
    p_company_companyID!: number;
    p_isColorUser!: number;

    constructor(data?: IIPayorFull) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.p_userid = _data["p_userid"];
            this.p_gender = _data["p_gender"];
            this.p_name = _data["p_name"];
            this.p_firstname = _data["p_firstname"];
            this.p_mail = _data["p_mail"];
            this.p_phone = _data["p_phone"];
            this.p_mobile = _data["p_mobile"];
            this.p_loginUnisite = _data["p_loginUnisite"];
            this.p_language = _data["p_language"];
            this.p_unisiteCode = _data["p_unisiteCode"];
            this.p_company_companyID = _data["p_company_companyID"];
            this.p_isColorUser = _data["p_isColorUser"];
        }
    }

    static fromJS(data: any): IPayorFull {
        data = typeof data === 'object' ? data : {};
        let result = new IPayorFull();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["p_userid"] = this.p_userid;
        data["p_gender"] = this.p_gender;
        data["p_name"] = this.p_name;
        data["p_firstname"] = this.p_firstname;
        data["p_mail"] = this.p_mail;
        data["p_phone"] = this.p_phone;
        data["p_mobile"] = this.p_mobile;
        data["p_loginUnisite"] = this.p_loginUnisite;
        data["p_language"] = this.p_language;
        data["p_unisiteCode"] = this.p_unisiteCode;
        data["p_company_companyID"] = this.p_company_companyID;
        data["p_isColorUser"] = this.p_isColorUser;
        return data;
    }
}

export interface IIPayorFull {
    p_userid: number;
    p_gender?: string | undefined;
    p_name?: string | undefined;
    p_firstname?: string | undefined;
    p_mail?: string | undefined;
    p_phone?: string | undefined;
    p_mobile?: string | undefined;
    p_loginUnisite?: string | undefined;
    p_language?: string | undefined;
    p_unisiteCode?: string | undefined;
    p_company_companyID: number;
    p_isColorUser: number;
}

export class ICompanyUserFull implements IICompanyUserFull {
    c_companyID!: number;
    c_unisiteCode?: string | undefined;
    c_socialReason?: string | undefined;
    c_address?: string | undefined;
    c_postalCode?: string | undefined;
    c_city?: string | undefined;
    c_country?: string | undefined;
    c_siret?: string | undefined;
    c_tva?: string | undefined;
    c_siren?: string | undefined;

    constructor(data?: IICompanyUserFull) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c_companyID = _data["c_companyID"];
            this.c_unisiteCode = _data["c_unisiteCode"];
            this.c_socialReason = _data["c_socialReason"];
            this.c_address = _data["c_address"];
            this.c_postalCode = _data["c_postalCode"];
            this.c_city = _data["c_city"];
            this.c_country = _data["c_country"];
            this.c_siret = _data["c_siret"];
            this.c_tva = _data["c_tva"];
            this.c_siren = _data["c_siren"];
        }
    }

    static fromJS(data: any): ICompanyUserFull {
        data = typeof data === 'object' ? data : {};
        let result = new ICompanyUserFull();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c_companyID"] = this.c_companyID;
        data["c_unisiteCode"] = this.c_unisiteCode;
        data["c_socialReason"] = this.c_socialReason;
        data["c_address"] = this.c_address;
        data["c_postalCode"] = this.c_postalCode;
        data["c_city"] = this.c_city;
        data["c_country"] = this.c_country;
        data["c_siret"] = this.c_siret;
        data["c_tva"] = this.c_tva;
        data["c_siren"] = this.c_siren;
        return data;
    }
}

export interface IICompanyUserFull {
    c_companyID: number;
    c_unisiteCode?: string | undefined;
    c_socialReason?: string | undefined;
    c_address?: string | undefined;
    c_postalCode?: string | undefined;
    c_city?: string | undefined;
    c_country?: string | undefined;
    c_siret?: string | undefined;
    c_tva?: string | undefined;
    c_siren?: string | undefined;
}

export class ICompanyPayorFull implements IICompanyPayorFull {
    cPayor_companyID!: number;
    cPayor_unisiteCode?: string | undefined;
    cPayor_socialReason?: string | undefined;
    cPayor_address?: string | undefined;
    cPayor_postalCode?: string | undefined;
    cPayor_city?: string | undefined;
    cPayor_country?: string | undefined;
    cPayor_siret?: string | undefined;
    cPayor_tva?: string | undefined;
    cPayor_siren?: string | undefined;

    constructor(data?: IICompanyPayorFull) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cPayor_companyID = _data["cPayor_companyID"];
            this.cPayor_unisiteCode = _data["cPayor_unisiteCode"];
            this.cPayor_socialReason = _data["cPayor_socialReason"];
            this.cPayor_address = _data["cPayor_address"];
            this.cPayor_postalCode = _data["cPayor_postalCode"];
            this.cPayor_city = _data["cPayor_city"];
            this.cPayor_country = _data["cPayor_country"];
            this.cPayor_siret = _data["cPayor_siret"];
            this.cPayor_tva = _data["cPayor_tva"];
            this.cPayor_siren = _data["cPayor_siren"];
        }
    }

    static fromJS(data: any): ICompanyPayorFull {
        data = typeof data === 'object' ? data : {};
        let result = new ICompanyPayorFull();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cPayor_companyID"] = this.cPayor_companyID;
        data["cPayor_unisiteCode"] = this.cPayor_unisiteCode;
        data["cPayor_socialReason"] = this.cPayor_socialReason;
        data["cPayor_address"] = this.cPayor_address;
        data["cPayor_postalCode"] = this.cPayor_postalCode;
        data["cPayor_city"] = this.cPayor_city;
        data["cPayor_country"] = this.cPayor_country;
        data["cPayor_siret"] = this.cPayor_siret;
        data["cPayor_tva"] = this.cPayor_tva;
        data["cPayor_siren"] = this.cPayor_siren;
        return data;
    }
}

export interface IICompanyPayorFull {
    cPayor_companyID: number;
    cPayor_unisiteCode?: string | undefined;
    cPayor_socialReason?: string | undefined;
    cPayor_address?: string | undefined;
    cPayor_postalCode?: string | undefined;
    cPayor_city?: string | undefined;
    cPayor_country?: string | undefined;
    cPayor_siret?: string | undefined;
    cPayor_tva?: string | undefined;
    cPayor_siren?: string | undefined;
}

export class IBillingFull implements IIBillingFull {
    b_billingID!: number;
    b_billingInfo?: string | undefined;
    b_nbProducts!: number;
    b_amountTotal!: number;
    b_currency!: number;
    b_transDate?: string | undefined;
    b_transID!: number;
    b_transStatus!: number;
    b_tvaID!: number;
    b_idAdrLiv!: number;
    b_idAdrFact!: number;
    b_login?: string | undefined;
    b_email?: string | undefined;
    b_language?: string | undefined;
    b_invoiceCode?: string | undefined;
    b_orderNumber?: string | undefined;
    b_SageCode?: string | undefined;
    b_PaymentCB!: number;
    b_InvoiceNotification?: string | undefined;
    b_InvoiceDate?: string | undefined;
    b_unisiteCode?: string | undefined;
    b_FDPManuel!: number;
    b_isSended!: number;
    bd_billingdetailID!: number;
    bd_billingID!: number;
    bd_productID!: number;
    bd_qty!: number;
    bd_rentingID!: number;
    p_typeP!: number;
    t_tva!: number;

    constructor(data?: IIBillingFull) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.b_billingID = _data["b_billingID"];
            this.b_billingInfo = _data["b_billingInfo"];
            this.b_nbProducts = _data["b_nbProducts"];
            this.b_amountTotal = _data["b_amountTotal"];
            this.b_currency = _data["b_currency"];
            this.b_transDate = _data["b_transDate"];
            this.b_transID = _data["b_transID"];
            this.b_transStatus = _data["b_transStatus"];
            this.b_tvaID = _data["b_tvaID"];
            this.b_idAdrLiv = _data["b_idAdrLiv"];
            this.b_idAdrFact = _data["b_idAdrFact"];
            this.b_login = _data["b_login"];
            this.b_email = _data["b_email"];
            this.b_language = _data["b_language"];
            this.b_invoiceCode = _data["b_invoiceCode"];
            this.b_orderNumber = _data["b_orderNumber"];
            this.b_SageCode = _data["b_SageCode"];
            this.b_PaymentCB = _data["b_PaymentCB"];
            this.b_InvoiceNotification = _data["b_InvoiceNotification"];
            this.b_InvoiceDate = _data["b_InvoiceDate"];
            this.b_unisiteCode = _data["b_unisiteCode"];
            this.b_FDPManuel = _data["b_FDPManuel"];
            this.b_isSended = _data["b_isSended"];
            this.bd_billingdetailID = _data["bd_billingdetailID"];
            this.bd_billingID = _data["bd_billingID"];
            this.bd_productID = _data["bd_productID"];
            this.bd_qty = _data["bd_qty"];
            this.bd_rentingID = _data["bd_rentingID"];
            this.p_typeP = _data["p_typeP"];
            this.t_tva = _data["t_tva"];
        }
    }

    static fromJS(data: any): IBillingFull {
        data = typeof data === 'object' ? data : {};
        let result = new IBillingFull();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["b_billingID"] = this.b_billingID;
        data["b_billingInfo"] = this.b_billingInfo;
        data["b_nbProducts"] = this.b_nbProducts;
        data["b_amountTotal"] = this.b_amountTotal;
        data["b_currency"] = this.b_currency;
        data["b_transDate"] = this.b_transDate;
        data["b_transID"] = this.b_transID;
        data["b_transStatus"] = this.b_transStatus;
        data["b_tvaID"] = this.b_tvaID;
        data["b_idAdrLiv"] = this.b_idAdrLiv;
        data["b_idAdrFact"] = this.b_idAdrFact;
        data["b_login"] = this.b_login;
        data["b_email"] = this.b_email;
        data["b_language"] = this.b_language;
        data["b_invoiceCode"] = this.b_invoiceCode;
        data["b_orderNumber"] = this.b_orderNumber;
        data["b_SageCode"] = this.b_SageCode;
        data["b_PaymentCB"] = this.b_PaymentCB;
        data["b_InvoiceNotification"] = this.b_InvoiceNotification;
        data["b_InvoiceDate"] = this.b_InvoiceDate;
        data["b_unisiteCode"] = this.b_unisiteCode;
        data["b_FDPManuel"] = this.b_FDPManuel;
        data["b_isSended"] = this.b_isSended;
        data["bd_billingdetailID"] = this.bd_billingdetailID;
        data["bd_billingID"] = this.bd_billingID;
        data["bd_productID"] = this.bd_productID;
        data["bd_qty"] = this.bd_qty;
        data["bd_rentingID"] = this.bd_rentingID;
        data["p_typeP"] = this.p_typeP;
        data["t_tva"] = this.t_tva;
        return data;
    }
}

export interface IIBillingFull {
    b_billingID: number;
    b_billingInfo?: string | undefined;
    b_nbProducts: number;
    b_amountTotal: number;
    b_currency: number;
    b_transDate?: string | undefined;
    b_transID: number;
    b_transStatus: number;
    b_tvaID: number;
    b_idAdrLiv: number;
    b_idAdrFact: number;
    b_login?: string | undefined;
    b_email?: string | undefined;
    b_language?: string | undefined;
    b_invoiceCode?: string | undefined;
    b_orderNumber?: string | undefined;
    b_SageCode?: string | undefined;
    b_PaymentCB: number;
    b_InvoiceNotification?: string | undefined;
    b_InvoiceDate?: string | undefined;
    b_unisiteCode?: string | undefined;
    b_FDPManuel: number;
    b_isSended: number;
    bd_billingdetailID: number;
    bd_billingID: number;
    bd_productID: number;
    bd_qty: number;
    bd_rentingID: number;
    p_typeP: number;
    t_tva: number;
}

export class ILogLacourEditV1 implements IILogLacourEditV1 {
    logLacourEditID!: number;
    parentLogLacourEditID?: number | undefined;
    date!: Date;
    valueName?: string | undefined;
    pKey!: number;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    author?: string | undefined;
    reversible!: boolean;

    constructor(data?: IILogLacourEditV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logLacourEditID = _data["logLacourEditID"];
            this.parentLogLacourEditID = _data["parentLogLacourEditID"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.valueName = _data["valueName"];
            this.pKey = _data["pKey"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.author = _data["author"];
            this.reversible = _data["reversible"];
        }
    }

    static fromJS(data: any): ILogLacourEditV1 {
        data = typeof data === 'object' ? data : {};
        let result = new ILogLacourEditV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logLacourEditID"] = this.logLacourEditID;
        data["parentLogLacourEditID"] = this.parentLogLacourEditID;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["valueName"] = this.valueName;
        data["pKey"] = this.pKey;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["author"] = this.author;
        data["reversible"] = this.reversible;
        return data;
    }
}

export interface IILogLacourEditV1 {
    logLacourEditID: number;
    parentLogLacourEditID?: number | undefined;
    date: Date;
    valueName?: string | undefined;
    pKey: number;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    author?: string | undefined;
    reversible: boolean;
}

export enum Roles {
    Unknown = 0,
    AdminLacour = 1,
    CTC = 2,
    UserIxell = 4,
    RT = 8,
    UserColor = 16,
    TechLine = 32,
    Axalta = 64,
    Attum = 128,
    ColorBook = 256,
    AdminRenault = 512,
    MCI = 1024,
    Hotline = 2048,
    ResponsableHotline = 4096,
    PreProd = 8192,
    Monitoring = 16384,
    Formateur = 32768,
    InternCorporate = 65536,
    ClientCorporate = 131072,
    HaveGPI = 262144,
    AdminRenaultPays = 524288,
    Fournisseur = 1048576,
    Akzo = 2097152,
}

export class LoginData implements ILoginData {
    item1?: string | undefined;
    item2?: string | undefined;
    item3?: string | undefined;
    login?: string | undefined;
    password?: string | undefined;
    language?: string | undefined;

    constructor(data?: ILoginData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
            this.item3 = _data["item3"];
            this.login = _data["login"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): LoginData {
        data = typeof data === 'object' ? data : {};
        let result = new LoginData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        data["item3"] = this.item3;
        data["login"] = this.login;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    }
}

export interface ILoginData {
    item1?: string | undefined;
    item2?: string | undefined;
    item3?: string | undefined;
    login?: string | undefined;
    password?: string | undefined;
    language?: string | undefined;
}

export class Accessoire implements IAccessoire {
    accessoire_id?: string | undefined;
    designation?: string | undefined;
    teintes?: TeinteCB[] | undefined;
    front!: boolean;
    codeColorWeb?: string | undefined;

    constructor(data?: IAccessoire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessoire_id = _data["accessoire_id"];
            this.designation = _data["designation"];
            if (Array.isArray(_data["teintes"])) {
                this.teintes = [] as any;
                for (let item of _data["teintes"])
                    this.teintes!.push(TeinteCB.fromJS(item));
            }
            this.front = _data["front"];
            this.codeColorWeb = _data["codeColorWeb"];
        }
    }

    static fromJS(data: any): Accessoire {
        data = typeof data === 'object' ? data : {};
        let result = new Accessoire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessoire_id"] = this.accessoire_id;
        data["designation"] = this.designation;
        if (Array.isArray(this.teintes)) {
            data["teintes"] = [];
            for (let item of this.teintes)
                data["teintes"].push(item.toJSON());
        }
        data["front"] = this.front;
        data["codeColorWeb"] = this.codeColorWeb;
        return data;
    }
}

export interface IAccessoire {
    accessoire_id?: string | undefined;
    designation?: string | undefined;
    teintes?: TeinteCB[] | undefined;
    front: boolean;
    codeColorWeb?: string | undefined;
}

export class TeinteCB implements ITeinteCB {
    accessoire_id?: string | undefined;
    teinte_id?: string | undefined;
    code_couleur?: string | undefined;
    libelle?: string | undefined;
    couleur?: string | undefined;
    dateOfUse?: string | undefined;
    aerosol?: string | undefined;
    effects?: string | undefined;
    grpCoul?: string | undefined;
    application?: string | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;

    constructor(data?: ITeinteCB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessoire_id = _data["accessoire_id"];
            this.teinte_id = _data["teinte_id"];
            this.code_couleur = _data["code_couleur"];
            this.libelle = _data["libelle"];
            this.couleur = _data["couleur"];
            this.dateOfUse = _data["dateOfUse"];
            this.aerosol = _data["aerosol"];
            this.effects = _data["effects"];
            this.grpCoul = _data["grpCoul"];
            this.application = _data["application"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
        }
    }

    static fromJS(data: any): TeinteCB {
        data = typeof data === 'object' ? data : {};
        let result = new TeinteCB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessoire_id"] = this.accessoire_id;
        data["teinte_id"] = this.teinte_id;
        data["code_couleur"] = this.code_couleur;
        data["libelle"] = this.libelle;
        data["couleur"] = this.couleur;
        data["dateOfUse"] = this.dateOfUse;
        data["aerosol"] = this.aerosol;
        data["effects"] = this.effects;
        data["grpCoul"] = this.grpCoul;
        data["application"] = this.application;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        return data;
    }
}

export interface ITeinteCB {
    accessoire_id?: string | undefined;
    teinte_id?: string | undefined;
    code_couleur?: string | undefined;
    libelle?: string | undefined;
    couleur?: string | undefined;
    dateOfUse?: string | undefined;
    aerosol?: string | undefined;
    effects?: string | undefined;
    grpCoul?: string | undefined;
    application?: string | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
}

export class IConstructeurV1 implements IIConstructeurV1 {
    constructeur_id!: number;
    libelle?: string | undefined;
    logo?: string | undefined;
    doc?: string | undefined;
    terme?: string | undefined;
    site_id!: number;
    lang_id!: number;
    statut!: number;

    constructor(data?: IIConstructeurV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constructeur_id = _data["constructeur_id"];
            this.libelle = _data["libelle"];
            this.logo = _data["logo"];
            this.doc = _data["doc"];
            this.terme = _data["terme"];
            this.site_id = _data["site_id"];
            this.lang_id = _data["lang_id"];
            this.statut = _data["statut"];
        }
    }

    static fromJS(data: any): IConstructeurV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IConstructeurV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constructeur_id"] = this.constructeur_id;
        data["libelle"] = this.libelle;
        data["logo"] = this.logo;
        data["doc"] = this.doc;
        data["terme"] = this.terme;
        data["site_id"] = this.site_id;
        data["lang_id"] = this.lang_id;
        data["statut"] = this.statut;
        return data;
    }
}

export interface IIConstructeurV1 {
    constructeur_id: number;
    libelle?: string | undefined;
    logo?: string | undefined;
    doc?: string | undefined;
    terme?: string | undefined;
    site_id: number;
    lang_id: number;
    statut: number;
}

export class IModeleV1 implements IIModeleV1 {
    modele_id!: number;
    libelle?: string | undefined;
    constructeur_id!: number;
    statut!: number;
    gamme?: string | undefined;
    serie?: string | undefined;
    dateDeb?: string | undefined;
    dateFin?: string | undefined;

    constructor(data?: IIModeleV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modele_id = _data["modele_id"];
            this.libelle = _data["libelle"];
            this.constructeur_id = _data["constructeur_id"];
            this.statut = _data["statut"];
            this.gamme = _data["gamme"];
            this.serie = _data["serie"];
            this.dateDeb = _data["dateDeb"];
            this.dateFin = _data["dateFin"];
        }
    }

    static fromJS(data: any): IModeleV1 {
        data = typeof data === 'object' ? data : {};
        let result = new IModeleV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modele_id"] = this.modele_id;
        data["libelle"] = this.libelle;
        data["constructeur_id"] = this.constructeur_id;
        data["statut"] = this.statut;
        data["gamme"] = this.gamme;
        data["serie"] = this.serie;
        data["dateDeb"] = this.dateDeb;
        data["dateFin"] = this.dateFin;
        return data;
    }
}

export interface IIModeleV1 {
    modele_id: number;
    libelle?: string | undefined;
    constructeur_id: number;
    statut: number;
    gamme?: string | undefined;
    serie?: string | undefined;
    dateDeb?: string | undefined;
    dateFin?: string | undefined;
}

export class TeinteCarrosserie implements ITeinteCarrosserie {
    modeleID!: number;
    designation?: string | undefined;
    code?: string | undefined;
    effetMetal!: boolean;
    couleur?: string | undefined;

    constructor(data?: ITeinteCarrosserie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modeleID = _data["modeleID"];
            this.designation = _data["designation"];
            this.code = _data["code"];
            this.effetMetal = _data["effetMetal"];
            this.couleur = _data["couleur"];
        }
    }

    static fromJS(data: any): TeinteCarrosserie {
        data = typeof data === 'object' ? data : {};
        let result = new TeinteCarrosserie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modeleID"] = this.modeleID;
        data["designation"] = this.designation;
        data["code"] = this.code;
        data["effetMetal"] = this.effetMetal;
        data["couleur"] = this.couleur;
        return data;
    }
}

export interface ITeinteCarrosserie {
    modeleID: number;
    designation?: string | undefined;
    code?: string | undefined;
    effetMetal: boolean;
    couleur?: string | undefined;
}

export class ColorGroup implements IColorGroup {
    libelle?: string | undefined;
    num!: number;
    rvb?: string | undefined;

    constructor(data?: IColorGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.libelle = _data["libelle"];
            this.num = _data["num"];
            this.rvb = _data["rvb"];
        }
    }

    static fromJS(data: any): ColorGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ColorGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["libelle"] = this.libelle;
        data["num"] = this.num;
        data["rvb"] = this.rvb;
        return data;
    }
}

export interface IColorGroup {
    libelle?: string | undefined;
    num: number;
    rvb?: string | undefined;
}

export class Application implements IApplication {
    libelle?: string | undefined;
    codeInfo!: number;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.libelle = _data["libelle"];
            this.codeInfo = _data["codeInfo"];
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["libelle"] = this.libelle;
        data["codeInfo"] = this.codeInfo;
        return data;
    }
}

export interface IApplication {
    libelle?: string | undefined;
    codeInfo: number;
}

export class Reference implements IReference {
    manufacturer?: string | undefined;
    code?: string | undefined;
    designation?: string | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    formuleNum?: string | undefined;
    shadeGuideNum?: string | undefined;
    technology?: string | undefined;
    shade?: string | undefined;
    lignes?: Ligne[] | undefined;
    vehicles?: Vehicle[] | undefined;
    description?: string | undefined;
    variante?: string | undefined;
    vident!: number;
    logoName?: string | undefined;
    logo?: string | undefined;
    biTon!: boolean;
    tident!: number;
    rvb?: string | undefined;
    ssCouche?: string | undefined;
    master?: string | undefined;
    shadeGuideNumAlt?: string | undefined;
    popularite?: string | undefined;
    region?: string | undefined;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.code = _data["code"];
            this.designation = _data["designation"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.formuleNum = _data["formuleNum"];
            this.shadeGuideNum = _data["shadeGuideNum"];
            this.technology = _data["technology"];
            this.shade = _data["shade"];
            if (Array.isArray(_data["lignes"])) {
                this.lignes = [] as any;
                for (let item of _data["lignes"])
                    this.lignes!.push(Ligne.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            this.description = _data["description"];
            this.variante = _data["variante"];
            this.vident = _data["vident"];
            this.logoName = _data["logoName"];
            this.logo = _data["logo"];
            this.biTon = _data["biTon"];
            this.tident = _data["tident"];
            this.rvb = _data["rvb"];
            this.ssCouche = _data["ssCouche"];
            this.master = _data["master"];
            this.shadeGuideNumAlt = _data["shadeGuideNumAlt"];
            this.popularite = _data["popularite"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["code"] = this.code;
        data["designation"] = this.designation;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["formuleNum"] = this.formuleNum;
        data["shadeGuideNum"] = this.shadeGuideNum;
        data["technology"] = this.technology;
        data["shade"] = this.shade;
        if (Array.isArray(this.lignes)) {
            data["lignes"] = [];
            for (let item of this.lignes)
                data["lignes"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["description"] = this.description;
        data["variante"] = this.variante;
        data["vident"] = this.vident;
        data["logoName"] = this.logoName;
        data["logo"] = this.logo;
        data["biTon"] = this.biTon;
        data["tident"] = this.tident;
        data["rvb"] = this.rvb;
        data["ssCouche"] = this.ssCouche;
        data["master"] = this.master;
        data["shadeGuideNumAlt"] = this.shadeGuideNumAlt;
        data["popularite"] = this.popularite;
        data["region"] = this.region;
        return data;
    }
}

export interface IReference {
    manufacturer?: string | undefined;
    code?: string | undefined;
    designation?: string | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    formuleNum?: string | undefined;
    shadeGuideNum?: string | undefined;
    technology?: string | undefined;
    shade?: string | undefined;
    lignes?: Ligne[] | undefined;
    vehicles?: Vehicle[] | undefined;
    description?: string | undefined;
    variante?: string | undefined;
    vident: number;
    logoName?: string | undefined;
    logo?: string | undefined;
    biTon: boolean;
    tident: number;
    rvb?: string | undefined;
    ssCouche?: string | undefined;
    master?: string | undefined;
    shadeGuideNumAlt?: string | undefined;
    popularite?: string | undefined;
    region?: string | undefined;
}

export class Ligne implements ILigne {
    famille?: string | undefined;
    id_Form!: number;
    iIdent!: number;
    formule?: Ingredient[] | undefined;
    lstInfos?: Info[] | undefined;
    hideProduct!: boolean;
    effect?: string | undefined;
    numFormule?: string | undefined;
    iversionDate?: string | undefined;
    iversionDateFull?: string | undefined;
    iversion?: string | undefined;
    ilayer?: string | undefined;
    fnum?: string | undefined;

    constructor(data?: ILigne) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.famille = _data["famille"];
            this.id_Form = _data["id_Form"];
            this.iIdent = _data["iIdent"];
            if (Array.isArray(_data["formule"])) {
                this.formule = [] as any;
                for (let item of _data["formule"])
                    this.formule!.push(Ingredient.fromJS(item));
            }
            if (Array.isArray(_data["lstInfos"])) {
                this.lstInfos = [] as any;
                for (let item of _data["lstInfos"])
                    this.lstInfos!.push(Info.fromJS(item));
            }
            this.hideProduct = _data["hideProduct"];
            this.effect = _data["effect"];
            this.numFormule = _data["numFormule"];
            this.iversionDate = _data["iversionDate"];
            this.iversionDateFull = _data["iversionDateFull"];
            this.iversion = _data["iversion"];
            this.ilayer = _data["ilayer"];
            this.fnum = _data["fnum"];
        }
    }

    static fromJS(data: any): Ligne {
        data = typeof data === 'object' ? data : {};
        let result = new Ligne();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["famille"] = this.famille;
        data["id_Form"] = this.id_Form;
        data["iIdent"] = this.iIdent;
        if (Array.isArray(this.formule)) {
            data["formule"] = [];
            for (let item of this.formule)
                data["formule"].push(item.toJSON());
        }
        if (Array.isArray(this.lstInfos)) {
            data["lstInfos"] = [];
            for (let item of this.lstInfos)
                data["lstInfos"].push(item.toJSON());
        }
        data["hideProduct"] = this.hideProduct;
        data["effect"] = this.effect;
        data["numFormule"] = this.numFormule;
        data["iversionDate"] = this.iversionDate;
        data["iversionDateFull"] = this.iversionDateFull;
        data["iversion"] = this.iversion;
        data["ilayer"] = this.ilayer;
        data["fnum"] = this.fnum;
        return data;
    }
}

export interface ILigne {
    famille?: string | undefined;
    id_Form: number;
    iIdent: number;
    formule?: Ingredient[] | undefined;
    lstInfos?: Info[] | undefined;
    hideProduct: boolean;
    effect?: string | undefined;
    numFormule?: string | undefined;
    iversionDate?: string | undefined;
    iversionDateFull?: string | undefined;
    iversion?: string | undefined;
    ilayer?: string | undefined;
    fnum?: string | undefined;
}

export class Ingredient implements IIngredient {
    bnum?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    weight!: number;
    volume!: number;
    densite!: number;
    prixlitre!: number;
    cumul!: number;
    typesol!: number;
    bintervientdansproduit!: number;

    constructor(data?: IIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bnum = _data["bnum"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.densite = _data["densite"];
            this.prixlitre = _data["prixlitre"];
            this.cumul = _data["cumul"];
            this.typesol = _data["typesol"];
            this.bintervientdansproduit = _data["bintervientdansproduit"];
        }
    }

    static fromJS(data: any): Ingredient {
        data = typeof data === 'object' ? data : {};
        let result = new Ingredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bnum"] = this.bnum;
        data["code"] = this.code;
        data["name"] = this.name;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["densite"] = this.densite;
        data["prixlitre"] = this.prixlitre;
        data["cumul"] = this.cumul;
        data["typesol"] = this.typesol;
        data["bintervientdansproduit"] = this.bintervientdansproduit;
        return data;
    }
}

export interface IIngredient {
    bnum?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    weight: number;
    volume: number;
    densite: number;
    prixlitre: number;
    cumul: number;
    typesol: number;
    bintervientdansproduit: number;
}

export class Info implements IInfo {
    libelle?: string | undefined;
    type?: string | undefined;

    constructor(data?: IInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.libelle = _data["libelle"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Info {
        data = typeof data === 'object' ? data : {};
        let result = new Info();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["libelle"] = this.libelle;
        data["type"] = this.type;
        return data;
    }
}

export interface IInfo {
    libelle?: string | undefined;
    type?: string | undefined;
}

export class Vehicle implements IVehicle {
    manufacturer?: string | undefined;
    model?: string | undefined;
    year!: number;

    constructor(data?: IVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): Vehicle {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["year"] = this.year;
        return data;
    }
}

export interface IVehicle {
    manufacturer?: string | undefined;
    model?: string | undefined;
    year: number;
}

export class ReferenceDetails implements IReferenceDetails {
    vident!: number;
    language?: string | undefined;
    currentReference?: Reference | undefined;
    model?: string | undefined;
    year?: string | undefined;
    application?: string | undefined;
    colorGroup?: string | undefined;
    variant?: string | undefined;
    ligneDLLPAE?: Ligne | undefined;

    constructor(data?: IReferenceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vident = _data["vident"];
            this.language = _data["language"];
            this.currentReference = _data["currentReference"] ? Reference.fromJS(_data["currentReference"]) : <any>undefined;
            this.model = _data["model"];
            this.year = _data["year"];
            this.application = _data["application"];
            this.colorGroup = _data["colorGroup"];
            this.variant = _data["variant"];
            this.ligneDLLPAE = _data["ligneDLLPAE"] ? Ligne.fromJS(_data["ligneDLLPAE"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReferenceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vident"] = this.vident;
        data["language"] = this.language;
        data["currentReference"] = this.currentReference ? this.currentReference.toJSON() : <any>undefined;
        data["model"] = this.model;
        data["year"] = this.year;
        data["application"] = this.application;
        data["colorGroup"] = this.colorGroup;
        data["variant"] = this.variant;
        data["ligneDLLPAE"] = this.ligneDLLPAE ? this.ligneDLLPAE.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReferenceDetails {
    vident: number;
    language?: string | undefined;
    currentReference?: Reference | undefined;
    model?: string | undefined;
    year?: string | undefined;
    application?: string | undefined;
    colorGroup?: string | undefined;
    variant?: string | undefined;
    ligneDLLPAE?: Ligne | undefined;
}

export class Retour_DLL_PAE implements IRetour_DLL_PAE {
    sTStuct_Formule?: STStuct_Formule | undefined;
    marq_code_int!: number;
    list_st_retour_choix_vernis?: string[] | undefined;
    st_retour_choix_vernis?: string | undefined;
    psDilution?: string | undefined;
    etapeDLL?: string | undefined;
    besoinEtapeDLL?: string | undefined;
    bases?: BASES | undefined;
    id_ingr_v2_info1?: string | undefined;
    pae_base_spe_type_base!: boolean;
    isMultiCouche!: boolean;

    constructor(data?: IRetour_DLL_PAE) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sTStuct_Formule = _data["sTStuct_Formule"] ? STStuct_Formule.fromJS(_data["sTStuct_Formule"]) : <any>undefined;
            this.marq_code_int = _data["marq_code_int"];
            if (Array.isArray(_data["list_st_retour_choix_vernis"])) {
                this.list_st_retour_choix_vernis = [] as any;
                for (let item of _data["list_st_retour_choix_vernis"])
                    this.list_st_retour_choix_vernis!.push(item);
            }
            this.st_retour_choix_vernis = _data["st_retour_choix_vernis"];
            this.psDilution = _data["psDilution"];
            this.etapeDLL = _data["etapeDLL"];
            this.besoinEtapeDLL = _data["besoinEtapeDLL"];
            this.bases = _data["bases"] ? BASES.fromJS(_data["bases"]) : <any>undefined;
            this.id_ingr_v2_info1 = _data["id_ingr_v2_info1"];
            this.pae_base_spe_type_base = _data["pae_base_spe_type_base"];
            this.isMultiCouche = _data["isMultiCouche"];
        }
    }

    static fromJS(data: any): Retour_DLL_PAE {
        data = typeof data === 'object' ? data : {};
        let result = new Retour_DLL_PAE();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sTStuct_Formule"] = this.sTStuct_Formule ? this.sTStuct_Formule.toJSON() : <any>undefined;
        data["marq_code_int"] = this.marq_code_int;
        if (Array.isArray(this.list_st_retour_choix_vernis)) {
            data["list_st_retour_choix_vernis"] = [];
            for (let item of this.list_st_retour_choix_vernis)
                data["list_st_retour_choix_vernis"].push(item);
        }
        data["st_retour_choix_vernis"] = this.st_retour_choix_vernis;
        data["psDilution"] = this.psDilution;
        data["etapeDLL"] = this.etapeDLL;
        data["besoinEtapeDLL"] = this.besoinEtapeDLL;
        data["bases"] = this.bases ? this.bases.toJSON() : <any>undefined;
        data["id_ingr_v2_info1"] = this.id_ingr_v2_info1;
        data["pae_base_spe_type_base"] = this.pae_base_spe_type_base;
        data["isMultiCouche"] = this.isMultiCouche;
        return data;
    }
}

export interface IRetour_DLL_PAE {
    sTStuct_Formule?: STStuct_Formule | undefined;
    marq_code_int: number;
    list_st_retour_choix_vernis?: string[] | undefined;
    st_retour_choix_vernis?: string | undefined;
    psDilution?: string | undefined;
    etapeDLL?: string | undefined;
    besoinEtapeDLL?: string | undefined;
    bases?: BASES | undefined;
    id_ingr_v2_info1?: string | undefined;
    pae_base_spe_type_base: boolean;
    isMultiCouche: boolean;
}

export class STStuct_Formule implements ISTStuct_Formule {
    id!: number;
    nNumFormule!: number;
    nTypeFormule!: number;
    nTypeEffet!: number;
    nNumConstructeur!: number;
    sNomConstructeur?: string | undefined;
    nNumLigne!: number;
    sNomLigne?: string | undefined;
    sSysteme?: string | undefined;
    sCode?: string | undefined;
    sNom?: string | undefined;
    sNuancier2?: string | undefined;
    rCoef!: number;
    rCoefPAE!: number;
    sCommentaire?: string | undefined;
    bRegroupePAE_Avec_Formule!: boolean;
    bRegroupePAE_Avec_Formule_EtatInitial!: boolean;
    bQteDem_Egale_PAE!: boolean;
    nNbIngredientsFormule!: number;
    nNbIngredientsFormule_EtatInitial!: number;
    bAvecPAE!: boolean;
    bTeinteSpectro!: boolean;
    bTeinteREL!: boolean;
    bTeinteCorrigee!: boolean;
    bMultiFlash!: boolean;
    stTListeIngredient?: STStuct_IngredientFormule[] | undefined;
    stTListeIngredientOrigine?: STStuct_IngredientFormule[] | undefined;
    sDateCreation?: string | undefined;
    sDateModification?: string | undefined;
    nStepEncour!: number;
    nMaxStep!: number;
    nIDForm_VehiculeSuivant!: number;
    nFinition!: number;
    sQualite?: string | undefined;
    bteinte_IC!: boolean;
    bteinte_GPI!: boolean;
    sRealisation?: string | undefined;
    bEnAttente!: boolean;
    stCommentaireAvantPesee?: string | undefined;
    bMelange!: boolean;
    sDilution?: string | undefined;
    nCouleur!: number;
    bAvecACTIVATOR!: boolean;
    bTeinteSuivante!: boolean;

    constructor(data?: ISTStuct_Formule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nNumFormule = _data["nNumFormule"];
            this.nTypeFormule = _data["nTypeFormule"];
            this.nTypeEffet = _data["nTypeEffet"];
            this.nNumConstructeur = _data["nNumConstructeur"];
            this.sNomConstructeur = _data["sNomConstructeur"];
            this.nNumLigne = _data["nNumLigne"];
            this.sNomLigne = _data["sNomLigne"];
            this.sSysteme = _data["sSysteme"];
            this.sCode = _data["sCode"];
            this.sNom = _data["sNom"];
            this.sNuancier2 = _data["sNuancier2"];
            this.rCoef = _data["rCoef"];
            this.rCoefPAE = _data["rCoefPAE"];
            this.sCommentaire = _data["sCommentaire"];
            this.bRegroupePAE_Avec_Formule = _data["bRegroupePAE_Avec_Formule"];
            this.bRegroupePAE_Avec_Formule_EtatInitial = _data["bRegroupePAE_Avec_Formule_EtatInitial"];
            this.bQteDem_Egale_PAE = _data["bQteDem_Egale_PAE"];
            this.nNbIngredientsFormule = _data["nNbIngredientsFormule"];
            this.nNbIngredientsFormule_EtatInitial = _data["nNbIngredientsFormule_EtatInitial"];
            this.bAvecPAE = _data["bAvecPAE"];
            this.bTeinteSpectro = _data["bTeinteSpectro"];
            this.bTeinteREL = _data["bTeinteREL"];
            this.bTeinteCorrigee = _data["bTeinteCorrigee"];
            this.bMultiFlash = _data["bMultiFlash"];
            if (Array.isArray(_data["stTListeIngredient"])) {
                this.stTListeIngredient = [] as any;
                for (let item of _data["stTListeIngredient"])
                    this.stTListeIngredient!.push(STStuct_IngredientFormule.fromJS(item));
            }
            if (Array.isArray(_data["stTListeIngredientOrigine"])) {
                this.stTListeIngredientOrigine = [] as any;
                for (let item of _data["stTListeIngredientOrigine"])
                    this.stTListeIngredientOrigine!.push(STStuct_IngredientFormule.fromJS(item));
            }
            this.sDateCreation = _data["sDateCreation"];
            this.sDateModification = _data["sDateModification"];
            this.nStepEncour = _data["nStepEncour"];
            this.nMaxStep = _data["nMaxStep"];
            this.nIDForm_VehiculeSuivant = _data["nIDForm_VehiculeSuivant"];
            this.nFinition = _data["nFinition"];
            this.sQualite = _data["sQualite"];
            this.bteinte_IC = _data["bteinte_IC"];
            this.bteinte_GPI = _data["bteinte_GPI"];
            this.sRealisation = _data["sRealisation"];
            this.bEnAttente = _data["bEnAttente"];
            this.stCommentaireAvantPesee = _data["stCommentaireAvantPesee"];
            this.bMelange = _data["bMelange"];
            this.sDilution = _data["sDilution"];
            this.nCouleur = _data["nCouleur"];
            this.bAvecACTIVATOR = _data["bAvecACTIVATOR"];
            this.bTeinteSuivante = _data["bTeinteSuivante"];
        }
    }

    static fromJS(data: any): STStuct_Formule {
        data = typeof data === 'object' ? data : {};
        let result = new STStuct_Formule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nNumFormule"] = this.nNumFormule;
        data["nTypeFormule"] = this.nTypeFormule;
        data["nTypeEffet"] = this.nTypeEffet;
        data["nNumConstructeur"] = this.nNumConstructeur;
        data["sNomConstructeur"] = this.sNomConstructeur;
        data["nNumLigne"] = this.nNumLigne;
        data["sNomLigne"] = this.sNomLigne;
        data["sSysteme"] = this.sSysteme;
        data["sCode"] = this.sCode;
        data["sNom"] = this.sNom;
        data["sNuancier2"] = this.sNuancier2;
        data["rCoef"] = this.rCoef;
        data["rCoefPAE"] = this.rCoefPAE;
        data["sCommentaire"] = this.sCommentaire;
        data["bRegroupePAE_Avec_Formule"] = this.bRegroupePAE_Avec_Formule;
        data["bRegroupePAE_Avec_Formule_EtatInitial"] = this.bRegroupePAE_Avec_Formule_EtatInitial;
        data["bQteDem_Egale_PAE"] = this.bQteDem_Egale_PAE;
        data["nNbIngredientsFormule"] = this.nNbIngredientsFormule;
        data["nNbIngredientsFormule_EtatInitial"] = this.nNbIngredientsFormule_EtatInitial;
        data["bAvecPAE"] = this.bAvecPAE;
        data["bTeinteSpectro"] = this.bTeinteSpectro;
        data["bTeinteREL"] = this.bTeinteREL;
        data["bTeinteCorrigee"] = this.bTeinteCorrigee;
        data["bMultiFlash"] = this.bMultiFlash;
        if (Array.isArray(this.stTListeIngredient)) {
            data["stTListeIngredient"] = [];
            for (let item of this.stTListeIngredient)
                data["stTListeIngredient"].push(item.toJSON());
        }
        if (Array.isArray(this.stTListeIngredientOrigine)) {
            data["stTListeIngredientOrigine"] = [];
            for (let item of this.stTListeIngredientOrigine)
                data["stTListeIngredientOrigine"].push(item.toJSON());
        }
        data["sDateCreation"] = this.sDateCreation;
        data["sDateModification"] = this.sDateModification;
        data["nStepEncour"] = this.nStepEncour;
        data["nMaxStep"] = this.nMaxStep;
        data["nIDForm_VehiculeSuivant"] = this.nIDForm_VehiculeSuivant;
        data["nFinition"] = this.nFinition;
        data["sQualite"] = this.sQualite;
        data["bteinte_IC"] = this.bteinte_IC;
        data["bteinte_GPI"] = this.bteinte_GPI;
        data["sRealisation"] = this.sRealisation;
        data["bEnAttente"] = this.bEnAttente;
        data["stCommentaireAvantPesee"] = this.stCommentaireAvantPesee;
        data["bMelange"] = this.bMelange;
        data["sDilution"] = this.sDilution;
        data["nCouleur"] = this.nCouleur;
        data["bAvecACTIVATOR"] = this.bAvecACTIVATOR;
        data["bTeinteSuivante"] = this.bTeinteSuivante;
        return data;
    }
}

export interface ISTStuct_Formule {
    id: number;
    nNumFormule: number;
    nTypeFormule: number;
    nTypeEffet: number;
    nNumConstructeur: number;
    sNomConstructeur?: string | undefined;
    nNumLigne: number;
    sNomLigne?: string | undefined;
    sSysteme?: string | undefined;
    sCode?: string | undefined;
    sNom?: string | undefined;
    sNuancier2?: string | undefined;
    rCoef: number;
    rCoefPAE: number;
    sCommentaire?: string | undefined;
    bRegroupePAE_Avec_Formule: boolean;
    bRegroupePAE_Avec_Formule_EtatInitial: boolean;
    bQteDem_Egale_PAE: boolean;
    nNbIngredientsFormule: number;
    nNbIngredientsFormule_EtatInitial: number;
    bAvecPAE: boolean;
    bTeinteSpectro: boolean;
    bTeinteREL: boolean;
    bTeinteCorrigee: boolean;
    bMultiFlash: boolean;
    stTListeIngredient?: STStuct_IngredientFormule[] | undefined;
    stTListeIngredientOrigine?: STStuct_IngredientFormule[] | undefined;
    sDateCreation?: string | undefined;
    sDateModification?: string | undefined;
    nStepEncour: number;
    nMaxStep: number;
    nIDForm_VehiculeSuivant: number;
    nFinition: number;
    sQualite?: string | undefined;
    bteinte_IC: boolean;
    bteinte_GPI: boolean;
    sRealisation?: string | undefined;
    bEnAttente: boolean;
    stCommentaireAvantPesee?: string | undefined;
    bMelange: boolean;
    sDilution?: string | undefined;
    nCouleur: number;
    bAvecACTIVATOR: boolean;
    bTeinteSuivante: boolean;
}

export class STStuct_IngredientFormule implements ISTStuct_IngredientFormule {
    id!: number;
    nType!: number;
    nNumBase!: number;
    rDensite!: number;
    sNomBase?: string | undefined;
    sLibelleBase?: string | undefined;
    nTypeBase!: number;
    nIdMessage!: number;
    sMessage?: string | undefined;
    nDelais!: number;
    rQte!: number;
    rQteFormule!: number;
    nOrdreAffichage!: number;
    bTypeDiluant!: boolean;
    nOrdreFormule!: number;
    tabPeseeProduitPot?: StPeseeProduitPot[] | undefined;
    bPresentDansDW!: boolean;
    bPAE!: boolean;
    prix!: number;

    constructor(data?: ISTStuct_IngredientFormule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nType = _data["nType"];
            this.nNumBase = _data["nNumBase"];
            this.rDensite = _data["rDensite"];
            this.sNomBase = _data["sNomBase"];
            this.sLibelleBase = _data["sLibelleBase"];
            this.nTypeBase = _data["nTypeBase"];
            this.nIdMessage = _data["nIdMessage"];
            this.sMessage = _data["sMessage"];
            this.nDelais = _data["nDelais"];
            this.rQte = _data["rQte"];
            this.rQteFormule = _data["rQteFormule"];
            this.nOrdreAffichage = _data["nOrdreAffichage"];
            this.bTypeDiluant = _data["bTypeDiluant"];
            this.nOrdreFormule = _data["nOrdreFormule"];
            if (Array.isArray(_data["tabPeseeProduitPot"])) {
                this.tabPeseeProduitPot = [] as any;
                for (let item of _data["tabPeseeProduitPot"])
                    this.tabPeseeProduitPot!.push(StPeseeProduitPot.fromJS(item));
            }
            this.bPresentDansDW = _data["bPresentDansDW"];
            this.bPAE = _data["bPAE"];
            this.prix = _data["prix"];
        }
    }

    static fromJS(data: any): STStuct_IngredientFormule {
        data = typeof data === 'object' ? data : {};
        let result = new STStuct_IngredientFormule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nType"] = this.nType;
        data["nNumBase"] = this.nNumBase;
        data["rDensite"] = this.rDensite;
        data["sNomBase"] = this.sNomBase;
        data["sLibelleBase"] = this.sLibelleBase;
        data["nTypeBase"] = this.nTypeBase;
        data["nIdMessage"] = this.nIdMessage;
        data["sMessage"] = this.sMessage;
        data["nDelais"] = this.nDelais;
        data["rQte"] = this.rQte;
        data["rQteFormule"] = this.rQteFormule;
        data["nOrdreAffichage"] = this.nOrdreAffichage;
        data["bTypeDiluant"] = this.bTypeDiluant;
        data["nOrdreFormule"] = this.nOrdreFormule;
        if (Array.isArray(this.tabPeseeProduitPot)) {
            data["tabPeseeProduitPot"] = [];
            for (let item of this.tabPeseeProduitPot)
                data["tabPeseeProduitPot"].push(item.toJSON());
        }
        data["bPresentDansDW"] = this.bPresentDansDW;
        data["bPAE"] = this.bPAE;
        data["prix"] = this.prix;
        return data;
    }
}

export interface ISTStuct_IngredientFormule {
    id: number;
    nType: number;
    nNumBase: number;
    rDensite: number;
    sNomBase?: string | undefined;
    sLibelleBase?: string | undefined;
    nTypeBase: number;
    nIdMessage: number;
    sMessage?: string | undefined;
    nDelais: number;
    rQte: number;
    rQteFormule: number;
    nOrdreAffichage: number;
    bTypeDiluant: boolean;
    nOrdreFormule: number;
    tabPeseeProduitPot?: StPeseeProduitPot[] | undefined;
    bPresentDansDW: boolean;
    bPAE: boolean;
    prix: number;
}

export class StPeseeProduitPot implements IStPeseeProduitPot {
    id!: number;
    nIdpot!: number;
    rQte!: number;
    rQteReste!: number;

    constructor(data?: IStPeseeProduitPot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nIdpot = _data["nIdpot"];
            this.rQte = _data["rQte"];
            this.rQteReste = _data["rQteReste"];
        }
    }

    static fromJS(data: any): StPeseeProduitPot {
        data = typeof data === 'object' ? data : {};
        let result = new StPeseeProduitPot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nIdpot"] = this.nIdpot;
        data["rQte"] = this.rQte;
        data["rQteReste"] = this.rQteReste;
        return data;
    }
}

export interface IStPeseeProduitPot {
    id: number;
    nIdpot: number;
    rQte: number;
    rQteReste: number;
}

export class BASES implements IBASES {
    bnum!: number;
    tpident!: number;
    bcode?: string | undefined;
    bnom?: string | undefined;
    bdensite!: number;
    bvoc!: number;
    bcouleur!: number;
    libProduit?: string | undefined;

    constructor(data?: IBASES) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bnum = _data["bnum"];
            this.tpident = _data["tpident"];
            this.bcode = _data["bcode"];
            this.bnom = _data["bnom"];
            this.bdensite = _data["bdensite"];
            this.bvoc = _data["bvoc"];
            this.bcouleur = _data["bcouleur"];
            this.libProduit = _data["libProduit"];
        }
    }

    static fromJS(data: any): BASES {
        data = typeof data === 'object' ? data : {};
        let result = new BASES();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bnum"] = this.bnum;
        data["tpident"] = this.tpident;
        data["bcode"] = this.bcode;
        data["bnom"] = this.bnom;
        data["bdensite"] = this.bdensite;
        data["bvoc"] = this.bvoc;
        data["bcouleur"] = this.bcouleur;
        data["libProduit"] = this.libProduit;
        return data;
    }
}

export interface IBASES {
    bnum: number;
    tpident: number;
    bcode?: string | undefined;
    bnom?: string | undefined;
    bdensite: number;
    bvoc: number;
    bcouleur: number;
    libProduit?: string | undefined;
}

export class FormulaLayer implements IFormulaLayer {
    components?: FormulaComponent[] | undefined;
    layerName?: string | undefined;
    layerNumber!: number;
    minimalAmount!: number;
    priceGroup?: string | undefined;
    productLineCode?: string | undefined;
    productNumber!: number;

    constructor(data?: IFormulaLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(FormulaComponent.fromJS(item));
            }
            this.layerName = _data["layerName"];
            this.layerNumber = _data["layerNumber"];
            this.minimalAmount = _data["minimalAmount"];
            this.priceGroup = _data["priceGroup"];
            this.productLineCode = _data["productLineCode"];
            this.productNumber = _data["productNumber"];
        }
    }

    static fromJS(data: any): FormulaLayer {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item.toJSON());
        }
        data["layerName"] = this.layerName;
        data["layerNumber"] = this.layerNumber;
        data["minimalAmount"] = this.minimalAmount;
        data["priceGroup"] = this.priceGroup;
        data["productLineCode"] = this.productLineCode;
        data["productNumber"] = this.productNumber;
        return data;
    }
}

export interface IFormulaLayer {
    components?: FormulaComponent[] | undefined;
    layerName?: string | undefined;
    layerNumber: number;
    minimalAmount: number;
    priceGroup?: string | undefined;
    productLineCode?: string | undefined;
    productNumber: number;
}

export class FormulaComponent implements IFormulaComponent {
    absoluteValue!: number;
    code?: string | undefined;
    cumulativeValue!: number;
    density!: number;
    description?: string | undefined;
    hasChemicalProducts!: boolean;
    hasChrome!: boolean;
    hasLead!: boolean;
    isBasePaint!: boolean;
    isFactoryPack!: boolean;
    number!: number;
    sequenceNumber!: number;
    solventExemptVolume!: number;
    tonerDescription?: string | undefined;
    ufi?: string | undefined;
    vocDry!: number;
    vocDryME!: number;
    vocTotal!: number;
    vocTotalME!: number;
    waterVolume!: number;
    weightPercentage!: number;
    weightPercSolids!: number;
    weightPercSolvents!: number;
    weightPercWater!: number;
    prixAuLitre!: number;
    volume!: number;

    constructor(data?: IFormulaComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.absoluteValue = _data["absoluteValue"];
            this.code = _data["code"];
            this.cumulativeValue = _data["cumulativeValue"];
            this.density = _data["density"];
            this.description = _data["description"];
            this.hasChemicalProducts = _data["hasChemicalProducts"];
            this.hasChrome = _data["hasChrome"];
            this.hasLead = _data["hasLead"];
            this.isBasePaint = _data["isBasePaint"];
            this.isFactoryPack = _data["isFactoryPack"];
            this.number = _data["number"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.solventExemptVolume = _data["solventExemptVolume"];
            this.tonerDescription = _data["tonerDescription"];
            this.ufi = _data["ufi"];
            this.vocDry = _data["vocDry"];
            this.vocDryME = _data["vocDryME"];
            this.vocTotal = _data["vocTotal"];
            this.vocTotalME = _data["vocTotalME"];
            this.waterVolume = _data["waterVolume"];
            this.weightPercentage = _data["weightPercentage"];
            this.weightPercSolids = _data["weightPercSolids"];
            this.weightPercSolvents = _data["weightPercSolvents"];
            this.weightPercWater = _data["weightPercWater"];
            this.prixAuLitre = _data["prixAuLitre"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): FormulaComponent {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["absoluteValue"] = this.absoluteValue;
        data["code"] = this.code;
        data["cumulativeValue"] = this.cumulativeValue;
        data["density"] = this.density;
        data["description"] = this.description;
        data["hasChemicalProducts"] = this.hasChemicalProducts;
        data["hasChrome"] = this.hasChrome;
        data["hasLead"] = this.hasLead;
        data["isBasePaint"] = this.isBasePaint;
        data["isFactoryPack"] = this.isFactoryPack;
        data["number"] = this.number;
        data["sequenceNumber"] = this.sequenceNumber;
        data["solventExemptVolume"] = this.solventExemptVolume;
        data["tonerDescription"] = this.tonerDescription;
        data["ufi"] = this.ufi;
        data["vocDry"] = this.vocDry;
        data["vocDryME"] = this.vocDryME;
        data["vocTotal"] = this.vocTotal;
        data["vocTotalME"] = this.vocTotalME;
        data["waterVolume"] = this.waterVolume;
        data["weightPercentage"] = this.weightPercentage;
        data["weightPercSolids"] = this.weightPercSolids;
        data["weightPercSolvents"] = this.weightPercSolvents;
        data["weightPercWater"] = this.weightPercWater;
        data["prixAuLitre"] = this.prixAuLitre;
        data["volume"] = this.volume;
        return data;
    }
}

export interface IFormulaComponent {
    absoluteValue: number;
    code?: string | undefined;
    cumulativeValue: number;
    density: number;
    description?: string | undefined;
    hasChemicalProducts: boolean;
    hasChrome: boolean;
    hasLead: boolean;
    isBasePaint: boolean;
    isFactoryPack: boolean;
    number: number;
    sequenceNumber: number;
    solventExemptVolume: number;
    tonerDescription?: string | undefined;
    ufi?: string | undefined;
    vocDry: number;
    vocDryME: number;
    vocTotal: number;
    vocTotalME: number;
    waterVolume: number;
    weightPercentage: number;
    weightPercSolids: number;
    weightPercSolvents: number;
    weightPercWater: number;
    prixAuLitre: number;
    volume: number;
}

export class IxellColorWebPAE implements IIxellColorWebPAE {
    cledilution?: string | undefined;
    nomdilution1?: string | undefined;
    nomdilution2?: string | undefined;
    nomdilution3?: string | undefined;
    nomdilution4?: string | undefined;
    nomdilution5?: string | undefined;
    nomdilution6?: string | undefined;
    nomdilution7?: string | undefined;
    nomdilution8?: string | undefined;
    nomdilution9?: string | undefined;
    nomdilution10?: string | undefined;
    nomdilution11?: string | undefined;
    numft?: string | undefined;
    numtitreft?: string | undefined;
    idsolution!: number;
    niv!: number;
    numaff!: number;
    numdetailft?: string | undefined;
    nivsuivant!: number;
    codemethode!: number;
    cleappli!: number;
    ratiodefaut!: number;
    ratio1!: number;
    ratio2!: number;
    ratioChoix!: number;
    bintervientdansproduit!: number;
    numingradd!: number;
    rang!: number;
    typesol!: number;
    delaimess!: number;
    bvolume!: number;
    pasinterval!: number;
    numtitre!: number;
    titre1?: string | undefined;
    titre2?: string | undefined;
    titre3?: string | undefined;
    titre4?: string | undefined;
    titre5?: string | undefined;
    titre6?: string | undefined;
    titre7?: string | undefined;
    titre8?: string | undefined;
    titre9?: string | undefined;
    titre10?: string | undefined;
    titre11?: string | undefined;
    nummessage!: number;
    messagesol1?: string | undefined;
    messagesol2?: string | undefined;
    messagesol3?: string | undefined;
    messagesol4?: string | undefined;
    messagesol5?: string | undefined;
    messagesol6?: string | undefined;
    messagesol7?: string | undefined;
    messagesol8?: string | undefined;
    messagesol9?: string | undefined;
    messagesol10?: string | undefined;
    messagesol11?: string | undefined;
    bnum!: number;
    tpident!: number;
    bcode?: string | undefined;
    bnom?: string | undefined;
    bdensite!: number;
    bvoc!: number;
    bcouleur!: number;
    volume!: number;
    gramme!: number;
    prixLitre!: number;

    constructor(data?: IIxellColorWebPAE) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cledilution = _data["cledilution"];
            this.nomdilution1 = _data["nomdilution1"];
            this.nomdilution2 = _data["nomdilution2"];
            this.nomdilution3 = _data["nomdilution3"];
            this.nomdilution4 = _data["nomdilution4"];
            this.nomdilution5 = _data["nomdilution5"];
            this.nomdilution6 = _data["nomdilution6"];
            this.nomdilution7 = _data["nomdilution7"];
            this.nomdilution8 = _data["nomdilution8"];
            this.nomdilution9 = _data["nomdilution9"];
            this.nomdilution10 = _data["nomdilution10"];
            this.nomdilution11 = _data["nomdilution11"];
            this.numft = _data["numft"];
            this.numtitreft = _data["numtitreft"];
            this.idsolution = _data["idsolution"];
            this.niv = _data["niv"];
            this.numaff = _data["numaff"];
            this.numdetailft = _data["numdetailft"];
            this.nivsuivant = _data["nivsuivant"];
            this.codemethode = _data["codemethode"];
            this.cleappli = _data["cleappli"];
            this.ratiodefaut = _data["ratiodefaut"];
            this.ratio1 = _data["ratio1"];
            this.ratio2 = _data["ratio2"];
            this.ratioChoix = _data["ratioChoix"];
            this.bintervientdansproduit = _data["bintervientdansproduit"];
            this.numingradd = _data["numingradd"];
            this.rang = _data["rang"];
            this.typesol = _data["typesol"];
            this.delaimess = _data["delaimess"];
            this.bvolume = _data["bvolume"];
            this.pasinterval = _data["pasinterval"];
            this.numtitre = _data["numtitre"];
            this.titre1 = _data["titre1"];
            this.titre2 = _data["titre2"];
            this.titre3 = _data["titre3"];
            this.titre4 = _data["titre4"];
            this.titre5 = _data["titre5"];
            this.titre6 = _data["titre6"];
            this.titre7 = _data["titre7"];
            this.titre8 = _data["titre8"];
            this.titre9 = _data["titre9"];
            this.titre10 = _data["titre10"];
            this.titre11 = _data["titre11"];
            this.nummessage = _data["nummessage"];
            this.messagesol1 = _data["messagesol1"];
            this.messagesol2 = _data["messagesol2"];
            this.messagesol3 = _data["messagesol3"];
            this.messagesol4 = _data["messagesol4"];
            this.messagesol5 = _data["messagesol5"];
            this.messagesol6 = _data["messagesol6"];
            this.messagesol7 = _data["messagesol7"];
            this.messagesol8 = _data["messagesol8"];
            this.messagesol9 = _data["messagesol9"];
            this.messagesol10 = _data["messagesol10"];
            this.messagesol11 = _data["messagesol11"];
            this.bnum = _data["bnum"];
            this.tpident = _data["tpident"];
            this.bcode = _data["bcode"];
            this.bnom = _data["bnom"];
            this.bdensite = _data["bdensite"];
            this.bvoc = _data["bvoc"];
            this.bcouleur = _data["bcouleur"];
            this.volume = _data["volume"];
            this.gramme = _data["gramme"];
            this.prixLitre = _data["prixLitre"];
        }
    }

    static fromJS(data: any): IxellColorWebPAE {
        data = typeof data === 'object' ? data : {};
        let result = new IxellColorWebPAE();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cledilution"] = this.cledilution;
        data["nomdilution1"] = this.nomdilution1;
        data["nomdilution2"] = this.nomdilution2;
        data["nomdilution3"] = this.nomdilution3;
        data["nomdilution4"] = this.nomdilution4;
        data["nomdilution5"] = this.nomdilution5;
        data["nomdilution6"] = this.nomdilution6;
        data["nomdilution7"] = this.nomdilution7;
        data["nomdilution8"] = this.nomdilution8;
        data["nomdilution9"] = this.nomdilution9;
        data["nomdilution10"] = this.nomdilution10;
        data["nomdilution11"] = this.nomdilution11;
        data["numft"] = this.numft;
        data["numtitreft"] = this.numtitreft;
        data["idsolution"] = this.idsolution;
        data["niv"] = this.niv;
        data["numaff"] = this.numaff;
        data["numdetailft"] = this.numdetailft;
        data["nivsuivant"] = this.nivsuivant;
        data["codemethode"] = this.codemethode;
        data["cleappli"] = this.cleappli;
        data["ratiodefaut"] = this.ratiodefaut;
        data["ratio1"] = this.ratio1;
        data["ratio2"] = this.ratio2;
        data["ratioChoix"] = this.ratioChoix;
        data["bintervientdansproduit"] = this.bintervientdansproduit;
        data["numingradd"] = this.numingradd;
        data["rang"] = this.rang;
        data["typesol"] = this.typesol;
        data["delaimess"] = this.delaimess;
        data["bvolume"] = this.bvolume;
        data["pasinterval"] = this.pasinterval;
        data["numtitre"] = this.numtitre;
        data["titre1"] = this.titre1;
        data["titre2"] = this.titre2;
        data["titre3"] = this.titre3;
        data["titre4"] = this.titre4;
        data["titre5"] = this.titre5;
        data["titre6"] = this.titre6;
        data["titre7"] = this.titre7;
        data["titre8"] = this.titre8;
        data["titre9"] = this.titre9;
        data["titre10"] = this.titre10;
        data["titre11"] = this.titre11;
        data["nummessage"] = this.nummessage;
        data["messagesol1"] = this.messagesol1;
        data["messagesol2"] = this.messagesol2;
        data["messagesol3"] = this.messagesol3;
        data["messagesol4"] = this.messagesol4;
        data["messagesol5"] = this.messagesol5;
        data["messagesol6"] = this.messagesol6;
        data["messagesol7"] = this.messagesol7;
        data["messagesol8"] = this.messagesol8;
        data["messagesol9"] = this.messagesol9;
        data["messagesol10"] = this.messagesol10;
        data["messagesol11"] = this.messagesol11;
        data["bnum"] = this.bnum;
        data["tpident"] = this.tpident;
        data["bcode"] = this.bcode;
        data["bnom"] = this.bnom;
        data["bdensite"] = this.bdensite;
        data["bvoc"] = this.bvoc;
        data["bcouleur"] = this.bcouleur;
        data["volume"] = this.volume;
        data["gramme"] = this.gramme;
        data["prixLitre"] = this.prixLitre;
        return data;
    }
}

export interface IIxellColorWebPAE {
    cledilution?: string | undefined;
    nomdilution1?: string | undefined;
    nomdilution2?: string | undefined;
    nomdilution3?: string | undefined;
    nomdilution4?: string | undefined;
    nomdilution5?: string | undefined;
    nomdilution6?: string | undefined;
    nomdilution7?: string | undefined;
    nomdilution8?: string | undefined;
    nomdilution9?: string | undefined;
    nomdilution10?: string | undefined;
    nomdilution11?: string | undefined;
    numft?: string | undefined;
    numtitreft?: string | undefined;
    idsolution: number;
    niv: number;
    numaff: number;
    numdetailft?: string | undefined;
    nivsuivant: number;
    codemethode: number;
    cleappli: number;
    ratiodefaut: number;
    ratio1: number;
    ratio2: number;
    ratioChoix: number;
    bintervientdansproduit: number;
    numingradd: number;
    rang: number;
    typesol: number;
    delaimess: number;
    bvolume: number;
    pasinterval: number;
    numtitre: number;
    titre1?: string | undefined;
    titre2?: string | undefined;
    titre3?: string | undefined;
    titre4?: string | undefined;
    titre5?: string | undefined;
    titre6?: string | undefined;
    titre7?: string | undefined;
    titre8?: string | undefined;
    titre9?: string | undefined;
    titre10?: string | undefined;
    titre11?: string | undefined;
    nummessage: number;
    messagesol1?: string | undefined;
    messagesol2?: string | undefined;
    messagesol3?: string | undefined;
    messagesol4?: string | undefined;
    messagesol5?: string | undefined;
    messagesol6?: string | undefined;
    messagesol7?: string | undefined;
    messagesol8?: string | undefined;
    messagesol9?: string | undefined;
    messagesol10?: string | undefined;
    messagesol11?: string | undefined;
    bnum: number;
    tpident: number;
    bcode?: string | undefined;
    bnom?: string | undefined;
    bdensite: number;
    bvoc: number;
    bcouleur: number;
    volume: number;
    gramme: number;
    prixLitre: number;
}

export class Tarif implements ITarif {
    tar_id!: number;
    marq_id!: number;
    tar_lib?: string | undefined;
    tar_dstart!: Date;
    tar_key?: string | undefined;
    sListCategorie?: string | undefined;
    listCategorie?: string[] | undefined;

    constructor(data?: ITarif) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tar_id = _data["tar_id"];
            this.marq_id = _data["marq_id"];
            this.tar_lib = _data["tar_lib"];
            this.tar_dstart = _data["tar_dstart"] ? new Date(_data["tar_dstart"].toString()) : <any>undefined;
            this.tar_key = _data["tar_key"];
            this.sListCategorie = _data["sListCategorie"];
            if (Array.isArray(_data["listCategorie"])) {
                this.listCategorie = [] as any;
                for (let item of _data["listCategorie"])
                    this.listCategorie!.push(item);
            }
        }
    }

    static fromJS(data: any): Tarif {
        data = typeof data === 'object' ? data : {};
        let result = new Tarif();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tar_id"] = this.tar_id;
        data["marq_id"] = this.marq_id;
        data["tar_lib"] = this.tar_lib;
        data["tar_dstart"] = this.tar_dstart ? this.tar_dstart.toISOString() : <any>undefined;
        data["tar_key"] = this.tar_key;
        data["sListCategorie"] = this.sListCategorie;
        if (Array.isArray(this.listCategorie)) {
            data["listCategorie"] = [];
            for (let item of this.listCategorie)
                data["listCategorie"].push(item);
        }
        return data;
    }
}

export interface ITarif {
    tar_id: number;
    marq_id: number;
    tar_lib?: string | undefined;
    tar_dstart: Date;
    tar_key?: string | undefined;
    sListCategorie?: string | undefined;
    listCategorie?: string[] | undefined;
}

export class SearchResponseFormula implements ISearchResponseFormula {
    colorInfo?: ColorInformation | undefined;
    formula?: Formula | undefined;
    hasError!: boolean;
    countryIsoCode?: string | undefined;
    languageCode?: string | undefined;
    ownerType?: string | undefined;

    constructor(data?: ISearchResponseFormula) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorInfo = _data["colorInfo"] ? ColorInformation.fromJS(_data["colorInfo"]) : <any>undefined;
            this.formula = _data["formula"] ? Formula.fromJS(_data["formula"]) : <any>undefined;
            this.hasError = _data["hasError"];
            this.countryIsoCode = _data["countryIsoCode"];
            this.languageCode = _data["languageCode"];
            this.ownerType = _data["ownerType"];
        }
    }

    static fromJS(data: any): SearchResponseFormula {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponseFormula();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorInfo"] = this.colorInfo ? this.colorInfo.toJSON() : <any>undefined;
        data["formula"] = this.formula ? this.formula.toJSON() : <any>undefined;
        data["hasError"] = this.hasError;
        data["countryIsoCode"] = this.countryIsoCode;
        data["languageCode"] = this.languageCode;
        data["ownerType"] = this.ownerType;
        return data;
    }
}

export interface ISearchResponseFormula {
    colorInfo?: ColorInformation | undefined;
    formula?: Formula | undefined;
    hasError: boolean;
    countryIsoCode?: string | undefined;
    languageCode?: string | undefined;
    ownerType?: string | undefined;
}

export class ColorInformation implements IColorInformation {
    akzoCode?: string | undefined;
    availableInProducts?: number[] | undefined;
    codeSystemsCommaSeparatedString?: string | undefined;
    firstUsed!: number;
    isOptimized!: boolean;
    lastUsed!: number;
    marketColorId?: string | undefined;
    name?: string | undefined;
    originalType?: string | undefined;
    ownerName?: string | undefined;
    variantNumber!: number;
    variantSuffix?: string | undefined;

    constructor(data?: IColorInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.akzoCode = _data["akzoCode"];
            if (Array.isArray(_data["availableInProducts"])) {
                this.availableInProducts = [] as any;
                for (let item of _data["availableInProducts"])
                    this.availableInProducts!.push(item);
            }
            this.codeSystemsCommaSeparatedString = _data["codeSystemsCommaSeparatedString"];
            this.firstUsed = _data["firstUsed"];
            this.isOptimized = _data["isOptimized"];
            this.lastUsed = _data["lastUsed"];
            this.marketColorId = _data["marketColorId"];
            this.name = _data["name"];
            this.originalType = _data["originalType"];
            this.ownerName = _data["ownerName"];
            this.variantNumber = _data["variantNumber"];
            this.variantSuffix = _data["variantSuffix"];
        }
    }

    static fromJS(data: any): ColorInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ColorInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["akzoCode"] = this.akzoCode;
        if (Array.isArray(this.availableInProducts)) {
            data["availableInProducts"] = [];
            for (let item of this.availableInProducts)
                data["availableInProducts"].push(item);
        }
        data["codeSystemsCommaSeparatedString"] = this.codeSystemsCommaSeparatedString;
        data["firstUsed"] = this.firstUsed;
        data["isOptimized"] = this.isOptimized;
        data["lastUsed"] = this.lastUsed;
        data["marketColorId"] = this.marketColorId;
        data["name"] = this.name;
        data["originalType"] = this.originalType;
        data["ownerName"] = this.ownerName;
        data["variantNumber"] = this.variantNumber;
        data["variantSuffix"] = this.variantSuffix;
        return data;
    }
}

export interface IColorInformation {
    akzoCode?: string | undefined;
    availableInProducts?: number[] | undefined;
    codeSystemsCommaSeparatedString?: string | undefined;
    firstUsed: number;
    isOptimized: boolean;
    lastUsed: number;
    marketColorId?: string | undefined;
    name?: string | undefined;
    originalType?: string | undefined;
    ownerName?: string | undefined;
    variantNumber: number;
    variantSuffix?: string | undefined;
}

export class Formula implements IFormula {
    brandCode?: string | undefined;
    colorOnDisplayUri?: string | undefined;
    colorOnDisplayUriLacour?: string | undefined;
    colorOnDisplayUriDownload?: string | undefined;
    formulaName?: string | undefined;
    formulaVersions?: FormulaVersion[] | undefined;
    isPrimerMandatory!: boolean;
    sprayOutMeasurement?: string | undefined;
    targetMeasurement?: string | undefined;

    constructor(data?: IFormula) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandCode = _data["brandCode"];
            this.colorOnDisplayUri = _data["colorOnDisplayUri"];
            this.colorOnDisplayUriLacour = _data["colorOnDisplayUriLacour"];
            this.colorOnDisplayUriDownload = _data["colorOnDisplayUriDownload"];
            this.formulaName = _data["formulaName"];
            if (Array.isArray(_data["formulaVersions"])) {
                this.formulaVersions = [] as any;
                for (let item of _data["formulaVersions"])
                    this.formulaVersions!.push(FormulaVersion.fromJS(item));
            }
            this.isPrimerMandatory = _data["isPrimerMandatory"];
            this.sprayOutMeasurement = _data["sprayOutMeasurement"];
            this.targetMeasurement = _data["targetMeasurement"];
        }
    }

    static fromJS(data: any): Formula {
        data = typeof data === 'object' ? data : {};
        let result = new Formula();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandCode"] = this.brandCode;
        data["colorOnDisplayUri"] = this.colorOnDisplayUri;
        data["colorOnDisplayUriLacour"] = this.colorOnDisplayUriLacour;
        data["colorOnDisplayUriDownload"] = this.colorOnDisplayUriDownload;
        data["formulaName"] = this.formulaName;
        if (Array.isArray(this.formulaVersions)) {
            data["formulaVersions"] = [];
            for (let item of this.formulaVersions)
                data["formulaVersions"].push(item.toJSON());
        }
        data["isPrimerMandatory"] = this.isPrimerMandatory;
        data["sprayOutMeasurement"] = this.sprayOutMeasurement;
        data["targetMeasurement"] = this.targetMeasurement;
        return data;
    }
}

export interface IFormula {
    brandCode?: string | undefined;
    colorOnDisplayUri?: string | undefined;
    colorOnDisplayUriLacour?: string | undefined;
    colorOnDisplayUriDownload?: string | undefined;
    formulaName?: string | undefined;
    formulaVersions?: FormulaVersion[] | undefined;
    isPrimerMandatory: boolean;
    sprayOutMeasurement?: string | undefined;
    targetMeasurement?: string | undefined;
}

export class FormulaVersion implements IFormulaVersion {
    hasColorPrimer!: boolean;
    instructions?: string[] | undefined;
    colorOnDisplayUri?: string[] | undefined;
    colorOnDisplayUriLacour?: string[] | undefined;
    colorOnDisplayUriDownload?: string[] | undefined;
    isEasydose!: boolean;
    isRadarCompliant!: boolean;
    isTotalRespray!: boolean;
    layer1?: FormulaLayer | undefined;
    layer2?: FormulaLayer | undefined;
    primer?: FormulaLayer | undefined;
    specification?: string | undefined;
    versionDate?: string | undefined;
    versionIdentifier?: string | undefined;

    constructor(data?: IFormulaVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasColorPrimer = _data["hasColorPrimer"];
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(item);
            }
            if (Array.isArray(_data["colorOnDisplayUri"])) {
                this.colorOnDisplayUri = [] as any;
                for (let item of _data["colorOnDisplayUri"])
                    this.colorOnDisplayUri!.push(item);
            }
            if (Array.isArray(_data["colorOnDisplayUriLacour"])) {
                this.colorOnDisplayUriLacour = [] as any;
                for (let item of _data["colorOnDisplayUriLacour"])
                    this.colorOnDisplayUriLacour!.push(item);
            }
            if (Array.isArray(_data["colorOnDisplayUriDownload"])) {
                this.colorOnDisplayUriDownload = [] as any;
                for (let item of _data["colorOnDisplayUriDownload"])
                    this.colorOnDisplayUriDownload!.push(item);
            }
            this.isEasydose = _data["isEasydose"];
            this.isRadarCompliant = _data["isRadarCompliant"];
            this.isTotalRespray = _data["isTotalRespray"];
            this.layer1 = _data["layer1"] ? FormulaLayer.fromJS(_data["layer1"]) : <any>undefined;
            this.layer2 = _data["layer2"] ? FormulaLayer.fromJS(_data["layer2"]) : <any>undefined;
            this.primer = _data["primer"] ? FormulaLayer.fromJS(_data["primer"]) : <any>undefined;
            this.specification = _data["specification"];
            this.versionDate = _data["versionDate"];
            this.versionIdentifier = _data["versionIdentifier"];
        }
    }

    static fromJS(data: any): FormulaVersion {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasColorPrimer"] = this.hasColorPrimer;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item);
        }
        if (Array.isArray(this.colorOnDisplayUri)) {
            data["colorOnDisplayUri"] = [];
            for (let item of this.colorOnDisplayUri)
                data["colorOnDisplayUri"].push(item);
        }
        if (Array.isArray(this.colorOnDisplayUriLacour)) {
            data["colorOnDisplayUriLacour"] = [];
            for (let item of this.colorOnDisplayUriLacour)
                data["colorOnDisplayUriLacour"].push(item);
        }
        if (Array.isArray(this.colorOnDisplayUriDownload)) {
            data["colorOnDisplayUriDownload"] = [];
            for (let item of this.colorOnDisplayUriDownload)
                data["colorOnDisplayUriDownload"].push(item);
        }
        data["isEasydose"] = this.isEasydose;
        data["isRadarCompliant"] = this.isRadarCompliant;
        data["isTotalRespray"] = this.isTotalRespray;
        data["layer1"] = this.layer1 ? this.layer1.toJSON() : <any>undefined;
        data["layer2"] = this.layer2 ? this.layer2.toJSON() : <any>undefined;
        data["primer"] = this.primer ? this.primer.toJSON() : <any>undefined;
        data["specification"] = this.specification;
        data["versionDate"] = this.versionDate;
        data["versionIdentifier"] = this.versionIdentifier;
        return data;
    }
}

export interface IFormulaVersion {
    hasColorPrimer: boolean;
    instructions?: string[] | undefined;
    colorOnDisplayUri?: string[] | undefined;
    colorOnDisplayUriLacour?: string[] | undefined;
    colorOnDisplayUriDownload?: string[] | undefined;
    isEasydose: boolean;
    isRadarCompliant: boolean;
    isTotalRespray: boolean;
    layer1?: FormulaLayer | undefined;
    layer2?: FormulaLayer | undefined;
    primer?: FormulaLayer | undefined;
    specification?: string | undefined;
    versionDate?: string | undefined;
    versionIdentifier?: string | undefined;
}

export class IResponseQrCodeFormule implements IIResponseQrCodeFormule {
    idFormule!: number;
    qrCode?: string | undefined;

    constructor(data?: IIResponseQrCodeFormule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idFormule = _data["idFormule"];
            this.qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): IResponseQrCodeFormule {
        data = typeof data === 'object' ? data : {};
        let result = new IResponseQrCodeFormule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFormule"] = this.idFormule;
        data["qrCode"] = this.qrCode;
        return data;
    }
}

export interface IIResponseQrCodeFormule {
    idFormule: number;
    qrCode?: string | undefined;
}

export class Facets implements IFacets {
    aerospaceCompanies?: string | undefined;
    brands?: string[] | undefined;
    brandTypes?: string[] | undefined;
    codeSystems?: string | undefined;
    colorGroups?: string[] | undefined;
    colorsUsedInYear?: string[] | undefined;
    filter?: string | undefined;
    fleetGroups?: string | undefined;
    mixitOwnerName?: string | undefined;
    models?: string[] | undefined;
    parts?: string[] | undefined;
    ownerType?: string[] | undefined;
    productLines?: string | undefined;

    constructor(data?: IFacets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aerospaceCompanies = _data["aerospaceCompanies"];
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            if (Array.isArray(_data["brandTypes"])) {
                this.brandTypes = [] as any;
                for (let item of _data["brandTypes"])
                    this.brandTypes!.push(item);
            }
            this.codeSystems = _data["codeSystems"];
            if (Array.isArray(_data["colorGroups"])) {
                this.colorGroups = [] as any;
                for (let item of _data["colorGroups"])
                    this.colorGroups!.push(item);
            }
            if (Array.isArray(_data["colorsUsedInYear"])) {
                this.colorsUsedInYear = [] as any;
                for (let item of _data["colorsUsedInYear"])
                    this.colorsUsedInYear!.push(item);
            }
            this.filter = _data["filter"];
            this.fleetGroups = _data["fleetGroups"];
            this.mixitOwnerName = _data["mixitOwnerName"];
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(item);
            }
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(item);
            }
            if (Array.isArray(_data["ownerType"])) {
                this.ownerType = [] as any;
                for (let item of _data["ownerType"])
                    this.ownerType!.push(item);
            }
            this.productLines = _data["productLines"];
        }
    }

    static fromJS(data: any): Facets {
        data = typeof data === 'object' ? data : {};
        let result = new Facets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aerospaceCompanies"] = this.aerospaceCompanies;
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        if (Array.isArray(this.brandTypes)) {
            data["brandTypes"] = [];
            for (let item of this.brandTypes)
                data["brandTypes"].push(item);
        }
        data["codeSystems"] = this.codeSystems;
        if (Array.isArray(this.colorGroups)) {
            data["colorGroups"] = [];
            for (let item of this.colorGroups)
                data["colorGroups"].push(item);
        }
        if (Array.isArray(this.colorsUsedInYear)) {
            data["colorsUsedInYear"] = [];
            for (let item of this.colorsUsedInYear)
                data["colorsUsedInYear"].push(item);
        }
        data["filter"] = this.filter;
        data["fleetGroups"] = this.fleetGroups;
        data["mixitOwnerName"] = this.mixitOwnerName;
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item);
        }
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item);
        }
        if (Array.isArray(this.ownerType)) {
            data["ownerType"] = [];
            for (let item of this.ownerType)
                data["ownerType"].push(item);
        }
        data["productLines"] = this.productLines;
        return data;
    }
}

export interface IFacets {
    aerospaceCompanies?: string | undefined;
    brands?: string[] | undefined;
    brandTypes?: string[] | undefined;
    codeSystems?: string | undefined;
    colorGroups?: string[] | undefined;
    colorsUsedInYear?: string[] | undefined;
    filter?: string | undefined;
    fleetGroups?: string | undefined;
    mixitOwnerName?: string | undefined;
    models?: string[] | undefined;
    parts?: string[] | undefined;
    ownerType?: string[] | undefined;
    productLines?: string | undefined;
}

export class SearchResponseMarket implements ISearchResponseMarket {
    count!: number;
    facets?: Facets | undefined;
    results?: Results[] | undefined;

    constructor(data?: ISearchResponseMarket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.facets = _data["facets"] ? Facets.fromJS(_data["facets"]) : <any>undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Results.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponseMarket {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponseMarket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["facets"] = this.facets ? this.facets.toJSON() : <any>undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponseMarket {
    count: number;
    facets?: Facets | undefined;
    results?: Results[] | undefined;
}

export class Results implements IResults {
    akzoCode?: string | undefined;
    ixellCode?: string | undefined;
    codes?: string[] | undefined;
    codesCar?: string[] | undefined;
    colorCodes?: ColorCodes[] | undefined;
    codeSystem?: string[] | undefined;
    colorDescription?: string | undefined;
    colorName?: string | undefined;
    colorOnDisplayUri?: string | undefined;
    colorOnDisplayUriLacour?: string | undefined;
    colorOnDisplayUriDownload?: string | undefined;
    colorUsedInYearsDescription?: string | undefined;
    combinationOf?: string[] | undefined;
    documentation?: string[] | undefined;
    hasParts!: boolean;
    hasVariants!: boolean;
    isFavorite!: boolean;
    makeDescription?: string | undefined;
    marketColorId?: string | undefined;
    numberOfTimesMixed!: number;
    originalTypeOfColor?: string | undefined;
    ownerName?: string | undefined;
    ownerType?: string | undefined;
    partNames?: string[] | undefined;
    partColorRelations?: PartColorRelation[] | undefined;
    variantAkzoCodes?: string[] | undefined;

    constructor(data?: IResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.akzoCode = _data["akzoCode"];
            this.ixellCode = _data["ixellCode"];
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(item);
            }
            if (Array.isArray(_data["codesCar"])) {
                this.codesCar = [] as any;
                for (let item of _data["codesCar"])
                    this.codesCar!.push(item);
            }
            if (Array.isArray(_data["colorCodes"])) {
                this.colorCodes = [] as any;
                for (let item of _data["colorCodes"])
                    this.colorCodes!.push(ColorCodes.fromJS(item));
            }
            if (Array.isArray(_data["codeSystem"])) {
                this.codeSystem = [] as any;
                for (let item of _data["codeSystem"])
                    this.codeSystem!.push(item);
            }
            this.colorDescription = _data["colorDescription"];
            this.colorName = _data["colorName"];
            this.colorOnDisplayUri = _data["colorOnDisplayUri"];
            this.colorOnDisplayUriLacour = _data["colorOnDisplayUriLacour"];
            this.colorOnDisplayUriDownload = _data["colorOnDisplayUriDownload"];
            this.colorUsedInYearsDescription = _data["colorUsedInYearsDescription"];
            if (Array.isArray(_data["combinationOf"])) {
                this.combinationOf = [] as any;
                for (let item of _data["combinationOf"])
                    this.combinationOf!.push(item);
            }
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(item);
            }
            this.hasParts = _data["hasParts"];
            this.hasVariants = _data["hasVariants"];
            this.isFavorite = _data["isFavorite"];
            this.makeDescription = _data["makeDescription"];
            this.marketColorId = _data["marketColorId"];
            this.numberOfTimesMixed = _data["numberOfTimesMixed"];
            this.originalTypeOfColor = _data["originalTypeOfColor"];
            this.ownerName = _data["ownerName"];
            this.ownerType = _data["ownerType"];
            if (Array.isArray(_data["partNames"])) {
                this.partNames = [] as any;
                for (let item of _data["partNames"])
                    this.partNames!.push(item);
            }
            if (Array.isArray(_data["partColorRelations"])) {
                this.partColorRelations = [] as any;
                for (let item of _data["partColorRelations"])
                    this.partColorRelations!.push(PartColorRelation.fromJS(item));
            }
            if (Array.isArray(_data["variantAkzoCodes"])) {
                this.variantAkzoCodes = [] as any;
                for (let item of _data["variantAkzoCodes"])
                    this.variantAkzoCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): Results {
        data = typeof data === 'object' ? data : {};
        let result = new Results();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["akzoCode"] = this.akzoCode;
        data["ixellCode"] = this.ixellCode;
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item);
        }
        if (Array.isArray(this.codesCar)) {
            data["codesCar"] = [];
            for (let item of this.codesCar)
                data["codesCar"].push(item);
        }
        if (Array.isArray(this.colorCodes)) {
            data["colorCodes"] = [];
            for (let item of this.colorCodes)
                data["colorCodes"].push(item.toJSON());
        }
        if (Array.isArray(this.codeSystem)) {
            data["codeSystem"] = [];
            for (let item of this.codeSystem)
                data["codeSystem"].push(item);
        }
        data["colorDescription"] = this.colorDescription;
        data["colorName"] = this.colorName;
        data["colorOnDisplayUri"] = this.colorOnDisplayUri;
        data["colorOnDisplayUriLacour"] = this.colorOnDisplayUriLacour;
        data["colorOnDisplayUriDownload"] = this.colorOnDisplayUriDownload;
        data["colorUsedInYearsDescription"] = this.colorUsedInYearsDescription;
        if (Array.isArray(this.combinationOf)) {
            data["combinationOf"] = [];
            for (let item of this.combinationOf)
                data["combinationOf"].push(item);
        }
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item);
        }
        data["hasParts"] = this.hasParts;
        data["hasVariants"] = this.hasVariants;
        data["isFavorite"] = this.isFavorite;
        data["makeDescription"] = this.makeDescription;
        data["marketColorId"] = this.marketColorId;
        data["numberOfTimesMixed"] = this.numberOfTimesMixed;
        data["originalTypeOfColor"] = this.originalTypeOfColor;
        data["ownerName"] = this.ownerName;
        data["ownerType"] = this.ownerType;
        if (Array.isArray(this.partNames)) {
            data["partNames"] = [];
            for (let item of this.partNames)
                data["partNames"].push(item);
        }
        if (Array.isArray(this.partColorRelations)) {
            data["partColorRelations"] = [];
            for (let item of this.partColorRelations)
                data["partColorRelations"].push(item.toJSON());
        }
        if (Array.isArray(this.variantAkzoCodes)) {
            data["variantAkzoCodes"] = [];
            for (let item of this.variantAkzoCodes)
                data["variantAkzoCodes"].push(item);
        }
        return data;
    }
}

export interface IResults {
    akzoCode?: string | undefined;
    ixellCode?: string | undefined;
    codes?: string[] | undefined;
    codesCar?: string[] | undefined;
    colorCodes?: ColorCodes[] | undefined;
    codeSystem?: string[] | undefined;
    colorDescription?: string | undefined;
    colorName?: string | undefined;
    colorOnDisplayUri?: string | undefined;
    colorOnDisplayUriLacour?: string | undefined;
    colorOnDisplayUriDownload?: string | undefined;
    colorUsedInYearsDescription?: string | undefined;
    combinationOf?: string[] | undefined;
    documentation?: string[] | undefined;
    hasParts: boolean;
    hasVariants: boolean;
    isFavorite: boolean;
    makeDescription?: string | undefined;
    marketColorId?: string | undefined;
    numberOfTimesMixed: number;
    originalTypeOfColor?: string | undefined;
    ownerName?: string | undefined;
    ownerType?: string | undefined;
    partNames?: string[] | undefined;
    partColorRelations?: PartColorRelation[] | undefined;
    variantAkzoCodes?: string[] | undefined;
}

export class ColorCodes implements IColorCodes {
    code?: string | undefined;
    codeSystem?: string | undefined;

    constructor(data?: IColorCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.codeSystem = _data["codeSystem"];
        }
    }

    static fromJS(data: any): ColorCodes {
        data = typeof data === 'object' ? data : {};
        let result = new ColorCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeSystem"] = this.codeSystem;
        return data;
    }
}

export interface IColorCodes {
    code?: string | undefined;
    codeSystem?: string | undefined;
}

export class PartColorRelation implements IPartColorRelation {
    colorCode?: string | undefined;
    partNames?: string[] | undefined;

    constructor(data?: IPartColorRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorCode = _data["colorCode"];
            if (Array.isArray(_data["partNames"])) {
                this.partNames = [] as any;
                for (let item of _data["partNames"])
                    this.partNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PartColorRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PartColorRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorCode"] = this.colorCode;
        if (Array.isArray(this.partNames)) {
            data["partNames"] = [];
            for (let item of this.partNames)
                data["partNames"].push(item);
        }
        return data;
    }
}

export interface IPartColorRelation {
    colorCode?: string | undefined;
    partNames?: string[] | undefined;
}

export class SearchResponseVariants implements ISearchResponseVariants {
    akzoCode?: string | undefined;
    marketColorId?: string | undefined;
    variants?: Variants[] | undefined;

    constructor(data?: ISearchResponseVariants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.akzoCode = _data["akzoCode"];
            this.marketColorId = _data["marketColorId"];
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants!.push(Variants.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponseVariants {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponseVariants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["akzoCode"] = this.akzoCode;
        data["marketColorId"] = this.marketColorId;
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponseVariants {
    akzoCode?: string | undefined;
    marketColorId?: string | undefined;
    variants?: Variants[] | undefined;
}

export class Variants implements IVariants {
    number?: string | undefined;
    variantSuffix?: string | undefined;
    colorOnDisplayUri?: string | undefined;
    colorOnDisplayUriLacour?: string | undefined;
    colorOnDisplayUriDownload?: string | undefined;
    documentations?: Documentations[] | undefined;
    imitations?: Imitations[] | undefined;
    mostLikelyVariantProbability!: number;
    haveRadar!: boolean;

    constructor(data?: IVariants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.variantSuffix = _data["variantSuffix"];
            this.colorOnDisplayUri = _data["colorOnDisplayUri"];
            this.colorOnDisplayUriLacour = _data["colorOnDisplayUriLacour"];
            this.colorOnDisplayUriDownload = _data["colorOnDisplayUriDownload"];
            if (Array.isArray(_data["documentations"])) {
                this.documentations = [] as any;
                for (let item of _data["documentations"])
                    this.documentations!.push(Documentations.fromJS(item));
            }
            if (Array.isArray(_data["imitations"])) {
                this.imitations = [] as any;
                for (let item of _data["imitations"])
                    this.imitations!.push(Imitations.fromJS(item));
            }
            this.mostLikelyVariantProbability = _data["mostLikelyVariantProbability"];
            this.haveRadar = _data["haveRadar"];
        }
    }

    static fromJS(data: any): Variants {
        data = typeof data === 'object' ? data : {};
        let result = new Variants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["variantSuffix"] = this.variantSuffix;
        data["colorOnDisplayUri"] = this.colorOnDisplayUri;
        data["colorOnDisplayUriLacour"] = this.colorOnDisplayUriLacour;
        data["colorOnDisplayUriDownload"] = this.colorOnDisplayUriDownload;
        if (Array.isArray(this.documentations)) {
            data["documentations"] = [];
            for (let item of this.documentations)
                data["documentations"].push(item.toJSON());
        }
        if (Array.isArray(this.imitations)) {
            data["imitations"] = [];
            for (let item of this.imitations)
                data["imitations"].push(item.toJSON());
        }
        data["mostLikelyVariantProbability"] = this.mostLikelyVariantProbability;
        data["haveRadar"] = this.haveRadar;
        return data;
    }
}

export interface IVariants {
    number?: string | undefined;
    variantSuffix?: string | undefined;
    colorOnDisplayUri?: string | undefined;
    colorOnDisplayUriLacour?: string | undefined;
    colorOnDisplayUriDownload?: string | undefined;
    documentations?: Documentations[] | undefined;
    imitations?: Imitations[] | undefined;
    mostLikelyVariantProbability: number;
    haveRadar: boolean;
}

export class Documentations implements IDocumentations {
    name?: string | undefined;
    locationInDocumentation?: string | undefined;

    constructor(data?: IDocumentations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationInDocumentation = _data["locationInDocumentation"];
        }
    }

    static fromJS(data: any): Documentations {
        data = typeof data === 'object' ? data : {};
        let result = new Documentations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationInDocumentation"] = this.locationInDocumentation;
        return data;
    }
}

export interface IDocumentations {
    name?: string | undefined;
    locationInDocumentation?: string | undefined;
}

export class Imitations implements IImitations {
    hasSellingOutToners!: boolean;
    productId?: string | undefined;
    radarCompliant?: string | undefined;

    constructor(data?: IImitations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSellingOutToners = _data["hasSellingOutToners"];
            this.productId = _data["productId"];
            this.radarCompliant = _data["radarCompliant"];
        }
    }

    static fromJS(data: any): Imitations {
        data = typeof data === 'object' ? data : {};
        let result = new Imitations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSellingOutToners"] = this.hasSellingOutToners;
        data["productId"] = this.productId;
        data["radarCompliant"] = this.radarCompliant;
        return data;
    }
}

export interface IImitations {
    hasSellingOutToners: boolean;
    productId?: string | undefined;
    radarCompliant?: string | undefined;
}

export class DRStats implements IDRStats {
    region?: string | undefined;
    nbAccountActivated!: number;
    nbAccountCreated!: number;

    constructor(data?: IDRStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"];
            this.nbAccountActivated = _data["nbAccountActivated"];
            this.nbAccountCreated = _data["nbAccountCreated"];
        }
    }

    static fromJS(data: any): DRStats {
        data = typeof data === 'object' ? data : {};
        let result = new DRStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["nbAccountActivated"] = this.nbAccountActivated;
        data["nbAccountCreated"] = this.nbAccountCreated;
        return data;
    }
}

export interface IDRStats {
    region?: string | undefined;
    nbAccountActivated: number;
    nbAccountCreated: number;
}

export class CountryStats implements ICountryStats {
    country?: string | undefined;
    nbAccountActivated!: number;
    nbAccountCreated!: number;

    constructor(data?: ICountryStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.nbAccountActivated = _data["nbAccountActivated"];
            this.nbAccountCreated = _data["nbAccountCreated"];
        }
    }

    static fromJS(data: any): CountryStats {
        data = typeof data === 'object' ? data : {};
        let result = new CountryStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["nbAccountActivated"] = this.nbAccountActivated;
        data["nbAccountCreated"] = this.nbAccountCreated;
        return data;
    }
}

export interface ICountryStats {
    country?: string | undefined;
    nbAccountActivated: number;
    nbAccountCreated: number;
}

export enum ETchatFlag {
    Closed = 0,
    Open = 1,
    Minimized = 2,
}

export class InfosImumu implements IInfosImumu {
    login?: string | undefined;
    pwd?: string | undefined;

    constructor(data?: IInfosImumu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.login = _data["login"];
            this.pwd = _data["pwd"];
        }
    }

    static fromJS(data: any): InfosImumu {
        data = typeof data === 'object' ? data : {};
        let result = new InfosImumu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["login"] = this.login;
        data["pwd"] = this.pwd;
        return data;
    }
}

export interface IInfosImumu {
    login?: string | undefined;
    pwd?: string | undefined;
}

export class EncoursDates implements IEncoursDates {
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IEncoursDates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EncoursDates {
        data = typeof data === 'object' ? data : {};
        let result = new EncoursDates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEncoursDates {
    startDate: Date;
    endDate: Date;
}

export class InfoRdvUnisite implements IInfoRdvUnisite {
    unisiteRdvID?: string | undefined;
    unisiteCongesID!: number;
    register!: boolean;
    message?: string | undefined;

    constructor(data?: IInfoRdvUnisite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unisiteRdvID = _data["unisiteRdvID"];
            this.unisiteCongesID = _data["unisiteCongesID"];
            this.register = _data["register"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InfoRdvUnisite {
        data = typeof data === 'object' ? data : {};
        let result = new InfoRdvUnisite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unisiteRdvID"] = this.unisiteRdvID;
        data["unisiteCongesID"] = this.unisiteCongesID;
        data["register"] = this.register;
        data["message"] = this.message;
        return data;
    }
}

export interface IInfoRdvUnisite {
    unisiteRdvID?: string | undefined;
    unisiteCongesID: number;
    register: boolean;
    message?: string | undefined;
}

export class ListeRdvUnisite implements IListeRdvUnisite {
    rdv?: RdvUnisitePlanning[] | undefined;

    constructor(data?: IListeRdvUnisite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rdv"])) {
                this.rdv = [] as any;
                for (let item of _data["rdv"])
                    this.rdv!.push(RdvUnisitePlanning.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListeRdvUnisite {
        data = typeof data === 'object' ? data : {};
        let result = new ListeRdvUnisite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rdv)) {
            data["rdv"] = [];
            for (let item of this.rdv)
                data["rdv"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListeRdvUnisite {
    rdv?: RdvUnisitePlanning[] | undefined;
}

export class RdvUnisitePlanning implements IRdvUnisitePlanning {
    rdvID!: number;
    dateDebutRDV?: Date | undefined;
    dateFinRDV?: Date | undefined;
    statut!: UnisiteTypeRDV;
    loginHotliner?: string | undefined;
    unisiteRdvID?: string | undefined;
    unisiteCongesID!: number;
    isConges!: boolean;

    constructor(data?: IRdvUnisitePlanning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rdvID = _data["rdvID"];
            this.dateDebutRDV = _data["dateDebutRDV"] ? new Date(_data["dateDebutRDV"].toString()) : <any>undefined;
            this.dateFinRDV = _data["dateFinRDV"] ? new Date(_data["dateFinRDV"].toString()) : <any>undefined;
            this.statut = _data["statut"];
            this.loginHotliner = _data["loginHotliner"];
            this.unisiteRdvID = _data["unisiteRdvID"];
            this.unisiteCongesID = _data["unisiteCongesID"];
            this.isConges = _data["isConges"];
        }
    }

    static fromJS(data: any): RdvUnisitePlanning {
        data = typeof data === 'object' ? data : {};
        let result = new RdvUnisitePlanning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rdvID"] = this.rdvID;
        data["dateDebutRDV"] = this.dateDebutRDV ? this.dateDebutRDV.toISOString() : <any>undefined;
        data["dateFinRDV"] = this.dateFinRDV ? this.dateFinRDV.toISOString() : <any>undefined;
        data["statut"] = this.statut;
        data["loginHotliner"] = this.loginHotliner;
        data["unisiteRdvID"] = this.unisiteRdvID;
        data["unisiteCongesID"] = this.unisiteCongesID;
        data["isConges"] = this.isConges;
        return data;
    }
}

export interface IRdvUnisitePlanning {
    rdvID: number;
    dateDebutRDV?: Date | undefined;
    dateFinRDV?: Date | undefined;
    statut: UnisiteTypeRDV;
    loginHotliner?: string | undefined;
    unisiteRdvID?: string | undefined;
    unisiteCongesID: number;
    isConges: boolean;
}

export class DataX implements IDataX {

    [key: string]: any;

    constructor(data?: IDataX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): DataX {
        data = typeof data === 'object' ? data : {};
        let result = new DataX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IDataX {

    [key: string]: any;
}

export class DataY implements IDataY {

    [key: string]: any;

    constructor(data?: IDataY) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): DataY {
        data = typeof data === 'object' ? data : {};
        let result = new DataY();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IDataY {

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}